(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';
var dialog = require('./dialog');

var $cache = {};

function initializeCache() {
    $cache.primary = $('#primary');
    $cache.checkoutForm = $cache.primary.find('.checkout-shipping.address').length > 0 ? $cache.primary.find('.checkout-shipping.address') : $cache.primary.find('.checkout-billing.address');
    $cache.submitFormButton = $cache.checkoutForm.find('button.saveShipping').length > 0 ? $cache.checkoutForm.find('button.saveShipping') : $cache.checkoutForm.find('button[name$=_save]');
    $cache.validatoionDialog = $cache.primary.find('#address-validation-dialog');
    $cache.byPassDAV = $cache.checkoutForm.find('.bypassDAV');
    $cache.address1 = $cache.checkoutForm.find('input[name$="_address1"]');
    $cache.address2 = $cache.checkoutForm.find('input[name$="_address2"]');
    $cache.city = $cache.checkoutForm.find('input[name$="_city"]');
    $cache.stateCode = $cache.checkoutForm.find('select[id$="_state"]');
    //SUR-316: Commented out as we are not displaying country field to the user.
    //$cache.countryCode = $cache.checkoutForm.find('select[id$="_country"]');
    $cache.postalCode = $cache.checkoutForm.find('input[name$="_postal"]');
    $cache.addressSections = $('#address-validation-dialog').find('button[id*="edit"]').length;
}

function initializeDom() {
    if ($cache.validatoionDialog.length > 0) {

        var dlg = dialog.create({
            target: $cache.validatoionDialog,
            options: {
                width: 670,
                dialogClass: 'address-validation-dialog',
                open: initializeEvents
            }
        });

        $cache.validatoionDialog.show();
        dlg.dialog('open');
    }
}


function initializeEvents() {

    $('body').on('click', '#original-address-edit', function () {
        $cache.validatoionDialog.dialog('close');
        jQuery('html, body').animate({
            scrollTop: 0
        }, 500);
    });

    $('body').on('click', '#original-account-address-edit', function (e) {
        e.preventDefault();
        $cache.validatoionDialog.dialog('close');
    });

    $('body').on('click', '#submit-original-account-address', function (e) {
        e.preventDefault();
        $('input[name*="passbydav"]').val(true);
        $cache.validatoionDialog.off('click').dialog('close');
        $cache.byPassDAV.attr('value', 'true');
        $('.apply-button').click();
    });

    $('body').on('click', '[id|="submit-address-selected"]', function (e) {
        e.preventDefault();
        var form = $('form[name*="profile_address"]');
        var selectedAddress = $(this).data('address').split('||');
        form.find('input[id*="address_address1"]').val(selectedAddress[0]);
        if (selectedAddress[1] !== 'undefined' && selectedAddress[1] !== '') {
            form.find('input[id*="address_address2"]').val(selectedAddress[1]);
        }
        form.find('input[id*="address_city"]').val(selectedAddress[2]);
        form.find('select[id*="address_states_state"]').val(selectedAddress[3]);
        form.find('input[id*="address_postal"]').val(selectedAddress[5]);
        form.find('input[name*="passbydav"]').attr('value', 'true');
        $cache.validatoionDialog.dialog('close');
        $cache.byPassDAV.attr('value', 'true');

        $('.apply-button').click();
    });

    $('body').on('click', '[id|="submit-pre-address-selected"]', function (e) {
        e.preventDefault();
        $(this).closest('.center').find('button').removeClass('selected');
        $(this).addClass('selected');
        var form = $('form[name*="giftregistry"]').find('fieldset[name*="address-before"]');
        var selectedAddress = $(this).data('address').split('||');
        form.find('input[id*="addressBeforeEvent_address1"]').val(selectedAddress[0]);
        if (selectedAddress[1] !== 'undefined' && selectedAddress[1] !== '') {
            form.find('input[id*="addressBeforeEvent_address2"]').val(selectedAddress[1]);
        }
        form.find('input[id*="addressBeforeEvent_city"]').val(selectedAddress[2]);
        form.find('select[id*="addressBeforeEvent_states_state"]').val(selectedAddress[3]);
        form.find('input[id*="addressBeforeEvent_postal"]').val(selectedAddress[5]);

        $(this).closest('.center').hide();
        if ($cache.addressSections === 1 || $('#address-validation-dialog').find('button.selected').length > 1) {
            $cache.validatoionDialog.dialog('close');
            jQuery('html, body').animate({
                scrollTop: 0
            }, 500);

            if ($cache.addressSections === 1 || $('#address-validation-dialog').find('button[id*="edit"].selected').length === 0) {
                $('input[name*="passbydav"]').val(true);
                $cache.byPassDAV.attr('value', 'true');
                $('button[name*="setBeforeAfterAddresses"]').click();
            }
        }
    });
    
    $('body').on('click', '[id|="submit-post-address-selected"]', function (e) {
        e.preventDefault();
        $(this).closest('.center').find('button').removeClass('selected');
        $(this).addClass('selected');
        var form = $('form[name*="giftregistry"]').find('fieldset[name*="address-after"]');
        var selectedAddress = $(this).data('address').split('||');
        form.find('input[id*="addressAfterEvent_address1"]').val(selectedAddress[0]);
        if (selectedAddress[1] !== 'undefined' && selectedAddress[1] !== '') {
            form.find('input[id*="addressAfterEvent_address2"]').val(selectedAddress[1]);
        }
        form.find('input[id*="addressAfterEvent_city"]').val(selectedAddress[2]);
        form.find('select[id*="addressAfterEvent_states_state"]').val(selectedAddress[3]);
        form.find('input[id*="addressAfterEvent_postal"]').val(selectedAddress[5]);
        $(this).closest('.center').hide();
        if ($cache.addressSections === 1 || $('#address-validation-dialog').find('button.selected').length > 1) {
            $cache.validatoionDialog.dialog('close');
            jQuery('html, body').animate({
                scrollTop: 0
            }, 500);

            if ($cache.addressSections === 1 || $('#address-validation-dialog').find('button[id*="edit"].selected').length === 0) {
                $('input[name*="passbydav"]').val(true);
                $cache.byPassDAV.attr('value', 'true');
                $('button[name*="setBeforeAfterAddresses"]').click();
            }
        }
    });

    $('body').on('click', '#original-gift-address-edit', function () {
        $(this).closest('.center').find('button').removeClass('selected');
        $(this).addClass('selected');
        if ($cache.addressSections === 1 || $('#address-validation-dialog').find('button.selected').length >= 1) {
            $cache.validatoionDialog.dialog('close');
            jQuery('html, body').animate({
                scrollTop: 0
            }, 500);
        }
    });

    $('body').on('click', '#ship-to-original-gift-address', function () {
        $(this).closest('.center').find('button').removeClass('selected');
        $(this).addClass('selected');
        if ($cache.addressSections === 1 || $('#address-validation-dialog').find('button.selected').length >= 1) {
            $cache.validatoionDialog.dialog('close');
            jQuery('html, body').animate({
                scrollTop: 0
            }, 500);
            if ($cache.addressSections === 1 || $('#address-validation-dialog').find('button[id*="edit"].selected').length === 0) {
                $('input[name*="passbydav"]').val(true);
                $cache.byPassDAV.attr('value', 'true');
                $('button[name*="setBeforeAfterAddresses"]').click();
            }
        }
    });

    $('body').on('click', '#ship-to-original-address', function () {
        $('input[name*="passbydav"]').val(true);

        $cache.validatoionDialog.dialog('close');
        $cache.byPassDAV.attr('value', 'true');
        $cache.submitFormButton.click();
    });

    $cache.validatoionDialog.off('click').on('click', '[id|="suggested-address-edit"]', function () {
        var selectedAddress = $(this).data('address').split('||');
        $cache.address1.val(selectedAddress[0]);
        if (selectedAddress[1] !== 'undefined' && selectedAddress[1] !== '') {
            $cache.address2.val(selectedAddress[1]);
        }
        $cache.city.val(selectedAddress[2]);
        $cache.stateCode.val(selectedAddress[3]);
        //SUR-316: Commented out as we are not displaying country field to the user.
        //$cache.countryCode.val(selectedAddress[4]);
        $cache.postalCode.val(selectedAddress[5]);
        $cache.validatoionDialog.dialog('close');
        jQuery('html, body').animate({
            scrollTop: 0
        }, 500);
    });

    $cache.validatoionDialog.off('click').on('click', '[id|="ship-to-address-selected"]', function () {
        var selectedAddress = $(this).data('address').split('||');
        $cache.address1.val(selectedAddress[0]);
        if (selectedAddress[1] !== 'undefined' && selectedAddress[1] !== '') {
            $cache.address2.val(selectedAddress[1]);
        }
        $cache.city.val(selectedAddress[2]);
        $cache.stateCode.val(selectedAddress[3]);
        //SUR-316: Commented out as we are not displaying country field to the user.
        //$cache.countryCode.val(selectedAddress[4]);
        $cache.postalCode.val(selectedAddress[5]);
        $cache.byPassDAV.attr('value', 'true');
        $cache.validatoionDialog.dialog('close');

        $cache.submitFormButton.click();
    });
}

exports.init = function() {
    initializeCache();
    initializeDom();
};

},{"./dialog":13}],2:[function(require,module,exports){
'use strict';

var progress = require('./progress'),
    util = require('./util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var getJson = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'json',
        url: options.url,
        async: (typeof options.async === 'undefined' || options.async === null) ? true : options.async,
        data: options.data || {},
        type: options.type || 'GET'
    })
    // success
    .done(function (response) {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail(function (xhr, textStatus) {
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null);
        }
    })
    // executed on success or fail
    .always(function () {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};
/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {Object} options Configuration options for the request.
 * @param {string} options.url URI for the request.
 * @param {Object} options.data Name/Value pair data request.
 * @param {(response: unknown, error?: string) => void} options.callback Callback function to be called.
 * @param {Object} options.target Selector or element that will receive content.
 */
var load = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'html',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        data: options.data,
        xhrFields: {
            withCredentials: true
        },
        type: options.type || 'GET'
    })
    .done(function (response) {
        // success
        if (options.target) {
            $(options.target).empty().html(response);
        }
        if (options.callback) {
            options.callback(response);
        }
    })
    .fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        options.callback(null, textStatus);
    })
    .always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

exports.getJson = getJson;
exports.load = load;

},{"./progress":59,"./util":78}],3:[function(require,module,exports){
/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

var _ = require('lodash');

var countries = require('./countries'),
    pwaRegistryLinks = require('./pwa-registry-links'),
    dialog = require('./dialog'),
    minicart = require('./minicart'),
    page = require('./page'),
    rating = require('./rating'),
    searchplaceholder = require('./searchplaceholder'),
    searchsuggest = require('./searchsuggest'),
    tooltip = require('./tooltip'),
    util = require('./util'),
    validator = require('./validator'),
    tls = require('./tls'),
    dateformat = require('./dateformat'),
    slickSlider = require('./slickSlider'),
    consentTracking = require('./consentTracking'),
    wishlist = require('./pages/product/wishlist'),
    turnto = require('./pages/product/turnto'),
    gtm = require('./gtm'),
    bloomreach = require('./bloomreach'),
    radar = require('./radar'),
    radarAutoComplete = require('./radarAutoComplete'),
    wunderkind = require('./wunderkind'),
    photoGrid = require('./pages/product/photo-grid/photo-grid-fe');


window.turnToFunctions = turnto;
window.gtmFunctions = gtm;

// if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
    var s = document.createElement('script');
    s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
    s.setAttribute('type', 'text/javascript');
    document.getElementsByTagName('head')[0].appendChild(s);
}

require('./jquery-ext')();
require('./cookieprivacy')();
consentTracking.init();
bloomreach.init();
pwaRegistryLinks.init();
require('./captcha')();
radar.init();

$('.top-level-cat .root-ctg-ul .level-2-rootctg').addClass('viewed');

var SetMenuTimer = 450;
var MegaMenuTimer = {
    id: null,
    clear: function() {
        if (MegaMenuTimer.id) {
            window.clearTimeout(MegaMenuTimer.id); 
            delete MegaMenuTimer.id;
        }
    },
    start: function(duration, $curObj) {
        MegaMenuTimer.id = setTimeout(function() {
            MegaMenuTimer.run($curObj);
        }, duration);
    },
    run: function($curObj) {
        if (!$curObj.hasClass('hovered-list')) {
            $curObj.siblings('li').removeClass('hovered-list');
            $curObj.addClass('hovered-list');

            if ($curObj.closest('.root-ctg-ul').find('.hovered-list .menulist').length > 0) {
                $curObj.closest('.root-ctg-ul').find('.hovered-list .menulist').remove();
            }
            megaMenu();
            if ($curObj.hasClass('viewed')) {
                $curObj.removeClass('viewed');
            }
        } else {
            megaMenueHegiht($curObj);
        }
    }
};


// Position registry dropdown centered under its trigger link when it doesn't naturally appear below it
function positionRegistryDropdown($li) {
    if (window.innerWidth < 1025) return;

    var $drop = $li.find('.registry-megamenudrop');
    if (!$drop.length) return;

    var $link = $li.find('.level-1-cat');
    if (!$link.length) return;

    // Reset to default CSS positioning to measure natural position
    $drop.css({'left': '', 'margin-left': ''});

    var linkRect = $link[0].getBoundingClientRect();
    var dropRect = $drop[0].getBoundingClientRect();

    // If the link is in the left portion of the dropdown, it appears visually "below" - leave as is.
    // If the link's left edge is past the dropdown's midpoint, the dropdown is too far left and needs centering.
    var dropMidpoint = dropRect.left + dropRect.width / 2;
    if (linkRect.left < dropMidpoint) {
        return;
    }

    // Center dropdown under the link, clamped to viewport edges
    var linkCenter = linkRect.left + linkRect.width / 2;
    var ancestorLeft = $drop.offsetParent()[0].getBoundingClientRect().left;
    var dropWidth = dropRect.width;
    var idealLeft = (linkCenter - ancestorLeft) - (dropWidth / 2);

    var padding = 8;
    var maxLeft = window.innerWidth - ancestorLeft - dropWidth - padding;
    var minLeft = padding - ancestorLeft;

    $drop.css({
        'left': Math.max(minLeft, Math.min(idealLeft, maxLeft)) + 'px',
        'margin-left': '0'
    });
}

//mega nav timer
var setNavTmr = 450;
var navigationTimer = {
    id: null,
    ajaxCalls: [],
    clear: function() {
        if (navigationTimer.id) {
            window.clearTimeout(navigationTimer.id);
            navigationTimer.ajaxCalls.forEach(function(call){
                call.abort();
            });
            navigationTimer.ajaxCalls.splice(0);
            navigationTimer.id = null;
        }
    },
    start: function(duration, $curObj) {
        function startNavigation() {
            if (!$curObj.hasClass('level-2-open')) {
                $curObj.siblings('li').removeClass('level-2-open');
                $curObj.addClass('level-2-open');
                if ($curObj.hasClass('brands')) {
                    $curObj.find('.Brands-list').css({'min-height':'','overflow-y':'','overflow-x':'','max-height':''});
                    $curObj.find('.Brands-list .blp-alpha-left').removeAttr('style');
                    $curObj.find('.Brands-list .blp-alpha-heading').removeAttr('style');
                    $curObj.find('.Brands-list .blp-alpha-left-child a').removeAttr('style');
                    var contentHeight=$curObj.find('.Brands-list').outerHeight()+$('.header-main').outerHeight()-28;
                    if (screen.availHeight>contentHeight) {
                        $curObj.find('.Brands-list').css('min-height', $curObj.find('.Brands-list').outerHeight());
                    } else {
                        if (window.matchMedia('(min-width: 1440px)').matches) {
                            $curObj.find('.Brands-list').css('min-height', screen.availHeight-$('.header-main').outerHeight()-28);
                            $curObj.find('.Brands-list .blp-alpha-left').css('margin-bottom','0');
                            $curObj.find('.Brands-list .blp-alpha-heading').css('padding-bottom','0');
                            $curObj.find('.Brands-list .blp-alpha-left-child a').css('padding-bottom','0');
                            var h=$curObj.find('.Brands-list .blp-alpha-left-child a').height();
                            var padding= $curObj.find('.Brands-list').height()-$curObj.find('.Brands-list .shop-all-btn').outerHeight()-$curObj.find('.first-row').height()-$curObj.find('.second-row').height()-$curObj.find('.third-row').height();
                            padding/=($curObj.find('.first-row').height()/h+$curObj.find('.second-row').height()/h+$curObj.find('.third-row').height()/h);
                            $curObj.find('.Brands-list .blp-alpha-heading').css('padding-bottom',padding+'px');
                            $curObj.find('.Brands-list .blp-alpha-left-child a').css('padding-bottom',padding+'px');
                        } else {
                            $curObj.find('.Brands-list').css('max-height', screen.availHeight-$('.header-main').outerHeight()-28);
                            $curObj.find('.Brands-list').css({'overflow-y':'auto','overflow-x':'hidden'});
                        }
                    }
                }
                $curObj.siblings('li').find('.level-1-cat').removeAttr('style');
                $curObj.siblings('li').find('.level-1-cat').css('opacity', '0.7');
                if ($curObj.hasClass('cat2211269')) {
                    $curObj.find('.level-1-cat').css({'color': '#B72F3B','font-weight': '700','opacity':''});
                } else {
                    $curObj.find('.level-1-cat').css({'color': '#1E1E1E','font-weight': '700','opacity':''});
                }
                positionRegistryDropdown($curObj);
            }
            var $firstMenu = $curObj.find('.products-megamenudrop .product-first-menu');
            if ($firstMenu.length > 0) {
                MegaMenuTimer.run($firstMenu);
            }
        }
        navigationTimer.id = setTimeout(function() {
            var $loadElem = $curObj.find('.sub-nav-load');
            if ($loadElem.length) {
                var catId = $loadElem.data('cat-id');
                var reqUrl = Urls.nav + (Urls.nav.indexOf('?') > 0 ? '&' : '?') + 'cat=' + encodeURIComponent(catId);
                navigationTimer.ajaxCalls.push($.get(reqUrl, function (data) {
                    $loadElem.remove();
                    $(data).appendTo($curObj);
                    startNavigation();
                }));
            } else {
                startNavigation();
            }
        }, duration);
    }
};

function isTouchDevice() {  
    return (('ontouchstart' in window) ||  
        (navigator.maxTouchPoints > 0) ||  
        (navigator.msMaxTouchPoints > 0));  
}

function initializeEvents() {
    //Check whether the geo-location enabled or not and set the cookie respectively
    $(window).on('load', function() {
        var showPopUp = true;
        if (window.subscribedUser) {
            showPopUp = false;
        } else {
            var url = new URL(window.location.href);
            if ((window.pageContext.type != undefined && (window.pageContext.type.toUpperCase() === 'CART' ||
                window.pageContext.type.toUpperCase() === 'CHECKOUT')) ||
                url.searchParams.get('utm_campaign') != null ||
                (url.searchParams.get('utm_medium') != null && url.searchParams.get('utm_medium') == 'email')) {
                showPopUp = false;
            }
        }
        
        if (showPopUp && document.cookie.indexOf('welcomePopupdisplayed=close') < 0) {
            welcomePopUp();
        }
    });
    
    $(document).off('blur keyup', '.attendeeDetails .firstname, .attendeeDetails .lastname, .editCartAttendeeDetails .firstname, .editCartAttendeeDetails .lastname').on('blur keyup', '.attendeeDetails .firstname, .attendeeDetails .lastname, .editCartAttendeeDetails .firstname, .editCartAttendeeDetails .lastname', function(e) {
        e.preventDefault();
        var firstlastName = $(this).val();
        var format = /^([\w\d?])([\w\d&'\-<. ])*$/;
        if (e.keyCode != 9) {
            if (firstlastName == '') {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_attendee_firstname" class="error">This field is required.</span>');
                $(this).addClass('error');
                $(this).closest('.form-row').removeClass('success').addClass('failure');
                return;
            } else if (!format.test(firstlastName)) {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_email" class="error">Please enter a valid name.</span>');
                $(this).addClass('error');
                $(this).closest('.form-row').removeClass('success').addClass('failure');
                return;
            }  else {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).removeClass('error');
                $(this).closest('.form-row').removeClass('failure').addClass('success');
            }
        }
    });
    
    $(document).off('blur keyup', '.attendeeDetails .attendee-email, .editCartAttendeeDetails .attendee-email').on('blur keyup', '.attendeeDetails .attendee-email, .editCartAttendeeDetails .attendee-email', function(e) {
        e.preventDefault();
        var attendeeEmail = $(this).val();
        if (e.keyCode != 9) {
            if (attendeeEmail == '') {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_attendee_email" class="error">This field is required.</span>');
                $(this).addClass('error');
                $(this).closest('.form-row').removeClass('success').addClass('failure');
                return;
            // SLTBE-8954: trim before validating. CartModel.updateAttendees now
            // trims server-side, and validateEmail in this same bundle already
            // does isEmail($.trim(value)) - without the trim here the blur
            // handler would be stricter than both, rejecting a pasted
            // 'john@example.com ' that the server would happily store.
            } else if (!validator.isEmail($.trim(attendeeEmail))) {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_email" class="error">Please enter a valid email address.</span>');
                $(this).addClass('error');
                $(this).closest('.form-row').removeClass('success').addClass('failure');
                return;
            } else {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).removeClass('error');
                $(this).closest('.form-row').removeClass('failure').addClass('success');
            }
        }
    });
    
    $(document).off('blur keyup', '.attendeeDetails .attendee-phone, .editCartAttendeeDetails .attendee-phone').on('blur keyup', '.attendeeDetails .attendee-phone, .editCartAttendeeDetails .attendee-phone', function(e) {
        e.preventDefault();
        var attendeePhone = $(this).val();
        var format = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
        if (e.keyCode != 9) {
            if (attendeePhone == '') {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_attendee_phone" class="error">This field is required.</span>');
                $(this).addClass('error');
                $(this).closest('.form-row').removeClass('success').addClass('failure');
                return;
            } else if (!format.test(attendeePhone)) {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_email" class="error">Please specify a valid phone number.</span>');
                $(this).addClass('error');
                $(this).closest('.form-row').removeClass('success').addClass('failure');
                return;
            } else {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).removeClass('error');
                $(this).closest('.form-row').removeClass('failure').addClass('success');
            }
        }
    });
    
    function welcomePopUp() {
        var $welcomeObj = $('.welcome-popup');
        var $welcomeClose = $welcomeObj.find('.notification .close');
        /* When a user lands on any page the slider will slide up */
        setTimeout(function() {
            $welcomeObj.slideDown();
        }, 3000);
    
        $welcomeClose.click(function(e) {
            e.preventDefault();
            var date = new Date();
            date = new Date(date.getTime() + 1000*60*60*24*30);
            document.cookie = 'welcomePopupdisplayed=close;expires=' + date.toUTCString() + ';path=/';
            $(this).closest('.welcome-popup').slideUp();
        });
    }
    
    if ($('.focus-date').length > 0) {
        util.datePicker();
    }
    
    //footer links navigation code
    $('.shipping li a').on('click', function(e) {
        e.preventDefault();
        var questId = $(this).attr('href');
        if ($('.header-main').hasClass('fixed')) {
            $(window).scrollTop($(questId).position().top - $('.header-main.fixed').find('.global-nav').outerHeight());
        } else {
            $(window).scrollTop($(questId).position().top - $('.header-main.fixed').find('.global-nav').outerHeight() - 100);
        }
    });
    
    // print handler
    $('.print-page').on('click', function () {
        window.print();
        return false;
    });

    // Registry checklist PDF print handler
    $(document).on('click', '.registry-checklist-print', function (e) {
        e.preventDefault();
        var pdfUrl = $(this).data('pdf-url');

        if (pdfUrl) {
            // Open PDF in new window and trigger print dialog
            var printWindow = window.open(pdfUrl, '_blank', 'width=800,height=600,toolbar=no,menubar=no');

            if (printWindow) {
                // Wait for content to load before triggering print
                printWindow.onload = function () {
                    setTimeout(function () {
                        printWindow.print();
                    }, 500);
                };
            } else {
                // Fallback if popup blocked
                alert('Please allow popups to download the registry checklist.');
            }
        }
    });

    // Registry mobile accordion handler for L2 category blocks
    $(document).on('click', '.registry-megamenudrop .l2-category-block .l2-header', function (e) {
        // Only apply accordion behavior on mobile (max-width: 1024px)
        if (window.innerWidth <= 1024) {
            e.preventDefault();
            var $block = $(this).closest('.l2-category-block');
            $block.toggleClass('is-expanded');
        }
    });

    window.addEventListener('popstate', function(e) {
        if (e.state == 'orderconfirmation' && pageContext.ns == 'orderconfirmation') {
            var lastVisitedPDPURL = Urls.homePage;
            if ($('#lastVisitedPDPURL').length > 0 && $('#lastVisitedPDPURL').val() != '') {
                lastVisitedPDPURL = $('#lastVisitedPDPURL').val();
            }
            window.location.href = lastVisitedPDPURL;
        }
    });

    //Hederbanner session
    if (sessionStorage.getItem('clickMe') == 'clicked') {		 
        $('.header-banner').slideUp();
        $('.header-main').addClass('promoClosed');
    } else {
        $('.header-slot').slideDown();
        $('.header-main').removeClass('promoClosed');
    }
    $('.promo-close').click(function() {
        $('.header-banner').slideUp();
        $('.header-main').addClass('promoClosed');
        sessionStorage.setItem('clickMe', 'clicked');
        if ($('.header-banner').length > 0 && $('.header-banner div').height() > 0) {
            $('.global-nav').css('top', 0);
        }
    }); 
    
    $('.text-ellipsis').ellipsis();
    $('.top-level-cat').addClass('viewed');

    $('body').off('click', 'a.level-1-cat:not(".noSubCats")').on('click', 'a.level-1-cat:not(".noSubCats")', function(ev) {
        if (!$(this).parents('.top-level-cat.level-2-open').length && isTouchDevice()) {
            ev.preventDefault();
        }
    });

    $('body').off('click', '.products-megamenudrop a.level-2-cat').on('click', '.products-megamenudrop a.level-2-cat', function(ev) {
        if (!$(this).parents('.level-2-rootctg.hovered-list').length && isTouchDevice()) {
            ev.preventDefault();
        }
    });
    
    // mega menu timer delay code  
    $('body').off('mouseenter', '.menu-category .top-level-cat').on('mouseenter', '.menu-category .top-level-cat', function() {
        if (window.matchMedia('(min-width: 1025px)').matches) {
            var $curObj = $(this);
            navigationTimer.start(isTouchDevice() ? 0 : setNavTmr, $curObj);
            if ($(this).hasClass('viewed')) {
                setTimeout(function() {
                    if ($curObj.hasClass('brands')) {
                        $curObj.find('.Brands-list').css({'min-height':'','overflow-y':'','overflow-x':'','max-height':''});
                        var contentHeight=$curObj.find('.Brands-list').outerHeight()+$('.header-main').outerHeight()-28;
                        if (screen.availHeight>contentHeight) {
                            $curObj.find('.Brands-list').css('min-height', $curObj.find('.Brands-list').outerHeight());
                        } else {
                            if (window.matchMedia('(min-width: 1440px)').matches) {
                                $curObj.find('.Brands-list').css('min-height', screen.availHeight-$('.header-main').outerHeight()-28);
                                $curObj.find('.Brands-list .blp-alpha-left').css('margin-bottom','0'); 
                                $curObj.find('.Brands-list .blp-alpha-heading').css('padding-bottom','0'); 
                                $curObj.find('.Brands-list .blp-alpha-left-child a').css('padding-bottom','0'); 
                                var h=$curObj.find('.Brands-list .blp-alpha-left-child a').height();
                                var padding= $curObj.find('.Brands-list').height()-$curObj.find('.Brands-list .shop-all-btn').outerHeight()-$curObj.find('.first-row').height()-$curObj.find('.second-row').height()-$curObj.find('.third-row').height();
                                padding/=($curObj.find('.first-row').height()/h+$curObj.find('.second-row').height()/h+$curObj.find('.third-row').height()/h);
                                $curObj.find('.Brands-list .blp-alpha-heading').css('padding-bottom',padding+'px'); 
                                $curObj.find('.Brands-list .blp-alpha-left-child a').css('padding-bottom',padding+'px'); 
                            } else {
                                $curObj.find('.Brands-list').css('max-height', screen.availHeight-$('.header-main').outerHeight()-28);
                                $curObj.find('.Brands-list').css({'overflow-y':'auto','overflow-x':'hidden'});
                            }
                        }
                    }
                    $curObj.removeClass('viewed');
                }, 500);
            }
        }
    }).off('mouseleave', '.menu-category .top-level-cat, .menu-category').on('mouseleave', '.menu-category .top-level-cat, .menu-category', function() {
        if (window.matchMedia('(min-width: 1025px)').matches) {
            var $curObj = $(this);
            if ($curObj.hasClass('menu-category')) {
                $curObj.find('.top-level-cat').removeClass('level-2-open');
                $('.menu-category').find('.level-1-cat').removeAttr('style');
            }
            navigationTimer.clear();
        }
    });

    // Position registry dropdown on hover after the nav timer opens it
    $('body').on('mouseenter', '.menu-category .top-level-cat', function() {
        if (!window.matchMedia('(min-width: 1025px)').matches) return;
        var $li = $(this);
        var attempts = 0;
        var interval = setInterval(function() {
            attempts++;
            if ($li.hasClass('level-2-open') && $li.find('.registry-megamenudrop').length) {
                positionRegistryDropdown($li);
                clearInterval(interval);
            } else if (attempts > 30) {
                clearInterval(interval);
            }
        }, 50);
    });

    // secand level catageries.
    $('body').off('mouseenter', '.products-megamenudrop .level-2-rootctg ').on('mouseenter', '.products-megamenudrop .level-2-rootctg', function() {
        if (window.matchMedia('(min-width: 1025px)').matches) {
            MegaMenuTimer.clear();
            MegaMenuTimer.start(isTouchDevice() ? 0 : SetMenuTimer, $(this));
        }
    }).off('mouseleave', '.products-megamenudrop .level-2-rootctg').on('mouseleave', '.products-megamenudrop .level-2-rootctg', function() {
        if (window.matchMedia('(min-width: 1025px)').matches) {
            MegaMenuTimer.clear();
        }
    }); 

    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

    $('body')
        .on('keydown', 'textarea[data-character-limit]', function (e) {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;

            if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length,
                charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this).closest('.field-wrapper ').find('div.char-count .char-remain-count').html(charsRemain);
        });

    // Gift Message
    var giftMessageTextArea = 'textarea[data-gift-message-char-limit]';
    var giftMessageInvalidErrorId = 'gift-message-invalid-error';
    var showGiftMessageError = function(message) {
        var _this = $(giftMessageTextArea);
        var hasNotMessage = !_this.parent().children(`#${giftMessageInvalidErrorId}`).length;
        if (hasNotMessage) {
            _this.parent().append($(`<span id="${giftMessageInvalidErrorId}" class="error">${message}</span>)`));
        }
    };
    $('body')
        .on('paste', giftMessageTextArea, function () {
            // Block pasting anything.
            showGiftMessageError(Resources.TYPE_IN_GIFT_MSG);
            return false;
        })
        .on('keydown', giftMessageTextArea, function (e) {
            var _this = $(this);
            var value = _this.val();
            var charsLimit = _this.data('gift-message-char-limit');
            var charsUsed = value.replaceAll('\n', '').length;

            _this.parent().children(`#${giftMessageInvalidErrorId}`).remove();

            // Block typing if there is no more characters available.
            if (charsUsed >= charsLimit && controlKeys.indexOf(e.which.toString() < 0)) {
                showGiftMessageError(String.format(Resources.LINE_CHAR_LIMIT_GIFT_MSG, currentLineNumber + 1));
                return false;
            }

            var lines = value.split('\n');
            var currentPosition = _this.prop('selectionStart');
            var currentLineNumber = value.substr(0, currentPosition).split('\n').length - 1;
            var nextLine = lines[currentLineNumber + 1];
            var maxLines = _this.prop('rows');
            var remainingText = value.substring(currentPosition);

            if (e.key === 'Enter') {
                // Block Enter if there is no more lines available.
                if (lines.length === maxLines) {
                    return false;
                }

                // Block Enter to move reaming text to next line with existing text.
                return !remainingText || !nextLine;
            }

            var previousLine = lines[currentLineNumber - 1];
            var currentLine = lines[currentLineNumber];

            if (e.key === 'Backspace') {
                // Block Backspace to return to previous line if there is text in previous line and current line.
                return value[currentPosition - 1] !== '\n' || !previousLine || !currentLine;
            }

            if (e.key === 'Delete') {
                // Block Delete to get the next line if is not empty.
                return value[currentPosition] !== '\n' || !nextLine;
            }

            var validChar = (e.keyCode >= 48 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 112) || e.keyCode >= 186 || e.keyCode === 32;
            var charsLimitPerLine = charsLimit / maxLines;

            // Typing a valid char exceeding the limit of the line.
            if (validChar && currentLine.length >= charsLimitPerLine) {

                // Block if it is the last line.
                if (currentLineNumber === maxLines - 1) {
                    showGiftMessageError(String.format(Resources.LINE_CHAR_LIMIT_GIFT_MSG, currentLineNumber + 1));
                    return false;
                }

                // Block if there is text in the next line.
                if (nextLine && nextLine.trim().length) {
                    showGiftMessageError(String.format(Resources.LINE_CHAR_LIMIT_GIFT_MSG, currentLineNumber + 1));
                    return false;
                }

                // User types Space then creates a new line.
                if (e.key === ' ') {
                    _this.val(value + '\n');
                    return true;
                }

                var currentLineWords = currentLine.split(' ');
                var currentLineLastWord = currentLineWords[currentLineWords.length - 1];

                // Block if user types a character in a word that has charsLimitPerLine characters.
                if (currentLineLastWord.length === charsLimitPerLine) {
                    showGiftMessageError(String.format(Resources.LINE_CHAR_LIMIT_GIFT_MSG, currentLineNumber + 1));
                    return false;
                }

                // User types a character on incomplete word then creates a new line with the full word.
                var nextPosition = currentPosition + 1;
                var newValueOfTheLine = currentLine.substring(0, currentLine.length - currentLineLastWord.length);
                lines[currentLineNumber] = newValueOfTheLine;
                lines[currentLineNumber + 1] = currentLineLastWord;
                _this.val(lines.join('\n'));
                _this.prop({
                    'selectionStart': nextPosition,
                    'selectionEnd': nextPosition
                });
                return true;
            }

            return true;
        })
        .on('keyup', giftMessageTextArea, function () {
            // Updates the gift message count text.
            var _this = $(this);
            var charsLimit = _this.data('gift-message-char-limit');
            var maxLines = _this.prop('rows');
            var charsLimitPerLine = charsLimit / maxLines;

            var value = _this.val();
            var lines = value.split('\n');
            var currentLineNumber = value.substr(0, _this.prop('selectionStart')).split('\n').length;
            var currentLine = lines[currentLineNumber - 1];

            var charsRemain = charsLimitPerLine - currentLine.length;
            var linesRemain = !lines[lines.length - 1] ? maxLines - lines.length + 1 : maxLines - lines.length;
            var message = String.format(Resources.CHAR_LIMIT_GIFT_MSG, charsRemain, currentLineNumber, linesRemain);

            _this.parent().find('div.gift-message-char-count').text(message);
            return true;
        });
    /**
     * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
     * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
     * */
    var $searchContainer = $('.header-search');
    searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH); 

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // add generic toggle functionality
    $('.toggle').next('.toggle-content').hide();
    $('.toggle').click(function () {
        $(this).toggleClass('expanded').next('.toggle-content').toggle();
    });
    
    // gift-pkg  expansion
    $(document).off('click', '.giftpack-toggle').on('click', '.giftpack-toggle', function() {
        $(this).toggleClass('open').next('.checkout-gift-pack').toggle(); 
    });
    
    // phone number formate code
    if ($('.phoneformat').length > 0) {
        var $curobjshipping = $('.phoneformat');
        $($curobjshipping).each(function(){
            var $updatedText = $(this).text().replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            $(this).text($updatedText);
        });
    }

    // gift-registry more-items expansion
    $('.toggle.gift-toggle ').click(function() {
        $('.more-items.top').toggle();
        $('.after-toggle').addClass('second-div');
        $(this).toggleClass('expanded').closest('.serach-gift-registry').find('.toggle-content.gift-toggle-content').toggle();
    });
    
    $(document).off('keypress', '.header-search input[type="text"]').on('keypress', '.header-search input[type="text"]', function() {
        if (window.matchMedia('(max-width: 1025px)').matches) {
            var currObj = $(this);
            var lengthtext = currObj.val().length;
            var clearval = '<span class="clearvalue"> </span>';
            if (lengthtext > 0 && $('.clearvalue').length <= 0) {
                $(this).closest('fieldset').append(clearval); 
            }
        }
    });
    $(document).off('keyup', '.header-search input[type="text"]').on('keyup', '.header-search input[type="text"]', function() {
        var currObj = $(this);
        var lengthtext = currObj.val().length;
        if (window.matchMedia('(max-width: 1025px)').matches) {
            if (lengthtext <= 0) {
                $('.clearvalue').remove();
            }
        }
    });
    $(document).off('click touchstart', '.clearvalue').on('click touchstart', '.clearvalue', function(e) {
        e.preventDefault();
        $('.header-search').find('input[type="text"]').val('');
        setTimeout(function(){$('.header-search').find('input[type="text"]').blur();},300);
        $(this).remove(); 
    });
    
    // subscribe email box
    var $subscribeEmail = $('.subscribe-email');
    if ($subscribeEmail.length > 0)    {
        $subscribeEmail.focus(function () { 
            var val = $(this.val());
            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({color: '#999999'}, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            var val = $.trim($(this.val()));
            if (val.length > 0) {
                return; // do not animate when contains value
            }
            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                .css('color', '#999999')
                .animate({color: '#333333'}, 500, 'linear');
        });
    }

    // check the newsletter checkbox if the user is already subscribed.
    if ($('input[name$="profile_customer_addtoemaillist"]').length > 0) {
        if (window.subscribedUser) {
            $('input[name$="profile_customer_addtoemaillist"]').attr('checked','checked');
        }
    }

    $('.privacy-policy').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'), 
            options: {
                height: 600
            }
        });
    });
    
    $('body').on('click','.privacy-policy-model', function (e) {
        var scrollPos;
        scrollPos = $(window).scrollTop();
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'), 
            options: {
                width: 600,
                open: function () {
                    $('.ui-dialog').addClass('dialog-updated');
                    $('body').addClass('modal-open');
                    $('#dialog-container')[0].scrollTop = 0;
                    $('html, body').animate({
                        scrollTop: scrollPos
                    }, 0);
                },
                close : function () {
                    $('body').removeClass('modal-open');   
                }
            },
            position: {
                my: 'top',
                at: 'top',
                of: window
            }
        });
        
    });
    if ($('body').find('.cat-landing-bottom-content').length > 0) {  
        $('.cat-landing-bottom-content').insertAfter('.search-result-options-pagination');
        $('.cat-landing-bottom-content').css('display','block');
      
    }
    if ($('body').find('.category-product-slots').length>0) {

        $('.category-product-slots').insertAfter('.breadcrumb');
        $('.calloutMsg').insertAfter('.search-result-options');
        if ($('.category-products-hits-banner-one').find('.html-slot-container').length>0) {
            $('.category-products-hits-banner-one').insertBefore('.header-category');
        }

    }

    $('.classes-slot-image-width-noslider').not('.slick-initialized').slick({

        dots: false,

        infinite: false,

        slidesToShow: 7.21,

        slidesToScroll: 1,

        initialSlide:0,

        cssEase: 'linear',

        variableWidth: false,

        responsive: [

            {

                breakpoint: 1023,

                settings: {

                    slidesToShow: 2,

                    slidesToScroll: 2,

                    arrows: false,

                    infinite:false

                }

            }

        ]

    });

    $('.consent-tracking-policy').on('click', function (e) {
        e.preventDefault();
        consentTracking.show();
    });
    
    function homePageSlider() {
        $('.homepage-slider-new').not('.slick-initialized').slick({
            dots: true,
            arrows: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: 'linear',
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: true
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    dots: true
                }
            }
            ]
        });
    }
    homePageSlider();
   
    function slickSliderClass() {
        if ($(window).width() <= 400) {
            $('.classes-slot-image-width, .homepage-feature-product-listing-3x4').not('.slick-initialized').slick({
                dots: true,
                mobileFirst: true,
                arrows: false,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 400,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false
                        }
                    }
                ]

            })

        }
    }
    
    slickSliderClass();
    $(window).resize(function() {
        var $openRegistry = $('.level-2-open');
        if ($openRegistry.length) {
            positionRegistryDropdown($openRegistry);
        }
    });
    $(window).resize(function() {
        if ($(window).width() > 400) {
            if ($('.classes-slot-image-width, .homepage-feature-product-listing-3x4').hasClass('slick-initialized')) {
                $('.classes-slot-image-width, .homepage-feature-product-listing-3x4').not('.slick-initialized').slick('unslick');
            }
        } else {
            if (!$('.classes-slot-image-width, .homepage-feature-product-listing-3x4').hasClass('slick-initialized')) {
                slickSliderClass();
            }
        }
    });

    // main menu toggle
    $('.menu-toggle').on('click', function() {
        $('#wrapper').toggleClass('menu-active');
        $('body').toggleClass('noscroll');
        $('#main').wrap('<div class="mask-div"></div>');
        var $footer = $('body').find('footer');
        var $headerBanner = $('body').find('.shipping-banner-message');
        if ($headerBanner.length < 1 || $footer.length < 1) {
            $('body').find('.mask-div').append($footer);
            $('body').find('.mask-div').prepend($headerBanner);
        }
        $('body').prepend('<span class="mask-area"></span>'); 
        if (!$('#wrapper').hasClass('menu-active')) {
            $('.menu-category li').removeClass('active-cat-1 in-active-cat-1 active-cat-2 in-active-cat-2 active-cat-3 in-active-cat-3 level-2-active-cat');
            $('#navigation').removeClass('level-1-open');   
        }
        $('body').find('.general-search').insertAfter('.close-menu');
        $('body').find('.mobile-search').css('display','block');
    }); 
    // mobile nav
    $('body').on('click','.navigation-closed, .mask-area', function() { 
        $('#wrapper').toggleClass('menu-active');
        $('body').toggleClass('noscroll');
        $('#main').unwrap('mask-div');
        $('.mask-area').remove();  
        $('body').find('.general-search').insertAfter('#navigation');
        $('body').find('.mobile-search').css('display','none');
        $('body').find('#navigation').find('.content-asset').removeClass('in-active-content-asset').removeClass('active-content-asset');
        $('body').find('#navigation').find('.blp-alpha-left').removeAttr('style');
        $('body').find('#navigation').find('.blp-alpha-heading').each(function(i, obj) {
            $(obj).replaceWith($('<div class="blp-alpha-heading">' + $(obj).text() + '</div>'));
        });
        $('body').find('.level-2-rootctg').removeClass('active-cat-2').siblings('li').removeClass('in-active-cat-2');
        $('body').find('li').removeClass('in-active-cat-3 active-cat-3');
        $('body').find('.active-cat-1').removeClass('level-2-active-cat');
        $('body').find('.top-level-cat').removeClass('active-cat-1').siblings('li').removeClass('in-active-cat-1');
        $('body').find('#navigation').removeClass('level-1-open');
        $('body').find('#navigation').find('.close-menu').show();
        $('body').find('.top-level-cat').find('.top-level-cat-name').removeAttr('style');
        $('body').find('.level-4').slideUp();
        $('body').find('#navigation').removeClass('navigation-main3');
    });

    function runLevel1ClickHandler($parent) {
        $parent.addClass('active-cat-1').siblings('li').addClass('in-active-cat-1');
        $(this).closest('#navigation').addClass('level-1-open');
        $(this).closest('#navigation').find('.close-menu').hide();
        $(this).closest('#navigation').find('.header-menu-utility').insertAfter($parent.find('.top-level-cat-name .content'));
        if ($parent.hasClass('brands')) {
            $parent.find('.blp-alpha-heading').each(function(i, obj) {
                $(obj).replaceWith($('<a class="blp-alpha-heading">' + $(obj).text() + '</a>'));
            });
        }
    }

    $(document).off('click', '.menu-category li a:not(".back-clp, .noSubCats")').on('click', '.menu-category li a:not(".back-clp, .noSubCats")', function(e) {
        history.pushState(undefined, '', window.location.href);
        if (window.matchMedia('(max-width: 1025px)').matches) {
            var $curObj = $(this),
                $parent = $curObj.closest('li');

            if ($curObj.hasClass('level-1-cat')) {
                e.preventDefault();

                var runLevel1Click = runLevel1ClickHandler.bind(this, $parent);
                var $loadElem = $parent.find('.sub-nav-load');
                if ($loadElem.length > 0) {
                    var catId = $loadElem.data('cat-id');
                    var reqUrl = Urls.nav + (Urls.nav.indexOf('?') > 0 ? '&' : '?') + 'cat=' + encodeURIComponent(catId);
                    $.get(reqUrl, function (data) {
                        var $elem = $(data);
                        $loadElem.replaceWith($elem);
                        runLevel1Click();
                    });
                } else {
                    runLevel1Click();
                }
            } else if ($curObj.hasClass('level-2-cat')) {
                if ($parent.hasClass('active-cat-2') || $parent.find('.level-3').length < 1) {
                    return true;
                } else {
                    e.preventDefault();
                    $parent.closest('.active-cat-1').addClass('level-2-active-cat');
                    $parent.addClass('active-cat-2').siblings('li').addClass('in-active-cat-2');
                    $(this).closest('#navigation').find('.close-menu').hide();
                    $(this).closest('.top-level-cat').find('.top-level-cat-name').hide();
                    $(this).closest('#navigation').find('.header-menu-utility').insertAfter($parent.find('.sub-level-cat-name'));
                }
            } else if ($curObj.hasClass('level-3-cat')) {
                e.preventDefault();
                if ($parent.hasClass('active-cat-3')) {
                    $parent.find('.level-4').slideUp();
                    $parent.removeClass('active-cat-3').nextAll('li').removeClass('in-active-cat-3');
                    $(this).closest('#navigation').removeClass('navigation-main3');
                } else {
                    $parent.siblings('li').removeClass('active-cat-3').addClass('in-active-cat-3').find('.level-4').slideUp();
                    $parent.removeClass('in-active-cat-3').addClass('active-cat-3').find('.level-4').slideDown();
                    $(this).closest('#navigation').addClass('navigation-main3');
                }

            }
            if ($curObj.hasClass('blp-alpha-heading')) {
                e.preventDefault();
                if ($(this).parents('.content-asset').hasClass('active-content-asset')) {
                    $(this).parents('.content-asset').find('.blp-alpha-left').hide();
                    $(this).parents('.content-asset').removeClass('active-content-asset');
                    $(this).parents('.right-section').find('.content-asset').removeClass('in-active-content-asset');

                    $(this).closest('#navigation').removeClass('navigation-main3');
                } else {
                    $(this).parents('.right-section').find('.content-asset').removeClass('active-content-asset').addClass('in-active-content-asset').find('.blp-alpha-left').hide();
                    $(this).parents('.content-asset').removeClass('in-active-content-asset').addClass('active-content-asset').find('.blp-alpha-left').show();
                    $(this).closest('#navigation').addClass('navigation-main3');
                }
            }
        }
    });

    // Loading sub-level categories to include them in the search engine ranking algorithms.
    $('.menu-category li a:not(".back-clp, .noSubCats").level-1-cat').each(function() {
        var $loadElem = $(this).closest('li').find('.sub-nav-load');
        if ($loadElem.length > 0) {
            var catId = $loadElem.data('cat-id');
            var reqUrl = Urls.nav + (Urls.nav.indexOf('?') > 0 ? '&' : '?') + 'cat=' + encodeURIComponent(catId);
            $.get(reqUrl, function (data) {
                var $elem = $(data);
                $loadElem.replaceWith($elem);
            });
        }
    });

    $(document).off('click', '.content .back-root').on('click', '.content .back-root', function(e) {
        if (window.matchMedia('(max-width: 1025px)').matches) {
            e.preventDefault();
            var $curObj = $(this),
                $parent = $curObj.closest('li');
            if ($curObj.hasClass('back-root')) {
                if ($parent.hasClass('active-cat-1')) {
                    if ($parent.hasClass('brands')) {
                        $parent.find('.blp-alpha-heading').each(function(i, obj) {
                            $(obj).replaceWith($('<div class="blp-alpha-heading">' + $(obj).text() + '</div>'));
                        });
                        $parent.find('.content-asset').removeClass('in-active-content-asset').removeClass('active-content-asset');
                        $parent.find('.blp-alpha-left').removeAttr('style');
                    }
                    $parent.removeClass('active-cat-1').siblings('li').removeClass('in-active-cat-1');
                    $(this).closest('#navigation').removeClass('level-1-open');
                    $(this).closest('#navigation').find('.close-menu').show();
                    $parent.find('.header-menu-utility').insertAfter('#navigation .close-menu');
                }
                if ($parent.hasClass('active-cat-2')) {
                    $parent.removeClass('active-cat-2').siblings('li').removeClass('in-active-cat-2');
                    $parent.find('li').removeClass('in-active-cat-3 active-cat-3');
                    $parent.closest('.active-cat-1').removeClass('level-2-active-cat');
                    $parent.find('.header-menu-utility').insertAfter('#navigation .close-menu');
                    $(this).parents('.top-level-cat').find('.top-level-cat-name').show();
                    $(this).closest('#navigation').find('.header-menu-utility').insertAfter($(this).parents('.top-level-cat').find('.top-level-cat-name .content'));
                }
            }
        }
        $(this).closest('#navigation').removeClass('navigation-main3');
    });

    $(document).on('click', '.read-more', function(e) {
        e.preventDefault();
        if (window.matchMedia('(max-width: 500px)').matches) {
            $(this).closest('.main-section').find('.left-section').toggleClass('ReadMoreaActive');
            $(this).find('span').toggleClass('hide');
        }
    }); 
    
    $(document).off('click', '.search-sug-close').on('click', '.search-sug-close', function(e) {
        e.preventDefault();
        $('#search-suggestions').hide();
        $('body').removeClass('noscroll-device');
        $('.header-search').find('input[type="text"]').blur();
        $('.header-search').find('input[type="text"]').val('');    
    }); 
    

    $(document).on('click', '.search-icon', function(e) {
        if (window.matchMedia('(min-width: 1025px)').matches) {  
            e.preventDefault();
            $('.header-search').addClass('slide-search');
            setTimeout(function(){$('.header-search').find('input[type="text"]').focus();},500);
            $(this).addClass('hide');   
        }
    });
    $(document).on('click', '.mobile-search', function(e) {
        e.preventDefault();
        var curobj = $(this);
        if (!$('#wrapper').hasClass('menu-active') && window.matchMedia('(max-width: 1025px)').matches) {
            $('.header-menu-utility').toggleClass('search-active');
            $(this).find('.slt-mobile-sprite').toggleClass('SearchIconmobile');
            $(this).find('.slt-mobile-sprite').toggleClass('CLOSEICON');
            if ($(this).find('.slt-mobile-sprite').hasClass('CLOSEICON')) {
                $('#main').wrap('<div class="mask-div"></div>');
                var $footer = $('body').find('footer');
                var $headerBanner = $('body').find('.shipping-banner-message');
                $('body').find('.mask-div').append($footer);
                $('body').find('.mask-div').prepend($headerBanner);  
                $('.mask-div').prepend('<span class="mask-area"></span>');
                setTimeout(function(){$('.header-search').find('input[type="text"]').focus();},500); 
            } else {
                $('#main').unwrap('mask-div'); 
                $('.mask-area').remove();
            }
            $(curobj).on('click', '.CLOSEICON', function() {
                $('.header-search').find('input[type="text"]').val('');
                $('#search-suggestions').hide(); 
            });
        }
    });  
    // secondary section for mobile
    $('span.sticky-hide').on('click', function() {
        if (window.matchMedia('(max-width: 1023px)').matches) {
            $(this).toggleClass('stickynav-mobile');
            $('#secondary').slideToggle();		
        }
    });
    //Accordion Global
    var allPanels = $('.accordion .content').hide();
    $('.accordion .heading').click(function() {
        $('.accordion .heading').not($(this)).removeClass('active');
        allPanels.not($(this).next()).slideUp();
        $(this).toggleClass('active').next().slideToggle();
        return false;
    });

    $('#tabs').tabs(); 
    
/*    setTimeout(function(){
        var setmargintop = $('.header-main').height();
        $('#main').removeAttr('style');
        $('#main').css('margin-top', setmargintop);
    }, 500);  */ 
    // body touch events
    $('body').on('click touchstart', function(e) {
        if (window.matchMedia('(min-width: 1023px)').matches && window.matchMedia('(max-width: 1025px)').matches) {
            var navarea = $(e.target).closest('#navigation').length;
            var searcharea = $(e.target).closest('.header-search').length;
            var menubar = $(e.target).closest('.menu-toggle').length;
            var mobileSearch = $(e.target).closest('.mobile-search').length; 
            if (navarea === 0 && searcharea === 0 && menubar === 0 && $('#navigation').is(':visible')) {
                $('.menu-toggle').trigger('click');
            } else if ($('.header-search').is(':visible') && $('.header-menu-utility').hasClass('search-active') && searcharea === 0 && mobileSearch == 0 && menubar === 0) {
                $('.header-menu-utility').removeClass('search-active'); 
                $('.mobile-search').find('.slt-mobile-sprite').removeClass('CLOSEICON').addClass('SearchIconmobile');  
                $('#main').unwrap('mask-div');
                $('.mask-area').remove();   
            } 
        }
    });
    //Initialize recommendations for 404 page
    var $defaulValuesClp1 = {
        infinite: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 4
    };
    var $responsiveClp1 = {
        dots: true,
        infinite: true
    };
    slickSlider.init('.error-page-footer-recommendation .clp-category-listing ul', $defaulValuesClp1, $responsiveClp1);

    function handleCarouselSlider(module) {
        let slickSliderInitialized = false;
        const $defaulValuesClp = {
            infinite: true,
            arrows: true,
            slidesToShow: 5,
            slidesToScroll: 5
        };
        const $responsiveClp = {
            dots: true,
            infinite: true
        };
        const images = document.querySelectorAll(`.${module.replaceAll(' ', '.')} .clp-category-listing .search-result-items`);
        if (images.length) {
            slickSlider.init(images[0], $defaulValuesClp, $responsiveClp);
            slickSliderInitialized = true;
        }
        return slickSliderInitialized;
    }

    var slickModules = [
        'trending-products bloomreach-recommend' 
    ];
    slickModules.forEach(function (module) {
        const sliders = document.getElementsByClassName(module);
        if (sliders.length) {
            if (!handleCarouselSlider(module)) {
                const observer = new MutationObserver(function() {
                    if (handleCarouselSlider(module)) {
                        observer.disconnect();   
                    }
                });
                observer.observe(sliders[0], {childList: true, subtree: true});
            }
        }
    });

} 

//mega nav drop down
function megaMenu() {
    // Skip registry mega menu - it doesn't need reorganization
    if ($('.level-2-open .registry-megamenudrop').length > 0) {
        return;
    }

    var $con = $('.level-2-open .products-megamenudrop .root-ctg-ul');
    $con.each(function() {
        var $mega = $(this).find('.hovered-list');
        var divlength = 4;
        var datalist = '';
        var brandcontent='';
        if ($mega.find('.megamenu-categories .brands').length>0) {
            brandcontent=$mega.find('.megamenu-categories .brands').html();
        }
        for (var i = 1; i <= divlength; i++) {
            $mega.find('.megamenu-categories').append('<li class="menulist menulist-' + i + '"></li>');
            $mega.find('.mega_subcategory').each(function() {
                if (!$(this).hasClass('brands')) {
                    if ($(this).find('a.toplevel-subcategory').eq(0).hasClass('column-' + i)) {
                        datalist = $(this).html();
                        $mega.find('.menulist-' + i).append(datalist);
                        if ($(this).find('a').length > 1) {
                            $mega.find('.menulist-' + i).addClass('multiple-tags');
                            $mega.find('.menulist-' + i).find('a').last().addClass('last-tag');
                        } else if ($(this).find('a').length == 1) {
                            $mega.find('.menulist-' + i).addClass('single-tag'); 
                        }
                    }
                }
            });
        } 
        if ($mega.find('.megamenu-categories').find('.column-cat').length==0) {
            var category =$mega.find('.megamenu-categories').html();
            $mega.find('.megamenu-categories').html('').append('<div class="column-cat">'+category+'</div>');
        } else {
            // Prev version can cause duplication, so we need to avoid .menulist elements that are already in .column-cat
            $mega.find('.column-cat .menulist').remove();
            $mega.find('.menulist').appendTo($mega.find('.column-cat'));
        }
        var length=$mega.find('.menulist').length;
        for (var j = 1; j <= length; j++) {
            if ($mega.find('.menulist-'+j).children().length==0) {
                $mega.find('.menulist-'+j).remove();
            }
        }
        $mega.find('.categery-flayout-right-sec').appendTo($mega.find('.megamenu-categories'));
        $mega.find('.mega_subcategory').addClass('hide'); 
        if ($mega.find('.megamenu-categories .brand-catalog').length ==0) {
            $mega.find('.megamenu-categories').append(
                '<div class="brand-catalog">'+
                brandcontent+
                '</div>'
            );
        } else {
            $mega.find('.brand-catalog').appendTo($mega.find('.megamenu-categories'));
        }
        $mega.find('.shop-all-desk ').appendTo($mega.find('.megamenu-categories .brand-catalog'));
        $mega.find('.brand-catalog .toplevel-subcategory').text('Brands:');
        $mega.parents('.level-2').css('width','unset');
        var catWidth=$mega.find('.column-cat').width(); 
        if (!$mega.find('.megamenu-categories').hasClass('widthToken')) {
            var panelWidth=catWidth+$mega.find('.categery-flayout-right-sec').outerWidth()+$mega.parents('.root-ctg-ul').outerWidth()+64;
            panelWidth*=100;
            panelWidth/=1519;
            $mega.find('.megamenu-categories').addClass('widthToken');
            $mega.find('.megamenu-categories').addClass(''+panelWidth);
            $mega.parents('.level-2').css('width',panelWidth+'%');
            var bannerWidth= ($mega.find('.categery-flayout-right-sec').outerWidth()*100)/(catWidth+$mega.find('.categery-flayout-right-sec').outerWidth());
            $mega.find('.categery-flayout-right-sec').css({'width':bannerWidth+'%','padding-right':'0'});
            $mega.find('.categery-flayout-right-sec .mega-menu-banner').css({'padding-right':'32px'});
            catWidth=100-bannerWidth;
            $mega.find('.column-cat').css('width',catWidth+'%');
        } else {
            var d=$mega.find('.megamenu-categories').attr('class').split(' ').pop();
            $mega.parents('.level-2').css('width',d+'%');
        }
        if ($mega.find('.megamenu-categories .brand-catalog .level-4').length==0) {
            $mega.find('.megamenu-categories .brand-catalog .shop-all-desk').css('width','100%');
        }
        $mega.parents('.level-2').css({'min-height':'','overflow-y':''});
        var x;
        if ($mega.parents('.root-ctg-ul').outerHeight()>$mega.find('.column-cat').outerHeight()) {
            x=$mega.parents('.root-ctg-ul').outerHeight();
        } else {
            x=$mega.find('.column-cat').outerHeight()+32; 
        }
        var contentHeight=$mega.find('.brand-catalog').outerHeight()+$('.header-main').outerHeight()+x;
        if (screen.availHeight>contentHeight) {
            $mega.parents('.level-2').css('min-height', $mega.find('.brand-catalog').outerHeight()+x);
        } else {
            $mega.parents('.level-2').css('min-height', screen.availHeight-$('.header-main').outerHeight()-28);
            if (window.matchMedia('(min-width: 1440px)').matches) { 
                $mega.find('.menulist').css('margin-bottom','0');
                $mega.find('.menulist .level-4').css('padding','0 0 0');
                $mega.find('.menulist .level-4 li').css('margin','0');
                var padding= $mega.parents('.level-2').outerHeight()-$mega.find('.brand-catalog').outerHeight()-$mega.find('.column-cat').height();
                var maxli;
                var maxbrand;
                for (var n = 1; n <= $mega.find('.menulist').length; n++) {
                    if (n==1) {
                        maxli=$mega.find('.menulist-'+n).find('li').length;
                        maxbrand=$mega.find('.menulist-'+n).find('.level-4').length;
                    }
                    if ($mega.find('.menulist-'+n).find('.level-4').length>maxbrand) {
                        maxbrand=$mega.find('.menulist-'+n).find('.level-4').length;
                    }
                    if ($mega.find('.menulist-'+n).find('li').length>maxli) {
                        maxli=$mega.find('.menulist-'+n).find('li').length;
                    }
                }
                padding/=(maxli+maxbrand);
                $mega.find('.menulist .level-3-cat').css('padding','0 0 '+padding+'px');
                $mega.find('.menulist li').css('padding','0 0 '+padding+'px');
            } else {
                $mega.parents('.level-2').css('overflow-y', 'auto');
            }
        }
    });
}
function megaMenueHegiht($curObj) {
    var $mega= $curObj;
    $mega.parents('.level-2').css({'min-height':'','overflow-y':''});
    $mega.find('.menulist').removeAttr('style');
    $mega.find('.menulist .level-4').removeAttr('style');
    $mega.find('.menulist .level-4 li').removeAttr('style');
    var x;
    if ($mega.parents('.root-ctg-ul').outerHeight()>$mega.find('.column-cat').outerHeight()) {
        x=$mega.parents('.root-ctg-ul').outerHeight();
    } else {
        x=$mega.find('.column-cat').outerHeight()+32; 
    }
    var contentHeight=$mega.find('.brand-catalog').outerHeight()+$('.header-main').outerHeight()+x;
    if (screen.availHeight>contentHeight) {
        $mega.parents('.level-2').css('min-height', $mega.find('.brand-catalog').outerHeight()+x);
    } else {
        $mega.parents('.level-2').css('min-height', screen.availHeight-$('.header-main').outerHeight()-28);
        if (window.matchMedia('(min-width: 1440px)').matches) { 
            $mega.find('.menulist').css('margin-bottom','0');
            $mega.find('.menulist .level-4').css('padding','0 0 0');
            $mega.find('.menulist .level-4 li').css('margin','0');
            var padding= $mega.parents('.level-2').outerHeight()-$mega.find('.brand-catalog').outerHeight()-$mega.find('.column-cat').height();
            var maxli;
            var maxbrand;
            for (var s = 1; s <= $mega.find('.menulist').length; s++) {
                if (s==1) {
                    maxli=$mega.find('.menulist-'+s).find('li').length;
                    maxbrand=$mega.find('.menulist-'+s).find('.level-4').length;
                }
                if ($mega.find('.menulist-'+s).find('.level-4').length>maxbrand) {
                    maxbrand=$mega.find('.menulist-'+s).find('.level-4').length;
                }
                if ($mega.find('.menulist-'+s).find('li').length>maxli) {
                    maxli=$mega.find('.menulist-'+s).find('li').length;
                }
            }
            padding/=(maxli+maxbrand);
            $mega.find('.menulist .level-3-cat').css('padding','0 0 '+padding+'px');
            $mega.find('.menulist li').css('padding','0 0 '+padding+'px');
        } else {
            $mega.parents('.level-2').css('overflow-y', 'auto');
        }
        
    }
    
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll'); 
    }
    // load js specific styles
    util.limitCharacters();
    util.limitCharactersGiftMessage();
}

var pages = {
    account: require('./pages/account'),
    cart: require('./pages/cart'),
    checkout: require('./pages/checkout'),
    compare: require('./pages/compare'),
    product: require('./pages/product'),
    registry: require('./pages/registry'),
    search: require('./pages/search'),
    storefront: require('./pages/storefront'),
    wishlist: require('./pages/wishlist'),
    storelocator: require('./pages/storelocator')
};

var app = {
    headerHeight: 202,
    init: function () {
        this.headerHeight = $('.header-banner').height() + $('.global-nav').height();
        window.sgDialog = require('./dialog');
        window.sgUtil = require('./util');
        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }
        initializeDom();
        initializeEvents();

        // init specific global components
        countries.init();
        tooltip.init();
        minicart.init();
        validator.init();
        rating.init();
        dateformat.init();
        searchplaceholder.init();
        radarAutoComplete.init();
        // execute page specific initializations
        $.extend(page, window.pageContext);
        wunderkind.init();
        var ns = page.ns;
        if (ns && pages[ns] && pages[ns].init) {
            pages[ns].init();
        }

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }
        
        //Initialize Single Page Checkout.
        require('./spc').init();
        
        if (isGTMEnabled) {
            //Initialize gtm
            require('./gtm').init();
        }

        var $createAccountContainer = $('.login-create-account-container');
        $(document).on('click', '.login-create-account-container', (e) => {
            if (e.target === e.currentTarget) {
                $createAccountContainer.hide();
            }
        });
        $(document).on('click', '.login-create-account__close', () => $createAccountContainer.hide());
        $(document).on('click', '#order-create-account', () => $createAccountContainer.show());

        var $messageContainer = $('.message-dialog-container');
        $(document).on('click', '.message-dialog-container', (e) => {
            if (e.target === e.currentTarget) {
                $messageContainer.hide();
            }
        });
        $(document).on('click', '.message-dialog__close, .message-dialog__button', () => $messageContainer.hide());
        $(document).on('click', '#newslatter-subscribe', () => {
            var email = $('#customerEmail').val();
            var dialog = $('#message-dialog-container--subscribed');
            var title = dialog.find('.message-dialog__title');
            var text = dialog.find('.message-dialog__text');
            $.ajax({
                type: 'POST',
                url: Urls.footerSubscription, // eslint-disable-line no-undef
                data: {emailAddress: email, formatajax: true},
                success: function (response) {
                    if (response && response.success) {
                        if (response.accountStatus == 'accountexists') {
                            title.text(Resources.EMAILEXISTSMSGERRORTITLE);
                            text.html('<p>' + Resources.EMAILEXISTSMSGERRORBODY + '</p>');
                        } else if (response.accountStatus == 'accountcreated') {
                            title.text('Congratulations');
                            text.html('<p>' + Resources.SUCCESSFULYSIGNUPMSG + '</p>');
                        } else if (response.accountStatus == 'submitted') {
                            title.text('Congratulations');
                            text.html('<p>' + 'Your data was submitted. Shortly you should receive an email with confirmation link.' + '</p>');
                        } else if (response.accountStatus == 'error') {
                            title.text('Error');
                            text.html('<p>' + 'We are sorry, your email subscription was unsuccessful. Please try again.' + '</p>');
                        } else if (response.accountStatus == 'disabled') {
                            title.text('Subscriptions');
                            text.html('<p>' + 'Subscriptions are currently disabled.' + '</p>');
                        } else {
                            title.text('Error');
                            text.html('<p>' + 'Unexpected error. Please try again.' + '</p>');
                        }
                        dialog.show();
                    }
                }
            });
        });
    }
};

// general extension functions
(function () {
    String.format = function () {
        var s = arguments[0];
        var i, len = arguments.length - 1;
        for (i = 0; i < len; i++) {
            var reg = new RegExp('\\{' + i + '\\}', 'gm');
            s = s.replace(reg, arguments[i + 1]);
        }
        return s;
    };
})();

// initialize app
$(document).ready(function () {
    gtm.onCLPPageView(
        $('select[data-attributeid="classType"]').val() || '',
        $('.set-preferred-location').data('store-id'),
        $('.set-preferred-location').data('store-name')
    );

    app.init();
});

//Global scroll function
$(window).scroll(function(e) {
    app.headerHeight = $('.header-banner').height() + $('.global-nav').height();

    var position = $(this).scrollTop();
    var isMobile = window.matchMedia('(max-width: 1024px)').matches;
    var messageHeight = isMobile ? $('.shipping-banner-message').height() || 0 : 0;
    if (position > messageHeight) {
        $('.header-main').addClass('fixed');
        if (isMobile) {
            $('#main').css('margin-top', app.headerHeight + 'px');
        }

        if ($('.header-banner').length > 0 && $('.header-banner div').height() > 0 && !$('.header-banner').is(':hidden') && !$('.header-main').hasClass('promoClosed')) {
            var headerBanner = $('.header-banner div').height();
            $('.global-nav').css('top', headerBanner);
        }
        if (window.matchMedia('(min-width: 1025px)').matches) {
            var searchwidth=$('.global-nav').width()-$('#menuUtilityUser').width()-$('#navigation').width()-$('.primary-logo').outerWidth()-parseInt(($('.primary-logo').css('margin-right')),10)-parseInt(($('.header-menu-utility').css('padding-right')),10);
            $('.global-nav .header-menu-utility ').css('width', searchwidth);
        }
    } else {
        $('.header-main').removeClass('fixed');
        $('.global-nav').css('top', 0);
        if (isMobile) {
            $('#main').css('margin-top', 0);
        }
        $('.global-nav .header-menu-utility ').removeAttr('style');
    }
    
    //Hide search flyout if page scrolls
    if ($('#search-suggestions').is(':visible') && window.matchMedia('(min-width: 1366px)').matches) {
        //$('.clearvalue').click(); 
        e.preventDefault();
        $('#search-suggestions').hide();
        $('body').removeClass('noscroll-device');
        $('.header-search').find('input[type="text"]').blur();
        $('.header-search').find('input[type="text"]').val('');     
    } 
    
}); 

$(window).resize(_.throttle(function() {
    app.headerHeight = $('.header-banner').height() + $('.global-nav').height();
    photoGrid.init();
    if ($('.text-ellipsis').length !==0 && 'ellipsis' in $('.text-ellipsis')) {
        $('.text-ellipsis').ellipsis();
    }
    if ($('#search-suggestions').is(':visible')) {
        var mobileFixedblocks = $('.header-main').height() + $('.header-search').height();
        var headerHeight = window.innerHeight - (mobileFixedblocks);
        if (window.matchMedia('(max-width: 1025px)').matches) {
            $('#search-suggestions').css('height', headerHeight);
        }
    } 
    if (window.matchMedia('(min-width: 1025px)').matches) {
        $('#navigation').removeAttr('style');
    }
    if (window.matchMedia('(min-width: 1024px)').matches && !$('#secondary').is('visible')) {
        $('#secondary').removeAttr('style');
    }
    if ($(window).width() > 1023) {
        $('.homepage-feature-product-listing-3x2').not('.slick-initialized').slick('unslick');
    }
    if ($(window).width() < 1024) {
        var $showFilter = $('body').find('.mobile-show.show-filter');
        if ($showFilter.length > 0) {
            var $showFilterWidth = $showFilter.width();
            $('body').find('#secondary.refinements, #tabs ul.ui-helper-reset').css('width', ($showFilterWidth * 2) + 1);
            $('body').find('.sort-by .custom-select').css('width', $showFilterWidth + 1);
        }
    } else {
        $('body').find('.mobile-show.show-filter, #secondary.refinements').removeClass('active'); 
        $('body').find('#secondary.refinements, #tabs ul.ui-helper-reset, .sort-by .custom-select').removeAttr('style');
    }
    if (window.matchMedia('(max-width: 1025px)').matches) {
        $('.products-megamenudrop .mega_subcategory').removeClass('hide');
        $('.products-megamenudrop .menulist').addClass('hide');
    } else {
        $('.products-megamenudrop .mega_subcategory').addClass('hide');
        $('.products-megamenudrop .menulist').removeClass('hide');
    }
    if (!$('.ui-dialog').hasClass('enlarge-dialog')) {
        $('.ui-dialog-content:visible').each(function () {
            $(this).dialog('option', 'position', $(this).dialog('option', 'position'));
        });
    }
    if (window.matchMedia('(max-width: 1024px)').matches) {
        if ($('.clearvalue').length <= 0) {
            $('#q').val('');
        }
        $('.header-search').find('#q').attr('placeholder',Resources.search);
        $('.header-search').find('.search-input').css('display','inline-block');
    } else {
        $('.header-search').find('#q').attr('placeholder',Resources.simplesearch);
        if ($('.clearvalue').length <= 0) {
            $('#q').val('');
        }
        if ($('.header-main').hasClass('fixed')) {
            var searchwidth=$('.global-nav').width()-$('#menuUtilityUser').width()-$('#navigation').width()-$('.primary-logo').outerWidth()-parseInt(($('.primary-logo').css('margin-right')),10)-parseInt(($('.header-menu-utility').css('padding-right')),10);
            $('.global-nav .header-menu-utility ').css('width', searchwidth);
        } else {
            $('.global-nav .header-menu-utility ').removeAttr('style');
        }
    }
}, 1000, {trailing: true})); 

// Calling wishlist functionality

wishlist();

$('#dwfrm_wishlist_search_firstname').attr('placeholder', Resources.FIRST_NAME);
$('#dwfrm_wishlist_search_lastname').attr('placeholder', Resources.LAST_NAME);
$('#dwfrm_wishlist_search_email').attr('placeholder', Resources.EMAILADDRESS +' *');
$('label[for=dwfrm_wishlist_search_email] .required-indicator').css('display', 'none');


$(document).on('click', '.exclusions-apply-msg', function (e) {
    e.preventDefault();
    var currentPosition = $(document).scrollTop();
    
    dialog.open({
        url: $(e.target).attr('href'),
        options: {
            title: '',
            dialogClass:'exclusions-apply-dialog',
            width: 462,
            height: '462',
            draggable: false,
            close: function () {
                $(window).scrollTop(currentPosition);
            },
            open: function () {
                $(window).scrollTop(0);
                $(document).on('click', '.ui-widget-overlay', function () {
                    $('.ui-dialog-titlebar-close').trigger('click');
                });
            }
        }
    });
    return false;
})

if (window.matchMedia('(max-width: 1024px)').matches) {
    $('.header-search').find('#q').css('display','inline-block');
    $('.header-search').find('.search-input').attr('placeholder',Resources.search);
    $('.header-search').find('.search-input').css('display','inline-block');

} else {
    $('.header-search').find('.search-input').attr('placeholder',Resources.simplesearch);
}

},{"./bloomreach":4,"./captcha":6,"./consentTracking":9,"./cookieprivacy":10,"./countries":11,"./dateformat":12,"./dialog":13,"./gtm":18,"./jquery-ext":19,"./minicart":21,"./page":22,"./pages/account":23,"./pages/cart":24,"./pages/checkout":32,"./pages/compare":35,"./pages/product":40,"./pages/product/photo-grid/photo-grid-fe":43,"./pages/product/turnto":48,"./pages/product/wishlist":50,"./pages/registry":51,"./pages/search":52,"./pages/storefront":53,"./pages/storelocator":54,"./pages/wishlist":55,"./pwa-registry-links":60,"./radar":62,"./radarAutoComplete":63,"./rating":64,"./searchplaceholder":65,"./searchsuggest":66,"./slickSlider":67,"./spc":68,"./tls":76,"./tooltip":77,"./util":78,"./validator":79,"./wunderkind":80,"lodash":94}],4:[function(require,module,exports){
'use strict';


var bloomreach = {
    init: function () {

        window.dw = window.dw || {}
        window.dw.bloomreach = window.dw.bloomreach || {};

        window.dw.bloomreach.onWidgetRendered = function(accountId, wrid, wid, wty) {
            if (window.BrTrk) {
                var eventData = {};
                eventData.acct_id = accountId;
                eventData.wrid = wrid;
                eventData.wid = wid;
                eventData.wty = wty;
                window.BrTrk.getTracker().logEvent('widget', 'widget-view', eventData, true);
            } else {
                window.console.log(`BR: onWidgetRendered: acct_id: ${accountId} wrid: ${wrid} wid: ${wid} wty: ${wty}`);
            }
        }

        window.dw.bloomreach.onWidgetClicked = function(accountId, wrid, wid, wty, pid) {
            if (window.BrTrk) {
                var eventData = {};
                eventData.acct_id = accountId;
                eventData.wrid = wrid;
                eventData.wid = wid;
                eventData.wty = wty;
                eventData.item_id = pid;
                window.BrTrk.getTracker().logEvent('widget', 'widget-click', eventData, true);
            } else {
                window.console.log(`BR: onWidgetClicked: acct_id: ${accountId} wrid: ${wrid} wid: ${wid} wty: ${wty} pid: ${pid}`);
            }
        }

    }
};

module.exports = bloomreach;

},{}],5:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    util = require('./util');

var selectedList = [];
var maxItems = 1;
var bliUUID = '';

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts() {
    var bonusproducts = [];

    var i, len;
    for (i = 0, len = selectedList.length; i < len; i++) {
        var p = {
            pid: selectedList[i].pid,
            qty: selectedList[i].qty,
            options: {}
        };
        var a, alen, bp = selectedList[i];
        if (bp.options) {
            for (a = 0, alen = bp.options.length; a < alen; a++) {
                var opt = bp.options[a];
                p.options = {optionName:opt.name, optionValue:opt.value};
            }
        }
        bonusproducts.push({product:p});
    }
    return {bonusproducts: bonusproducts};
}

var selectedItemTemplate = function (data) {
    var attributes = '';
    for (var attrID in data.attributes) {
        var attr = data.attributes[attrID];
        attributes += '<li data-attribute-id="' + attrID + '">\n';
        attributes += '<span class="display-name">' + attr.displayName + '</span>: ';
        attributes += '<span class="display-value">' + attr.displayValue + '</span>\n';
        attributes += '</li>';
    }
    attributes += '<li class="item-qty">\n';
    attributes += '<span class="display-name">Qty</span>: ';
    attributes += '<span class="display-value">' + data.qty + '</span>';
    return [
        '<li class="selected-bonus-item" data-uuid="' + data.uuid + '" data-pid="' + data.pid + '">',
        '<i class="remove-link fa fa-remove" title="Remove this product" href="#"></i>',
        '<div class="item-name">' + data.name + '</div>',
        '<ul class="item-attributes">',
        attributes,
        '<ul>',
        '<li>'
    ].join('\n');
};

// hide swatches that are not selected or not part of a Product Variation Group
var hideSwatches = function () {
    $('.bonus-product-item:not([data-producttype="master"]) .swatches li').not('.selected').not('.variation-group-value').hide();
    // prevent unselecting the selected variant
    $('.bonus-product-item .swatches .selected').on('click', function () {
        return false;
    });
};

/**
 * @private
 * @function
 * @description Updates the summary page with the selected bonus product
 */
function updateSummary() {
    var $bonusProductList = $('#bonus-product-list');
    if (!selectedList.length) {
        $bonusProductList.find('li.selected-bonus-item').remove();
    } else {
        var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
        var i, len;
        for (i = 0, len = selectedList.length; i < len; i++) {
            var item = selectedList[i];
            var li = selectedItemTemplate(item);
            $(li).appendTo(ulList);
        }
    }

    // get remaining item count
    var remain = maxItems - selectedList.length;
    $bonusProductList.find('.bonus-items-available').text(remain);
    if (remain <= 0) {
        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    } else {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
    }
}

function initializeGrid () {
    var $bonusProduct = $('#bonus-product-dialog'),
        $bonusProductList = $('#bonus-product-list'),
        bliData = $bonusProductList.data('line-item-detail');
    maxItems = bliData.maxItems;
    bliUUID = bliData.uuid;

    if (bliData.itemCount >= maxItems) {
        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    }

    var cartItems = $bonusProductList.find('.selected-bonus-item');
    cartItems.each(function () {
        var ci = $(this);
        var product = {
            uuid: ci.data('uuid'),
            pid: ci.data('pid'),
            qty: ci.find('.item-qty').text(),
            name: ci.find('.item-name').html(),
            attributes: {}
        };
        var attributes = ci.find('ul.item-attributes li');
        attributes.each(function () {
            var li = $(this);
            product.attributes[li.data('attributeId')] = {
                displayName:li.children('.display-name').html(),
                displayValue:li.children('.display-value').html()
            };
        });
        selectedList.push(product);
    });

    $bonusProductList.on('click', '.bonus-product-item a[href].swatchanchor', function (e) {
        e.preventDefault();
        var url = this.href,
            $this = $(this);
        url = util.appendParamsToUrl(url, {
            'source': 'bonus',
            'format': 'ajax'
        });
        $.ajax({
            url: url,
            success: function (response) {
                $this.closest('.bonus-product-item').empty().html(response);
                hideSwatches();
            }
        });
    })
    .on('change', '.input-text', function () {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
        $(this).closest('.bonus-product-form').find('.quantity-error').text('');
    })
    .on('click', '.select-bonus-item', function (e) {
        e.preventDefault();
        if (selectedList.length >= maxItems) {
            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            $bonusProductList.find('.bonus-items-available').text('0');
            return;
        }

        var form = $(this).closest('.bonus-product-form'),
            detail = $(this).closest('.product-detail'),
            uuid = form.find('input[name="productUUID"]').val(),
            qtyVal = form.find('input[name="Quantity"]').val(),
            qty = (isNaN(qtyVal)) ? 1 : (+qtyVal);

        if (qty > maxItems) {
            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
            return;
        }

        var product = {
            uuid: uuid,
            pid: form.find('input[name="pid"]').val(),
            qty: qty,
            name: detail.find('.product-name').text(),
            attributes: detail.find('.product-variations').data('attributes'),
            options: []
        };

        var optionSelects = form.find('.product-option');

        optionSelects.each(function () {
            product.options.push({
                name: this.name,
                value: $(this).val(),
                display: $(this).children(':selected').first().html()
            });
        });
        selectedList.push(product);
        updateSummary();
    })
    .on('click', '.remove-link', function (e) {
        e.preventDefault();
        var container = $(this).closest('.selected-bonus-item');
        if (!container.data('uuid')) { return; }

        var uuid = container.data('uuid');
        var i, len = selectedList.length;
        for (i = 0; i < len; i++) {
            if (selectedList[i].uuid === uuid) {
                selectedList.splice(i, 1);
                break;
            }
        }
        updateSummary();
    })
    .on('click', '.add-to-cart-bonus', function (e) {
        e.preventDefault();
        var url = util.appendParamsToUrl(Urls.addBonusProduct, {bonusDiscountLineItemUUID: bliUUID});
        var bonusProducts = getBonusProducts();
        if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
            bonusProducts.bonusproducts[0].product.qty = maxItems;
        }
        // make the server call
        $.ajax({
            type: 'POST',
            dataType: 'json',
            cache: false,
            contentType: 'application/json',
            url: url,
            data: JSON.stringify(bonusProducts)
        })
        .done(function () {
            // success
            page.refresh();
        })
        .fail(function (xhr, textStatus) {
            // failed
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        })
        .always(function () {
            $bonusProduct.dialog('close');
        });
    })
    .on('click', '#more-bonus-products', function (e) {
        e.preventDefault();
        var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;

        //get the next page of choice of bonus products
        var lineItemDetail = JSON.parse($('#bonus-product-list').attr('data-line-item-detail'));
        lineItemDetail.pageStart = lineItemDetail.pageStart + lineItemDetail.pageSize;
        $('#bonus-product-list').attr('data-line-item-detail', JSON.stringify(lineItemDetail));

        var url = util.appendParamsToUrl(Urls.getBonusProducts, {
            bonusDiscountLineItemUUID: uuid,
            format: 'ajax',
            lazyLoad: 'true',
            pageStart: lineItemDetail.pageStart,
            pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
            bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail.bpTotal
        });

        $.ajax({
            type: 'GET',
            cache: false,
            contentType: 'application/json',
            url: url
        })
        .done(function (data) {
            //add the new page to DOM and remove 'More' link if it is the last page of results
            $('#more-bonus-products').before(data);
            if ((lineItemDetail.pageStart + lineItemDetail.pageSize) >= $('#bonus-product-list').data().lineItemDetail.bpTotal) {
                $('#more-bonus-products').remove();
            }
        })
        .fail(function (xhr, textStatus) {
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        });
    });
}

var bonusProductsView = {
    /**
     * @function
     * @description Open the list of bonus products selection dialog
     */
    show: function (url) {
        var $bonusProduct = $('#bonus-product-dialog');
        // create the dialog
        dialog.open({
            target: $bonusProduct,
            url: url,
            options: {
                width: 795,
                title: Resources.BONUS_PRODUCTS
            },
            callback: function () {
                initializeGrid();
                hideSwatches();
            }
        });
    },
    /**
     * @function
     * @description Open bonus product promo prompt dialog
     */
    loadBonusOption: function () {
        var    self = this,
            bonusDiscountContainer = document.querySelector('.bonus-discount-container');
        if (!bonusDiscountContainer) { return; }

        // get the html from minicart, then trash it
        var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
        bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

        dialog.open({
            html: bonusDiscountContainerHtml,
            options: {
                width: 400,
                title: Resources.BONUS_PRODUCT,
                buttons: [{
                    text: Resources.SELECT_BONUS_PRODUCTS,
                    click: function () {
                        var uuid = $('.bonus-product-promo').data('lineitemid'),
                            url = util.appendParamsToUrl(Urls.getBonusProducts, {
                                bonusDiscountLineItemUUID: uuid,
                                source: 'bonus',
                                format: 'ajax',
                                lazyLoad: 'false',
                                pageStart: 0,
                                pageSize: 10,
                                bonusProductsTotal: -1
                            });
                        $(this).dialog('close');
                        self.show(url);
                    }
                }, {
                    text: Resources.NO_THANKS,
                    click: function () {
                        $(this).dialog('close');
                    }
                }]
            },
            callback: function () {
                // show hide promo details
                $('.show-promo-details').on('click', function () {
                    $('.promo-details').toggleClass('visible');
                });
            }
        });
    }
};

module.exports = bonusProductsView;

},{"./dialog":13,"./page":22,"./util":78}],6:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');
var util = require('./util');
var SessionAttributes = window.SessionAttributes;

/**
 * @function captcha    Used to display/control the scrim containing the simulated captcha code
 **/
module.exports = function () {
    /**
     * if the session.privacy.ratelimited element is present then show the notification
     * NOTE: You will probably want to replace this with a call to an actual CAPTCHA system to replace the simple one here
     */
    if (SessionAttributes.SHOW_CAPTCHA) {
        dialog.open({
            html: '<h3 class="h3">' + Resources.ARE_YOU_HUMAN + '</h3>',
            options: {
                closeOnEscape: false,
                dialogClass: 'no-close human-close',
                buttons: [{
                    text: Resources.OK,
                    click: function () {
                        var url = util.appendParamsToUrl(Urls.rateLimiterReset, {format: 'ajax'});
                        $.ajax({
                            url: url
                        });
                        $(this).dialog('close');
                    }
                }]
            }
        });
    }
};

},{"./dialog":13,"./util":78}],7:[function(require,module,exports){
'use strict';

var util = require('./util');

function init() {
    var KEY_COMPARE_PRODUCTS = 'slt_compare_products';
    var KEY_COMPARE_PRODUCTS_ENABLED = 'slt_compare_products_enabled';
    var KEY_LAST_VIEWED_PLP_URL = 'slt_last_viewed_plp_url';
    var KEY_COMPARE_PRODUCTS_SHOW_COACH_MARK  = 'slt_compare_products_show_coach_mark';
    var KEY_COMPARE_PRODUCTS_AB_TEST_MODE  = 'comparisonFeatureMode';

    window.setComparisonFeatureMode = function(mode) {
        var isSearchPage = digitalData.page.category.pageType === 'search listing';
        var isPLPPage = digitalData.page.category.pageType === 'product listing';

        var isEnabled = false;

        if (SitePreferences.comparisonFeatureEnabled && mode) {
            isEnabled = (isSearchPage && mode.includes('SEARCH')) || isPLPPage && mode.includes('PLP');
        }

        window.sessionStorage.setItem(KEY_COMPARE_PRODUCTS_AB_TEST_MODE, mode);

        var productSlots = $('.compare-products-bar .products .product:not(.empty)');
        var hasProducts = productSlots.length > 0;
        var isChecked = window.localStorage.getItem(KEY_COMPARE_PRODUCTS_ENABLED) === 'true';

        $('.compare-products-header').css('display', isEnabled ? 'flex' : 'none');
        $('.compare-products').css('display', isEnabled && isChecked ? 'flex' : 'none');
        $('.compare-products-bar').css('display', isEnabled && isChecked && hasProducts ? 'flex' : 'none');
    };

    var addProductToLocalStorage = function(masterId, sku, imageUrl) {
        var products = JSON.parse(window.localStorage.getItem(KEY_COMPARE_PRODUCTS) || '[]');

        var product = products.find(function(p) {
            return p.sku === sku;
        });

        if (!product) {
            products.push({
                masterId: masterId,
                sku: sku,
                imageUrl: imageUrl
            });

            window.localStorage.setItem(KEY_COMPARE_PRODUCTS, JSON.stringify(products));
        }
    };

    var removeProductFromLocalStorage = function(masterId) {
        var products = JSON.parse(window.localStorage.getItem(KEY_COMPARE_PRODUCTS) || '[]');

        products = products.filter(function(p) {
            return p.masterId !== masterId;
        });

        window.localStorage.setItem(KEY_COMPARE_PRODUCTS, JSON.stringify(products));
    };

    var updateComponents = function() {
        var productSlots = $('.compare-products-bar .products .product:not(.empty)');
        var isBarFull = productSlots.length > 2;

        if (isBarFull) {
            $('.compare-product-button:not(:disabled)').prop('disabled', true);
        } else {
            $('.compare-product-button:disabled').removeAttr('disabled');
        }

        var skus = productSlots.map(function() {
            var masterId = $(this).attr('data-itemid');
            $('button[data-itemid=' + masterId + '].compare-product-button').prop('disabled', true);

            return $(this).attr('data-sku');
        }).toArray();
        $('#compare-products-bar-compare-button').attr('href', '/compare?p=' + skus.join(','));

        var isChecked = $('#compare-products-toggle').is(':checked');
        $('.compare-products-bar').css('display', isChecked && productSlots.length > 0 ? 'flex' : 'none');

        // Move empty slots to the right in the comparison bar
        $('.compare-products-bar .products .product-wrapper').each(function() {
            if ($(this).find('.empty').length) {
                $(this).detach().insertAfter('.compare-products-bar .products .product-wrapper:last');
            }
        })
    };

    var removeProductFromBar = function(masterId) {
        var productSlot = $('.compare-products-bar .product[data-itemid=' + masterId + ']');

        productSlot.find('#compare-products-bar-product-image-' + masterId).remove();
        productSlot.attr('data-itemid', '');
        productSlot.attr('data-sku', '');
        productSlot.addClass('empty');
        productSlot.find('.remove').css('display', 'none');

        $('button[data-itemid=' + masterId + '].compare-product-button').removeAttr('disabled');

        updateComponents();

        removeProductFromLocalStorage(masterId);
    };

    var addProductToBar = function(masterId, sku, imageUrl) {
        var emptySlots = $('.compare-products-bar .products .product.empty');

        if (emptySlots.length <= 0) {
            return;
        }

        var emptySlot = emptySlots.first();

        var img = document.createElement('img');
        img.id = 'compare-products-bar-product-image-' + masterId;
        img.src = imageUrl;

        emptySlot.append(img); 
        emptySlot.attr('data-itemid', masterId);
        emptySlot.attr('data-sku', sku);
        emptySlot.removeClass('empty');

        emptySlot.find('.remove').css('display', 'block');

        updateComponents();

        addProductToLocalStorage(masterId, sku, imageUrl);
    }

    var toggleCompareProducts = function(enable) {
        $('.compare-products').css('display', enable ? 'flex' : 'none');

        var productSlots = $('.compare-products-bar .products .product:not(.empty)');
        $('.compare-products-bar').css('display', enable && productSlots.length > 0 ? 'flex' : 'none');
    };

    // Toggle on header to enable the comparison
    $(document).on('click', '#compare-products-toggle', function() {
        var isChecked = $(this).is(':checked');

        window.localStorage.setItem(KEY_COMPARE_PRODUCTS_ENABLED, isChecked);

        toggleCompareProducts(isChecked);
    });

    // Coach Mark
    $(document).on('click', '#compare-products-coach-mark', function () {
        $('#compare-products-coach-mark .tooltip').css('display', 'flex');

        $(document).on('click', '#compare-products-coach-mark-close', (e) => {
            e.stopPropagation();
            e.preventDefault();

            $('#compare-products-coach-mark').css('display', 'none');

            $('#compare-products-coach-mark .tooltip').css('display', 'none');

            window.localStorage.setItem(KEY_COMPARE_PRODUCTS_SHOW_COACH_MARK, false);
        });
    });

    // Button of each product to select it to compare
    $(document).on('click', '.compare-product-button', function() {
        var isDisabled = $(this).prop('disabled');
        var sku = $(this).val();
        var masterId = $(this).attr('data-itemid');

        if (!isDisabled) {
            $(this).attr('disabled', true);
            var imageUrl = $('img[data-sku=' + sku + ']').attr('src');

            addProductToBar(masterId, sku, imageUrl);
        }
    });

    // Button to remove product from comparison bar
    $(document).on('click', '.compare-products-bar .product .remove', function() {
        var masterId = $(this).parent().attr('data-itemid');

        removeProductFromBar(masterId);
    });

    // Button to remove all products from comparison bar
    $(document).on('click', '.compare-products-bar #compare-products-bar-clear-all-button', function() {
        var productSlots = $('.compare-products-bar .products .product:not(.empty)');

        productSlots.each(function() {
            var masterId = $(this).attr('data-itemid');

            removeProductFromBar(masterId);
        });
    });

    // Button to send to PWA comparison page
    $(document).on('click', '#compare-products-bar-compare-button', function() {
        window.localStorage.setItem(KEY_LAST_VIEWED_PLP_URL, location.pathname + location.search);
    });

    // Swatch list for products with variants
    $(document).on('click', '.swatch-list .swatch', function (e) {
        e.preventDefault();

        var sku = $(this).find('.varaintproductId').val();
        if (sku) {
            var image = $(this).parents('.product-card').find('.product-image-PLP img');
            image.attr('data-sku', sku);

            var checkbox = $(this).parents('.product-card').find('.compare-product-button');
            checkbox.val(sku);
        }

        updateComponents();
    });

    var loadProducts = function(products) {
        var showCoachMark = window.localStorage.getItem(KEY_COMPARE_PRODUCTS_SHOW_COACH_MARK) !== 'false';
        if (showCoachMark) {
            setTimeout(() => {
                $('#compare-products-coach-mark').css('display', 'block');
            }, 500);
        }

        var isEnabled = window.localStorage.getItem(KEY_COMPARE_PRODUCTS_ENABLED) === 'true';
        if (isEnabled) {
            var toggle = $('#compare-products-toggle');

            toggle.trigger('click');

            if (!toggle.is(':checked')) {
                toggle.trigger('click');
            }
        }

        if (products.length) {
            products.forEach(function(product) {
                $('button[data-itemid=' + product.masterId + '].compare-product-button').attr('disabled', true);

                addProductToBar(product.masterId, product.sku, product.imageUrl);
            });
        }

        var mode = window.sessionStorage.getItem(KEY_COMPARE_PRODUCTS_AB_TEST_MODE);

        window.setComparisonFeatureMode(mode || SitePreferences.comparisonFeatureMode);
    };

    // Handle tabs on Search Result page
    $(document).on('click', '#tabs [role=tablist] [role=tab]', function () {
        var isProductsTab = $(this).attr('aria-controls') === 'tabs-1';

        if (isProductsTab) {
            updateComponents();
        }

        var mode = window.sessionStorage.getItem(KEY_COMPARE_PRODUCTS_AB_TEST_MODE);
        window.setComparisonFeatureMode(mode || SitePreferences.comparisonFeatureMode);
    });

    var products = JSON.parse(window.localStorage.getItem(KEY_COMPARE_PRODUCTS) || '[]');
    var ids = products.map(function(product) {
        removeProductFromLocalStorage(product.masterId);

        return product.sku;
    });

    if (!ids.length) {
        loadProducts([]);

        return;
    }

    var url = util.appendParamsToUrl(Urls.GetProductsAvailability, {ids: ids.join(',')});
    $.ajax({
        dataType: 'json',
        url: url,
        success: function(response) {
            var availableProducts = [];

            products.forEach(function(product) {
                var p = response[product.sku];

                if (p && p.masterOnline && p.online && p.inStock) {
                    availableProducts.push(product);
                } else if (p && p.nextAvailableVariant) {
                    availableProducts.push(p.nextAvailableVariant);
                }
            });

            loadProducts(availableProducts);
        },
        error: function() {
            loadProducts(products);
        }
    });
}

module.exports = {
    init: init
};

},{"./util":78}],8:[function(require,module,exports){
'use strict';

var page = require('./page'),
    util = require('./util'),
    TPromise = require('promise');

var _currentCategory = '',
    MAX_ACTIVE = 4;

/**
 * @private
 * @function
 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
 */
function refreshContainer() {
    var $compareContainer = $('.compare-items');
    var $compareItems = $compareContainer.find('.compare-item');
    var numActive = $compareItems.filter('.active').length;

    if (numActive < 2) {
        $('#compare-items-button').attr('disabled', 'disabled');
    } else {
        $('#compare-items-button').removeAttr('disabled');
    }

    $compareContainer.toggle(numActive > 0);
}
/**
 * @private
 * @function
 * @description Adds an item to the compare container and refreshes it
 */
function addToList(data) {
    // get the first compare-item not currently active
    var $item = $('.compare-items .compare-item').not('.active').first(),
        $productTile = $('#' + data.uuid);

    if ($item.length === 0) {
        if ($productTile.length > 0) {
            $productTile.find('.compare-check')[0].checked = false;
        }
        window.alert(Resources.COMPARE_ADD_FAIL);
        return;
    }

    // if already added somehow, return
    if ($('[data-uuid="' + data.uuid + '"]').length > 0) {
        return;
    }
    // set as active item
    $item.addClass('active')
        .attr('data-uuid', data.uuid)
        .attr('data-itemid', data.itemid)
        .data('uuid', data.uuid)
        .data('itemid', data.itemid)
        .append($(data.img).clone().addClass('compare-item-image'));
}
/**
 * @private
 * @function
 * description Removes an item from the compare container and refreshes it
 */
function removeFromList($item) {
    if ($item.length === 0) {
        return;
    }
    // remove class, data and id from item
    $item.removeClass('active')
        .removeAttr('data-uuid')
        .removeAttr('data-itemid')
        .data('uuid', '')
        .data('itemid', '')
        // remove the image
        .find('.compare-item-image').remove();
}

function addProductAjax(args) {
    var promise = new TPromise(function(resolve, reject) {
        $.ajax({
            url: Urls.compareAdd,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function(response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_ADD_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function(jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function removeProductAjax(args) {
    var promise = new TPromise(function(resolve, reject) {
        $.ajax({
            url: Urls.compareRemove,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function(response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_REMOVE_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function(jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function shiftImages() {
    return new TPromise(function(resolve) {
        var $items = $('.compare-items .compare-item');
        $items.each(function(i, item) {
            var $item = $(item);
            // last item
            if (i === $items.length - 1) {
                return removeFromList($item);
            }
            var $next = $items.eq(i + 1);
            if ($next.hasClass('active')) {
                // remove its own image
                $next.find('.compare-item-image').detach().appendTo($item);
                $item.addClass('active')
                    .attr('data-uuid', $next.data('uuid'))
                    .attr('data-itemid', $next.data('itemid'))
                    .data('uuid', $next.data('uuid'))
                    .data('itemid', $next.data('itemid'));
            }
        });
        resolve();
    });
}

/**
 * @function
 * @description Adds product to the compare table
 */
function addProduct(args) {
    var promise;
    var $items = $('.compare-items .compare-item');
    var $cb = $(args.cb);
    var numActive = $items.filter('.active').length;
    if (numActive === MAX_ACTIVE) {
        if (!window.confirm(Resources.COMPARE_CONFIRMATION)) {
            $cb[0].checked = false;
            return;
        }

        // remove product using id
        var $firstItem = $items.first();
        promise = removeItem($firstItem).then(function() {
            return shiftImages();
        });
    } else {
        promise = TPromise.resolve(0);
    }
    return promise.then(function() {
        return addProductAjax(args).then(function() {
            addToList(args);
            if ($cb && $cb.length > 0) {
                $cb[0].checked = true;
            }
            refreshContainer();
        });
    }).then(null, function() {
        if ($cb && $cb.length > 0) {
            $cb[0].checked = false;
        }
    });
}

/**
 * @function
 * @description Removes product from the compare table
 * @param {object} args - the arguments object should have the following properties: itemid, uuid and cb (checkbox)
 */
function removeProduct(args) {
    var $cb = args.cb ? $(args.cb) : null;
    return removeProductAjax(args).then(function() {
        var $item = $('[data-uuid="' + args.uuid + '"]');
        removeFromList($item);
        if ($cb && $cb.length > 0) {
            $cb[0].checked = false;
        }
        refreshContainer();
    }, function() {
        if ($cb && $cb.length > 0) {
            $cb[0].checked = true;
        }
    });
}

function removeItem($item) {
    var uuid = $item.data('uuid'),
        $productTile = $('#' + uuid);
    return removeProduct({
        itemid: $item.data('itemid'),
        uuid: uuid,
        cb: ($productTile.length === 0) ? null : $productTile.find('.compare-check')
    });
}

/**
 * @private
 * @function
 * @description Initializes the DOM-Object of the compare container
 */
function initializeDom() {
    var $compareContainer = $('.compare-items');
    _currentCategory = $compareContainer.data('category') || '';
    var $active = $compareContainer.find('.compare-item').filter('.active');
    $active.each(function() {
        var $productTile = $('#' + $(this).data('uuid'));
        if ($productTile.length === 0) {
            return;
        }
        $productTile.find('.compare-check')[0].checked = true;
    });
    // set container state
    refreshContainer();
}

/**
 * @private
 * @function
 * @description Initializes the events on the compare container
 */
function initializeEvents() {
    // add event to buttons to remove products
    $('.compare-item').on('click touchstart', '.compare-item-remove', function() {
        removeItem($(this).closest('.compare-item'));
    });

    // Button to go to compare page
    $('#compare-items-button').on('click', function() {
        page.redirect(util.appendParamToURL(Urls.compareShow, 'category', _currentCategory));
    });

    // Button to clear all compared items
    // rely on refreshContainer to take care of hiding the container
    $('#clear-compared-items').on('click', function() {
        $('.compare-items .active').each(function() {
            removeItem($(this));
        });
    });
}

exports.init = function() {
    initializeDom();
    initializeEvents();
};

exports.addProduct = addProduct;
exports.removeProduct = removeProduct;

},{"./page":22,"./util":78,"promise":96}],9:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');
var util = require('./util');
/**
 * @function getConsent Used to display/control of the modal containing the consent management message
 **/

function getConsent() {
    dialog.open({
        url: Urls.consentTracking,
        options: {
            closeOnEscape: false,
            dialogClass: 'no-close',
            buttons: [{
                text: Resources.TRACKING_CONSENT,
                click: function() {
                    $(this).dialog('close');
                    $.ajax({
                        type: 'GET',
                        url: util.appendParamToURL(Urls.consentTrackingSetSession, 'consentTracking', true),
                        success: function() {
                            showPrivacyDialog();
                        },
                        error: function() {
                            showPrivacyDialog();
                        }
                    })
                }
            }, {
                text: Resources.TRACKING_NO_CONSENT,
                click: function() {
                    $(this).dialog('close');
                    $.ajax({
                        type: 'GET',
                        url: util.appendParamToURL(Urls.consentTrackingSetSession, 'consentTracking', false),
                        success: function() {
                            showPrivacyDialog();
                        },
                        error: function() {
                            showPrivacyDialog();
                        }
                    })
                }
            }]
        }
    });
}

function enablePrivacyCookies() {
    if (document.cookie.indexOf('dw=1') < 0) {
        document.cookie = 'dw=1; path=/; Secure';
    }
    if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
        document.cookie = 'dw_cookies_accepted=1; path=/;Secure';
    }
}

function showPrivacyDialog() {

    if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
        // check for privacy policy page
        if ($('.privacy-policy').length === 0) {
            dialog.open({
                url: Urls.cookieHint,
                options: {
                    closeOnEscape: false,
                    dialogClass: 'no-close',
                    buttons: [{
                        text: Resources.I_AGREE,
                        click: function() {
                            $(this).dialog('close');
                            enablePrivacyCookies();
                        }
                    }]
                }
            });
        }
    } else {
        // Otherwise, we don't need to show the asset, just enable the cookies
        enablePrivacyCookies();
    }
}
var consentTracking = {
    init: function() {
        if (consent == null && SitePreferences.CONSENT_TRACKING_HINT) { // eslint-disable-line no-undef
            getConsent();
        }

        if (consent != null && SitePreferences.CONSENT_TRACKING_HINT) { // eslint-disable-line no-undef
            showPrivacyDialog();
        }

    },
    show: function() {
        getConsent();
    }
};
module.exports = consentTracking;

},{"./dialog":13,"./util":78}],10:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');

/**
 * @function cookieprivacy    Used to display/control the scrim containing the cookie privacy code
 **/
module.exports = function() {
    /**
     * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
     * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
     */
    if (!SitePreferences.CONSENT_TRACKING_HINT && SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
        // check for privacy policy page
        if ($('.privacy-policy').length === 0) {
            dialog.open({
                url: Urls.cookieHint,
                options: {
                    closeOnEscape: false,
                    dialogClass: 'no-close',
                    buttons: [{
                        text: Resources.I_AGREE,
                        click: function() {
                            $(this).dialog('close');
                            enableCookies();
                        }
                    }]
                }
            });
        }
    } else {
        // Otherwise, we don't need to show the asset, just enable the cookies
        enableCookies();
    }

    function enableCookies() {
        if (document.cookie.indexOf('dw=1') < 0) {
            document.cookie = 'dw=1; path=/; Secure';
        }
        if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
            document.cookie = 'dw_cookies_accepted=1; path=/; Secure';
        }
    }
};

},{"./dialog":13}],11:[function(require,module,exports){
'use strict';

exports.init = function init () {
    $('.country-selector .current-country').on('click', function () {
        $('.country-selector .selector').toggleClass('active');
        $(this).toggleClass('selector-active');
    });
    // set currency first before reload
    $('.country-selector .selector .locale').on('click', function (e) {
        e.preventDefault();
        var url = this.href;
        var currency = this.getAttribute('data-currency');
        $.ajax({
            dataType: 'json',
            url: Urls.setSessionCurrency,
            data: {
                format: 'ajax',
                currencyMnemonic: currency
            }
        })
        .done(function (response) {
            if (!response.success) {
                throw new Error('Unable to set currency');
            }
            window.location.href = url;
        });
    });
};

},{}],12:[function(require,module,exports){
'use strict';

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

module.exports = {
    endDateCap: function(startDate, endDate) {
        var end = endDate;
        if (end.length <= 0){
            $('.class-applyrefinement').attr('disabled', 'disabled');
            $('.class-applyrefinement').addClass('button-disable-refinment');
            return;
        } else {
            $('.class-applyrefinement').removeAttr('disabled');
            $('.class-applyrefinement').removeClass('button-disable-refinment');
        }
        var start = startDate;
        if (start.length <= 0){
            $('.class-applyrefinement').attr('disabled', 'disabled');
            $('.class-applyrefinement').addClass('button-disable-refinment');
            return;
        } else {
            $('.class-applyrefinement').removeAttr('disabled');
            $('.class-applyrefinement').removeClass('button-disable-refinment');
        }
    },
    init: function() {

    }
};

},{}],13:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    _ = require('lodash'),
    imagesLoaded = require('imagesloaded');

var dialog = {
    option: function(option, value) {
        if (typeof value === 'undefined') {
            return this.$container.dialog('option', option);
        }
        return this.$container.dialog('option', option, value);
    },

    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function(params) {
        var $target, id;

        if (_.isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
            } else {
                $target = $('#' + params.target);
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else {
            $('#dialog-container').remove();
            $('<div id="dialog-container" class="dialog-content">').appendTo('body');
            $target = $('#dialog-container');
        }

        // if no element found, create one
        if ($target.length === 0) {
            if ($target.selector && $target.selector.charAt(0) === '#') {
                id = $target.selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(_.merge({}, this.settings, params.options || {}));
        return this.$container;
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function(params) {
        // close any open dialog
        this.close();
        this.create(params);
        this.replace(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function(params) {
        var content, position, callback;

        if (!this.$container) {
            return;
        }
        content = params.content || params.html;
        if (!content) {
            return;
        }
        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }
        if (!position) {
            position = this.settings.position;
        }
        imagesLoaded(this.$container).on('done', function() {
            this.$container.dialog('option', 'position', position);
        }.bind(this));

        callback = (typeof params.callback === 'function') ? params.callback : function() {};
        callback();
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function(params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function(response) {
                    params.content = response;
                    this.openWithContent(params);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function() {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');
    },
    exists: function() {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function() {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        resizable: false,
        title: '',
        width: '800',
        close: function() {
            $(this).dialog('close');
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

module.exports = dialog;

},{"./ajax":2,"./util":78,"imagesloaded":93,"lodash":94}],14:[function(require,module,exports){
'use strict';

module.exports = function () {

    if ($('input[name="eddEnabled"]').length > 0) {
    
        var zip = $('#user-input-text-zipcode').val();

        var reg = /^\d{5}(-\d{4})?$/;

        if (zip == '' || !reg.test(zip)) {
            $('#user-input-text-zipcode').val('');
            $('#user-input-text-zipcode').addClass('error-style');
            $('.estimated-delivery .errorMessage').text(zip == '' ? Resources.ZIPCODE_EMPTY : Resources.ZIPCODE_AVALIBILITY_CHAR);
            $('.estimated-delivery .errorMessage').css('display','block');
        } else {
            var queryString = '?zipCode='+zip;
            $.ajax({
                url: Urls.getedd + queryString,
                type: 'GET',
                success: function (data) {
                    var finalEDD = data.finalEDD;
                    if (isNaN(finalEDD)) {
                        $('#user-input-text-zipcode').addClass('error-style');
                        $('.estimated-delivery .errorMessage').text(Resources.ZIPCODE_CANT_FOUND);
                        $('.estimated-delivery .errorMessage').css('display','block');
                    } else {
                        var existingEDD = $('.estimated-delivery .estimation').text();
                        $('.estimated-delivery .estimation').text(finalEDD);
                        $('.estimated-delivery .errorMessage').css('display','none');
                        $('#user-input-text-zipcode').removeClass('error-style');
                        require('./gtm').onEDDChange(finalEDD, existingEDD);
                    }
                }
            });
        }

    }
}

},{"./gtm":18}],15:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util');
/**
 * @function
 * @description Load details to a given gift certificate
 * @param {String} id The ID of the gift certificate
 * @param {Function} callback A function to called
 */
exports.checkBalance = function (id, callback) {
    // load gift certificate details
    var url = util.appendParamToURL(Urls.giftCardCheckBalance, 'giftCertificateID', id);

    ajax.getJson({
        url: url,
        callback: callback
    });
};

},{"./ajax":2,"./util":78}],16:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    minicart = require('./minicart'),
    util = require('./util');

/*
 * @function
 * @description handle add gift certificate to cart
 * @param {event} add to cart click event
 */
var setAddToCartHandler = function (e) {
    e.preventDefault();
    var form = $(this).closest('form');

    var options = {
        url: util.ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };
    $.ajax(options).done(function (response) {
        if (response.success) {
            ajax.load({
                url: Urls.minicartGC,
                data: {lineItemId: response.result.lineItemId},
                callback: function (response) {
                    minicart.show(response);
                    form.find('input,textarea').val('');
                }
            });
        } else {
            form.find('span.error').hide();
            for (var id in response.errors.FormErrors) {
                var $errorEl = $('#' + id).addClass('error').removeClass('valid').next('.error');
                if (!$errorEl || $errorEl.length === 0) {
                    $errorEl = $('<span for="' + id + '" generated="true" class="error" style=""></span>');
                    $('#' + id).after($errorEl);
                }
                $errorEl.text(response.errors.FormErrors[id].replace(/\\'/g, '\'')).show();
            }
        }
    }).fail(function (xhr, textStatus) {
        // handle fail response 
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        } else {
            window.alert(Resources.SERVER_CONNECTION_ERROR);
        }
    });
};

exports.init = function () {
    $('#AddToBasketButton').on('click', setAddToCartHandler);
};

},{"./ajax":2,"./minicart":21,"./util":78}],17:[function(require,module,exports){
'use strict';

/**
 * Same-Day delivery is available for the product and postal code
 */
var enableSameDayDelivery = function(storeId, postalCode, selectOption) {
    if (storeId) {
        $('#goLocalStoreID').val(storeId);
    }
    var goLocalPostalCode = $('#golocal-pdp-delivery-to-value');
    if (postalCode) {
        goLocalPostalCode.text(postalCode);
        goLocalPostalCode.parent().removeClass('hidden');
        $('#golocal-pdp-not-available-for-value').text(postalCode);
    }
    $('.GoLocalOption.GoLocalOption__Eligible').removeClass('hidden');
    $('.GoLocalOption.GoLocalOption__NotEligible').addClass('hidden');
    $('#golocal-pdp-shipping').removeClass('not-eligible');
    $('[name="shipOption"][value="shipGoLocal"]').attr('disabled', false);

    if (selectOption) {
        $('[name="shipOption"]').prop('checked','false');
        $('[name="shipOption"][value="shipGoLocal"]').prop('checked','true').change();
    }
    $('#golocal-pdp-shipping-container .NotAvailable__container').addClass('hidden');
    $('#golocal-pdp-shipping-container .ShippingPrice__container').removeClass('hidden')
}

/**
 * Same-Day delivery is available for the product but not for the postal code
 */
var disableSameDayDelivery = function(postalCode) {
    var goLocalPostalCode = $('#golocal-pdp-not-available-for-value');
    var goLocalEnterLocation = $('#golocal-not-eligible-pdp-enter-your-location');
    if (postalCode) {
        goLocalPostalCode.text(postalCode);
        $('#golocal-pdp-delivery-to-value').text(postalCode);
        goLocalPostalCode.parent().removeClass('hidden');
        goLocalEnterLocation.addClass('hidden');
    } else if (goLocalPostalCode.text().trim()) {
        goLocalPostalCode.parent().removeClass('hidden');
        goLocalEnterLocation.addClass('hidden');
    } else {
        goLocalPostalCode.parent().addClass('hidden');
        goLocalEnterLocation.removeClass('hidden');
    }
    $('#golocal-pdp-shipping').addClass('not-eligible');
    $('.GoLocalOption.GoLocalOption__Eligible').addClass('hidden');
    $('.GoLocalOption.GoLocalOption__NotEligible').removeClass('hidden');
    $('[name="shipOption"]').prop('checked','false');
    $('[name="shipOption"][value="shipToAdress"]').prop('checked','true').change();
    $('[name="shipOption"][value="shipGoLocal"]').attr('disabled', true);
    $('#golocal-pdp-shipping-container .NotAvailable__container').addClass('hidden');
    $('#golocal-pdp-shipping-container .ShippingPrice__container').removeClass('hidden')
}

/**
 * Same-Day delivery is not available for the product
 */
var unavailableSameDayDelivery = function() {
    $('#golocal-pdp-shipping').addClass('not-eligible');

    $('#golocal-pdp-not-available-for-value').parent().addClass('hidden');
    $('#golocal-not-eligible-pdp-enter-your-location').addClass('hidden');

    $('#golocal-pdp-shipping-container .ShippingPrice__container').addClass('hidden');
    $('#golocal-pdp-shipping-container .NotAvailable__container').removeClass('hidden');

    $('.GoLocalOption.GoLocalOption__Eligible').addClass('hidden');
    $('.GoLocalOption.GoLocalOption__NotEligible').addClass('hidden');

    $('[name="shipOption"]').prop('checked','false');
    $('[name="shipOption"][value="shipToAdress"]').prop('checked','true').change();
    $('[name="shipOption"][value="shipGoLocal"]').attr('disabled', true);
}

var updateDeliveryDescriptions = function (storeTimeZone) {
    if (!storeTimeZone) {
        return;
    }

    $('input[name="goLocalStoreTimeZone"]').val(storeTimeZone);

    // Set the Store time zone. The new date still have the browser timezone,
    // but the hours and minutes are from the store time zone.
    var now = new Date(new Date().toLocaleString('en-US', {timeZone: storeTimeZone}));
    var current = now.getHours() * 100 + now.getMinutes();

    $('[data-golocalcutofftime]').each(function(_id, element){
        var $elem = $(element);
        var time = $elem.data('golocalcutofftime').split(':');
        var reference = Number(time[0]) * 100 + Number(time[1]);
        // Using > since hours and minutes are zero-based
        // 00:00 Means: it is always next day delivery
        // 23:59 Means: it is always same day delivery
        $elem.html(current > reference ? $(element).data('nextdaytext') : $(element).data('samedaytext'));
        $('#goLocalDelivery').val(current >= reference ? 'next-day' : 'same-day');
    });
}

var checkUserAddressEligibility = function(pid, qty) {
    if (!$('input[name="goLocalPostalCode"]').val()) {
        return;
    }

    var url = Urls.GetUserAddressEligibility 
    + (Urls.GetUserAddressEligibility.indexOf('?') > 0 ? '&' : '?')
    + 'pid=' + pid
    + '&qty=' + qty;

    $.ajax({
        url: url,
        type: 'POST',
        success: function(response) {
            $('#golocal-pdp-enter-your-location').addClass('hidden');
            if (response.success) {
                enableSameDayDelivery(response.store.id, null, false);
                updateDeliveryDescriptions(response.store.timeZone);
            } else if (response.code === 'NOT_ELIGIBLE') {
                unavailableSameDayDelivery();
            } else {
                disableSameDayDelivery();
            }
        }
    });
}

var checkEligibility = function(pid, quantity, latitude, longitude, onSuccess) {
    var url = Urls.GetEligibility 
    + (Urls.GetEligibility.indexOf('?') > 0 ? '&' : '?')
    + 'pid=' + pid
    + '&qty=' + quantity
    + '&lat=' + latitude
    + '&lng=' + longitude;

    $.ajax({
        url: url,
        type: 'POST',
        success: onSuccess
    });
}

var checkEligibilityForPDP = function(userAddress) {
    if (!userAddress || !userAddress.postalCode) {
        return;
    }

    var pid = $('input[name="pid"]').val();
    var qty = $('input[name="Quantity"]').val();
    var isProductVariant = $('input[name="isProductVariant"]').val() === 'true';

    if (!isProductVariant || Number.isNaN(pid) || Number.isNaN(qty)) {
        return;
    }

    var onSuccess = function(response) {
        $('#golocal-pdp-enter-your-location').addClass('hidden');
        if (response.success) {
            enableSameDayDelivery(response.store.id, userAddress.postalCode, true);
            updateDeliveryDescriptions(response.store.timeZone);
        } else if (response.code === 'NOT_ELIGIBLE') {
            unavailableSameDayDelivery();
        } else {
            disableSameDayDelivery(userAddress.postalCode);
        }
    };

    checkEligibility(
        pid,
        qty,
        userAddress.latitude,
        userAddress.longitude,
        onSuccess
    );
}

var updateStore = function(address, onSuccess) {
    if (address.postalCode && (!address.isIPAddress || !$('input[name="goLocalPostalCode"]').val())) {
        $('input[name="goLocalPostalCode"]').val(address.postalCode);
    }

    var pid = $('input[name="pid"]').val();
    var qty = $('input[name="Quantity"]').val();
    if (!pid || !qty || pid.toUpperCase().startsWith('PRO-')) {
        return;
    }

    var url = Urls.UpdateStore + '?pid=' + pid + '&qty=' + qty;

    $.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(address),
        success: function(response) {
            if (response.store) {
                $('#goLocalStoreID').val(response.store.id);
            }

            if (typeof onSuccess === 'function') {
                onSuccess(response);
            }
        }
    });
}

var init = function() {
    var timeZone = $('input[name="goLocalStoreTimeZone"]').val();
    updateDeliveryDescriptions(timeZone);
}

module.exports = {
    init: init,
    checkEligibility: checkEligibility,
    checkEligibilityForPDP: checkEligibilityForPDP,
    checkUserAddressEligibility: checkUserAddressEligibility,
    disableSameDayDelivery: disableSameDayDelivery,
    enableSameDayDelivery: enableSameDayDelivery,
    updateDeliveryDescriptions: updateDeliveryDescriptions,
    updateStore: updateStore
}

},{}],18:[function(require,module,exports){
'use strict';

var util = require('./util');

/**
 * My Account Forgot Password - Fire when user initiates forgot password procedure
 */
/*
exports.forgotPassword = function() {
    dataLayer.push({
        'event': 'myAccountForgot', // case sensitive - use exact value
        'eventCategory': pageContext.type,
        'eventAction': 'Retrieve Password',
        'eventLabel': 'Forgot Password'
    });
};
*/

/**
 * Variant Click Event - Fire when a user clicks on a visible variant swatch on PDP/Quick view
 */
exports.onSearch = function (param) {
    if (digitalData != null && digitalData != undefined) {
        var ddSearchEvent = {
            'eventInfo': {
                'eventName': 'search',
                'type': 'search',
                'timeStamp': new Date(),
                'processed': {
                    'adobeAnalytics': false //dtm will change this to true once processed
                }
            },
            'searchTerm': param,
            'search': {
                'term': param
            }
        };

        //Push it onto the event array on digitalData object
        window.digitalData = window.digitalData || {};
        window.digitalData.event = window.digitalData.event || [];
        window.digitalData.event.push(ddSearchEvent);

        sendCustomEvent('search');
    }

    dataLayer.push({
        'event': 'search',
        'eventCategory': 'search',
        'searchTerm': param,
        'search': {
            'term': param
        }
    });
}


/**
 * All-page geolocation KPI (SLTBE-8783). Fired once per page view with the
 * browser Geolocation permission outcome plus the resolved city/zip — city
 * and zipCode come from wherever the location resolved (browser GPS or the
 * IP fallback via GoLocal-GeoLocate).
 */
exports.onGeolocationCaptured = function (geoPermission, city, zipCode) {
    dataLayer.push({
        'event': 'geolocation_captured',
        'geolocation': {
            'geoPermission': geoPermission,
            'city': city,
            'zipCode': zipCode
        }
    });
};

exports.onSearchSuggestionClick = function(searchTerm, searchSuggestion) {
    dataLayer.push({
        'event': 'click_search_suggestion',
        'search': {
            'term': searchTerm,
            'suggestionSelected': searchSuggestion
        }
    });
};

exports.onCLPPageView = function (classType, storeId, storeName) {
    try {
        if (!isGTMEnabled ||
            !window.digitalData ||
            !window.digitalData.page ||
            !window.digitalData.page.category ||
            window.digitalData.page.category.pageType != 'classes listing') {
            return;
        }

        dataLayer.push({
            event: 'clp_page_view',
            category: window.digitalData.page.category,
            filterClassType: classType,
            filterStoreId: storeId,
            filterStoreName: storeName
        });
    } catch (e) {
        window.console.warn(e);
    }
};

//TEB-121
exports.emailcheckou = function() {
    $(document).ready(function() {
        if (digitalData.page.pageInfo.pageName == 'Checkout: Step 3 - Review'){
            var isbillingemailval = $('.isbillingemailval').val();
            window.digitalData.cart.email = isbillingemailval; 
        }
    });
};

exports.onEDDChange = function(newValue, currentValue) {
    window.digitalData = window.digitalData || {};
    window.digitalData.page = window.digitalData.page || {};
    window.digitalData.page.pageInfo = window.digitalData.page.pageInfo || {};
    window.digitalData.page.pageInfo.EDD = newValue; 
    if (newValue != currentValue) {
        dataLayer.push({'event': 'optimize.activate'});
    }
};

/**
 * Variant Click Event - Fire when a user clicks on a visible variant swatch on PDP/Quick view
 */
exports.variantClick = function () {
    if (digitalData == null || digitalData == undefined) {
        return;
    }
    var product, variant;
    var sku = $('.product-number span.prodSku').length > 0 ? $('.product-number span.prodSku').text() : '';
    if (!(digitalData.product == undefined) && !(digitalData.product.length == 0) && !(digitalData.product[0].productInfo == undefined)) {
        product = digitalData.product[0];
        variant = digitalData.product[0].skuVariant[sku];
    } else if ($('#QuickViewDialog').length > 0) {
        //Filter logic
        var productID = $('.product-number span.prodSku').length > 0 ? $('.product-number span.prodSku').data('masterid') : '';
        product = digitalData.event.filter(function (obj) {
            return obj.eventInfo.eventName == 'quickView' && obj.product[0].productInfo.productID == productID;
        })[0].product[0];
        variant = product ? product.skuVariant[sku] : '';
    }
    if (variant == null || variant == undefined) {
        sku = '';
    }
    if (product == null || product == undefined) {
        return;
    }
    window.digitalData = window.digitalData || {};
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push({
        'eventInfo': {
            'eventName': 'skuSelection',
            'type': 'product interaction',
            'timeStamp': new Date(),
            'processed': {
                'adobeAnalytics': false
            }
        },
        'product': [{
            'productInfo': {
                'productName': product.productInfo.productName,
                'productID': product.productInfo.productID,
                'sku': sku,
                'findInStore': !(variant == '' || variant == undefined) ? variant.findInStore : '',
                'availability': !(variant == '' || variant == undefined) ? variant.availability : '',
                'shipping': !(variant == '' || variant == undefined) ? variant.shipping : ''
            },
            'category': {
                'productType': 'Merch: variants'
            }
        }]
    });
    sendCustomEvent('skuSelection');
};

/**
 * Product Click from Recommendation Zone - Fire when a user clicks a recommended item in the PDP Recommendation Zone
 */
/*
exports.productClickRecPDP = function($this) {

    var sku = $this.find('.capture-product-id').text();
    var impression = pageData.ecommerce.detail.impressions.filter(function(obj) {
        return obj.id == sku;
    })[0];

    dataLayer.push({
        'event': 'productClick',
        'productClicked': sku,
        'eventAction': 'product click',
        'eventLabel': '', //Product List Value ie. category name / search result
        'ecommerce': {
            'currencyCode': pageData.ecommerce.currencyCode,
            'click': {
                'actionField': {
                    'list': 'PDP you might also like'
                },
                'products': [{
                    'name': impression.name,
                    'id': impression.id,
                    'price': impression.price,
                    'category': impression.category,
                    'list': impression.list, // value will need to persist to the purchase event
                    'position': impression.position
                }]
            }
        }
    });
};
*/

/**
 *  Category Page Sort - Fire when a user changes the sort by value on the category grid page
 */
/*
exports.sort = function(sortID) {
    dataLayer.push({
        'event': 'pageSort',
        'eventCategory': pageContext.type,
        'eventAction': 'page sort',
        'eventLabel': 'category page sort: ' + sortID //Note naming convention
    });
};
*/

/**
 *  Category Page Refinement - Fire when a user makes a category refinement selection
 */
/*
exports.refinement = function($this) {

    if ($this.parents('.refinement').length === 0) {
        return;
    }

    var refinementType = $this.parents('.refinement').find('h3').text();
    var refinementValue = $this.text();
    dataLayer.push({
        'event': 'pageRefinement',
        'eventCategory': pageContext.type,
        'eventAction': 'category refinement',
        'eventLabel': 'category page refinement: ' + (refinementType ? refinementType.replace(/(?:\r\n|\r|\n)/g, '') : '') + ': ' + (refinementValue ? refinementValue.replace(/(?:\r\n|\r|\n)/g, '') : ''),
        'refinementType': refinementType ? refinementType.replace(/(?:\r\n|\r|\n)/g, '') : '',
        'refinementValue': refinementValue ? refinementValue.replace(/(?:\r\n|\r|\n)/g, '') : ''
    });
};

*/

/**
 *  Add to Cart - Fires when a user adds an item from wishlist
 */
exports.addToCartFromwishlist = function ($form) {
    if (digitalData == null || digitalData == undefined) {
        return;
    }
    var product , location;
    var registryID = '';
    var sku = $form.closest('div').parent().find('div.product-list-item .sku span.value').text();
    if (!(digitalData.product == undefined) && !(digitalData.product.length == 0)) {
        product = digitalData.product.filter(function (obj) {
            return obj.productInfo.sku == sku;
        })[0];
    } else {
        return;
    }
    if ($form.closest('div').parent().hasClass('wishlist')) {
        location = 'wishlist';
    } else if ($form.closest('div').parent().hasClass('gift-registry')) {
        location = 'registry';
        registryID = product.productInfo.registryID;
    }

    window.digitalData = window.digitalData || {};
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push({
        'eventInfo': {
            'eventName': 'persistedListAddition',
            'type': 'persisted list',
            'location': location,
            'registryID': registryID,
            'target': 'cart',
            'timeStamp': new Date(),
            'processed': {
                'adobeAnalytics': false
            }
        },
        'product': [{
            'productInfo': {
                'productName': product.productInfo.productName,
                'productID': product.productInfo.productID,
                'sku': sku,
                'findInStore': product.productInfo.findInStore,
                'availability': product.productInfo.availability,
                'shipping': product.productInfo.shipping
            },
            'category': {
                'productType': product.category.productType
            },
            'quantity': $form.find('input[name="Quantity"]').val()
        }]
    });
    sendCustomEvent('persistedListAddition');
};

/**
 *  Add to Cart - Fires when a user adds an item to their shopping cart
 */
exports.addToCart = function ($form) {
    if (digitalData == null || digitalData == undefined) {
        return;
    }
    var product, location, variant;
    var sku = $('.product-number span.prodSku').length > 0 ? $('.product-number span.prodSku').first().text() : '';
    if (!(digitalData.product == undefined) && !(digitalData.product.length == 0) && !(digitalData.product[0].productInfo == undefined)) {
        product = digitalData.product[0];
        variant = sku ? digitalData.product[0].skuVariant[sku] : digitalData.product[0].productInfo.variant;
        location = digitalData.page.category.pageType;
    } else if ($('#QuickViewDialog').length > 0) {
        //Filter logic
        var productID = $('.product-number span.prodSku').length > 0 ? $('.product-number span.prodSku').data('masterid') : '';
        product = digitalData.event.filter(function (obj) {
            return obj.eventInfo.eventName == 'quickView' && obj.product[0].productInfo.productID == productID;
        })[0].product[0];
        location = 'quick view';
        variant = product ? product.skuVariant[sku] : '';
    }

    if (variant == null || variant == undefined) {
        sku = '';
    }

    if (product == null || product == undefined) {
        return;
    }

    var price = null;

    try {
        price = product.productInfo.price;
        if (price && price !== '0.01') {
            price = parseFloat(price);
        } else {
            var val = $form.find('input[name$=giftcard_customAmount]').val() || $('.price-details .product-price .price').text();
            if (val) {
                price = parseFloat(val.substring(1));
                digitalData.product[0].productInfo.price = price;
            }
        }
    } catch (e) {
        // Ignore
        window.console.error(e);
    }

    var quantity = parseInt($form.find('input[name="Quantity"]').val() || 1, 10);

    // Both GTMGetGlobalData and GTMGetMetaEventId are independent — pid is
    // known up front, so fire them concurrently and merge the results.
    // Tracking must not be blocked by the BFF call; each branch degrades
    // gracefully to an empty eventId on failure.
    var pid = product.productInfo.sku || product.productInfo.productID;
    var globalDataReq = Promise.resolve($.ajax({
        type: 'GET',
        url: util.ajaxUrl(Urls.GTMGetGlobalData)
    }));
    var metaEventIdReq = Promise.resolve($.ajax({
        type: 'GET',
        url: util.ajaxUrl(Urls.GTMGetMetaEventId),
        data: {pid: pid}
    })).then(function (metaRes) {
        return (metaRes && metaRes.eventId) || '';
    }, function () {
        return '';
    });

    Promise.all([globalDataReq, metaEventIdReq]).then(function (results) {
        var response = results[0];
        var eventId = results[1];
        response.event = 'addToCart';
        response.action = 'add';
        response.source = 'PDP';
        response.eventId = eventId;
        response.ecommerce = {
            'currencyCode': 'USD',
            'add': {
                'products': [{
                    'id': product.productInfo.productID,
                    'name': product.productInfo.productName,
                    'price': price,
                    'category': product.productInfo.category,
                    'brand': product.productInfo.brand,
                    'variant': product.productInfo.sku, //variation product id
                    'quantity': quantity
                }]
            }
        };
        dataLayer.push(response);
    });

    window.digitalData = window.digitalData || {};
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push({
        'eventInfo': {
            'eventName': 'persistedListAddition',
            'type': 'persisted list',
            'location': location,
            'registryID': '',
            'target': 'cart',
            'timeStamp': new Date(),
            'processed': {
                'adobeAnalytics': false
            }
        },
        'product': [{
            'productInfo': {
                'productName': product.productInfo.productName,
                'productID': product.productInfo.productID,
                'sku': sku,
                'findInStore': !(variant == null && variant == undefined) ? variant.findInStore : '',
                'availability': !(variant == null && variant == undefined) ? variant.availability : '',
                'shipping': !(variant == null && variant == undefined) ? variant.shipping : ''
            },
            'category': {
                'productType': product.category.productType
            },
            'quantity': $form.find('input[name="Quantity"]').val()
        }]
    });
    sendCustomEvent('persistedListAddition');
};
/**
 *  Select Variant - Fires when a user changes the date or location of a cooking class
 */
exports.selectVariant = function (variantSku) {
    if (digitalData == null || digitalData == undefined) {
        return;
    }
    if (!(digitalData.product) || !(digitalData.product.length) || !(digitalData.product[0].productInfo)) {
        return;
    }
    var product = digitalData.product[0];
    // Caller passes the freshly-selected variant SKU (parsed from the AJAX response).
    // digitalData.product[0].productInfo.sku is set server-side at initial render and
    // is stale after an in-place AJAX content update, so we cannot rely on it here.
    // Fallback chain: explicit param -> #pid input value -> .prodSku text -> digitalData.
    var pidVal = ($('#product-content #pid').val() || $('#pid').val() || '').toString().trim();
    var prodSkuText = $('#product-content .product-number .prodSku').first().text().trim()
        || $('.product-number .prodSku').first().text().trim();
    var variant = (variantSku && String(variantSku).trim()) || pidVal || prodSkuText || product.productInfo.sku;
    var price = null;

    try {
        price = product.productInfo.price;
        if (price && price !== '0.01') {
            price = parseFloat(price);
        }
    } catch (e) {
        window.console.error(e);
    }

    Promise.resolve($.ajax({
        type: 'GET',
        url: util.ajaxUrl(Urls.GTMGetGlobalData)
    })).then(function (response) {
        response.event = 'select_variant';
        response.action = 'select';
        response.source = 'CDP';
        response.ecommerce = {
            'currencyCode': 'USD',
            'select': {
                'products': [{
                    'id': product.productInfo.productID,
                    'name': product.productInfo.productName,
                    'price': price,
                    'category': product.productInfo.category,
                    'brand': product.productInfo.brand,
                    'variant': variant,
                    'quantity': 1
                }]
            }
        };

        dataLayer.push(response);
    });
};
/**
 *  Add to Wishlist - Fires when a user adds an item to their Wishlist
 */
exports.addToWishlist = function () {
    if (digitalData == null || digitalData == undefined) {
        return;
    }
    var product, location, variant;
    var sku = $('.product-number span').length > 0 ? $('.product-number span').first().text() : '';
    if (!(digitalData.product == undefined) && !(digitalData.product.length == 0) && !(digitalData.product[0].productInfo == undefined)) {
        product = digitalData.product[0];
        variant = digitalData.product[0].skuVariant[sku];
        location = 'product detail';
    } else if ($('#QuickViewDialog').length > 0) {
        //Filter logic
        var productID = $('.product-number span.prodSku').length > 0 ? $('.product-number span.prodSku').data('masterid') : '';
        product = digitalData.event.filter(function (obj) {
            return obj.eventInfo.eventName == 'quickView' && obj.product[0].productInfo.productID == productID;
        })[0].product[0];
        location = 'quick view';
        variant = product ? product.skuVariant[sku] : '';
    }

    if (variant == null || variant == undefined) {
        sku = '';
    }

    if (product == null || product == undefined) {
        return;
    }
    window.digitalData = window.digitalData || {};
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push({
        'eventInfo': {
            'eventName': 'persistedListAddition',
            'type': 'persisted list',
            'location': location,
            'target': 'wishlist',
            'timeStamp': new Date(),
            'processed': {
                'adobeAnalytics': false
            }
        },
        'product': [{
            'productInfo': {
                'productName': product.productInfo.productName,
                'productID': product.productInfo.productID,
                'sku': sku,
                'findInStore': !(variant == '' || variant == undefined) ? variant.findInStore : '',
                'availability': !(variant == '' || variant == undefined) ? variant.availability : '',
                'shipping': !(variant == '' || variant == undefined) ? variant.shipping : ''
            },
            'category': {
                'productType': product.category.productType
            },
            'quantity': $('input[name="Quantity"]').length > 0 ? $('input[name="Quantity"]').val() : ''
        }]
    });
    sendCustomEvent('persistedListAddition');
};

/**
 *  Add to GiftRegistry - Fires when a user adds an item to their GiftRegistry
 */
exports.addToGiftRegistry = function() {
    if (digitalData == null || digitalData == undefined) {
        return;
    }
    var product, location, variant;
    var sku = $('.product-number span').length > 0 ? $('.product-number span').first().text() : '';
    if (!(digitalData.product == undefined) && !(digitalData.product.length == 0) && !(digitalData.product[0].productInfo == undefined)) {
        product = digitalData.product[0];
        variant = digitalData.product[0].skuVariant[sku];
        location = 'product detail';
    } else if ($('#QuickViewDialog').length > 0) {
        //Filter logic
        var productID = $('.product-number span.prodSku').length > 0 ? $('.product-number span.prodSku').data('masterid') : '';
        product = digitalData.event.filter(function (obj) {
            return obj.eventInfo.eventName == 'quickView' && obj.product[0].productInfo.productID == productID;
        })[0].product[0];
        location = 'quick view';
        variant = product ? product.skuVariant[sku] : '';
    }
    
    if (variant == null || variant == undefined) {
        sku ='';
    }

    if (product == null || product == undefined) {
        return;
    }
    window.digitalData = window.digitalData || {};
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push({
        'eventInfo': {
            'eventName': 'persistedListAddition',
            'type': 'persisted list',
            'location': location,
            'registryID': product.productInfo.registryID,
            'target': 'registry',
            'timeStamp': new Date(),
            'processed': {
                'adobeAnalytics': false
            }
        },
        'product': [{
            'productInfo': {
                'productName': product.productInfo.productName,
                'productID': product.productInfo.productID,
                'sku': sku,
                'findInStore': !(variant == '' || variant == undefined) ? variant.findInStore : '',
                'availability': !(variant == '' || variant == undefined) ? variant.availability : '',
                'shipping': !(variant == '' || variant == undefined) ? variant.shipping : ''
            },
            'category': {
                'productType': product.category.productType
            },
            'quantity': $('input[name="Quantity"]').length > 0 ? $('input[name="Quantity"]').val() : ''
        }]
    });
    sendCustomEvent('persistedListAddition');
};

/**
 *  Size Chart - When a user views the sizing chart information page on PDP
 */
/*
exports.sizeChart = function() {
    dataLayer.push({
        'event': 'sizeChart',
        'eventCategory': pageContext.type,
        'eventAction': 'product size chart',
        'eventLabel': $('.product-col-2').find('input[name="pid"]').val() + ':' + $('.product-col-2 .product-name').text()
    });
};
*/

/**
 * Find in Store - Fire when a user clicks "Find in Store" on PDP
 */
/*
exports.findInStorePDP = function() {
    dataLayer.push({
        'event': 'findInStore',
        'eventCategory': pageContext.type,
        'eventAction': 'find in store - initiate',
        'eventLabel': $('.product-col-2').find('input[name="pid"]').val() + ':' + $('.product-col-2 .product-name').text()
    });
};
*/

/**
 * Find in Store � Zip Code Search - Fire when a user searches their zip code for product availability
 */

exports.findInStoreSearchPDP = function (zipcode, stores) {
    if (digitalData == null || digitalData == undefined) {
        return;
    }
    var product, location, category, productInfo;
    if (digitalData.product !== null && digitalData.product !== undefined) {
        product = digitalData.product[0].productInfo;
        category = digitalData.product[0].category;
        location = 'product detail';
    } else if (digitalData.pageContext == 'search' && $('#QuickViewDialog').length > 0) {
        var productID = $('.product-number span.prodSku').length > 0 ? $('.product-number span.prodSku').data('masterid') : '';
        location = 'quick view';
        product = digitalData.event.filter(function (obj) {
            return obj.eventInfo.eventName == 'quickView' && obj.product[0].productInfo.productID == productID;
        })[0].product[0];
        productInfo = product.productInfo;
        category = product.category;
    }


    var ddFindInStoreEvent = {};
    ddFindInStoreEvent.eventInfo = {};
    ddFindInStoreEvent.eventInfo.eventName = 'findInStore';
    ddFindInStoreEvent.eventInfo.type = 'locate product';
    ddFindInStoreEvent.eventInfo.location = location;
    ddFindInStoreEvent.eventInfo.timeStamp = new Date();
    ddFindInStoreEvent.eventInfo.timeStamp.processed = {};
    ddFindInStoreEvent.eventInfo.timeStamp.processed.adobeAnalytics = false;
    
    ddFindInStoreEvent.product = [];
    ddFindInStoreEvent.product.push({
        'productInfo': productInfo,
        'category': category
    });
    
    if (ddFindInStoreEvent.product.length > 0 && ddFindInStoreEvent.product[0].productInfo != undefined && ddFindInStoreEvent.product[0].productInfo.sku != undefined) {
        ddFindInStoreEvent.product[0].productInfo.sku = $('input[name="pid"]').val();
    }
    
    ddFindInStoreEvent.findInStore = {};
    ddFindInStoreEvent.findInStore.params = {};
    ddFindInStoreEvent.findInStore.params.zipCode = zipcode;
    ddFindInStoreEvent.findInStore.params.radius = '100';    
    ddFindInStoreEvent.findInStore.results = {};
    ddFindInStoreEvent.findInStore.results.status = 'failure';   //"success" (if sku found in any store) or "failure"
    ddFindInStoreEvent.findInStore.results.locations = [];
    
    for (var i = 0; i < stores.length; i++) {
        var store = stores[i];
        if (store.status == 'Available In Store') {
            ddFindInStoreEvent.findInStore.results.status = 'success';
        }
        ddFindInStoreEvent.findInStore.results.locations.push({
            'locationID': 'LOC-' + store.storeId,
            'distance': '',
            'availability': store.status
        });
    }
    
    //Push it onto the event array on digitalData object
    window.digitalData = window.digitalData || {};
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push(ddFindInStoreEvent);
    
    sendCustomEvent('findInStore');
};


/**
 * Find in Store - Zip Code Search - Fire when a user searches their zip code for product availability
 */
/*
exports.bisnPDP = function() {
    dataLayer.push({
        'event': 'backInStock',
        'eventCategory': pageContext.type,
        'eventAction': 'back in stock click',
        'eventLabel': $('.product-col-2').find('input[name="pid"]').val() + ':' + $('.product-col-2 .product-name').text()
    });
};
*/

/**
 * Newsletter subscription event - Fire event when user moves to next step of checkout process
 */
/*
exports.newsLetterSignupCheckout = function() {
    dataLayer.push({
        'event': 'newsletterSubscriptionCheckout',
        'eventCategory': 'checkout',
        'eventAction': 'subscribe to newsletter',
        'eventLabel': $('input[name$="billing_billingAddress_addToEmailList"]').is(':checked') ? 'checked' : 'unchecked'
    });
};
*/

/**
 * Add to Wishlist / Save for Later - Fires when a user adds an item to their wishlist
 */
/*
exports.addToWishlistPDP = function($this) {
    if ($this.data('action') !== 'wishlist') {
        return;
    }
    dataLayer.push({
        'event': 'saveProduct',
        'eventCategory': pageContext.type,
        'eventAction': 'save for later',
        'eventLabel': $('.product-col-2').find('input[name="pid"]').val() + ':' + $('.product-col-2 .product-name').text()
    });
};
*/

/**
 * Promotion code applied - TIMING: Fires when a user adds an item to their shopping cart
 */

exports.applyCoupon = function(code, success, couponType) {
    var ddPromoApplicationEvent = {};
    ddPromoApplicationEvent.eventInfo = {};

    ddPromoApplicationEvent.promoData = {};
    ddPromoApplicationEvent.eventInfo.eventName = 'promoApplication';
    ddPromoApplicationEvent.eventInfo.type = 'promo';
    ddPromoApplicationEvent.eventInfo.timeStamp = new Date();
    ddPromoApplicationEvent.eventInfo.processed = {};
    ddPromoApplicationEvent.eventInfo.processed.adobeAnalytics = false;

    ddPromoApplicationEvent.promoData['promo code'] = code;
    ddPromoApplicationEvent.promoData['promo type'] = couponType;
    ddPromoApplicationEvent.promoData.success = success;
    
    window.digitalData = window.digitalData || {};
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push(ddPromoApplicationEvent);
    sendCustomEvent('promoApplication');
};

/**
 * Creates and dispatches an event trigger
 * @param {String} evt - The name of the event
 */
var sendCustomEvent = function(evt) {
    var event;
    if (document.createEvent && document.body.dispatchEvent) {
        event = document.createEvent('Event');
        event.initEvent(evt, true, true); //can bubble, and is cancellable
        document.body.dispatchEvent(event);
    } else if (window.CustomEvent && document.body.dispatchEvent) {
        event = new CustomEvent(evt, {
            bubbles: true,
            cancelable: true
        });
        document.body.dispatchEvent(event);
    }
}

exports.sendCustomEvent = sendCustomEvent;

exports.onNewsletterEmailSignUp = function(email) {
    if (!isGTMEnabled) {
        return;
    }

    dataLayer.push({
        'event': 'newsletterEmailSignUp',
        'email': email
    });
};

/**
 * Read the most recent value of a key from the GTM dataLayer. The Meta event
 * ids are pushed flat at render (gtmrenderdatalayer.isml) before the container
 * loads; this lets the browser hand them back to the BFF for the server-side
 * CAPI dispatch so the two hits dedup on a shared id.
 */
function findInDataLayer(key) {
    if (!window.dataLayer || !window.dataLayer.length) {
        return '';
    }
    for (var i = window.dataLayer.length - 1; i >= 0; i--) {
        if (window.dataLayer[i] && window.dataLayer[i][key]) {
            return window.dataLayer[i][key];
        }
    }
    return '';
}

/**
 * Fire-and-forget the SiteGenesis server-side Meta CAPI conversion. Only the
 * event name, the render-minted id, the product id (ViewContent) and the page
 * url travel from the browser — GoogleTagManager-Conversion reads every customer
 * signal from the shopper session and forwards it to the BFF. Errors are ignored
 * (tracking must never block the page).
 */
function dispatchConversion(eventName, eventId, pid) {
    if (!eventId) {
        return;
    }
    $.ajax({
        type: 'GET',
        url: util.ajaxUrl(Urls.GTMConversion),
        data: {
            eventName: eventName,
            eventId: eventId,
            pid: pid || '',
            url: window.location.href
        }
    });
}

exports.init = function() {

    // SLTBE-8652: fire the SiteGenesis server-side Meta CAPI conversions for
    // PageView (every page) and ViewContent (PDPs). The ids were minted at
    // render and embedded in the dataLayer; the Meta Pixel tags fire with the
    // same ids, so the browser just hands them to the BFF to dedup against.
    dispatchConversion('PageView', findInDataLayer('pageViewEventId'));
    if (pageContext.type === 'product') {
        var vcProductId = '';
        if (digitalData && digitalData.product && digitalData.product.length > 0 && digitalData.product[0].productInfo) {
            vcProductId = digitalData.product[0].productInfo.productID;
        }
        dispatchConversion('ViewContent', findInDataLayer('viewContentEventId'), vcProductId);
    }

    if (pageContext.type === 'MyAccount') {

        //} else if (pageContext.type === 'storefront') {


        //} else if (pageContext.type === 'product') {


    } else if (pageContext.type === 'product') {
        // $('.wish-container button.delete-item').on('click', function () {
        //     var sku = $('.product-detail #product-teasers .prodSku').text();
        //     if (digitalData == null || digitalData == undefined || digitalData.product == undefined || digitalData.product.length == 0) {
        //         return;
        //     }
        //     var product = digitalData.product.filter(function(obj) {
        //         return obj.productInfo.sku == (sku);
        //     })[0];
            
        //     if (product == null || product == '' || product == undefined) {
        //         return;
        //     }
           
        //     var productName = $('.product-detail .product-name').text();
        //     var productID = $('.product-detail #product-teasers .prodSku').attr('data-masterid');
        //     var findInStore = $('.product-detail #product-teasers .prodSku').attr('data-findinstore');
        //     var availability = $('.product-detail #product-teasers .prodSku').attr('data-availability');
        //     var shipping = $('.product-detail #product-teasers .prodSku').attr('data-shipping');
        //     var brand = '';
        //     var category = '';
        //     var productType = 'Merch';
        //     var Qty = $('#quantity').val();

        //     window.digitalData = window.digitalData || {};
        //     window.digitalData.event = window.digitalData.event || [];

        //     window.digitalData.event.push({
        //         'eventInfo': {
        //             'eventName': 'persistedListRemoval',
        //             'type': 'persisted list',
        //             'location': 'wishlist',
        //             'timeStamp': new Date(),
        //             'processed': {
        //                 'adobeAnalytics': false
        //             }
        //         },
        //         'product': [{
        //             'productInfo': {
        //                 'productName': productName,
        //                 'productID': productID,
        //                 'sku': sku,
        //                 'findInStore': findInStore,
        //                 'availability': availability,
        //                 'shipping': shipping,
        //                 'brand': brand,
        //                 'category': category
        //             },
        //             'category': {
        //                 'productType': productType
        //             },
        //             'quantity': Qty
        //         }]
        //     });
        //     sendCustomEvent('persistedListRemoval');
        // });
    }  else if (pageContext.type === 'Cart') {

        /**
         * Promotion code applied - TIMING: Fires when a user adds an item to their shopping cart
         */
        $('button[name$="_cart_addCoupon"]').click(function() {
            var ddPromoApplicationEvent = {};
            ddPromoApplicationEvent.eventInfo = {};

            ddPromoApplicationEvent.promoData = {};
            ddPromoApplicationEvent.eventInfo.eventName = 'promoApplication';
            ddPromoApplicationEvent.eventInfo.type = 'promo';
            ddPromoApplicationEvent.eventInfo.timeStamp = new Date();
            ddPromoApplicationEvent.eventInfo.processed = {};
            ddPromoApplicationEvent.eventInfo.processed.adobeAnalytics = false;

            ddPromoApplicationEvent.promoData['promo code'] = $('input[name$="_cart_couponCode"]').val();
            ddPromoApplicationEvent.promoData['promo type'] = '';
            ddPromoApplicationEvent.promoData.success = '';
            
            window.digitalData = window.digitalData || {};
            window.digitalData.event = window.digitalData.event || [];
            window.digitalData.event.push(ddPromoApplicationEvent);
            sendCustomEvent('promoApplication');
        });
        
        /**
         * Remove from Cart - Fire when a user removes an item, or clears all items from their shopping cart
         */
        $('.cart-row .item-quantity button[name$="_deleteProduct"]').click(function() {
            if (digitalData == null || digitalData.cart == undefined || digitalData.cart.item == undefined || digitalData.cart.item.length < 1) {
                return;
            }
            var sku = $(this).closest('.cart-row').find('.item-details .sku .value').text();
            var shipping = $(this).closest('.cart-row').find('.item-user-actions').data('shipping') !== 'undefined' ? $(this).closest('.cart-row').find('.item-user-actions').data('shipping') : ''; 
            var findinstore = $(this).closest('.cart-row').find('.item-user-actions').data('findinstore') !== 'undefined' ? $(this).closest('.cart-row').find('.item-user-actions').data('findinstore') : '';
            var product = digitalData.cart.item.filter(function(obj) {
                return obj.productInfo.sku == (sku);
            })[0].productInfo;
            
            var prodType = digitalData.cart.item.filter(function(obj) {
                return obj.productInfo.sku == (sku);
            })[0].category;

            if (product == null || product == '' || product == undefined) {
                return;
            }
            dataLayer.push({
                'event': 'removeFromCart',
                'ecommerce': {
                    'currencyCode': 'USD',
                    'remove': {
                        'products': [{
                            'id': product.productID,
                            'name': product.productName,
                            'price': product.cost,
                            'category': product.category,
                            'quantity': product.qty,
                            'brand': product.brand,
                            'variant': product.variant
                        }]
                    }
                }
            });

            window.digitalData = window.digitalData || {};
            window.digitalData.event = window.digitalData.event || [];
            window.digitalData.event.push({
                'eventInfo': {
                    'eventName': 'persistedListRemoval',
                    'type': 'persisted list',
                    'location': 'cart',
                    'registryID': '',
                    'target': 'cart',
                    'timeStamp': new Date(),
                    'processed': {
                        'adobeAnalytics': false
                    }
                },
                'product': [{
                    'productInfo': {
                        'productName': product.productName,
                        'productID': product.productID,
                        'sku': sku,
                        'findInStore': findinstore,
                        'availability': product.availability,
                        'shipping': shipping,
                        'brand': product.brand,
                        'category': product.category,
                        'cost': product.cost,
                        'qty': product.qty
                    },
                    'category': {
                        'productType': prodType.productType
                    },
                    'quantity': product.qty
                }]
            });
            sendCustomEvent('persistedListRemoval');

        });

        $('.cart-row .item-quantity button.add-to-wishlist').click(function () {
            var sku = $(this).closest('.cart-row').find('.item-details .sku .value').text();
            if (digitalData == null || digitalData.cart == undefined || digitalData.cart.item == undefined || digitalData.cart.item.length < 1) {
                return;
            }
            var product = digitalData.cart.item.filter(function (obj) {
                return obj.productInfo.sku == (sku);
            })[0];

            if (product == null || product == '' || product == undefined) {
                return;
            }

            window.digitalData = window.digitalData || {};
            window.digitalData.event = window.digitalData.event || [];
            window.digitalData.event.push({
                'eventInfo': {
                    'eventName': 'persistedListAddition',
                    'type': 'persisted list',
                    'location': 'cart',
                    'target': 'wishlist',
                    'timeStamp': new Date(),
                    'processed': {
                        'adobeAnalytics': false
                    }
                },
                'product': [{
                    'productInfo': {
                        'productName': product.productInfo.productName,
                        'productID': product.productInfo.productID,
                        'sku': sku,
                        'findInStore': product.productInfo.findInStore,
                        'availability': product.productInfo.availability,
                        'shipping': product.productInfo.shipping
                    },
                    'category': {
                        'productType': product.category.productType
                    },
                    'quantity': $(this).parent().closest('tr').find('div.quantity-box').find('input.qty_value').length > 0 ? $(this).parent().closest('tr').find('div.quantity-box').find('input.qty_value').val() : ''
                }]
            });
            sendCustomEvent('persistedListAddition');
        });
    } else if (pageContext.type === 'Wishlist') {
        $('.wishlist-products .option-update button.delete-item').click(function() {
            var sku = $(this).closest('.wishlist-products').find('.product-list-item .sku .value').text();
            if (digitalData == null || digitalData == undefined || digitalData.product == undefined || digitalData.product.length == 0) {
                return;
            }
            var product = digitalData.product.filter(function(obj) {
                return obj.productInfo.sku == (sku);
            })[0];
            
            if (product == null || product == '' || product == undefined) {
                return;
            }
            
            window.digitalData = window.digitalData || {};
            window.digitalData.event = window.digitalData.event || [];
            window.digitalData.event.push({
                'eventInfo': {
                    'eventName': 'persistedListRemoval',
                    'type': 'persisted list',
                    'location': 'wishlist',
                    'timeStamp': new Date(),
                    'processed': {
                        'adobeAnalytics': false
                    }
                },
                'product': [{
                    'productInfo': {
                        'productName': product.productInfo.productName,
                        'productID': product.productInfo.productID,
                        'sku': sku,
                        'findInStore': product.productInfo.findInStore,
                        'availability': product.productInfo.availability,
                        'shipping': product.productInfo.shipping,
                        'brand': product.productInfo.brand,
                        'category': product.productInfo.category
                    },
                    'category': {
                        'productType': product.category.productType
                    },
                    'quantity': product.productInfo.quantity
                }]
            });
            sendCustomEvent('persistedListRemoval');
        });
    } else if (pageContext.type === 'GiftRegistry') {
        $('.wishlist-products .option-update button.delete-item').click(function() {
            var sku = $(this).closest('.wishlist-products').find('.product-list-item .sku .value').text();
            if (digitalData == null || digitalData == undefined || digitalData.product == undefined || digitalData.product.length == 0) {
                return;
            }
            var product = digitalData.product.filter(function(obj) {
                return obj.productInfo.sku == (sku);
            })[0];
            
            if (product == null || product == '' || product == undefined) {
                return;
            }
            
            window.digitalData = window.digitalData || {};
            window.digitalData.event = window.digitalData.event || [];
            window.digitalData.event.push({
                'eventInfo': {
                    'eventName': 'persistedListRemoval',
                    'type': 'persisted list',
                    'location': 'regsitry',
                    'registryID': product.productInfo.registryID,
                    'timeStamp': new Date(),
                    'processed': {
                        'adobeAnalytics': false
                    }
                },
                'product': [{
                    'productInfo': {
                        'productName': product.productInfo.productName,
                        'productID': product.productInfo.productID,
                        'sku': sku,
                        'findInStore': product.productInfo.findInStore,
                        'availability': product.productInfo.availability,
                        'shipping': product.productInfo.shipping,
                        'brand': product.productInfo.brand,
                        'category': product.productInfo.category
                    },
                    'category': {
                        'productType': product.category.productType
                    },
                    'quantity': product.productInfo.quantity
                }]
            });
            sendCustomEvent('persistedListRemoval');
        });
    }
};

exports.startCheckout = function () {
    if (digitalData == null || digitalData == undefined) {
        return;
    }

    dataLayer.push({
        'event': 'startCheckout'
    });
};

},{"./util":78}],19:[function(require,module,exports){
'use strict';
// jQuery extensions

module.exports = function () {
    // params
    // toggleClass - required
    // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
    // eventName - optional. defaults to 'click'
    $.fn.toggledList = function (options) {
        if (!options.toggleClass) { return this; }
        var list = this;
        return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
            e.preventDefault();
            var classTarget = options.triggerSelector ? $(this).parent() : $(this);
            classTarget.toggleClass(options.toggleClass);
            // execute callback if exists
            if (options.callback) {options.callback();}
        });
    };

    $.fn.syncHeight = function () {
        var arr = $.makeArray(this);
        arr.sort(function (a, b) {
            return $(a).height() - $(b).height();
        });
        return this.height($(arr[arr.length - 1]).height());
    };
};

},{}],20:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    validator = require('./validator');

var login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
        //o-auth binding for which icon is clicked
        $('.oAuthIcon').bind('click', function () {
            $('#OAuthProvider').val(this.id);
        });
    

        //toggle the value of the rememberme checkbox
        $('#dwfrm_login_rememberme').bind('change', function () {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }
        });
        
        $('#password-reset').on('click', function (e) {
            e.preventDefault();
            dialog.open({
                url: $(e.target).attr('href'),
                options: {
                    dialogClass: 'forget-pwd kiosk',
                    width: 640,
                    open: function () {
                        validator.init();
                        var $requestPasswordForm = $('[name$="_requestpassword"]');
                        var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
                        $($submit).on('click', function (e) {
                            if (!$requestPasswordForm.valid()) {
                                return;
                            }
                            e.preventDefault();
                            var data = $requestPasswordForm.serialize();
                            // add form action to data
                            data += '&' + $submit.attr('name') + '=';
                            // make sure the server knows this is an ajax request
                            if (data.indexOf('ajax') === -1) {
                                data += '&format=ajax';
                            }
                            $.ajax({
                                type: 'POST',
                                url: $requestPasswordForm.attr('action'),
                                data: data,
                                success: function (response) {
                                    if (typeof response === 'object' &&
                                            !response.success &&
                                            response.error === Resources.CSRF_TOKEN_MISMATCH) {
                                        page.redirect(Urls.csrffailed);
                                    } else if (typeof response === 'string') {
                                        dialog.$container.html(response);
                                    }
                                },
                                failure: function () {
                                    dialog.$container.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
                                }
                            });
                        });
                    }
                }
            });
        });
    }
}

module.exports = login;

},{"./dialog":13,"./page":22,"./validator":79}],21:[function(require,module,exports){
'use strict';

var util = require('./util'),
    bonusProductsView = require('./bonus-products-view'),
    wunderkind = require('./wunderkind');

var timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

var minicart = {
    init: function () {
        this.$el = $('#mini-cart');
        this.$content = this.$el.find('.mini-cart-content');

        $('.mini-cart-product').eq(0).find('.mini-cart-toggle').addClass('fa-caret-down');
        $('.mini-cart-product').not(':first').addClass('collapsed')
            .find('.mini-cart-toggle').addClass('fa-caret-right');

        if (!SitePreferences.enableNewAddToCartOnPDP) {
            $('.mini-cart-toggle').on('click', function () {
                $(this).toggleClass('fa-caret-down fa-caret-right');
                $(this).closest('.mini-cart-product').toggleClass('collapsed');
            });
            
            // events
            var count = 1;
            this.$el.find('.mini-cart-total').on('mouseenter click', function (e) {
                var $counter = count++;
                if ($(window).width() <= 1023 && $counter == 2) {
                    e.preventDefault();
                    return false;
                } else {
                    if (this.$content.not(':visible')) {
                        this.slide();
                    }
                }
            }.bind(this));
        }

        this.$content.on('mouseenter', function () {
            timer.clear();
        }).on('mouseleave', function () {
            timer.clear();
            timer.start(30, this.close.bind(this));
        }.bind(this));

        /*
         revert SUR-820 changes

        $('.mini-cart-link-checkout').click(function() {
            history.replaceState('', '', Urls.cartShow);
        });
        */
    },
    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html) {
        this.$el.html(html);
        this.loadPayPalBtn();
        this.init();
        this.slide();
        if (pageContext.ns !== 'search') {
            util.scrollBrowser(0);
        }
        bonusProductsView.loadBonusOption();
    },
    /**
     * @function
     * @description update the given content in the mini cartinit
     * @param {String} A HTML string with the content which will be updated
     */
    showForQty: function(html){
        this.$el.html(html);
        this.loadPayPalBtn();
        this.init();
        bonusProductsView.loadBonusOption();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide: function () {
        timer.clear();
        // show the item
        this.$content.slideDown('slow');
        // after a time out automatically close it
        timer.start(6000, this.close.bind(this));
    },
    /**
     * @function
     * @description Closes the mini cart with given delay
     * @param {Number} delay The delay in milliseconds
     */
    close: function (delay) {
        timer.clear();
        this.$content.slideUp(delay);
    },
    loadPayPalBtn: function(){
        $('.js_paypal_button').each(function () {
            var $btn = $(this);
            if ($btn.data('isInited')) {
                return;
            }
            var config = $btn.data('paypalConfig');
            if (typeof config !== 'object' || config === null) {
                return;
            }
            if (config.billingAgreementFlow) {
                var billingAgreementFlowConfig = {
                    isShippingAddressExist: config.billingAgreementFlow.isShippingAddressExist,
                    startBillingAgreementCheckoutUrl: config.billingAgreementFlow.startBillingAgreementCheckoutUrl,
                    editShppingAddressUrl: config.billingAgreementFlow.editShppingAddressUrl,
                    editShppingAddressPopupTitle: config.billingAgreementFlow.editShppingAddressPopupTitle
                };
                if (!config.style) {
                    config.style = {
                        layout: 'horizontal',
                        label: 'paypal',
                        maxbuttons: 1,
                        fundingicons: false,
                        shape: 'rect',
                        size: 'medium',
                        tagline: false
                    };
                }
                config.style.maxbuttons = 1;
                config.payment = function () {};
                config.onAuthorize = function () {};
                config.validate = function (actions) {
                    return actions.disable();
                };
                config.onClick = function () {
                    window.paypalHandleBillingAgreementFlowOBJ(billingAgreementFlowConfig);
                };
                delete config.billingAgreementFlow;
            }
            window.paypalUtils.initButton(config, $btn[0]);
            $btn.data('isInited', true);
        });
    },
    update: function (html) {
        this.$el.html(html);

        wunderkind.updateCart();
    }
};

module.exports = minicart;

},{"./bonus-products-view":5,"./util":78,"./wunderkind":80}],22:[function(require,module,exports){
'use strict';

var util = require('./util');

var page = {
    title: '',
    type: '',
    params: util.getQueryStringParams(window.location.search.substr(1)),
    redirect: function (newURL) {
        setTimeout(function () {
            window.location.href = newURL;
        }, 0);
    },
    refresh: function () {
        setTimeout(function () {
            window.location.assign(window.location.href);
        }, 500);
    }
};

module.exports = page;

},{"./util":78}],23:[function(require,module,exports){
'use strict';

var giftcert = require('../giftcert'),
    tooltip = require('../tooltip'),
    util = require('../util'),
    dialog = require('../dialog'),
    page = require('../page'),
    login = require('../login'),
    validator = require('../validator');

/**
 * @function
 * @description Initializes the events on the address form (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm() {
    var $form = $('#edit-address-form');

    $form.find('input[name="format"]').remove();
    tooltip.init();

	//handle click event on apply button for adding new address or editing an existing one
    $form.on('click', '.apply-button', function (e) {
        e.preventDefault();
        if (!$form.valid()) {
            return false;
        }
        var url = util.appendParamToURL($form.attr('action'), 'format', 'ajax');
        var applyName = $form.find('.apply-button').attr('name');
        var options = {
            url: url,
            data: $form.serialize() + '&' + applyName + '=x',
            type: 'POST'
        };
        $.ajax(options).done(function (data, status, xhr) {
            var type = xhr.getResponseHeader('content-type');
            if (type.indexOf('text/html') > -1) {
                $('.address-validation-dialog-container').empty().append($(xhr.responseText));
                require('../addressvalidation').init();
            } else if (typeof(data) !== 'string') {
                if (data.success) {
                    dialog.close();
                    page.refresh();
                } else if (data.error) {
                    page.redirect(Urls.csrffailed);
                } else {
                    window.alert(data.message);
                    return false;
                }
            } else {
                $('#dialog-container').html(data);
                account.init();
                tooltip.init();
            }
        });
    })
	//handle click on cancel button in address form
    .on('click', '.cancel-button, .close-button', function (e) {
        e.preventDefault();
        dialog.close();
    })
	//handle click on delete address link in address page
    .on('click', '.delete-button', function (e) {
        e.preventDefault();
        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            var url = util.appendParamsToUrl(Urls.deleteAddress, {
                AddressID: $form.find('#addressid').val(),
                format: 'ajax'
            });
            $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    dialog.close();
                    page.refresh();
                } else if (data.message.length > 0) {
                    window.alert(data.message);
                    return false;
                } else {
                    dialog.close();
                    page.refresh();
                }
            });
        }
    });

    validator.init();
}
/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder () {
    $('.order-items')
        .find('li.hidden:first')
        .prev('li')
        .append('<a class="toggle">View All</a>')
        .children('.toggle')
        .click(function () {
            $(this).parent().siblings('li.hidden').show();
            $(this).remove();
        });
}
/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
    var addresses = $('#addresses');
    if (addresses.length === 0) { return; }
    
	//handle address edit and create events
    addresses.on('click', '.address-edit, .address-create', function (e) {
        e.preventDefault();
        dialog.open({
            url: this.href,
            options: {
                dialogClass: 'add-address-dialog',
                position: {
                    my: 'center top',
                    at: 'center top',
                    of: window,
                    collision: 'fit'
                },
                open: initializeAddressForm
            }
        });
	//handle delete address event
    }).on('click', '.delete', function (e) {
        e.preventDefault();
        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            $.ajax({
                url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax'),
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    page.redirect(Urls.addressesList);
                } else if (data.message.length > 0) {
                    window.alert(data.message);
                } else {
                    page.refresh();
                }
            });
        }
    });
}
/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
    $('.add-card').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                width: 434.8,
                height: 'auto',
                draggable: false,
                dialogClass: 'add-card-dialog',
                open: initializePaymentForm,
                close: function() {
                    $('#wrapper').css('position','relative');
                    $('body').removeClass('modal-open');
                }
            }
        });
    });

    var paymentList = $('.payment-list');
    if (paymentList.length === 0) { return; }

    util.setDeleteConfirmation(paymentList, String.format(Resources.CONFIRM_DELETE, Resources.TITLE_CREDITCARD));
	//handle remove payment event
    $('.payment-remove').on('click', function (e) {
        e.preventDefault();
        var formId = $(this).parents('form').attr('id');
        var cardName= $(this).parents('.payment-block').find('.cc-type').text();
        dialog.open({
            html:deleteCCTemplate(cardName),
            options: {
                title: '',
                dialogClass:'delete-cc-panel',
                width: 462,
                height: 'auto',
                draggable: false,
                open: function() {

                    $(document).on('click', '.cancel-delete-btn', function () {
                        $('.ui-dialog-titlebar-close').trigger('click');
                    });

                    $(document).on('click', '.delete-list-btn', function () {
                        $('#'+formId).trigger('submit');
                    });
                    if (window.matchMedia('(max-width: 1024px)').matches) {
                        var top;
                        if ($('header-main').hasClass('fixed')) {
                            top=$('.header-main').height();
                        } else {
                            top=$('.header-main').height()+$('.shipping-banner-message').height();
                        }
                        $('.delete-cc-panel').css('margin-top',top+16);
                        $('#wrapper').css('position','fixed');
                        $('.ui-widget-overlay ').css('top',top);
                
                    }
                    $('body').addClass('modal-open');   
                },
                close: function() {
                    $('#wrapper').css('position','relative');
                    $('body').removeClass('modal-open');   
                }
            }
        });
    });
    $('form[name="payment-remove"]').on('submit', function (e) {
        e.preventDefault();
        // override form submission in order to prevent refresh issues
        var button = $(this).find('.delete-cc');
        $('<input/>').attr({
            type: 'hidden',
            name: button.attr('name'),
            value: button.attr('value') || 'delete card'
        }).appendTo($(this));
        var data = $(this).serialize();
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: data
        })
        .done(function () {
            page.redirect(Urls.paymentsList);
        });
    });
    
    function deleteCCTemplate (cardName) {
        var template = '<div class="cc-container">';
        template += '<div class="title-section"><span>'+Resources.DELETEPAYMENT+'</span></div>'+
        '<div class="description-msg">Are you sure you want to delete payment <span class="b2" >'+cardName+'</span> from our account?</div></div>';
        template += '<div class="actions-section"><button class="delete-list-btn button-primary-inverse">'+Resources.YESDELETEPAYMENT  +'</button><button class="cancel-delete-btn button-primary">'+Resources.CANCELELETEPAYMENT +'</button></div>';
        template += '</div>';
        return template;
    }
}
$('body').on('click','#verifyNow', function (e) {
    e.preventDefault();

    var url= $(this).data('url');

    $.ajax({
        url: url,
        method: 'POST',
        dataType: 'json'
    }).done(function (data) {
        if (data.success) {
            dialog.open({
                html: sentUthinicationLink(),
                options: {
                    title: '',
                    dialogClass:'sent-link-meesage',
                    width: 462,
                    height: 'auto',
                    draggable: false,
                    open:  function() {
                        if (window.matchMedia('(max-width: 1024px)').matches) {
                            var top1;
                            if ($('header-main').hasClass('fixed')) {
                                top1=$('.header-main').height();
                        
                            } else {
                                top1=$('.header-main').height()+$('.shipping-banner-message').height();
                            }
                            $('.sent-link-meesage').css('margin-top',top1+16);
                            $('#wrapper').css('position','fixed');
                            $('.ui-widget-overlay ').css('top',top1);
                        }
                        $('body').addClass('modal-open');   
                    },
                    close: function() {
                        $('body').removeClass('modal-open');   
                        $('#wrapper').css('position','relative');
                    }
                }
            });
        }
    });
});
function sentUthinicationLink () {
    var template = '<div class="link-sending-message">';
    template += '<div class="title-section"><span>'+Resources.LINKSENDING+'</span></div>';
    template += '<div class="actions-section"><span>'+ Resources.LINKSENDINGMESSAGE+'</span></div>';
    template += '</div>';
    return template;
}
function initializePaymentForm() {
	//close payment form when click on cancel button
    $('#CreditCardForm').on('click', '.cancel-button', function (e) {
        e.preventDefault();
        dialog.close();
    });
    if (window.matchMedia('(max-width: 1024px)').matches) {
        var top3;
        if ($('header-main').hasClass('fixed')) {
            top3=$('.header-main').height();
    
        } else {
            top3=$('.header-main').height()+$('.shipping-banner-message').height();
        }
        $('.add-card-dialog').css('margin-top',top3);
        $('.add-card-dialog').css('max-height', 'calc(100% - ' + (top3 + 8) + 'px)');
        $('#wrapper').css('position','fixed');
        $('.ui-widget-overlay ').css('position','unset');
    }
    $('body').addClass('modal-open');
}
$(window).on('resize', function() {
    if ($('.add-card-dialog').length >0) {
        if (window.matchMedia('(max-width: 1024px)').matches) { 
            var top4;
            if ($('header-main').hasClass('fixed')) {
                top4=$('.header-main').height();
            } else {
                top4=$('.header-main').height()+$('.shipping-banner-message').height();
            }
            $('.add-card-dialog').css('margin-top',top4);
            $('.add-card-dialog').css('max-height', 'calc(100% - ' + (top4 + 8) + 'px)');
            $('#wrapper').css('position','fixed');
            $('.ui-widget-overlay ').css('position','unset');
    
        } else {
            $('.add-card-dialog').css('margin-top','');
            $('.add-card-dialog').css('max-height', '');
            $('#wrapper').css('position','relative');
            $('.ui-widget-overlay ').css('position','fixed');
        }
    }
    if ($('.delete-cc-panel').length >0 || $('.sent-link-meesage').length >0) {
        if (window.matchMedia('(max-width: 1024px)').matches) {      
            var top5;
            if ($('header-main').hasClass('fixed')) {
                top5=$('.header-main').height();
            } else {
                top5=$('.header-main').height()+$('.shipping-banner-message').height();
        
            }
            $('.delete-cc-panel').css('margin-top',top5+16);
            $('.sent-link-meesage').css('margin-top',top5+16);
            $('#wrapper').css('position','fixed');
            $('.ui-widget-overlay ').css('top',top5);  
        } else {
            $('.delete-cc-panel').css('margin-top','');
            $('.sent-link-meesage').css('margin-top','');
            $('#wrapper').css('position','relative');
            $('.ui-widget-overlay ').css('top',0);
        }
    }
});
/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
    toggleFullOrder();
    initAddressEvents();
    initPaymentEvents();
    login.init();
}

var account = {
    init: function () {
        initializeEvents();
        giftcert.init();
    },
    initCartLogin: function () {
        login.init();
    }
};

module.exports = account;

},{"../addressvalidation":1,"../dialog":13,"../giftcert":16,"../login":20,"../page":22,"../tooltip":77,"../util":78,"../validator":79}],24:[function(require,module,exports){
'use strict';

var account = require('./account'),
    slickSlider = require('../slickSlider'),
    util = require('../util'),
    //bonusProductsView = require('../bonus-products-view'),
    //quickview = require('../quickview'),
    cartStoreInventory = require('../storeinventory/cart'),
    dialog = require('../dialog'),
    applepay = require('./checkout/applepay'),
    couponCodeModule = require('./checkout/couponCodeModule'),
    minicart = require('../minicart'),
    gtm = require('../gtm');

const freeShipping = require('./checkout/freeShipping');

/**
 * code to add item to wish list in cart page 
 *  
 */
function cartAddToWishTemplate () {
    var template = '<div class="success-message-container">'+Resources.CART_SUCCESS_ADD_ITEM_TOWISHLIST+'</div>';
    return template;
}

/**
 * 
 * @param {*} addToWishListUrl 
 * @param {*} current 
 */
function addToWishlist (addToWishListUrl, current) {
    var url = util.appendParamToURL(addToWishListUrl, 'isAjax', true);
    $.ajax({
        type: 'GET',
        url: url,
        success: function(data) {
            if (data.success) {
                dialog.open({
                    html:cartAddToWishTemplate(),
                    options: {
                        title: '',
                        dialogClass:'cart-wish-list-panel',
                        width: 342,
                        height: 'auto',
                        open: function () {
                            $('.ui-widget-header').hide();
                            var item = $(this);
                            window.setTimeout(function() {
                                item.dialog('close');
                                var parentElement = current.closest('.remove-button ');
                                current.remove();
                                parentElement.append('<div class="in-wishlist">'+Resources.ITEM_ALREADY_INWISHLIST_MSG+'</div>');
                            }, 
                            5000);
                        }
                    }
                });
            }
        },
        error: function() {
        }
    })
}

/**
 * 
 * @param {*} addToWishListUrl 
 * @param {*} current 
 */
function addToWishlistCart (addToWishListUrl) {
    var url = util.appendParamToURL(addToWishListUrl, 'isAjax', true);
    url = util.appendParamToURL(url, 'needRedirectURL', true);
    $.ajax({
        type: 'GET',
        url: url,
        success: function(data) {
            if (data.needRedirectURL){
                window.location.href = data.redirectUrl;
            }
        }
    })
}
/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
    updateExtendCartIframe();
    /*$('.cart-table').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        quickview.show({
            url: e.target.href,
            source: 'cart'
        });
    })
    .on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
        e.preventDefault();
        bonusProductsView.show(this.href);
    });*/

    // override enter key for coupon code entry

    // write reuired code for extend styling in cart page 
    $('button.add-to-wishlist').on('click', function () {
        var addToWishListUrl = $(this).data('url');
        var current = $(this);
        addToWishlist(addToWishListUrl, current);
    });
    $('button.add-to-wishlist-cart').on('click', function () {
        var addToWishListUrl = $(this).data('url');
        var current = $(this);
        addToWishlistCart(addToWishListUrl, current);
    });
    var cartCheckoutLink = $('.cart-checkout-link');

    $(document).on('click', '.cart-checkout-link', function(e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) {
            return;
        }
        var href = $(this).attr('href');
        var options = {
            url: Urls.cartValidateCheckout,
            type: 'POST'
        };
        $.ajax(options).done(function (data) {
            if (data.valid) {
                window.location.assign(href);
            } else {
                cartCheckoutLink.attr('disabled', 'disabled');
                window.location.reload(); // Reload the cart to show inventory availability per item.
            }
        });
    });

    $('.extend-row-cart').each(function () {
        var extendLineItemUUID = $(this).data('uuid');
        var extendParentLineItemUUID = $(this).find('.hidden_extend_details').val();
        var extendParentQTY = $('.cart-row[data-uuid="'+extendParentLineItemUUID+'"] .qty_value').val();
        if (typeof(extendParentQTY) === 'undefined') {
            $(this).addClass('cart-row-error');
            $('.extend_show_msg_orphaned[data-id="'+extendLineItemUUID + '"]').addClass('show-extend-cart-error');
            $('.cart-action-checkout').find('button').attr('disabled', 'disabled');
            cartCheckoutLink.attr('disabled', 'disabled');
        } else {
            var extendQTY = $(this).find('.qty_value').val();
            if (extendQTY > extendParentQTY) {
                $(this).addClass('cart-row-error');
                $('.extend_show_msg_quantity[data-id="'+extendLineItemUUID + '"]').addClass('show-extend-cart-error');
                $('.cart-action-checkout').find('button').attr('disabled', 'disabled');
                cartCheckoutLink.attr('disabled', 'disabled');
            }
        }
    });
    $('form input[name$="_couponCode"]').on('keydown', function (e) {
        if (e.which === 13 && $(this).val().length === 0) { return false; }
    });

    $('.cartAttendeeDetails .editAttendee').on('click', function () {
        var $cartAttendeeDetails = $(this).parents('.cartAttendeeDetails');
        $cartAttendeeDetails.find('.edit-add-links').addClass('hide');
        var cartRowParent = $(this).parents('.cart-row').parent();
        cartRowParent.find('.lineitem-bottom-section').addClass('cart-border');
        cartRowParent.find('.edit-cart-row').removeClass('hide');
        var $editCartAttendeeDetails =  cartRowParent.find('.edit-cart-row').find('.editCartAttendeeDetails');
        if ($(this).hasClass('unclickable')) {
            return;
        }
        if ($cartAttendeeDetails.find('.seatqtyerr').is(':visible')) {
            $cartAttendeeDetails.find('.seatqtyerr').addClass('hide')
        }
        $cartAttendeeDetails.find('.showDetails').addClass('hide');
        $editCartAttendeeDetails.find('.editDetails').removeClass('hide');
        $('.updateAllAttendee').removeClass('hide');
        cartCheckoutLink.attr('disabled', 'disabled');
        var sku = $(this).parentsUntil('.edit-cart-row').find('input[name=productID]').val();
        validateAttendeeForm(sku);
    });
    
    $('.cartAttendeeDetails .addAttendee').on('click', function () {
        var $cartAttendeeDetails = $(this).parents('.cartAttendeeDetails');
        var $cartRow = $(this).closest('.cart-row');
        var $editCartAttendeeDetails = $(this).parents('.cart-row').parent().find('.editCartAttendeeDetails');
        var qty = parseInt($cartRow.find('.cart-class-quantity').val(),0);
        var index = qty+1;
        var pdtATS = parseInt($cartRow.parent().parent().find('input[class="productATS"]').val(),0);
        if (pdtATS <= 0) {
            $cartAttendeeDetails.find('.seatqtyerr').removeClass('hide');
            return;
        } else if (index > pdtATS) {
            $cartAttendeeDetails.find('.seatqtyerr').removeClass('hide');
            return;
        }
        $cartAttendeeDetails.find('.edit-add-links').addClass('hide');
        var cartRowParent = $(this).parents('.cart-row').parent();
        cartRowParent.find('.lineitem-bottom-section').addClass('cart-border');
        cartRowParent.find('.edit-cart-row').removeClass('hide');
        cartCheckoutLink.attr('disabled', 'disabled');
        $cartRow.find('.cart-class-quantity').val(index);
        $cartAttendeeDetails.find('.showDetails').addClass('hide');
        $editCartAttendeeDetails.find('.editDetails').removeClass('hide');
        $editCartAttendeeDetails.find('.editAttendee').addClass('unclickable');
        $('.updateAllAttendee').removeClass('hide');
        var uuid = $cartAttendeeDetails.data('uuid');
        $editCartAttendeeDetails.find('.addAttendeeForm').append(util.generateAttendeeFormCart(index, uuid));
        initAddAttendeeForm();
        var sku = $(this).parentsUntil('.edit-cart-row').find('input[name=productID]').val();
        validateAttendeeForm(sku);
    });
    
    $('.editCartAttendeeDetails .addAttendee').on('click', function () {
        var $editCartAttendeeDetails = $(this).parents('.editCartAttendeeDetails');
        var $cartAttendeeDetails = $(this).parents('.edit-cart-row').parent().find('.cartAttendeeDetails');
        $cartAttendeeDetails.find('.edit-add-links').addClass('hide');
        var $cartRow = $(this).parents('.edit-cart-row').parent();
        var qty = parseInt($cartRow.find('.cart-class-quantity').val(),0);
        var index = qty+1;
        var pdtATS = parseInt($cartRow.find('input[class="productATS"]').val(),0);
        if (pdtATS <= 0) {
            $cartAttendeeDetails.find('.seatqtyerr').removeClass('hide');
            return;
        } else if (index > pdtATS) {
            $cartAttendeeDetails.find('.seatqtyerr').removeClass('hide');
            return;
        }
        cartCheckoutLink.attr('disabled', 'disabled');
        $cartRow.find('.cart-class-quantity').val(index);
        $cartAttendeeDetails.find('.showDetails').addClass('hide');
        $editCartAttendeeDetails.find('.editDetails').removeClass('hide');
        $editCartAttendeeDetails.find('.editAttendee').addClass('unclickable');
        //$cartAttendeeDetails.find('.editAttendee').addClass('unclickable');
        $('.updateAllAttendee').removeClass('hide');
        var uuid = $cartAttendeeDetails.data('uuid');
        $editCartAttendeeDetails.find('.addAttendeeForm').append(util.generateAttendeeFormCart(index, uuid));
        initAddAttendeeForm();
        var sku = $(this).parentsUntil('.edit-cart-row').find('input[name=productID]').val();
        validateAttendeeForm(sku);
    });

    //to prevent multiple submissions of the form when removing a product from the cart
    var removeItemEvent = false;
    $('button[name$="deleteProduct"]').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
        }
    });
    
    $('button[name$="deleteAttendee"]').on('click', function (e) {
        e.preventDefault();
        var $cartRow = $(this).closest('.edit-cart-row').prev().prev('.cart-row');
        var qty = parseInt($cartRow.find('.cart-class-quantity').val(),0);
        if (qty == 1) {
            $(this).closest('.edit-cart-row').prev('.cart-row').find('button[name$="deleteProduct"]').trigger('click');
            return;
        } else {
            qty = qty-1;
            $cartRow.find('.cart-class-quantity').val(qty);
            //var form = $(this).closest('form');
            var attendeeForm = $(this).parents('.attendeeForm');
            attendeeForm.remove();
        }
    });

    $('button[name$="editAttendee"]').on('click', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var url = util.appendParamsToUrl(form.attr('action'), {format: 'ajax'});
        var applyName = $(this).attr('name');
        var options = {
            url: url,
            data: form.serialize() + '&' + applyName + '=x',
            type: 'POST'
        };
        $.ajax(options).done(function () {
            window.location.reload();
        });
    });
    
    // Check for the quantity error, and if present disable checkout button
    if ($('.cart-table div.quantityerr').is(':visible')) {
        cartCheckoutLink.attr('disabled', 'disabled');
    }

    var previousValueQtyInput;

    var validateExtend = function(sku) {
        var extend = $(String.format('.extend-association[value={0}]', sku));
        if (!extend) {
            return;
        }

        var extendParent = extend.parent();
        var extendQty = parseInt(extendParent.find('.qty_value').val(), 10);
        var extendPlusButton = extendParent.find('.quantity-box-plus');
        var extendMinusButton = extendParent.find('.quantity-box-minus');
        var skuQty = parseInt($(String.format('.product-ID[value={0}]', sku)).parent().find('.qty_value').val(), 10);

        extendMinusButton.prop('disabled', extendQty <= 1);
        extendPlusButton.prop('disabled', extendQty >= skuQty);
    };

    var validateQuantity = function(currentInput) {
        var productATS = parseInt(currentInput.parent().parent().find('.productATS').val(), 10);
        var isGiftRegistryWithError = currentInput.parent().parent().find('.isGiftRegistryWithError').val() === 'true';
        var extendLeadQuantity = currentInput.parent().parent().find('.extendLeadQuantity').val();
        var minusButton = currentInput.parent().find('.quantity-box-minus');
        var plusButton = currentInput.parent().find('.quantity-box-plus');
        var maximumQuantityExceededMessage = currentInput.parent().parent().find('.maximum-quantity-exceeded');
        var itemOutOfStockMessage = currentInput.parent().parent().find('.item-out-of-stock');
        var productId = currentInput.parent().parent().find('.product-ID').val();
        var isExtend = util.isExtendProductId(productId);

        if (isExtend) {
            productId = currentInput.parent().parent().find('.extend-association').val();
        }

        if (isGiftRegistryWithError) {
            currentInput.addClass('invalid-quantity');
            minusButton.addClass('invalid-quantity');
            plusButton.addClass('invalid-quantity');
            currentInput.prop('disabled', true);
            minusButton.prop('disabled', true);
            plusButton.prop('disabled', true);
            return;
        }

        if (productATS === 0) {
            currentInput.addClass('invalid-quantity');
            minusButton.addClass('invalid-quantity');
            plusButton.addClass('invalid-quantity');
            currentInput.prop('disabled', true);
            minusButton.prop('disabled', true);
            plusButton.prop('disabled', true);
            itemOutOfStockMessage.removeClass('hidden');
            validateExtend(productId)
            return;
        }

        var qty = parseInt(currentInput.val(), 10);
        if (Number.isNaN(qty)) {
            return;
        }

        minusButton.prop('disabled', qty <= 1);

        if (qty > productATS) {
            currentInput.addClass('invalid-quantity');
            minusButton.addClass('invalid-quantity');
            plusButton.addClass('invalid-quantity');
            plusButton.prop('disabled', true);
            maximumQuantityExceededMessage.removeClass('hidden');
        } else if (qty > 98) {
            plusButton.prop('disabled', true);
        } else if (extendLeadQuantity && qty >= Number(extendLeadQuantity)) {
            plusButton.prop('disabled', true);
        } else {
            currentInput.removeClass('invalid-quantity');
            minusButton.removeClass('invalid-quantity');
            plusButton.removeClass('invalid-quantity');
            plusButton.prop('disabled', false);
            maximumQuantityExceededMessage.addClass('hidden');

            var row = currentInput.closest('.cart-row');

            var onlyXLeftMessage = currentInput.parentsUntil('.cart-table').find('.low-stock.only-x-left');
            var limitedQuantityMessage = currentInput.parentsUntil('.cart-table').find('.low-stock.limited-quantity');
            var isBopis = row.find('.is-bopis').val() == 'true';
            var isSameDayDelivery = row.find('.is-same-day-delivery').val() == 'true';
            var qtyAvailableInBackorder = parseInt(row.find('.cart-items-form .available-in-backorder').val(), 10);
            var qtyAvailableInStock = isBopis ? productATS : parseInt(row.find('.cart-items-form .available-instock').val(), 10);

            if (qtyAvailableInStock <= SitePreferences.limitedQuantityBadgeThreshold && qty <= qtyAvailableInStock && qty > 0) {
                if (qtyAvailableInStock <= SitePreferences.onlyXLeftBadgeThreshold) {
                    onlyXLeftMessage.removeClass('hidden');
                } else {
                    limitedQuantityMessage.removeClass('hidden');
                }
            } else {
                onlyXLeftMessage.addClass('hidden');
                limitedQuantityMessage.addClass('hidden');
            }

            var backOrderTag = row.find('.stock-backorder');
            var uuid = row.data('uuid');
            var stockTypeTagRow = $('[data-uuid="' + uuid + '"].stock-type-tag-tr');
            if (qty > qtyAvailableInStock && qtyAvailableInBackorder > 0 && !isSameDayDelivery) {
                backOrderTag.removeClass('hidden');
                stockTypeTagRow.find('.stock-availability-date-tag').css('display','flex');
                var inStockDate = row.find('.cart-items-form .in-stock-date').val();
                var message = '';
                if (qtyAvailableInStock > 0) {
                    message = String.format(Resources.IN_STOCK_QUANTITIES_2, qtyAvailableInStock, qty - qtyAvailableInStock) + ' ';
                }
                message += String.format(Resources.IN_STOCK_DATE, inStockDate);
                stockTypeTagRow.find('.stock-availability-date-tag__date').html(message);
                stockTypeTagRow.css('display','');
            } else {
                backOrderTag.addClass('hidden');
                stockTypeTagRow.css('display','none');
                stockTypeTagRow.find('.stock-availability-date-tag').css('display','none');
            }
        }

        validateExtend(productId)
    };

    //Validation for quantity field on cart page
    $('.cart-table input.qty_value').on('change keyup', function () {
        var qty = parseInt($(this).closest('.quantity-box').find('.qty_value').val(),0);
        var key = event.which || event.keyCode || event.charCode;
        if (key == 8 && isNaN(qty)) {
            return;
        }
        if (qty === 0) {
            updateQTY(1, $(this));
        }

        validateQuantity($(this));

        var pdtATS = parseInt($(this).closest('.cart-row').find('input[class="productATS"]').val(),0);

        if (pdtATS <= 0) {
            $(this).closest('.quantity-box').find('.qty_value').val(1);
            $(this).closest('.item-quantity').find('.quantityerr').show();
            $(this).closest('.item-quantity').find('span.cart-dynamic-availability').text(pdtATS +' ');
            $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.prev-value.active').removeClass('active');
        } else if (qty == 1 || qty < 1 || isNaN(qty)) {
            if (pdtATS >= 1) {
                $(this).closest('.item-quantity').find('.quantityerr').hide();
                $(this).closest('.quantity-box').find('.next-value').addClass('active');
            } else {
                $(this).closest('.item-quantity').find('.quantityerr').show();
                $(this).closest('.item-quantity').find('span.cart-dynamic-availability').text(pdtATS +' ');
                $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
                $(this).closest('.quantity-box').find('.prev-value.active').removeClass('active');
            }
        } else if (qty > pdtATS) {
            $(this).closest('.item-quantity').find('div.quantityerr').show();
            $(this).closest('.item-quantity').find('span.cart-dynamic-availability').text(pdtATS +' ');
            //$(this).closest('.quantity-box').find('.qty_value').val(showATS);
            $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.prev-value').addClass('active');
        } else if (qty == pdtATS) {
            $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.prev-value').addClass('active');
            $(this).closest('.item-quantity').find('div.quantityerr').hide();
        } else {
            $(this).closest('.item-quantity').find('div.quantityerr').hide();
            $(this).closest('.quantity-box').find('.next-value').addClass('active');
        }
    });
    $('.cart-table input.qty_value').on('click', function () {
        var current = $(this);
        var value = current.val();
        if (value) {
            previousValueQtyInput = parseInt(value, 10);
        }

        current.val('');
        current.on('blur', function () {
            var currentValue = current.val();
            if (!currentValue) {
                current.val(previousValueQtyInput);
            }
            current.off('blur');
        });
    });
    $('.cart-table input.qty_value').on('keydown', function (e) {
        if ((90 >= e.which && e.which >= 65) || (111 >= e.which && e.which >= 107) || (192 >= e.which && e.which >= 186) || e.which==16 || (222 >= e.which && e.which >= 219) || (41 >= e.which && e.which >= 33)) {
            e.preventDefault();
        }
    });
    $('.cart-table input.qty_value').each(function() {
        validateQuantity($(this));
    });
    $('.cart-table input.qty_value').on('change', function () {
        var current = $(this);
        var qty = parseInt(current.closest('.quantity-box').find('.qty_value').val(), 10);
        if (qty > 0){
            updateQTY(qty, current);
        }
    });
    $('.cart-table .quantity-box-minus').on('click', function() {
        var current = $(this);
        var qtyInput = current.closest('.quantity-box').find('.qty_value');
        var qty = parseInt(qtyInput.val(), 10) - 1;

        if (Number.isNaN(qty)) {
            if (previousValueQtyInput > 1) {
                previousValueQtyInput--;
            }
            qty = previousValueQtyInput;
        }

        if (qty < 1) {
            qty = 1;
        }

        qtyInput.val(qty);

        validateQuantity(qtyInput);

        if (qty > 0){
            updateQTY(qty, qtyInput);
        }
    });
    $('.cart-table .quantity-box-plus').on('click', function() {
        var current = $(this);
        var qtyInput = current.closest('.quantity-box').find('.qty_value');
        var qty = parseInt(qtyInput.val(), 10) + 1;

        if (Number.isNaN(qty)) {
            if (previousValueQtyInput < 99) {
                previousValueQtyInput++;
            }
            qty = previousValueQtyInput;
        }

        if (qty > 99) {
            qty = 99;
        }

        qtyInput.val(qty);

        validateQuantity(qtyInput);

        if (qty > 0){
            updateQTY(qty, qtyInput);
        }
    });

    function updateQTY(qty, current){
        var prodcutID = current.closest('.cart-items-form').find('.product-ID').val()
        var productPosition = current.closest('.cart-row').find('.item-details').find('.product-list-item .c3').find('.prod-position').val();
        var url = util.appendParamsToUrl(Urls.UpdateCartQTY, {
            qty: qty,
            prodcutID: prodcutID,
            productPosition:productPosition,
            format: 'isAjax'
        }); 
        $.ajax({
            dataType: 'json',
            url: url,
            success: function(response) {
                if (response.success == true && response.partSuccess == true){
                    updateCartTotals(current, response, qty);
                } else if (response.success == false && response.partSuccess == false){
                    current.val(response.pliNewQty);
                } else if (response.success == false && response.partSuccess == true){
                    current.val(response.pliNewQty);
                    updateCartTotals(current, response, response.pliNewQty);
                }

                validateQuantity(current);

                if ($('#all-items-count').val() == 1 && response.isAllExecluded == true) {
                    if (qty > 1) {
                        $('.item-eligable-msg').text(Resources.COUPONELIGABLEPLIMSG);
                    } else if (qty == 1) {
                        $('.item-eligable-msg').text(Resources.COUPONELIGABLEPLIMSG1);
                    }
                }
                $('#single-item-qty').val(qty);
            }
        });
    }
    function updateCartTotals(current, response, qty){
        current.closest('.cart-row').parent().find('.item-total').find('.price-sales').text('$'+response.productTotalPrice.toFixed(2));
        $('.order-totals-table').find('.order-subtotal').find('.order-subtotal-summery').text('$'+response.totalWithoutDiscount.toFixed(2));
        if (response.totalShipment == 0 || response.isFreeShipping == true){
            $('.order-totals-table').find('.order-shipping .total-order-shipping').text('Free');
        } else if (response.totalShipment != 0) {
            $('.order-totals-table').find('.order-shipping .total-order-shipping').text('$'+response.totalShipment.toFixed(2)); 
        }
        if (response.totalSurcharge != null && response.totalSurcharge > 0){
            $('.order-totals-table').find('.totalSurcharge').find('.c3').text('$'+response.totalSurcharge.toFixed(2));
        }
        if (response.sameDayDeliveryShippingPrice > 0) {
            $('.order-totals-table').find('.total-order-shipping-sameday-delivery').text('$' + response.sameDayDeliveryShippingPrice.toFixed(2)); 
        }
        if (response.totalTax == 0){
            $('.order-totals-table').find('.order-sales-tax .total-order-tax').text('-');
        } else if (response.totalTax != 0) {
            $('.order-totals-table').find('.order-sales-tax .total-order-tax').text('$'+response.totalTax.toFixed(2)); 
        }
        $('.order-totals-table').find('.order-value').text('$'+response.cartTotalPrice.toFixed(2));
        $('.cart-container').find('.cart-group-title').find('.shiptome-header-cart').text('Ship to Address Items ('+response.shipToAddressTotal+')');
        $('.cart-container').find('.cart-group-title').find('.bopis-header-cart').text('Store Pickup ('+response.bopisTotal+')');
        $('.cart-container').find('.cart-group-title').find('.same-day-delivery-header-cart-quantity').text(' ('+response.sameDayDeliveryTotal+')');
        $('.cart-container').find('.cart-group-title').find('.culinary-egc-extendpp-header-cart').text('Cooking Classes / Experiences ('+response.classAndEGC+')');
        if (response.amountQualifiedIssue == true) {
            if ($('.rowcoupons .details .eligable-msg-display').length == 0){
                var displayEligableMsg = '<div class="eligable-msg-display"><span>'
                +'Eligible product subtotal must exceed $'+response.promotionAmount+'. Item(s) in your bag are not eligible for this promotion.'
                +'</span> <a href="/on/demandware.store/Sites-SLT-Site/default/Page-Show?cid='
                +response.promotionID+'" class="exclusions-apply-msg">'+
                Resources.DETAILS+'</a></div>'
                $('.rowcoupons .details').append(displayEligableMsg);
            } else {
                $('.rowcoupons .details .eligable-msg-display').css({'display':'block'})
            }
        }
        if (response.amountQualifiedIssue == false && response.isAllExecluded == false) {
            $('.rowcoupons .details .eligable-msg-display').css({'display':'none'})
        }
        if (response.isCouponApplied == false){
            $('.order-discount').css('display','none');
        }

        if (response.isCouponApplied == true || response.promoSavings > 0){
            var totalCouponDiscountToPromoSavings = response.totalCouponDiscount ? -Number(response.totalCouponDiscount) : 0;
            var discount = (response.promoSavings || totalCouponDiscountToPromoSavings).toFixed(2);
            $('.order-discount').remove();
            $('.order-subtotal').after(
                '<tr class="order-discount discount c3">'+
                '<td>' +Resources.ORDERPROMOSAVING +'</td>'+
                '<td class="order-discount-value">- '+Resources.DOLLARSIGN+discount+'</td>'+
                '</tr>'
            );
            $('.order-discount').css('display','revert');
        }
        updateAvailability(current, response, qty);
        refreshMiniCart();
        if (response.shipToAddressTotal > 0){
            refreshFreeShippingBar(response);
        }
        updateAPModel(response);
        if (response.extendTotal){
            extendCheckUp(current, response);
        }
    }
    function updateAvailability(current, response, qty){
        var preorder = current.closest('.cart-row').find('.cart-items-form .levels-preorder').val();
        var backorder = current.closest('.cart-row').find('.cart-items-form .levels-backorder').val();
        // var notAvailable = current.closest('.cart-row').find('.cart-items-form .levels-not-available').val();
        var prodAvailability = current.closest('.cart-row').find('.cart-items-form .productATS').val();
        // var inStockDate = current.closest('.cart-row').find('.cart-items-form .in-stock-date').val();
        if (prodAvailability >= qty && preorder == '0.0' && backorder == '0.0'){
            if (response.isBOPIS == true){
                current.closest('.cart-row').find('.product-availability-list .is-in-stock').text(Resources.INSTOCK_BOPIS);
            } else if (response.isBOPIS == false){
                current.closest('.cart-row').find('.product-availability-list .is-in-stock').text(Resources.IN_STOCK_SHIP);
            }
        } else if (prodAvailability < qty && preorder == '0.0' && backorder == '0.0'){ 
            current.closest('.cart-row').find('.product-availability-list .is-in-stock').text(prodAvailability+ ' Item(s) in Stock');
        }
        var checkoutTop = $('.top-section').find('.checkout-button-container').find('.button-primary-inverse');
        var checkoutBottom = $('.bottom-section').find('.checkout-bottom-container').find('.button-primary-inverse');
        var payPalButton = $('.bottom-section').find('.paypal-bottom-container');
        var policyInfo = $('.bottom-section').find('.privacy-policy-bottom');
        var applePayButtonTop = $('.top-section').find('.applepay-top-container');
        var applePayButtonBottom = $('.bottom-section').find('.applepay-bottom-container');
        var checkoutError = $('.cart-checkout-error');
        if (response.cartAvailable){
            checkoutTop.removeClass('disabled');
            checkoutTop.removeAttr('disabled');
            checkoutBottom.removeClass('disabled');
            checkoutBottom.removeAttr('disabled');
            if (response.bopisTotal <= 0 && response.sameDayDeliveryTotal <= 0) {
                payPalButton.removeClass('hidden');
            }
            policyInfo.removeClass('hidden');
            applePayButtonTop.removeClass('hidden');
            applePayButtonBottom.removeClass('hidden');
            checkoutError.addClass('hidden');
        } else {
            checkoutTop.addClass('disabled');
            checkoutTop.attr('disabled', 'disabled');
            checkoutBottom.addClass('disabled');
            checkoutBottom.attr('disabled', 'disabled');
            payPalButton.addClass('hidden');
            policyInfo.addClass('hidden');
            applePayButtonTop.addClass('hidden');
            applePayButtonBottom.addClass('hidden');
            checkoutError.removeClass('hidden');
        }
    }
    function refreshMiniCart(){
        var url = util.appendParamsToUrl(Urls.showMiniCart, {
            format: 'isAjax'
        });
        $.ajax({
            url: url
        }).then(function (response) {
            minicart.showForQty(response);
        });
    }
    function refreshFreeShippingBar(response){
        const thresoldShippingAmount = parseFloat($('input[type=hidden][name=thresoldShippingAmount]').val());
        const percentComplete = response.neededPercent;
        const cartNeededForFreeShipping = response.neededAmount;
        freeShipping.update(percentComplete, thresoldShippingAmount, cartNeededForFreeShipping);
    }
    function updateAPModel(response){
        $('#total-cart-amount-AP').html(response.cartTotalPrice.toFixed(2));
        
    }
    function extendCheckUp(current, response){
        var prodcutID = current.closest('.cart-items-form').find('.product-ID').val();
        var extendAssociation = $('input[class="extend-association"][value='+prodcutID+']');
        var oldQTY = extendAssociation.closest('.cart-items-form').find('.quantity-box .qty_value').val();
        if (oldQTY != response.extendNewQty){
            extendAssociation.closest('.cart-items-form').find('.quantity-box .qty_value').val(response.extendNewQty);
            extendAssociation.closest('.cart-table').find('.item-total').find('.price-sales').text('$'+response.extendNewPrice.toFixed(2));
        }
    }
    // Handling up and down buttons in cart page
    $('.cart-row .next-value').on('click', function() {
        var qty = $(this).closest('.quantity-box').find('.qty_value').val();
        $(this).addClass('active');

        var pdtATS = parseInt($(this).closest('.cart-row').find('input[class="productATS"]').val(),0);
        qty = parseInt(qty,0);
        var newqty = qty + 1;

        if (newqty > pdtATS) {
            $(this).closest('.item-quantity').find('.quantityerr').show();
            $(this).closest('.item-quantity').find('span.cart-dynamic-availability').text(pdtATS +' ');
            $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.prev-value').addClass('active');
        } else {
            $(this).closest('.quantity-box').find('.qty_value').val(newqty);
            $(this).closest('.item-quantity').find('.quantityerr').hide();
            if (newqty > 1) {
                $(this).closest('.quantity-box').find('.prev-value').addClass('active');
            }
        }
    });
    $('.cart-row .prev-value').on('click', function() {
        var qty = $(this).closest('.quantity-box').find('.qty_value').val();
        var pdtATS = parseInt($(this).closest('.cart-row').find('input[class="productATS"]').val(),0);
        qty = parseInt(qty,0);
        var newqty = qty - 1;

        if (newqty <= 1) {
            $(this).removeClass('active');
            $(this).closest('.quantity-box').find('.qty_value').val(1);
            $(this).closest('.quantity-box').find('.prev-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.next-value').addClass('active');
            if (pdtATS < 1) {
                $(this).closest('.item-quantity').find('.quantityerr').show();
                $(this).closest('.item-quantity').find('span.cart-dynamic-availability').text(pdtATS +' ');
                $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
                $(this).closest('.quantity-box').find('.prev-value').addClass('active');
            } else {
                $(this).closest('.item-quantity').find('.quantityerr').hide();
                $(this).closest('.quantity-box').find('.next-value').addClass('active');
                $(this).closest('.quantity-box').find('.prev-value.active').removeClass('active');
            }
        } else if (newqty <= pdtATS) {
            if (newqty == pdtATS) {
                $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
                $(this).closest('.quantity-box').find('.prev-value').addClass('active');
            } else {
                $(this).closest('.quantity-box').find('.next-value').addClass('active');
                $(this).closest('.quantity-box').find('.prev-value').addClass('active');
            }
            $(this).closest('.quantity-box').find('.qty_value').val(newqty);
            $(this).closest('.item-quantity').find('.quantityerr').hide();
        } else if (newqty > pdtATS) {
            $(this).closest('.quantity-box').find('.qty_value').val(newqty);
            $(this).closest('.item-quantity').find('.quantityerr').show();
            $(this).closest('.item-quantity').find('span.cart-dynamic-availability').text(pdtATS +' ');
            $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.prev-value').addClass('active');
        }
    });
    
    $(document).off('blur keyup','.attendee-input').on('blur keyup click', '.attendee-input', function() {
        var sku = $(this).parentsUntil('.edit-cart-row').find('input[name=productID]').val();
        validateAttendeeForm(sku);
    });

    $('a[data-testid="cart-summary-checkout"]').on('click', function() {
        if ($(this).attr('disabled') !== 'disabled') {
            gtm.startCheckout();
        }
    });

    $('a[data-testid="cart-item-remove"]').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();

        // Using replace to avoid the Back button going back to the same Cart page.
        window.location.replace(this.href);
    });
}
function initAddAttendeeForm() {
    var $form = $('#cart-items-form');
    $form.on('click', '.removeAttendee', function() {
        var $cartRow = $(this).parents('.edit-cart-row').prev('.cart-row').prev();
        var $cartAttendeeDetails = $(this).parents('.edit-cart-row').prev('.cart-row').prev().find('.cartAttendeeDetails');
        var qty = parseInt($cartRow.find('.cart-class-quantity').val(),0);
        qty = qty-1;
        
        if ($cartAttendeeDetails.find('.seatqtyerr').is(':visible')) {
            var pdtATS = parseInt($cartRow.find('input[class="productATS"]').val(),0);
            if (qty <= pdtATS) {
                $cartAttendeeDetails.find('.seatqtyerr').addClass('hide');
            }
        }
        $cartRow.find('.cart-class-quantity').val(qty);
        var attendeeForm = $(this).parents('.addmainAttendee');
        attendeeForm.remove();
        var sku = $(this).parentsUntil('.edit-cart-row').find('input[name=productID]').val();
        validateAttendeeForm(sku);
    });
}

function updateExtendCartIframe () {

    $('#cart-table-shipiment .cart-row').each(function (i, obj) {
        var updateFrame = setInterval(function () {
            var isExtendItem = $(obj).hasClass('extend-row-cart');
            if (isExtendItem) {
                clearInterval(updateFrame);
            }
            var productID = $(obj).attr('data-productid');
            if (window.matchMedia('(max-width: 1024px)').matches) {
                $('#cart-table-shipiment [data-productid="' + productID + '"].cart-row .item-details .extend-up-sell iframe').contents().find('.simple-offer').css({
                    'width': '100%',
                    'height': '41px',
                    'left': '229px',
                    'top': '751px',
                    'background': '#FFFFFF',
                    'box-sizing': 'border-box',
                    'box-shadow': 'none',
                    'border': '1px solid #1E1E1E',
                    'font-family': 'Lato, Nunito Sans, Arial',
                    'font-style': 'normal',
                    'font-weight': 'normal',
                    'font-size': '14px',
                    'line-height': '100%',
                    'text-align': 'center',
                    'letter-spacing': '0.25px',
                    'color': '#323232',
                    'border-radius':'0px'
                });
            } else {
                $('#cart-table-shipiment [data-productid="' + productID + '"].cart-row .item-details .extend-up-sell iframe').contents().find('.simple-offer').css({
                    'width': '100%',
                    'height': '41px',
                    'left': '229px',
                    'top': '751px',
                    'background': '#FFFFFF',
                    'box-sizing': 'border-box',
                    'box-shadow': 'none',
                    'border': '1px solid #1E1E1E',
                    'font-family': 'Lato, Nunito Sans, Arial',
                    'font-style': 'normal',
                    'font-weight': 'normal',
                    'font-size': '14px',
                    'line-height': '100%',
                    'text-align': 'center',
                    'letter-spacing': '0.25px',
                    'color': '#323232',
                    'border-radius':'0px'
                });
            }
            $('#cart-table-shipiment [data-productid="' + productID + '"].cart-row .item-details .extend-up-sell iframe').height(45);
            var FrameHeight =  Math.round($('[data-productid="' + productID + '"].cart-row .item-details .extend-up-sell').height());
            if (FrameHeight == 45) {
                $('#cart-table-shipiment [data-productid="' + productID + '"].cart-row .item-details .extend-up-sell').removeClass('hide_extend_upsell');
                clearInterval(updateFrame);
                $('.extend-up-sell[class="extend-up-sell"]').parents('.cart-row').next('.cart-row').addClass('extend-cart-row-padding');
                var simpleOffierText = $('#cart-table-shipiment [data-productid="' + productID + '"].cart-row .item-details .extend-up-sell iframe').contents().find('.simple-offer').text();
                var secondValue = simpleOffierText.split('accident')[1].split('\n')[0].split('from')[1]; 
                $('#cart-table-shipiment [data-productid="' + productID + '"].cart-row .item-details .extend-up-sell iframe').contents().find('.simple-offer').text('');
                $('#cart-table-shipiment [data-productid="' + productID + '"].cart-row .item-details .extend-up-sell iframe').contents().find('.simple-offer').append('Add '+'<span class="accident-style">Accident</span>'+' Protection for'+secondValue);
                if (window.matchMedia('(max-width: 1024px)').matches) {
                    $('#cart-table-shipiment [data-productid="' + productID + '"].cart-row .item-details .item-quantity-box').css('padding-bottom','16px');
                    $('.cart-row .item-details .extend-up-sell iframe').contents().find('.accident-style').css({display : 'none'});
                } else {
                    $('.cart-row .item-details .extend-up-sell iframe').contents().find('.accident-style').css({display : 'inline-block'});
            
                }
                $('#cart-table-shipiment [data-productid="' + productID + '"].cart-row .item-details .extend-up-sell iframe').contents().find('.simple-offer').css({overflow :'hidden',margin : '0'});
                $('#cart-table-shipiment [data-productid="' + productID + '"].cart-row .item-details .extend-up-sell iframe').contents().find('body').css({overflow :'hidden',margin : '0'});
            }
        }, 500);
    });
}
function validateAttendeeForm(sku) {
    if (!sku) {
        return;
    }

    var fieldLength = $('.attendee-input:not(input[type=checkbox])').length;
    var fieldSuccessLength = $('.form-row.success').length;
    var isChecked = $(String.format('input[data-id={0}]', sku)).prop('checked');
    if (fieldLength === fieldSuccessLength && isChecked) {
        $('.updateAllAttendee').removeAttr('disabled');
    } else {
        $('.updateAllAttendee').attr('disabled','disabled');
    }
}

/**
 * @private
 * @function
 * @description Initialize additional functionality related with PayPal integration
 */
function initPaypalFunctionality() {
    var dialog = require('../dialog'); //For SiteGenesis v100 - must be './dialog'
    var util = require('../util'); //For SiteGenesis v100- must be './util'
    var $expressButton = $('.js_paypal_start_ba_checkout');

    $expressButton.on('click', function() {
        if ($expressButton.data('is-address-exist') === true) {
            return true;
        }
        dialog.open({
            url: $expressButton.data('edit-address-url'),
            options: {
                title: $expressButton.data('edit-address-title'),
                open: initEditDefaultShippingAddressForm
            }
        });
        return false;
    });

    function initEditDefaultShippingAddressForm() {
        var $form = $('#paypalEditDefaultShippingAddress');
        $form.on('click', '.apply-button', function() {
            if (!$form.valid()) {
                return false;
            }
            var applyName = $form.find('.apply-button').attr('name');
            var options = {
                url: $form.attr('action'),
                data: $form.serialize() + '&' + applyName + '=x',
                type: 'POST'
            };
            $.ajax(options).done(function(data) {
                if (typeof(data) !== 'string') {
                    if (data.success) {
                        dialog.close();
                        window.location = $expressButton.attr('href');
                    } else {
                        window.alert(data.message);
                        return false;
                    }
                } else {
                    $('#dialog-container').html(data);
                    initEditDefaultShippingAddressForm();
                }
            });
            return false;
        });
        $form.on('click', '.cancel-button, .close-button', function() {
            dialog.close();
            return false;
        });
        $('#paypalSelectSavedAddress').change(function() {
            var data = $(this).val();
            try {
                data = JSON.parse(data);

                for (var name in data) {
                    var val = data[name];
                    if (typeof val === 'string') {
                        val = val.replace(/\^/g, '\'');
                    }
                    $('#dwfrm_profile_address_' + name).val(val);
                }
            } catch (e) {
                $form.find('input:text').val('');
                $form.find('select').val('');
            }
        });

        $('select[id$="_country"]', $form).on('change', function() {
            util.updateStateOptions($form);
        });
    }
}

function initFreeShippingBar() {
    const percentComplete = parseFloat($('input[type=hidden][name=percentComplete]').val());
    const thresoldShippingAmount = parseFloat($('input[type=hidden][name=thresoldShippingAmount]').val());
    const cartNeededForFreeShipping = parseFloat($('input[type=hidden][name=cartNeededForFreeShipping]').val());
    freeShipping.update(percentComplete, thresoldShippingAmount, cartNeededForFreeShipping);
}

exports.init = function () {
    applepay('cart');
    initializeEvents();
    
    couponCodeModule.init($('.cart-coupon-code'));
    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }
    account.initCartLogin();
    initPaypalFunctionality();
    initFreeShippingBar();
    //initAddAttendeeForm();
    var $defaulValuesClp ={infinite: true, arrows: true, slidesToShow: 5, slidesToScroll: 5};
    var $responsiveClp ={dots: true, infinite: true};
    slickSlider.init('.last-visited .search-result-items, .cart-empty .product-slot .search-result-items', $defaulValuesClp, $responsiveClp);
    $('.text-ellipsis').ellipsis();
    if ($('body').find('.rowcoupons').length > 0) {
        $('.cart-coupon-code .title').click();
    }
    

};
$(window).on('resize', function() {
    if (window.matchMedia('(max-width: 1024px)').matches) {
        $('.cart-row .item-details .extend-up-sell iframe').contents().find('.accident-style').css({display : 'none'});
        $('.extend-simple-offer').parents('.item-details').find('.item-quantity-box').css('padding-bottom','16px');
        $('.cart-row').each(function (i, obj) {
            var productUUID = $(obj).attr('data-uuid');
            $('[data-uuid="' + productUUID + '"].cart-row .item-quantity-column .item-quantity').appendTo($('[data-uuid="' + productUUID + '"].cart-row .item-details .item-quantity-box'));
        });
    } else {
        $('.cart-row .item-details .extend-up-sell iframe').contents().find('.accident-style').css({display : 'inline-block'});
        $('.cart-row').each(function (i, obj) {
            var productUUID = $(obj).attr('data-uuid');
            $('[data-uuid="' + productUUID + '"].cart-row .item-details .item-quantity-box .item-quantity').appendTo($('[data-uuid="' + productUUID + '"].cart-row .item-quantity-column'));      
        });

    }
});
if (window.matchMedia('(max-width: 1024px)').matches) {
    $('.cart-row').each(function (i, obj) {
        var productUUID = $(obj).attr('data-uuid');
        $('[data-uuid="' + productUUID + '"].cart-row .item-quantity-column .item-quantity').appendTo($('[data-uuid="' + productUUID + '"].cart-row .item-details .item-quantity-box'));
    });
} else {
    $('.cart-row').each(function (i, obj) {
        var productUUID = $(obj).attr('data-uuid');
        $('[data-uuid="' + productUUID + '"].cart-row .item-details .item-quantity-box .item-quantity').appendTo($('[data-uuid="' + productUUID + '"].cart-row .item-quantity-column'));      
    });
}
if ($('.cart-coupon-code .error').text().length == 0) {
    $('.cart-coupon-code .error').css('display','none');
} else {
    $('.cart-coupon-code .error').css('display','block');
}

},{"../dialog":13,"../gtm":18,"../minicart":21,"../slickSlider":67,"../storeinventory/cart":69,"../util":78,"./account":23,"./checkout/applepay":26,"./checkout/couponCodeModule":28,"./checkout/freeShipping":30}],25:[function(require,module,exports){
'use strict';

var util = require('../../util');
var shipping = require('./shipping');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
    var $form = $('.address');
    // select address from list
    $('select[name$="_addressList"]', $form).on('change', function () {
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');
        if (!selectedAddress) { return; }
        util.fillAddressFields(selectedAddress, $form);
        shipping.updateShippingMethodList();
    });
};

},{"../../util":78,"./shipping":34}],26:[function(require,module,exports){
'use strict';

module.exports = function (stepName) {
    var isApplePayAvailable = false;

    function useCurrentDomain(url) {
        var domain = window.Urls.homePage.replace('s/SLT/home', '');

        if (url.includes(domain)) {
            return url;
        }

        var pieces = url.split('/');
        var path =  pieces.splice(3).join('/');
        return domain + path;
    }

    try {
        isApplePayAvailable = window.dw && window.dw.applepay && window.ApplePaySession && window.ApplePaySession.canMakePayments();
    } catch (e) {
        isApplePayAvailable = false;
    }

    if (isApplePayAvailable) {
        var APPLE_PAY_GET_REQUEST_LAST_UPDATED_COOKIE_NAME = 'dwapupreq';
        var deleteApplePayGetRequestLastUpdatedCookie = function() {
            document.cookie = APPLE_PAY_GET_REQUEST_LAST_UPDATED_COOKIE_NAME + '=' + Date.now() + ';';
        }
        var updateApplePayURLParams = function(paramName, paramValue) {
            Object.keys(window.dw.applepay.action).forEach(function(key) {
                var existingURL = useCurrentDomain(window.dw.applepay.action[key])
                var updatedURL = new URL(existingURL);
                var updatedURLQueryParameters = updatedURL.searchParams;
                updatedURLQueryParameters.set(paramName, paramValue);
                updatedURL.search = updatedURLQueryParameters.toString();
                window.dw.applepay.action[key] = updatedURL.toString();
            });
        }
        updateApplePayURLParams('source', stepName);
        if (stepName === 'checkout-billing') {
            deleteApplePayGetRequestLastUpdatedCookie();
        }

    } else {
        $('isapplepay').hide();
        $('.dw-apple-pay-button, .dw-apple-pay-cart').hide();
        $('.payment-method-options .payment-DW_APPLE_PAY').hide();
        $(document).ready(function() {
            $('isapplepay').hide();
            $('.dw-apple-pay-button, .dw-apple-pay-cart').hide();
            $('.payment-method-options .payment-DW_APPLE_PAY').hide();
        });
    }
}

},{}],27:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    giftcard = require('../../giftcard'),
    util = require('../../util'),
    applepay = require('./applepay');

/**
 * @function
 * @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
 * @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
 */
function setCCFields(data) {
    var $creditCard = $('[data-method="CREDIT_CARD"]');
    $creditCard.find('input[name$="creditCard_owner"]').val(data.holder).trigger('change');
    $creditCard.find('select[name$="_type"]').val(data.type).trigger('change');
    $creditCard.find('input[name*="_creditCard_number"]').val(data.maskedNumber).trigger('change');

    //Updated for cybersource 
    var selectedPaymentMethodID = $('input[name$="_selectedPaymentMethodID"]:checked').val();
    if (selectedPaymentMethodID == 'SA_SILENTPOST') {
        $creditCard.find('[name$="_month"]').val(data.expirationMonth);
        $creditCard.find('[name$="_year"]').val(data.expirationYear);
    } else {
        $creditCard.find('[name$="_month"]').val(data.expirationMonth).trigger('change');
        $creditCard.find('[name$="_year"]').val(data.expirationYear).trigger('change');
    }

    $creditCard.find('input[name$="_cvn"]').val('').trigger('change');

    //Added for cybersource
    $creditCard.find('[name$="creditCard_selectedCardID"]').val(data.selectedCardID).trigger('change');
    $creditCard.find('input[name$="_cvn"]').val('');

}

/**
 * @function
 * @description Detect card type from card number
 * @param {String} credit card number
 */
function detectCardType(number) {
    var re = {
        visa: /^4/,
        mastercard: /^5[1-5]/,
        amex: /^3[4,7]/,
        discover: /^6/,
        maestro: /^(5018|5020|5038|6304|6759|6761|6763)/
    };
    if (re.visa.test(number)) {
        return 'Visa';
    } else if (re.mastercard.test(number)) {
        return 'MasterCard';
    } else if (re.amex.test(number)) {
        return 'Amex';
    } else if (re.maestro.test(number)) {
        return 'Maestro';
    } else if (re.discover.test(number)) {
        return 'Discover';
    } else {
        return undefined;
    }
}

/**
 * @function
 * @description Updates the credit card form with the attributes of a given card
 * @param {String} cardID the credit card ID of a given card
 */
function populateCreditCardForm(cardID, selectedPaymentMethod) {
    // load card details
    var url = util.appendParamToURL(Urls.billingSelectCC, 'creditCardUUID', cardID);
    ajax.getJson({
        url: url,
        callback: function(data) {
            if (!data) {
                window.alert(Resources.CC_LOAD_ERROR);
                return false;
            }
            //Added for cybersource
            switch (selectedPaymentMethod) {
                case 'SA_REDIRECT':
                    $('.payment-method-expanded .saCCToken .field-wrapper').val(data.selectedCardID);
                    $('#dwfrm_billing_paymentMethods_creditCard_selectedCardID').val(data.selectedCardID);
                    break;
                case 'SA_IFRAME':
                    $('.payment-method-expanded .saIframeCCToken .field-wrapper').val(data.selectedCardID);
                    $('#dwfrm_billing_paymentMethods_creditCard_selectedCardID').val(data.selectedCardID);
                    break;
                case 'CREDIT_CARD':
                    setCCFields(data);
                    break;
                default:
                    setCCFields(data);
            }
        }
    });
}

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
    var $paymentMethods = $('.payment-method');
    $paymentMethods.removeClass('payment-method-expanded');

    //Added for cybersource
    var dataMethod = paymentMethodID;
    if (paymentMethodID == 'SA_SILENTPOST' || paymentMethodID == 'SVS_GIFT_CARD') {
        dataMethod = 'CREDIT_CARD';
    }
    var $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + dataMethod + '"]');

    if ($selectedPaymentMethod.length === 0) {
        $selectedPaymentMethod = $('[data-method="Custom"]');
    }

    //Added for cybersource
    if (paymentMethodID == 'VISA_CHECKOUT') {
        formPrepare.hideContinue();
        $('.visacheckoutbutton').show();
    } else if (paymentMethodID == 'DW_APPLE_PAY') {
        formPrepare.hideContinue();
    } else if (paymentMethodID == 'PAYPAL' || paymentMethodID == 'PAYPAL_CREDIT') {
        $('#billingAgreementCheckbox').attr('checked', false);
        formPrepare.hideContinue();
    } else {
        formPrepare.showContinue();
        $('.visacheckoutbutton').hide();
    }
    if (paymentMethodID == 'CREDIT_CARD' || paymentMethodID == 'SA_SILENTPOST') {
        //$('.spsavecard').show();
        $('.cyb_paymentmethods').css('display', 'block');
    } else if ((paymentMethodID == 'SA_REDIRECT' || paymentMethodID == 'SA_IFRAME') && SitePreferences.TOKENIZATION_ENABLED) {
        $('.spsavecard').show();
    } else {
        $('.spsavecard').hide();
    }

    //Added for cybersource
    var isBicRequired = $selectedPaymentMethod.data('bicrequired');
    if (isBicRequired) {
        $('.bic-section').show();
    } else {
        $('.bic-section').hide();
    }

    $selectedPaymentMethod.addClass('payment-method-expanded');

    // ensure checkbox of payment method is checked
    $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
    $('input[value=' + paymentMethodID + ']').prop('checked', 'checked');

    formPrepare.validateForm();
    
    if (paymentMethodID == 'AFTERPAY_PBI') {
        $('.spc-billing-btn span').html('CONTINUE WITH AFTERPAY');
        $('.form-row-button').addClass('afterpay-button');
        $('.spc-billing-btn').addClass('afterpay-continue-btn');
    } else {
        $('.spc-billing-btn span').html('CONTINUE TO REVIEW ORDER');
    }    
}

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function() {
    applepay('checkout-billing');
    var $checkoutForm = $('.checkout-billing');
    var $addGiftCert = $('#add-giftcert');
    var $giftCertCode = $('input[name$="_giftCertCode"]');
//    var $addCoupon = $('#add-coupon');
//    var $couponCode = $('input[name$="_couponCode"]');
    $('input[id*="useShippingAddressInBillingSection"]').on('change', function(){
        if ($('input[name="shippingAddressJSON"]') && $('input[name="shippingAddressJSON"]').val() && this.checked) {
            var form =  $('form.checkout-billing.address');
            var shippingAddress = JSON.parse($('input[name="shippingAddressJSON"]').val());
            form.find('input[id*="firstName"]').val(shippingAddress.firstName);
            form.find('input[id*="lastName"]').val(shippingAddress.lastName);
            form.find('input[id*="address1"]').val(shippingAddress.address1);
            form.find('input[id*="address2"]').val(shippingAddress.address2);
            form.find('input[id*="postal"]').val(shippingAddress.postal);
            form.find('input[id*="city"]').val(shippingAddress.city);
            form.find('select[id*="state"]').val(shippingAddress.state);
            form.find('input[id*="phone"]').val(shippingAddress.phone);
        }
    });
    var $selectPaymentMethod = $('.payment-method-options');
    var selectedPaymentMethod = $selectPaymentMethod.find(':checked').val();

    formPrepare.init({
        formSelector: 'form[id$="billing"]',
        continueSelector: '[name$="billing_save"]'
    });

    //Added for cybersource
    var $ccContainer = $($checkoutForm).find('.payment-method').filter(function() {
        return $(this).data('method') == 'CREDIT_CARD';
    });
    $($checkoutForm).find('input[name$="_selectedCardID"]').val('');
    $($checkoutForm).find('input[name*="_number"]').val('');
    $($checkoutForm).find('input[name*="_creditCard_cvn"]').val('');
    if ($($checkoutForm).find('input[name*="_creditCard_cvn"]').hasClass('error')) {
        $($checkoutForm).find('input[name*="_creditCard_cvn"]').removeClass('error');
        $($checkoutForm).find('.cvn').next('span.error').remove();
    }
    $ccContainer.find('input[name*="_number"]').on('change', function() {
        $($checkoutForm).find('input[name$="_selectedCardID"]').val('');
    });
    $ccContainer.find('input[name$="_owner"]').on('change', function() {
        $($checkoutForm).find('input[name$="_selectedCardID"]').val('');
    });
    $ccContainer.find('select[name$="creditCard_type"]').on('change', function() {
        $($checkoutForm).find('input[name$="_selectedCardID"]').val('');
    });
    $ccContainer.find('select[name*="expiration"]').on('change', function() {
        $($checkoutForm).find('input[name$="_selectedCardID"]').val('');
        var selectedPaymentMethodID = $('input[name$="_selectedPaymentMethodID"]:checked').val();
        var cardNumber = $($checkoutForm).find('input[name*="_number"]').val();
        if (cardNumber.indexOf('****') != -1 && selectedPaymentMethodID == 'SA_SILENTPOST') {
            $($checkoutForm).find('input[name*="_number"]').val('');
        }

    });
    //var $ccNum = $ccContainer.find('input[name$="_number"]');


    // default payment method to 'CREDIT_CARD'
    updatePaymentMethod((selectedPaymentMethod) ? selectedPaymentMethod : 'CREDIT_CARD');
    $selectPaymentMethod.on('click', 'input[type="radio"]', function() {
        updatePaymentMethod($(this).val());
    });

    // select credit card from list
    $('#creditCardList').on('change', function() {
        var cardUUID = $(this).val();

        //Updated for cybersource
        if (!cardUUID) {
            $($checkoutForm).find('input[name$="_selectedCardID"]').val('');
            return;
        }
        populateCreditCardForm(cardUUID, selectedPaymentMethod);

        // remove server side error
        $('.required.error').removeClass('error');
        $('.error-message').remove();
    });
    
    $('#check-giftcert').on('click', function(e) {
        e.preventDefault();
        var $balance = $('.balance');
        if ($giftCertCode.length === 0 || $giftCertCode.val().length === 0) {
            var error = $balance.find('span.error');
            if (error.length === 0) {
                error = $('<span>').addClass('error').appendTo($balance);
            }
            error.html(Resources.GIFT_CERT_MISSING);
            return;
        }

        giftcard.checkBalance($giftCertCode.val(), function(data) {
            if (!data || !data.giftCertificate) {
                $balance.html(Resources.GIFT_CERT_INVALID).removeClass('success').addClass('error');
                return;
            }
            $balance.html(Resources.GIFT_CERT_BALANCE + ' ' + data.giftCertificate.balance).removeClass('error').addClass('success');
        });
    });

    $addGiftCert.on('click', function(e) {
        e.preventDefault();
        var code = $giftCertCode.val(),
            $error = $checkoutForm.find('.giftcert-error');
        if (code.length === 0) {
            $error.html(Resources.GIFT_CERT_MISSING);
            return;
        }

        var url = util.appendParamsToUrl(Urls.redeemGiftCert, {
            giftCertCode: code,
            format: 'ajax'
        });
        $.getJSON(url, function(data) {
            var fail = false;
            var msg = '';
            if (!data) {
                msg = Resources.BAD_RESPONSE;
                fail = true;
            } else if (!data.success) {
                msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
                fail = true;
            }
            if (fail) {
                $error.html(msg);
                return;
            } else {
                if ($('.spc-billing').length === 0) {
                    window.location.assign(Urls.billing);
                } else {
                    $('.spc-billing .checkout-tab-head.open[data-refreshurl]').trigger('click');
                }
            }
        });
    });

// SUR-850 removed add Coupon from billing form
//    $addCoupon.off().on('click', function(e) {
//        e.preventDefault();
//        var $error = $checkoutForm.find('.coupon-error'),
//            code = $couponCode.val();
//        if (code.length === 0) {
//            $error.html(Resources.COUPON_CODE_MISSING);
//            return;
//        }
//
//        var url = util.appendParamsToUrl(Urls.addCoupon, {
//            couponCode: code,
//            format: 'ajax'
//        });
//        $.getJSON(url, function(data) {
//            var fail = false;
//            var msg = '';
//            var couponType = '';
//            if (!data) {
//                msg = Resources.BAD_RESPONSE;
//                fail = true;
//            } else if (!data.success) {
//                msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
//                fail = true;
//            } else {
//                couponType =  data.couponType;
//            }
//            if (isGTMEnabled) {
//                require('../../gtm').applyCoupon(code, !fail, couponType);
//            }
//            if (fail) {
//                $error.html(msg);
//                return;
//            }
//
//            //basket check for displaying the payment section, if the adjusted total of the basket is 0 after applying the coupon
//            //this will force a page refresh to display the coupon message based on a parameter message
//            if (data.success) {
//                if ($('.spc-billing').length === 0) {
//                    window.location.assign(Urls.billing);
//                } else {
//                    window.saveBillingFormGlobal();
//                    $('.spc-billing .checkout-tab-head.open[data-refreshurl]').trigger('click');
//                }
//            }
//        });
//    });

    // trigger events on enter
//    $couponCode.on('keydown', function(e) {
//        if (e.which === 13) {
//            e.preventDefault();
//            $addCoupon.click();
//        }
//    });
    $giftCertCode.on('keydown', function(e) {
        if (e.which === 13) {
            e.preventDefault();
            $addGiftCert.click();
        }
    });

    $('[data-method="CREDIT_CARD"]').find('input[name*="_creditCard_number"]').keyup(function() {
        var cardNumber = $(this).val().trim();
        if (cardNumber && cardNumber != '') {
            var cardType = detectCardType(cardNumber);
            if (cardType != undefined) {
                $('[data-method="CREDIT_CARD"]').find('select[name*="_creditCard_type"]').val(cardType);
            }
        }
    });

    $('[data-method="CREDIT_CARD"]').find('select[name*="_creditCard_type"]').change(function() {
        var cardNumber = $('[data-method="CREDIT_CARD"]').find('input[name*="_creditCard_number"]').val().trim();
        if (cardNumber && cardNumber != '') {
            var cardType = detectCardType(cardNumber);
            if (cardType != $(this).val()) {
                $('[data-method="CREDIT_CARD"]').find('input[name*="_creditCard_number"]').val('');
            }
        }
    });
    require('../../addressvalidation').init();
};

},{"../../addressvalidation":1,"../../ajax":2,"../../giftcard":15,"../../util":78,"./applepay":26,"./formPrepare":29}],28:[function(require,module,exports){
'use strict';

var util = require('../../util'),
    dialog = require('../../dialog');
var freeShipping = require('./freeShipping');

var updateAddCouponBtn = function ($btnSelector, $existCoupon) {
    if ($existCoupon) {
        $btnSelector.addClass('applied-state');
        $btnSelector.attr('disabled', 'disabled');

    } else {
        $btnSelector.removeClass('applied-state');
        $btnSelector.removeAttr('disabled', 'disabled');
    }
}

var checkIfCouponAlreadyApplied = function ($parentSelector) {
    if ($parentSelector.find('.rowcoupons').length > 0) {
        updateAddCouponBtn($parentSelector.find('#add-coupon'), true);
        return true;
    } else {
        updateAddCouponBtn($parentSelector.find('#add-coupon'), false);
        return false;
    }
}

function refreshFreeShippingBar(response){
    const thresoldShippingAmount = parseFloat($('input[type=hidden][name=thresoldShippingAmount]').val());
    const percentComplete = response.neededPercent;
    const cartNeededForFreeShipping = response.neededAmount;
    freeShipping.update(percentComplete, thresoldShippingAmount, cartNeededForFreeShipping);
}

var updateCoupnData = function (response) {
    $('.coupons-section').html('');
    $('.rowcoupons').html('');
    $('.promo').remove();
    var couponLineItem = response.couponLineItem;
    var finalDiscountPrice = 0;
    var productcouponvalue  = '';
    var promoCode = '';
    for (var i = 0; i < couponLineItem.length; i++) {
        var btnID = '';
        if (couponLineItem[i].isRemoved && couponLineItem[i].isRemoved == true) {
            btnID = 'remove-session-coupon-code';
        } else {
            btnID = 'remove-coupon-code';
        }
        var promotionMsg = '<span class="bonus-item">'+response.promotionMSG+'</span>';

        var firstSection= '<div class="rowcoupons">';
        firstSection += '<div class="details"><div class="item-details">';
        firstSection += '<div class="cartcoupon clearfix"><span class="value">'+couponLineItem[i].couponCode +'</span></div>';
        firstSection += '<div class="item-quantity-details">';
        firstSection += '<button class="remove-coupon-btn" action="javascript:void(0);" id= '+btnID+' value='+couponLineItem[i].couponCode+'>'+ Resources.REMOVE +'</button>';
        firstSection += '</div></div>';
        firstSection += '<div class="item-details-col"><div class="item-total">';
        firstSection += promotionMsg;
        firstSection += '</div></div></div>';

        $('.coupons-section').append(firstSection);

        if (couponLineItem[i].valid && couponLineItem[i].applied) {
            finalDiscountPrice = couponLineItem[i].totalPrice;
            productcouponvalue += '<span class="productcouponvalue c2">'+
            couponLineItem[i].couponCode +'</br>'+'</span>';
            promoCode += '<div class="b2 promo promo-display ';
            if (i==0) {
                promoCode+='first">';
            } else if (i==couponLineItem.length-1) {
                promoCode+='last">';
            } else {
                promoCode+='">';
            }
            promoCode+=couponLineItem[i].couponLineItemText+'</div>';
        }

    }

    if (!finalDiscountPrice) {
        finalDiscountPrice = response.promoSavings;
    }
    var productLineItem;
    if (finalDiscountPrice) {
        finalDiscountPrice = Math.abs(finalDiscountPrice).toFixed(2);
        productLineItem = response.discountsPLIArray;
        for (var j= 0; j < productLineItem.length; j++) {
            $('[data-productid="' + productLineItem[j].productID + '"].cart-row .item-total').html('').append('<div class="total-coupon-discount"></div>');
            $('[data-productid="' + productLineItem[j].productID + '"].cart-row .item-total .total-coupon-discount').html(
                '<span class="price-sales">'+
                '<span>'+Resources.DOLLARSIGN+productLineItem[j].priceAfter.toFixed(2)+'</span>'+
                '</span>'
            );
            var lineItemElement = $('.line-item-coupon-msg-'+productLineItem[j].productID);
            var includeMsgTemplate = '<span class="item-inclusion-msg">'+response.couponCode+'. '+response.promotionMSG+'</span>';
            $(lineItemElement).append(includeMsgTemplate);
        }
        $('.order-discount').remove();
        $('.order-subtotal').after(
            '<tr class="order-discount discount c3">'+
            '<td>' +Resources.ORDERPROMOSAVING +'</td>'+
            '<td class="order-discount-value">- '+Resources.DOLLARSIGN+finalDiscountPrice+'</td>'+
            '</tr>'
        );
        $('.order-discount').css('display','revert');
    } else {
        productLineItem = response.discountsPLIArray;
        $('.order-discount').remove();
        $('.promo').remove();
        for (var d = 0; d < productLineItem.length; d++) {
            $('[data-productid="' + productLineItem[d].productID + '"].cart-row .item-total').html('').append('<div class="total-coupon-discount"></div>');
            $('[data-productid="' + productLineItem[d].productID + '"].cart-row .item-total .total-coupon-discount').html(           
                '<span class="price-sales">'+Resources.DOLLARSIGN+
                productLineItem[d].priceBefor.toFixed(2)+
            '</span>'
            ); 
        }
    }

    if (response.applicableCoupon && response.adjustedMerchandizeTotalNetPrice > 0) {
        $('.order-value').html('$' + response.adjustedMerchandizeTotalNetPrice.toFixed(2));
    } else if (response.orderTotalValue) {
        $('.order-value').html('$' + response.orderTotalValue); 
    }

    if (response.totalShipment == 0 || response.isFreeShipping){
        $('.order-totals-table').find('.order-shipping .total-order-shipping').text('Free');
    } else if (response.totalShipment != 0) {
        $('.order-totals-table').find('.order-shipping .total-order-shipping').text('$' + response.totalShipment.toFixed(2)); 
    }

    if (response.sameDayDeliveryShippingPrice > 0) {
        $('.order-totals-table').find('.total-order-shipping-sameday-delivery').text('$' + response.sameDayDeliveryShippingPrice.toFixed(2)); 
    }
}

var couponAdd = function ($addCoupon, $errorElement, $parentSelector) {
    $addCoupon.off('click').on('click', function (e) {
        e.preventDefault();
        $errorElement.html('');
        var $couponInput = $parentSelector.find('input[name$="_couponCode"]');
        var $codeValue = $couponInput.val();
        if (checkIfCouponAlreadyApplied($parentSelector)) {
            $errorElement.css('display', 'inline-block');
            $errorElement.html(Resources.ANOTHER_COUPON_CODE_APPLIED);

            updateAddCouponBtn($parentSelector.find('#add-coupon'), true);
            return false;
        }
        if ($codeValue.length == 0) {
            $errorElement.css('display', 'inline-block');
            $errorElement.html(Resources.COUPON_CODE_MISSING);
            return false;
        }

        var url = util.appendParamsToUrl(Urls.addCoupon, {
            couponCode: $codeValue,
            format: 'isAjax'
        });

        $.ajax({
            dataType: 'json',
            url: url,
            success: function(response) {
                $errorElement.html('');
                if (response.inVaildCode) {
                    $errorElement.html(Resources.COUPON_CODE_INVAILD);
                    $errorElement.css('display','inline-block');
                } else {
                    $errorElement.css('display','none');
                    var execludedProductsArray = response.ExecludedID;
                    for (var i =0; i < execludedProductsArray.length; i++){
                        var lineItemElement = $('.line-item-coupon-msg-'+execludedProductsArray[i]);
                        var excludeMsgTemplate = '<span class="item-exclusion-msg">'+Resources.ITEMEXCLUSIONMSG+'</span>';
                        $(lineItemElement).append(excludeMsgTemplate);
                    }
                    updateAddCouponBtn($parentSelector.find('#add-coupon'), true);
                    $('.checkout-coupon-code').addClass('coupon-section-border-bottom');
                    $('.cart-coupon-code').addClass('coupon-section-border-bottom');
                }
                updateCoupnData(response);
                refreshFreeShippingBar(response);
                var lineItemsLength = $('#all-items-count').val();
                var displayMsg = '';
                if (lineItemsLength > 1) {
                    displayMsg = Resources.COUPONELIGABLEPLIMSG;
                } else {
                    var singleLineItemQty = $('#single-item-qty').val();
                    if (singleLineItemQty > 1 && singleLineItemQty != false) {
                        displayMsg = Resources.COUPONELIGABLEPLIMSG;
                    } else if (singleLineItemQty) {
                        displayMsg = Resources.COUPONELIGABLEPLIMSG1;
                    }
                    
                }
                var displayEligableMsg = '';
                if (response.amountQualifiedIssue == true) {
                    displayEligableMsg = '<div class="eligable-msg-display"><span class="item-eligable-msg">'
                    +'Eligible product subtotal must exceed $'+response.promotionAmount+'. '+displayMsg
                    +'</span> <a href="/on/demandware.store/Sites-SLT-Site/default/Page-Show?cid='
                    +response.promotionID+'" class="exclusions-apply-msg">'+
                    Resources.DETAILS+'</a></div>'
                }
                if (response.allLinesExecluded == true) {
                    displayEligableMsg = 
                    '<div class="eligable-msg-display"><span class="item-eligable-msg">'+
                    displayMsg+
                    '</span> <a href="/on/demandware.store/Sites-SLT-Site/default/Page-Show?cid='+
                    response.promotionID+'" class="exclusions-apply-msg">'+Resources.DETAILS+'</a></div>'
                }
                $('.rowcoupons .details').append(displayEligableMsg);
            }
        });
        $couponInput.val('');
    });
}

var toggleCouponSection = function ($parentSelector) {
    var $title = $parentSelector.find('.title');
    $title.on('click', function () {
        $(this).toggleClass('active');
        $(this).siblings('.additional-content').toggle();
    });
}

var addDiscountToTableSummary = function () {
    if ($('body').find('.order-discount-table').length > 0) {
        $('.order-discount-table').insertAfter('.normal-table');
    }
}

var removeCouponCode = function ($addCoupon, $errorElement) {
    $(document).on('click', '#remove-coupon-code', function (e) {
        e.preventDefault();
        var $couponValue = $(this).val();
        var url = util.appendParamsToUrl(Urls.removeCoupon, {
            couponCode: $couponValue,
            format: 'isAjax'
        });

        $.ajax({
            dataType: 'json',
            url: url,
            success: function(response) {  
                $errorElement.css('display','none');      
                updateCoupnData(response);
                refreshFreeShippingBar(response);
                updateAddCouponBtn($addCoupon, false);
                $('.item-exclusion-msg').remove();
                $('.item-inclusion-msg').remove();
            }
        });
        $('.checkout-coupon-code').removeClass('coupon-section-border-bottom');
        $('.cart-coupon-code').removeClass('coupon-section-border-bottom');
    });
}

var couponCode = {
    init: function ($parentSelector) {      
        var $addCoupon = $parentSelector.find('#add-coupon');
        var $couponCode = $parentSelector.find('input[name$="_couponCode"]');
        var $errorElement = $parentSelector.find('.coupon-error');


        $couponCode.on('keyup', function () {
            if ($addCoupon.hasClass('applied-state')) {
                $addCoupon.removeClass('applied-state');
                $addCoupon.removeAttr('disabled', 'disabled');
            }
            //checkIfCouponAlreadyApplied($parentSelector);
        });
        checkIfCouponAlreadyApplied($parentSelector);

        couponAdd($addCoupon, $errorElement, $parentSelector);

        toggleCouponSection($parentSelector);

        addDiscountToTableSummary();

        removeCouponCode($addCoupon, $errorElement);
        
        $couponCode.on('focusout', function () {
            if ($(this).val() == '') {
                var $isCouponExist = checkIfCouponAlreadyApplied($parentSelector);
                if ($isCouponExist) {
                    updateAddCouponBtn($addCoupon, true)
                }
            }
        });

        $(document).on('click', '.exclusions-apply-msg', function (e) {
            e.preventDefault();
            var currentPosition = $(document).scrollTop();
            
            dialog.open({
                url: $(e.target).attr('href'),
                options: {
                    title: '',
                    dialogClass:'exclusions-apply-dialog',
                    width: 462,
                    height: '462',
                    draggable: false,
                    close: function () {
                        $(window).scrollTop(currentPosition);
                    },
                    open: function () {
                        $(window).scrollTop(0);
                        $(document).on('click', '.ui-widget-overlay', function () {
                            $('.ui-dialog-titlebar-close').trigger('click');
                        });
                    }
                }
            });
            return false;
        })

    }
}

module.exports = couponCode;

},{"../../dialog":13,"../../util":78,"./freeShipping":30}],29:[function(require,module,exports){
'use strict';

var _ = require('lodash');

var $form, $continue, validator;
var isShippingForm = false;

var showContinue = function() {
    $continue.show();
};

var hideContinue = function() {
    $continue.hide();
};


var disableContinue = function() {
    $continue.attr('disabled', 'disabled');
};

var validateForm = function () {
    if (!validator) {
        return;
    }

    if (validator.checkForm() && validateShippingMethod()) {
        $continue.removeAttr('disabled');
    } else {
        $continue.attr('disabled', 'disabled');
    }
};

var validateShippingMethod = function() {
    var isValid = true;
    if (isShippingForm) {
        if (typeof($('[name$="shippingAddress_shippingMethodID"]:checked').val()) == 'undefined') {
            isValid = false;
        }
    }
    return isValid;
};

var init = function (opts) {
    if (!opts.formSelector || !opts.continueSelector) {
        throw new Error('Missing form and continue action selectors.');
    }
    $form = $(opts.formSelector);
    $continue = $(opts.continueSelector);
    validator = $form.validate();
    isShippingForm = $continue.attr('name').indexOf('shippingAddress_save') > 0;
    validateForm();
    // start listening
    // Any posible change inside the form element triggers validateForm, so we need debouncing.
    $form.on('input keyup keypress blur change', _.debounce(validateForm, 200));
};

exports.init = init;
exports.validateForm = validateForm;
exports.showContinue = showContinue;
exports.hideContinue = hideContinue;
exports.disableContinue = disableContinue;

},{"lodash":94}],30:[function(require,module,exports){
'use strict';

function update(percentComplete, thresoldShippingAmount, cartNeededForFreeShipping) {
    const processbarContainer = $('#processbar-container');
    
    if (!processbarContainer.length) {
        return;
    }

    processbarContainer.removeClass('hidden');

    const price = processbarContainer.find('#bubble-price');
    
    processbarContainer.find('#processbar-completed').css('width', percentComplete.toFixed(2) + '%'); // 4x padding each side

    if (percentComplete >= 100) {
        processbarContainer.find('.free-shipping-complete').removeClass('hidden');
        processbarContainer.find('.free-shipping-incomplete').addClass('hidden');
        price.addClass('hidden');
    } else {
        processbarContainer.find('.free-shipping-complete').addClass('hidden');
        processbarContainer.find('.free-shipping-incomplete').removeClass('hidden');
        price.removeClass('hidden');

        let variation = 0;
        if (window.innerWidth > 375) {
            variation += 30 + Math.round(percentComplete) / 5 * 3;

            if (percentComplete > 60) {
                variation += 3;
            }
        } else {
            variation += Math.round(percentComplete) / 5 * 4;

            if (percentComplete > 60) {
                variation += 9;
            }
        }
        if (percentComplete < 40) {
            variation -= 3;
        } 
        price.css('left', 'calc(' + percentComplete + '% - ' + variation + 'px)');

        const cartTotalForFreeShipping = (thresoldShippingAmount - cartNeededForFreeShipping).toFixed(2);
        
        processbarContainer.find('#processbar-price').text('$' + cartTotalForFreeShipping);
        processbarContainer.find('#free-shipping-cart-total').text('$' + (cartNeededForFreeShipping.toFixed(2)));
    }
}

module.exports = {
    update
};

},{}],31:[function(require,module,exports){
'use strict';

var util = require('../../util');

//this function triggered when initiating gift package add to cart
function addgiftpackageitem($this) {
    var curGP, mainuuid, giftPosition, toVal, fromVal, gpUrl, data;
    curGP = $this.parents('.giftpackage-select');
    mainuuid = curGP.find('.js-giftpackage-checkbox').data('mainlineitem');
    giftPosition = curGP.find('.js-giftpackage-checkbox').data('position');
    toVal = curGP.find('.giftpackage-to').val();
    fromVal = curGP.find('.giftpackage-from').val();
    if (curGP.find('input.js-giftpackage-checkbox').is(':checked')) {
        data = {
            'mainuuid': mainuuid.toString(),
            'position': giftPosition.toString(),
            'to': toVal.toString(),
            'from': fromVal.toString()
        };
        gpUrl = Urls.addGiftPackage;
        gpUrl = util.appendParamsToUrl(gpUrl, {
            'giftpackconf': JSON.stringify(data),
            'index': $this.data('index')
        });
        if ($('body').find('div.spc-multi-shipping').length > 0) {
            gpUrl = util.appendParamToURL(gpUrl, 'multiship', true);
        }
        $.ajax({
            url: gpUrl,
            type: 'POST',
            async: false,
            success: function() {
                updateSummary();
            }
        });
    }
}

//Updating the minisummary with giftpackaging details
function updateSummary() {
    var url = Urls.summaryRefreshURL;
    url = util.appendParamToURL(url, 'format', 'ajax');
    var summary = $('#secondary.summary');
    summary.load(url, function() {
        summary.find('.checkout-mini-cart .minishipment .header a').hide();
        summary.find('.order-totals-table .order-shipping .label a').hide();
    });
}

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function() {

    //trigger addgiftpackageitem on focusout of to & from input fields from shipping page
    $('body').off('blur', 'input.giftpackage-from, input.giftpackage-to').on('blur', 'input.giftpackage-from, input.giftpackage-to', function(e) {
        e.stopPropagation();
        addgiftpackageitem($(this));
    });

    //To allow only specified characters in to & from giftpacking fields
    $('body').on('keypress', 'input.giftpackage-from, input.giftpackage-to', function(event) {
        var regex = new RegExp(/[^a-zA-Z0-9 \-\s\b]+$/);
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        var specialKeys = event.key;
        if (specialKeys == 'ArrowLeft' || specialKeys == 'ArrowRight' || specialKeys == 'Delete') {
            return true;
        }
        if (event.keyCode >= 96 && event.keyCode <= 105) {
            return true;
        }
        if (regex.test(key)) {
            event.preventDefault();
            return false;
        }
    });

    //trigger addgiftpackageitem on change of checkbox from shipping page
    //this is triggered incase user decides to send empty messages
    $('body').find('.giftpackage-select').off('click').on('click', 'input.js-giftpackage-checkbox', function() {
        if ($(this).is(':checked')) {
            $(this).parents('.giftpackage-select').find('.giftpack-formfield').removeClass('hide');
            $(this).parents('.giftpackage-select').find('.giftpackage-tagline').addClass('hide');
            $(this).parents('.giftpackage-select').find('.giftpackage-add-tagline').removeClass('hide');
            addgiftpackageitem($(this));
        } else if (!($(this).is(':checked'))) {
            var curGP, mainuuid, giftPosition, removeGpUrl;
            mainuuid = $(this).data('mainlineitem');
            giftPosition = $(this).data('position');
            curGP = $(this).parents('.giftpackage-select');
            curGP.find('.giftpack-formfield').addClass('hide');
            curGP.find('.giftpack-formfield').find('.giftpackage-to').val('');
            curGP.find('.giftpack-formfield').find('.giftpackage-from').val('');
            curGP.find('.giftpackage-add-tagline').addClass('hide');
            curGP.find('.giftpackage-tagline').removeClass('hide');
            removeGpUrl = Urls.removeGiftPackage;
            removeGpUrl = util.appendParamsToUrl(removeGpUrl, {
                'mainuuid': mainuuid,
                'position': giftPosition,
                'index': $(this).data('index')
            });
            if ($('body').find('div.spc-multi-shipping').length > 0) {
                removeGpUrl = util.appendParamsToUrl(removeGpUrl, {
                    'multiship': true
                });
            }
            $.ajax({
                url: removeGpUrl,
                type: 'POST',
                async: false,
                success: function() {
                    updateSummary();
                }
            });
        }
    });
    $(document).ready(function () {
        var giftPackButton = $('.giftpack-toggle');
        var isAddedGiftPack = $('#addedGiftPack').val();
        if (giftPackButton && isAddedGiftPack === 'true') {
            giftPackButton.click();
        }
    });
};

},{"../../util":78}],32:[function(require,module,exports){
'use strict';

var address = require('./address'),
    billing = require('./billing'),
    multiship = require('./multiship'),
    shipping = require('./shipping'),
    //couponCode = require('./couponCode'),
    applepay = require('./applepay'),
    couponCodeModule = require('./couponCodeModule');
    

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
    applepay('checkout-login');
    address.init();
    couponCodeModule.init($('.billing-coupon-code-sec'));
    if (isGTMEnabled) {
        require('../../gtm').emailcheckou();
    }
    if ($('.checkout-shipping').length > 0) {
        shipping.init();
    } else if ($('.checkout-multi-shipping').length > 0) {
        multiship.init();
    } else if ($('.checkout-billing').length > 0) { //PREVAIL-Added $('.checkout-billing').length > 0 to handle SPC
        billing.init();
    }

    //if on the order review page and there are products that are not available diable the submit order button
    if ($('.order-summary-footer').length > 0) {
        if ($('.notavailable').length > 0) {
            $('.order-summary-footer .submit-order .button-fancy-large').attr('disabled', 'disabled');
        }
    }

    history.replaceState(history.state, null, Urls.startCheckout);
/*
	revert SUR-820 changes

    if (pageContext && pageContext.ns == 'checkout' && history.state != 'saveAddress') {
        history.replaceState('saveAddress', '', window.location.href);
        history.pushState('saveAddress', null, window.location.href);
    }
    window.addEventListener('popstate', function(e) {
        if (e.state == 'saveAddress') {
            var form = $('#dwfrm_singleshipping_shippingAddress');
            if (form != null && form.length > 0) {
                form.validate();
                if (form.valid()) {
                    $.ajax({
                        url: Urls.updateShippingAddress,
                        data: form.serialize(),
                        type: 'get'
                    });
                }
            }
            window.location.href = Urls.cartShow;
        }
    });
*/

};

},{"../../gtm":18,"./address":25,"./applepay":26,"./billing":27,"./couponCodeModule":28,"./multiship":33,"./shipping":34}],33:[function(require,module,exports){
'use strict';

var address = require('./address'),
    formPrepare = require('./formPrepare'),
    dialog = require('../../dialog'),
    util = require('../../util'),
    validator = require('../../validator');

/**
 * @function
 * @description Initializes gift message box for multiship shipping, the message box starts off as hidden and this will display it if the radio button is checked to yes, also added event handler to listen for when a radio button is pressed to display the message box
 */
function initMultiGiftMessageBox() {
    $.each($('.item-list'), function () {
        var $this = $(this);
        var $giftMessage = $this.find('.gift-message-text');

        //handle initial load
        $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');

        //set event listeners
        $this.on('change', function () {
            $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');
        });
    });
}


/**
 * @function
 * @description capture add edit adddress form events
 */
function addEditAddress(target) {
    var $addressForm = $('form[name$="multishipping_editAddress"]'),
        $addressDropdown = $addressForm.find('select[name$=_addressList]'),
        $addressList = $addressForm.find('.address-list'),
        add = true,
        originalUUID,
        resetOptionValue = false,
        selectedAddressUUID = $(target).parent().siblings('.select-address').val();

    $addressDropdown.on('change', function (e) {
        e.preventDefault();

        var selectedAddress = $addressList.find('select').val();
        if (selectedAddress !== 'newAddress') {
            selectedAddress = $.grep($addressList.data('addresses'), function (add) {
                return add.UUID === selectedAddress;
            })[0];
            add = false;
            resetOptionValue = false;
            // proceed to fill the form with the selected address
            util.fillAddressFields(selectedAddress, $addressForm);
        } else if  (selectedAddress === 'newAddress') {
            add = true;
            resetOptionValue = true;
            $addressForm.find('.input-text, .input-select').val('');
        } else {
            //reset the form if the value of the option is not a UUID
            $addressForm.find('.input-text, .input-select').val('');
        }
    });

    $addressForm.on('click', '.cancel', function (e) {
        e.preventDefault();
        dialog.close();
    });

    $addressForm.on('submit', function (e) {
        e.preventDefault();
        if (!$addressForm.valid()) {
            return false;
        }

        $.getJSON(Urls.addEditAddress, $addressForm.serialize(), function (response) {
            if (!response.success) {
                $('#multiaddresserror').html(Resources.COULD_NOT_SAVE_ADDRESS);
                return;
            }
            $('#multiaddresserror').toggleClass('hidden', response.success);

            var address = response.address,
                $shippingAddress = $(target).closest('.shippingaddress'),
                $select = $shippingAddress.find('.select-address'),
                $selected = $select.find('option:selected'),
                newOption = '<option value="' + address.UUID + '">' +
                    ((address.ID) ? '(' + address.ID + ')' : address.firstName + ' ' + address.lastName) + ', ' +
                    address.address1 + ', ' + address.city + ', ' + address.stateCode + ', ' + address.postalCode +
                    '</option>';
            dialog.close();

            if (address.UUID !== originalUUID) {
                resetOptionValue = true;
            }

            if (add) {
                $('.shippingaddress select').removeClass('no-option').append(newOption);
                $('.no-address').hide();
            } else {
                $('.shippingaddress select').find('option[value="' + address.UUID + '"]').html(newOption);
            }
            // if there's no previously selected option, select it
            if ($selected.length === 0 || $selected.val() === '' || resetOptionValue) {
                $select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
            }
        });
    });

    //preserve the uuid of the option for the hop up form
    if (selectedAddressUUID) {
        //update the form with selected address
        $addressList.find('option').each(function () {
            //check the values of the options
            if ($(this).attr('value') === selectedAddressUUID) {
                $(this).prop('selected', 'selected');
                $addressDropdown.trigger('change');
            }
        });
        originalUUID = selectedAddressUUID;
    }

    validator.init();
}

/**
 * @function
 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
 */
exports.init = function () {
    initMultiGiftMessageBox();
    if ($('.cart-row .shippingaddress .select-address').length > 0) {
        formPrepare.init({
            continueSelector: '[name$="addressSelection_save"]',
            formSelector: '[id$="multishipping_addressSelection"]'
        });
    }
    $('.edit-address').on('click', 'span', function (e) {
        dialog.open({url: this.attributes.href.value,  options: {open: function () {
            address.init();
            addEditAddress(e.target);
        }}});
    });
};

},{"../../dialog":13,"../../util":78,"../../validator":79,"./address":25,"./formPrepare":29}],34:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    progress = require('../../progress'),
    tooltip = require('../../tooltip'),
    couponCode = require('./couponCodeModule'),
    util = require('../../util');

var shippingMethods;
/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
    // show gift message box, if shipment is gift
    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
    var $summary = $('#secondary.summary');
    // indicate progress
    progress.show($summary);

    // load the updated summary area
    var url = Urls.summaryRefreshURL;
    url = util.appendParamToURL(url, 'format', 'ajax');
    $summary.load(url, function () {
        // hide edit shipping method link
        $summary.fadeIn('fast');
        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
        setTimeout(() => {
            couponCode.init($('.billing-coupon-code-sec'));
        }, 3000);
    });
}

/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
    var $form = $('.address');
    var params = {
        format: 'ajax',
        address1: $form.find('input[name$="_address1"]').val(),
        address2: $form.find('input[name$="_address2"]').val(),
        countryCode: $form.find('select[id$="_country"]').val(),
        stateCode: $form.find('select[id$="_state"]').val(),
        postalCode: $form.find('input[name$="_postal"]').val(),
        city: $form.find('input[name$="_city"]').val()
    };
    return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
    // nothing entered
    if (!shippingMethodID) {
        return;
    }
    // attempt to set shipping method
    var url = getShippingMethodURL(Urls.selectShippingMethodsList, {shippingMethodID: shippingMethodID});
    ajax.getJson({
        url: url,
        callback: function (data) {
            var form =  $('form.checkout-shipping.address');
            var selectdState = form.find('select[id*="state"]').val();
            var excludedShippingSku = $('#AKHINoShippingProduct').val();
            var doUpdate = true;
            $('.order-summary-content .mini-cart-right').each(function () {
                var lineItemSku = $(this).data('productitemid');
                if (excludedShippingSku.includes(lineItemSku) && (selectdState == 'HI' || selectdState == 'AK')) {
                    doUpdate = false;
                }
            });
            if (doUpdate){
                updateSummary();
            }
            if (!data || !data.shippingMethodID) {
                window.alert('Couldn\'t select shipping method.');
                return false;
            }
            // display promotion in UI and update the summary section,
            // if some promotions were applied
            $('.shippingpromotions').empty();


            // if (data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
            //     var len = data.shippingPriceAdjustments.length;
            //     for (var i=0; i < len; i++) {
            //         var spa = data.shippingPriceAdjustments[i];
            //     }
            // }
        }
    });
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
    formPrepare.disableContinue();
    var $shippingMethodList = $('#shipping-method-list');
    if (!$shippingMethodList || $shippingMethodList.length === 0) {
        return; 
    }
    var url = getShippingMethodURL(Urls.shippingMethodsJSON);
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data) {
                window.alert('Couldn\'t get list of applicable shipping methods.');
                return false;
            }

            if (shippingMethods && shippingMethods.toString() === data.toString()) {
                // No need to update the UI.  The list has not changed.
                //if nothing is selected in the shipping methods select the first one
                if ($shippingMethodList.find('.input-radio:checked').length === 0) {
                    $shippingMethodList.find('.input-radio:first').prop('checked', 'checked');
                }
                formPrepare.validateForm();
                return true;
            }

            // We need to update the UI.  The list has changed.
            // Cache the array of returned shipping methods.
            shippingMethods = data;
            // indicate progress
            progress.show($shippingMethodList);

            // load the shipping method form
            var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
            $shippingMethodList.load(smlUrl, function () {
                $shippingMethodList.fadeIn('fast');
                // rebind the radio buttons onclick function to a handler.
                $shippingMethodList.find('[name$="_shippingMethodID"]').click(function () {
                    selectShippingMethod($(this).val());
                });
                var form =  $('form.checkout-shipping.address');
                var selectdState = form.find('select[id*="state"]').val();
                var excludedShippingSku = $('#AKHINoShippingProduct').val();
                var doUpdate = true;
                $('.order-summary-content .mini-cart-right').each(function () {
                    var lineItemSku = $(this).data('productitemid');
                    if (excludedShippingSku.includes(lineItemSku) && (selectdState == 'HI' || selectdState == 'AK')) {
                        doUpdate = false;
                    }
                });
                if (doUpdate) {
                    updateSummary();
                }
                progress.hide();
                tooltip.init();
                
                //if nothing is selected in the shipping methods select the first one
                if ($shippingMethodList.find('.input-radio:checked').length === 0) {
                    $shippingMethodList.find('.input-radio:first').prop('checked', 'checked');
                    $shippingMethodList.find('.input-radio:first').trigger('click');
                }
                
                $('input[name$="_addressFields_address1"], input[name$="_addressFields_address2"]').on('change', function() {
                    var pattern = new RegExp('[PO.]*\\s?B(ox)?.*\\d+', 'i');
                    if ($(this).val().match(pattern)) {
                        if ($(this).next('.po-error').length ==0) { 
                            $(this).after('<span class="po-error error">' + Resources.VALIDATE_POBOXES + '</span>');
                        }  
                    } else {
                        $(this).next('.po-error').remove();
                    }
                });

                formPrepare.validateForm();
            });
        }
    });
}

exports.init = function () {
    formPrepare.init({
        continueSelector: '[name$="shippingAddress_save"]',
        formSelector:'[id$="singleshipping_shippingAddress"]'
    });
    $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);

    $('.address').on('change',
        'input[name$="_addressFields_address1"], input[name$="_addressFields_address2"], select[name$="_addressFields_states_state"], input[name$="_addressFields_city"], input[name$="_addressFields_zip"]',
        updateShippingMethodList
    );
    // APO/FPO link should not be clickable
    $('form.checkout-shipping a.tooltip').click(function (e) {
        e.preventDefault();
    });
    $('select[name$="_addressList"]').on('change', function () {
        var state = $('select[name$="_addressFields_states_state"]').val();
        var parentWrapper = $('select[name$="_addressFields_states_state"]').closest('.field-wrapper');
        var form =  $('form.checkout-shipping.address');
        if (state == 'HI' || state == 'AK') {
            var excludedShippingSku = $('#AKHINoShippingProduct').val();
            $('.order-summary-content .mini-cart-right').each(function () {
                var lineItemSku =  $(this).data('productitemid');
                if (excludedShippingSku.includes(lineItemSku)) {
                    setTimeout(() => {
                        form.find('select[id*="state"]').addClass('error');
                    }, 200);
                    $(this).closest('.mini-cart-product').addClass('remove-product-padding');
                    $(this).closest('.mini-cart-container').addClass('has-error-msg');
                    if ($(this).closest('.mini-cart-container').find('.item-shipment-exclusion').length == 0) {
                        $(this).closest('.mini-cart-container').append('<div class="item-shipment-exclusion"><span class="error">'+Resources.ITEMSHIPMENTEXCLUSIONMSG+'</span></div>');
                    }
                    if ($('#state-shipment-exclusion-msg').length == 0) {
                        parentWrapper.append('<span id="state-shipment-exclusion-msg" class="error">'+Resources.StateShipmentExclusionMSG+'</span>');
                    }
                }
            });
        } else {
            $('.mini-cart-container').find('.item-shipment-exclusion').remove();
            $('#state-shipment-exclusion-msg').remove();
            form.find('select[id*="state"]').removeClass('error');
        }
    });
    $('input[name="use_gift_registry_address"]').on('click', function () {
        var form =  $('form.checkout-shipping.address');
        if ($(this).val() === 'null' && !$(this).hasClass('checked')) {
            form.find('input[id*="firstName"]').val('');
            form.find('input[id*="lastName"]').val('');
            form.find('input[id*="address1"]').val('');
            form.find('input[id*="address2"]').val('');
            form.find('input[id*="postal"]').val('');
            form.find('input[id*="city"]').val('');
            form.find('select[id*="state"]').val('');
            form.find('input[id*="phone"]').val('');
            form.find('select[id*="addressList"]').trigger('change');
            $(this).addClass('checked');
        }
    });

    $('input[name="use_gift_registry_address"]').change(function () {
        var form =  $('form.checkout-shipping.address');
        if ($(this).val() === 'null') {
            form.find('input[id*="listAddressID"]').val('');
            $(form.find('fieldset')[0]).find('.form-row').show();
        } else {
            $(form.find('fieldset')[0]).find('.form-row').hide();
            $(form.find('fieldset')[0]).find('.form-row.gift-check-box').show();
            $(form.find('fieldset')[0]).find('.form-row.gift-message-text').show();
            var address = JSON.parse($(this).val());
            form.find('input[id*="firstName"]').val(address.firstName);
            form.find('input[id*="lastName"]').val(address.lastName);
            form.find('input[id*="address1"]').val(address.address1);
            form.find('input[id*="address2"]').val(address.address2);
            form.find('input[id*="postal"]').val(address.zipCode);
            form.find('input[id*="city"]').val(address.city);
            form.find('select[id*="state"]').val(address.state);
            form.find('input[id*="phone"]').val(address.phoneNumber);
            form.find('input[id*="listAddressID"]').val(address.ID);
            $('input[name*="shippingAddress_useAsBillingAddress"]').prop('checked', false);
            $('input[name="use_gift_registry_address"]').removeClass('checked');
        }
    });

    giftMessageBox();
    setTimeout(() => {
        updateShippingMethodList();
    }, 1500); 
    require('../../addressvalidation').init();
    $($('input[name="use_gift_registry_address"]:checked')).trigger('change');
    var form =  $('form.checkout-shipping.address');
    if ($('#state-shipment-exclusion-msg').length > 0) {
        form.find('select[id*="state"]').addClass('error');
    }

    util.limitCharactersGiftMessage();
};

exports.updateShippingMethodList = updateShippingMethodList;
$('body').on('click', 'input#dwfrm_singleshipping_shippingAddress_addressFields_city, input#dwfrm_billing_billingAddress_addressFields_city', function(){
    $('input#dwfrm_singleshipping_shippingAddress_addressFields_city, input#dwfrm_billing_billingAddress_addressFields_city').addClass('city-name');
});
$('body').on('click','.checkout-coupon-code .billing-coupon-code-sec label', function() {
    $(this).toggleClass('active');
    $('.checkout-coupon-code .billing-coupon-code-sec .label-above .field-wrapper').toggle();        
});
$('body').on('click','.checkout-mini-cart-header', function() {
    if (window.matchMedia('(max-width: 1025px)').matches) {
        $('.icon').toggleClass('active');
        $('.order-summary-content').toggle();   
    }

});
$(window).on('resize', function() {
    if (window.matchMedia('(min-width: 1025px)').matches) {
        if ($('.order-summary-content').css('display')=='none'){
            $('.order-summary-content').css('display','block');
        } 
    } else {
        if ($('.icon').hasClass('active')) { 
            $('.order-summary-content').css('display','block');
        } else {
            $('.order-summary-content').css('display','none');
        }
    }
});
if (window.matchMedia('(min-width: 1025px)').matches) {
    if ($('.order-summary-content').css('display')=='none') {
        $('.order-summary-content').css('display','block');
    } 
} else {
    if ($('.icon').hasClass('active')) { 
        $('.order-summary-content').css('display','block');
    } else {
        $('.order-summary-content').css('display','none');
    }
} 

},{"../../addressvalidation":1,"../../ajax":2,"../../progress":59,"../../tooltip":77,"../../util":78,"./couponCodeModule":28,"./formPrepare":29}],35:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    page = require('../page'),
    productTile = require('../product-tile'),
    quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
    $('#compare-table').on('click', '.remove-link', function (e) {
        e.preventDefault();
        ajax.getJson({
            url: this.href,
            callback: function () {
                page.refresh();
            }
        });
    })
    .on('click', '.open-quick-view', function (e) {
        e.preventDefault();
        var url = $(this).closest('.product').find('.thumb-link').attr('href');
        quickview.show({
            url: url,
            source: 'quickview'
        });
    })
    .on('click', '.add-to-cart-compare', function (e) {
        e.preventDefault();
        var datauuid = $(this).closest('div').data('attribute');
        datauuid = '#'+datauuid;
        var url = $(this).parents('#compare-table').find(datauuid).find('.thumb-link').attr('href');
        quickview.show({
            url: url,
            source: 'quickview'
        });
    });
    
    $('#compare-category-list').on('change', function () {
        $(this).closest('form').submit();
    });
}

exports.init = function () {
    productTile.init();
    initializeEvents();
    addProductToCart();
};

},{"../ajax":2,"../page":22,"../product-tile":57,"../quickview":61,"./product/addToCart":36}],36:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
    productdialog = require('../../productdialog'),
    productStoreInventory = require('../../storeinventory/index'),
    minicart = require('../../minicart'),
    addedToCartDialog = require('../../pdpAddToCartDialog'),
    page = require('../../page'),
    util = require('../../util'),
    Promise = require('promise'),
    progress = require('../../progress'),
    _ = require('lodash');

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form) {
    var $form = $(form),
        $qty = $form.find('input[name="Quantity"]'),
        $shipoption = $form.find('input[name="shipOption"]:checked').val();
    if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
        $qty.val('1');
    }
    
    if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.checkInStoreAvailability();
    }
    if (SitePreferences.GO_LOCAL_ENABLED) {
        productStoreInventory.checkInStoreAvailabilityForGoLocal();
    }
    progress.show($('.product-add-to-cart'));
    
    var formserialize= $form.serialize();
    if ($('input[name="eddEnabled"]').length > 0) {
        if ($shipoption=='shipToAdress') {
            formserialize+='&eddCheck=true';
        } else {
            formserialize+='&eddCheck=false';
        }
    } else {
        formserialize+='&eddCheck=false';
    }
    return Promise.resolve($.ajax({
        type: 'POST',
        url: util.ajaxUrl(Urls.addProduct),
        data: formserialize
    })).then(function (response) {
        // handle error in the response
        if (response.error) {
            throw new Error(response.error);
        } else {
            progress.hide();

            try {
                if (isGTMEnabled) {
                    require('../../gtm').addToCart($form);
                }
            } catch (e) {
                window.console.error('Error to send addToCart event to GTM', e);
            }

            return response;
        }
    });
};

/**
 * @description GTM event trigger when add a product to cart from wishlist 
 */
var addToCart = function (e) {
    e.preventDefault();
    if ($('.classAttendees') && $('.classAttendees').length){
        $('.classAttendees input').blur().focus();
        if ($('#cancellationPolicy-agreement')[0].checked){
            $('.cancellationPolicy-agreement-error').addClass('hide').css('display', 'none');
        } else {
            $('.cancellationPolicy-agreement-error').removeClass('hide').css('display', 'block');
        }
        var fieldLength = $('.classAttendees .attendee-input').length -1;
        var fieldSuccessLength = $('.classAttendees .form-row.success').length;
        if (!(fieldLength === fieldSuccessLength && $('#cancellationPolicy-agreement')[0].checked)) {
            if ($('.classAttendees').find('input.error').length) {
                if (window.matchMedia('(min-width: 1365px)').matches) {
                    $('html, body').animate({scrollTop : $('.classAttendees').find('input.error').first().parents('.form-row').offset().top - $('.header-main.fixed').outerHeight()},0);
                } else {
                    $('html, body').animate({scrollTop : $('.classAttendees').find('input.error').first().parents('.form-row').offset().top - $('.header-main.fixed').outerHeight() - 60},0);
                }
                $('.classAttendees input.error').first().blur().focus();
            }
            return;
        }
    }
    var $form = $('.product-detail .add-to-cart').closest('form');

    // Extend Integration
    if ($('#extend-offer').length) {
        extendAddToCart($form, page, minicart, dialog, addItemToCart, addedToCartDialog);
        return;
    }
    
    addItemToCart($form).then(function (response) {
        var $uuid = $form.find('input[name="uuid"]');
        if ($uuid.length > 0 && $uuid.val().length > 0) {
            page.refresh();
        } else {
            // do not close quickview if adding individual item that is part of product set
            // @TODO should notify the user some other way that the add action has completed successfully
            if (!$('.product-detail .add-to-cart').hasClass('sub-product-item')) {
                productdialog.close();
            }

            var isQuickView = $('#isQuickView').val() === 'true';
            var enableNewAddToCartOnPDPABTest = $('input[type=hidden][name=enableNewAddToCartOnPDPABTest]').val() === 'true';
            if (!isQuickView && SitePreferences.enableNewAddToCartOnPDP && enableNewAddToCartOnPDPABTest) {
                minicart.update(response);
                addedToCartDialog.show({});
            } else {
                minicart.show(response);
            }
        }
    }.bind($('.product-detail .add-to-cart')));
};

/**
 * @description Handler to handle the add to cart event for wish list and gift registry
 */
var addToCartFromWishlist = function () {
    var $form = $(this).closest('form');
    if (isGTMEnabled) {
        require('../../gtm').addToCartFromwishlist($form);
    }
    $form.submit($form.serialize());
};

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllToCart = function (e) {
    e.preventDefault();
    var $productForms = $('#product-set-list').find('form').toArray();
    Promise.all(_.map($productForms, addItemToCart))
        .then(function (responses) {
            dialog.close();
            // show the final response only, which would include all the other items
            minicart.show(responses[responses.length - 1]);
        });
};

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = function () {
    $('.add-to-cart[disabled]').attr('title', $('.availability-msg').text());
    if (($('input[name="physical"]').length > 0 && $('input[name="physical"]').val() == 'true') || ($('input[name="electronic"]').length > 0 && $('input[name="electronic"]').val() == 'true')) {
        $('.product-detail button#add-to-cart').removeAttr('disabled');
        $('.product-detail button#add-to-cart').removeClass('add-to-cart-disabled');
        $('.product-detail button#add-to-cart').addClass('add-to-cart');
    }
    $('.product-detail').on('click', '.add-to-cart', function(e) {
        if ($('input[name="masterProduct"]').val() == 'true' && $('input[name="electronic"]').val() == 'true') {
            var headerHeightcal = $('.header-main.fixed .global-nav').outerHeight() + $('.header-main.fixed').outerHeight();
            $('.variant-error-message').removeClass('hide');
            $('html, body').animate({
                scrollTop: $('.variant-error-message').offset().top - headerHeightcal
            }, 100);
            return false;
        } else {
            $('.variant-error-message').addClass('hide'); 
        }
        if (($('input[name="physical"]').length > 0 && $('input[name="physical"]').val() == 'true') || ($('input[name="electronic"]').length > 0 && $('input[name="electronic"]').val() == 'true')) {
            $(this).closest('form').find('input').blur().focus();
            if ($('input.error').length) {
                var headerHeight = $('.header-main.fixed .global-nav').outerHeight() + $('.header-main.fixed').outerHeight();
                $('html, body').animate({scrollTop : $('input.error').first().offset().top - headerHeight},0);
                $('input.error').first().blur().focus();
            } else {
                addToCart(e);
            }
        } else {
            addToCart(e);
        }
    });
    $('textarea[data-gift-message-char-limit]').on('change blur', function (e) {
        var button = $('#add-to-cart');
        if (e.target.classList.contains('error')) {
            button.attr('disabled', 'disabled');
        } else {
            button.removeAttr('disabled');
        }
    });
    $('.wishlist-products').on('click', '.add-to-cart', addToCartFromWishlist);
    $('#add-all-to-cart').on('click', addAllToCart);
    $("button#add-to-cart.pdp-enabled").removeAttr("disabled");
    $("button#add-to-cart.pdp-enabled").removeClass("pdp-enabled");
};

},{"../../dialog":13,"../../gtm":18,"../../minicart":21,"../../page":22,"../../pdpAddToCartDialog":56,"../../productdialog":58,"../../progress":59,"../../storeinventory/index":74,"../../util":78,"lodash":94,"promise":96}],37:[function(require,module,exports){
'use strict';

module.exports = function () {
    var isApplePayAvailable = false;

    function useCurrentDomain(url) {
        var domain = window.Urls.homePage.replace('s/SLT/home', '');

        if (url.includes(domain)) {
            return url;
        }

        var pieces = url.split('/');
        var path =  pieces.splice(3).join('/');
        return domain + path;
    }

    try {
        isApplePayAvailable = window.dw && window.dw.applepay && window.ApplePaySession && window.ApplePaySession.canMakePayments();
    } catch (e) {
        isApplePayAvailable = false;
    }

    if (isApplePayAvailable) {

        var APPLE_PAY_GET_REQUEST_LAST_UPDATED_COOKIE_NAME = 'dwapupreq';
        var formInputsToIgnore = new Set([
            'q', 'lang', 'masterProduct', 'uuid', 'physical', 'electronic',
            'minAmount', 'maxAmount', 'cartAction', 'isShipToAddress', 'searchStoreRadius',
            'searchStoreText'
        ]);

        var deleteApplePayGetRequestLastUpdatedCookie = function() {
            document.cookie = APPLE_PAY_GET_REQUEST_LAST_UPDATED_COOKIE_NAME + '=' + Date.now() + ';';
        }

        var updateApplePayURLParams = function(paramName, paramValue) {
            Object.keys(window.dw.applepay.action).forEach(function(key) {
                var existingURL = useCurrentDomain(window.dw.applepay.action[key])
                var updatedURL = new URL(existingURL);
                var updatedURLQueryParameters = updatedURL.searchParams;
                if (typeof(paramValue) === 'undefined' || paramValue === null || paramValue === 'null') {
                    updatedURLQueryParameters.delete(paramName);
                } else if (paramName.indexOf('attendee_') > -1) {
                    updatedURLQueryParameters.append(paramName, paramValue);
                } else {
                    updatedURLQueryParameters.set(paramName, paramValue);
                }
                updatedURL.search = updatedURLQueryParameters.toString();
                window.dw.applepay.action[key] = updatedURL.toString();
            });
            deleteApplePayGetRequestLastUpdatedCookie();
        }

        var updateApplePayRequestParams = function() {

            updateApplePayURLParams('attendee_firstname_[]', null);
            updateApplePayURLParams('attendee_lastname_[]', null);
            updateApplePayURLParams('attendee_email_[]', null);
            updateApplePayURLParams('attendee_phone_[]', null);

            var formInputs = $('form').serializeArray();
            for (var i = 0; i < formInputs.length; i++) {
                var inputName = formInputs[i].name;
                var inputValue = formInputs[i].value;
                if (inputValue != '' && !formInputsToIgnore.has(inputName)) {
                    updateApplePayURLParams(inputName, formInputs[i].value);
                }
            }

            var newShipOption = $('[name=shipOption]:checked').val();
            updateApplePayURLParams('shipOption', newShipOption);

            var newStoreSelectedId = $('#storeSelectedId').val();
            updateApplePayURLParams('storeSelectedId', newStoreSelectedId);

            updateApplePayURLParams('eddCheck', (newShipOption == 'shipToAdress' && $('input[name="eddEnabled"]').length > 0));

            if (newShipOption === 'shipGoLocal') {
                if ($('isapplepay').is(':visible')) {
                    $('isapplepay').addClass('applepay-golocal-hidden').hide();
                }
                if ($('.dw-apple-pay-button').is(':visible')) {
                    $('.dw-apple-pay-button').addClass('applepay-golocal-hidden').hide();
                }
            } else {
                $('isapplepay.applepay-golocal-hidden').show()
                $('.dw-apple-pay-button.applepay-golocal-hidden').show();
            }
        }

        var updateApplePayRequestParamsForExtend = function() {
            var hasExtendPlan = false;
            if ($('#extend-offer').length) {
                var extendComponent = window.Extend.buttons.instance('#extend-offer');
                if (extendComponent) {
                    var extendPlan = extendComponent.getPlanSelection();
                    if (extendPlan) {
                        hasExtendPlan = true;
                        updateApplePayURLParams('extendPlanId', extendPlan.planId);
                        updateApplePayURLParams('extendPrice', extendPlan.price);
                        updateApplePayURLParams('extendTerm', extendPlan.term);
                    }
                }
            }
            if (!hasExtendPlan) {
                updateApplePayURLParams('extendPlanId', undefined);
                updateApplePayURLParams('extendPrice', undefined);
                updateApplePayURLParams('extendTerm', undefined);
            }
        }

        var updateApplePayRequestParamsForCulinary = function(e) {
            if ($('.classAttendees') && $('.classAttendees').length) {
                $('.classAttendees input').blur().focus();
                if ($('#cancellationPolicy-agreement')[0].checked){
                    $('.cancellationPolicy-agreement-error').addClass('hide');
                } else {
                    $('.cancellationPolicy-agreement-error').removeClass('hide');
                }
                var fieldLength = $('.classAttendees .attendee-input').length - 1;
                var fieldSuccessLength = $('.classAttendees .form-row.success').length;
                if (!(fieldLength === fieldSuccessLength && $('#cancellationPolicy-agreement')[0].checked)) {
                    if (window.matchMedia('(min-width: 1365px)').matches) {
                        $('html, body').animate({scrollTop : $('.classAttendees').find('input.error').first().parents('.form-row').offset().top - $('.header-main.fixed').outerHeight()},0);
                    } else {
                        $('html, body').animate({scrollTop : $('.classAttendees').find('input.error').first().parents('.form-row').offset().top - $('.header-main.fixed').outerHeight() - 60},0);
                    }
                    $('.classAttendees input.error').first().blur().focus();
                    e.stopPropagation();
                }
            }
        }

        var updateApplePayRequestParamsForGiftCard = function(e) {
            if ($('input[name="masterProduct"]').val() == 'true' && $('input[name="electronic"]').val() == 'true') {
                var headerHeightcal = $('.header-main.fixed .global-nav').outerHeight() + $('.header-main.fixed').outerHeight();
                $('.variant-error-message').removeClass('hide');
                $('html, body').animate({
                    scrollTop: $('.variant-error-message').offset().top - headerHeightcal
                }, 100);
                e.stopPropagation();
            } else {
                $('.variant-error-message').addClass('hide');
            }
            if (($('input[name="physical"]').length > 0 && $('input[name="physical"]').val() == 'true') || ($('input[name="electronic"]').length > 0 && $('input[name="electronic"]').val() == 'true')) {
                $(e.target).closest('form').find('input').blur().focus();
                if ($('input.error').length) {
                    var headerHeight = $('.header-main.fixed .global-nav').outerHeight() + $('.header-main.fixed').outerHeight();
                    $('html, body').animate({scrollTop : $('input.error').first().offset().top - headerHeight},0);
                    $('input.error').first().blur().focus();
                    e.stopPropagation();
                }
            }
        }

        $(document).on('change', '[name=shipOption], #storeSelectedId, #Quantity, input[name^="dwfrm_giftcard_"]', function() {
            updateApplePayRequestParams();
        });

        var triggerAddToCartEvent = function() {
            var $form = $('.pdpForm');
            var fieldLength = $('.classAttendees .attendee-input').length - 1;
            var fieldSuccessLength = $('.classAttendees .form-row.success').length;
            var isCulinary = !!$('.classAttendees').length;
            var isInvalidCulinary = isCulinary && !(fieldLength === fieldSuccessLength && $('#cancellationPolicy-agreement')[0].checked);

            var containErrors = !!(isInvalidCulinary || $('input.error').length);

            if ($form && isGTMEnabled && !containErrors) {
                require('../../gtm').addToCart($form);
            }
        };

        document.addEventListener('click', function(e) {

            if (e.target && e.target.id == 'dw-apple-pay-button') {
                updateApplePayRequestParams();
                updateApplePayRequestParamsForExtend();
                updateApplePayRequestParamsForCulinary(e);
                updateApplePayRequestParamsForGiftCard(e);

                triggerAddToCartEvent();
            }

        }, true);

        updateApplePayRequestParams();

    } else {
        $('isapplepay').hide();
        $('.dw-apple-pay-button').hide();
        $(document).ready(function() {
            $('isapplepay').hide();
            $('.dw-apple-pay-button').hide();
        });
    }
}

},{"../../gtm":18}],38:[function(require,module,exports){
'use strict';

var ajax =  require('../../ajax'),
    productStoreInventory = require('../../storeinventory/product'),
    util = require('../../util');

var updateContainer = function (data, $this) {
    var currentForm = $this.closest('form[id]');
    var $availabilityMsg = currentForm.find('.availability-msg');
    var message; // this should be lexically scoped, when `let` is supported (ES6)
    var shipToAdressTooltip = '<span class="tooltip"><span class="info-icon"></span><span class="tooltip-content">' + Resources.SHIP_TO_ADDRESS_TOOLTIP + '</span></span>';
    if (!data) {
        $availabilityMsg.html(Resources.ITEM_STATUS_NOTAVAILABLE);
        return;
    }
    if (data.isMaster) {
        return false;
    }
    $availabilityMsg.empty();
    // Look through levels ... if msg is not empty, then create span el
    if (data.levels.IN_STOCK > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            // Just in stock
            message = Resources.IN_STOCK;
        } else {
            // In stock with conditions ...
            message = data.inStockMsg;
        }
        if ($availabilityMsg.hasClass('dropShipMsg')) {
            message = message+': Ships directly from vendor' + shipToAdressTooltip;
        }
        $availabilityMsg.append('<p class="in-stock-msg">' + message + '</p>');
        currentForm.find('.add-to-cart').attr('disabled', false);
    }
    if (data.levels.PREORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.PREORDER;
        } else {
            message = data.preOrderMsg;
        }
        if ($availabilityMsg.hasClass('dropShipMsg')) {
            message = message+': Ships directly from vendor' + shipToAdressTooltip;
        }
        $availabilityMsg.append('<p class="preorder-msg">' + message + '</p>');
    }
    if (data.levels.BACKORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.PREORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.BACKORDER;
        } else {
            message = data.backOrderMsg;
        }
        if ($availabilityMsg.hasClass('dropShipMsg')) {
            message = message+': Ships directly from vendor' + shipToAdressTooltip;
        }
        $availabilityMsg.append('<p class="backorder-msg">' + message + '</p>');
        currentForm.find('.add-to-cart').attr('disabled', false);
    }
    if (data.inStockDate !== '' && data.levels.IN_STOCK < 1) {
        $availabilityMsg.append('<p class="in-stock-date-msg">' + String.format(Resources.IN_STOCK_DATE, data.inStockDate) + '</p>');
    }
    if (data.levels.NOT_AVAILABLE > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.IN_STOCK === 0) {
            message = Resources.NOT_AVAILABLE;
        } else {
            message = Resources.REMAIN_NOT_AVAILABLE;
        }
        $availabilityMsg.append('<p class="not-available-msg">' + message + '</p>');
        currentForm.find('.add-to-cart').attr('disabled', true);
        $('#add-all-to-cart').attr('disabled', true);
    } else { 
        if ($('.add-to-cart[disabled="disabled"]').length === 0) { 
            $('#add-all-to-cart').attr('disabled', false);
        } else {
            $('#add-all-to-cart').attr('disabled', true);
        }
    }
};

var getAvailability = function () {
    var $this = $(this);
    var productId = $('.pdpForm #pid').val();
    var maxProductQty = parseInt($('input[class="productATS"]').length > 0 ? $('input[class="productATS"]').val() : 99,0); 
    ajax.getJson({
        url: util.appendParamsToUrl(Urls.getAvailability, {
            pid: productId, // JIRA PREV-55:Inventory message is not displaying for the individual product within the product set.
            Quantity: $(this).val(),
            maxpoductcanbeadded: maxProductQty
        }),
        async: false, //JIRA PREV-45 : Able to proceed to checkout flow with more than instock qty by clicking on Go straight to checkout in the Mini cart.
        callback: function (data) {
            updateContainer(data, $this);
        }
    });
    productStoreInventory.init();
};

module.exports = function () {
    $('body').on('change', '.inventory input[name="Quantity"]', getAvailability);
};

},{"../../ajax":2,"../../storeinventory/product":75,"../../util":78}],39:[function(require,module,exports){
'use strict';
var dialog = require('../../dialog');
var util = require('../../util');
var qs = require('qs');
var url = require('url');
var _ = require('lodash');
var slickSlider = require('../../slickSlider');

var zoomMediaQuery = matchMedia('(min-width: 960px)');

/**
 * @description Enables the zoom viewer on the product detail page
 * @param zmq {Media Query List}
 */
function loadZoom (zmq) {
    var $imgZoom = $('#pdpMain .main-image'),
        hiresUrl;
    if (!zmq) {
        zmq = zoomMediaQuery;
    }
    if ($imgZoom.length === 0 || dialog.isActive() || util.isMobile() || !zoomMediaQuery.matches) {
        // remove zoom
        $imgZoom.trigger('zoom.destroy');
        return;
    }
    hiresUrl = $imgZoom.attr('href');

    if (hiresUrl && hiresUrl !== 'null' && hiresUrl.indexOf('noimagelarge') === -1 && zoomMediaQuery.matches) {
        $imgZoom.zoom({
            url: hiresUrl
        });
    }
}

zoomMediaQuery.addListener(loadZoom);

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
function setMainImage (atts) {
    $('#pdpMain .primary-image, .recipe-detail-page .primary-image').attr({
        src: atts.url,
        alt: atts.alt,
        title: atts.title
    });
    updatePinButton(atts.url);
    if (!dialog.isActive() && !util.isMobile()) {
        $('#pdpMain .main-image').attr('href', atts.hires);
    }
    loadZoom();
}

function updatePinButton (imageUrl) {
    var pinButton = document.querySelector('.share-icon[data-share=pinterest]');
    if (!pinButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
    }
    var href = url.parse(pinButton.href);
    var query = qs.parse(href.query);
    query.media = url.resolve(window.location.href, newUrl);
    query.url = window.location.href;
    var newHref = url.format(_.extend({}, href, {
        query: query, // query is only used if search is absent
        search: qs.stringify(query)
    }));
    pinButton.href = newHref;
}

/**
 * @description Replaces the images in the image container, for eg. when a different color was clicked.
 */
function replaceImages () {
    var $newImages = $('#update-images'),
        $imageContainer = $('#pdpMain .product-image-container .product-primary-image-section');
    if ($newImages.length === 0) { return; }

    $imageContainer.html($newImages.html());
    $newImages.remove();
    loadZoom();
}

/* @Module pdp slick
 	PDP slick
*/
function pdpSlickFunctionalities() {

    var isQuickView;
    if ($(document).find('.quick-view').length > 0) {
        isQuickView = true;
    } else {
        isQuickView = false;
    }
    var $pdpthumps = {
        infinite: true,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        vertical: true,
        useTransform: false,
        speed: 300
    };
    var $responsiveClp = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    slickSlider.init('.thumbnail-slick-mob-tablet .product-thumbnails-mobile', {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows:false
    },{
        slidesToShow: 1,
        slidesToScroll: 1 
    });    
    if (isQuickView === false) {
        slickSlider.init('.product-thumbnails .thumbnail-slick',$pdpthumps , $responsiveClp);
    } else {
        $('.qv-thumbnail-slick').not('.slick-initialized').slick({
            infinite: true,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1
        });
    }  
    //Gift card variation slick
    var $defaulValuesGiftCard = {
        infinite: true,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 1
    };
    var $responsiveGiftCard = {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    slickSlider.init('.giftcard-variations .thumbnail-slick', $defaulValuesGiftCard, $responsiveGiftCard);

    //PDP Video slick
    /*var $videodefaulValuesClp = {
        infinite: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1
    };
    var $videoresponsiveClp = { 
        slidesToShow: 6,
        slidesToScroll: 1,
        slidesToShowMobile: 3,
        slidesToScrollMobile: 1
    };*/

    //slickSlider.init('.pdp-videos .videos', $videodefaulValuesClp, $videoresponsiveClp);

    //PDP video popup functionalities
    $('.video-thumbnailimage, .video-player-icon').click(function(e) {
        e.preventDefault();
        $('<div id="video-container" class="video-container" />').appendTo('body');
        var srcUrl = $(this).attr('src');
        var className = $(this).attr('class');
        var url = '';
        if (className === 'video-player-icon') {
            var parent = $(this).parent();
            url = parent.find('.video-thumbnailimage').attr('data-vidurl');
        } else {
            url = $(this).attr('data-vidurl');
        }
        if (isQuickView) {
            $('#video-container').dialog({
                width: 761,
                dialogClass: 'pdp-video-popup',
                modal: true,
                open: function() {
                    $('.video-wrap').remove();
                    $('.pdp-video-popup .ui-dialog-title').html('<div class=\'product-name\'>' + $('.product-name').html() + '</div>');
                    $('<div class="video-wrap" />').appendTo('.video-container');
                    $('<div class="sub-wrapper"><img class="video-thumbnailimage" src="' + srcUrl + '" data-vidurl="' + url + '" /><span class="video-frame"><iframe width="854" height="480" src="' + url + '?autoplay=1&showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></span></div>').appendTo('.video-wrap');
                    $('.qv-thumb.video-thumbnailimage').each(function(index, element) {
                        $('.video-wrap').append('<div class="sub-wrapper"><img class="video-thumbnailimage"  src="' + $(element).attr('src') + '" data-vidurl="' + $(element).attr('data-vidurl') + '" /></div>');
                    });
                    var $defaulValuesClp = {
                        infinite: true,
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    };
                    var $responsiveClp = {
                        infinite: true,
                        arrows: true,
                        swipe: false,
                        draggable: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    };
    
                    slickSlider.init('.video-wrap', $defaulValuesClp, $responsiveClp);
    
                    $(document).on('click', '.pdp-video-popup .slick-arrow', function() {
                        $('.sub-wrapper .video-frame').remove();
                        $('.pdp-video-popup .video-wrap .sub-wrapper.slick-active').html($('.pdp-video-popup .video-wrap .sub-wrapper.slick-active').html() + '<span class="video-frame"><iframe width="854" height="480" src="' + $('.pdp-video-popup .video-wrap .sub-wrapper.slick-active .video-thumbnailimage').attr('data-vidurl') + '?autoplay=1&showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></span>');
                    });
                    $('.ui-dialog').css({position:'fixed',top:'5%'});
    
                },
                close: function() {
                    $('#video-container').remove();
                }
            });
        } else {
            $('#video-container').dialog({
                width: 761,
                dialogClass: 'pdp-video-popup',
                modal: true,
                open: function() {
                    $('.video-wrap').remove();
                    $('.pdp-video-popup .ui-dialog-title').html('<div class=\'product-name\'>' + $('.product-name').html() + '</div>');
                    $('<div class="video-wrap" />').appendTo('.video-container');
                    $('<div class="sub-wrapper"><img class="video-thumbnailimage" src="' + srcUrl + '" data-vidurl="' + url + '" /><span class="video-frame"><iframe width="854" height="480" src="' + url + '?autoplay=1&showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></span></div>').appendTo('.video-wrap');
                    $('.thump.video-thumbnailimage').each(function(index, element) {
                        $('.video-wrap').append('<div class="sub-wrapper"><img class="video-thumbnailimage"  src="' + $(element).attr('src') + '" data-vidurl="' + $(element).attr('data-vidurl') + '" /></div>');
                    });
                    var $defaulValuesClp = {
                        infinite: true,
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    };
                    var $responsiveClp = {
                        infinite: true,
                        arrows: true,
                        swipe: false,
                        draggable: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    };
    
                    slickSlider.init('.video-wrap', $defaulValuesClp, $responsiveClp);
    
                    $(document).on('click', '.pdp-video-popup .slick-arrow', function() {
                        $('.sub-wrapper .video-frame').remove();
                        $('.pdp-video-popup .video-wrap .sub-wrapper.slick-active').html($('.pdp-video-popup .video-wrap .sub-wrapper.slick-active').html() + '<span class="video-frame"><iframe width="854" height="480" src="' + $('.pdp-video-popup .video-wrap .sub-wrapper.slick-active .video-thumbnailimage').attr('data-vidurl') + '?autoplay=1&showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></span>');
                    });
                    $('.ui-dialog').css({position:'fixed',top:'5%'});
    
                },
                close: function() {
                    $('#video-container').remove();
                }
            });
        }
    });
}

function imageClick() {
	//Disabling the ability to click main image on PDP and CDP
    $('.product-image.main-image').click(function(e) {
        e.preventDefault();
    });
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
module.exports = function () {
    if (dialog.isActive() || util.isMobile()) {
        $('#pdpMain .main-image').removeAttr('href');
    }
    updatePinButton();
    loadZoom();
    // handle product thumbnail click event
    $('#pdpMain, .recipe-detail-page').on('click', '.productthumbnail, .video-thumbnailimage, .video-player-icon .product-thumbnails-mobile', function (e) {
        e.preventDefault();
        // switch indicator
        $(this).closest('.product-thumbnails').find('.thumb.selected').removeClass('selected');
        $(this).closest('.thumb').addClass('selected');
        if ($(this).data('lgimg') != null) {
            setMainImage($(this).data('lgimg'));
        }
    });
    $('#pdpMain, .recipe-detail-page').on('click', '.qv-productthumbnail , .video-thumbnailimage, .video-player-icon', function (e) {
        e.preventDefault();
        // switch indicator
        $(this).closest('.qv-product-thumbnails').find('.qv-thumb.selected').removeClass('selected');
        $(this).closest('.qv-thumb').addClass('selected');
        if ($(this).data('lgimg') != null) {
            setMainImage($(this).data('lgimg'));   
        }
    });
    $('.thumbnail-slick-mob-tablet').on('click', '.productthumbnail', '.video-thumbnailimage', function (e) {
        e.preventDefault();
        $(this).closest('.product-thumbnails-mobile').find('.thumb.selected').removeClass('selected');
        $(this).closest('.thumbnail-slick-mob-tablet.thumb').addClass('selected');
        if ($(this).data('lgimg') != null) {
            setMainImage($(this).data('lgimg'));   
        }
    });
    imageClick();
};
module.exports.loadZoom = loadZoom;
module.exports.setMainImage = setMainImage;
module.exports.replaceImages = replaceImages;
module.exports.imageClick = imageClick;
module.exports.pdpSlickFunctionalities = pdpSlickFunctionalities;

},{"../../dialog":13,"../../slickSlider":67,"../../util":78,"lodash":94,"qs":106,"url":114}],40:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
    productStoreInventory = require('../../storeinventory/product'),
    tooltip = require('../../tooltip'),
    util = require('../../util'),
    addToCart = require('./addToCart'),
    pdpLocationDialog = require('./pdpLocationDialog'),
    availability = require('./availability'),
    image = require('./image'),
    productNav = require('./productNav'),
    productSet = require('./productSet'),
    recommendations = require('./recommendations'),
    slickSlider = require('../../slickSlider'),
    variant = require('./variant'),
    applepay = require('./applepay'),
    radar = require('../../radar');

var photoGrid = require('./photo-grid/photo-grid-fe');

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {
    productNav();
    recommendations();
    tooltip.init();
    photoGrid.init();
}

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    var $pdpMain = $('#pdpMain');

    applepay();
    addToCart();
    availability();
    variant();

    photoGrid.init();

    image();

    productSet();
    readMore();
    pdpFunctionalities();
    updateExtendIFrameStyle();
    radar.updateFromRadar();

    // PDP Location Dialog for Same Day Delivery.
    pdpLocationDialog.init();
    $(document).on('click', '.GoLocalOption__ModalLink', function() {
        pdpLocationDialog.show();
    });

    productStoreInventory.init();
    if ($('.availability-msg').find('.not-available-msg').length > 0) {
        $('#add-to-cart').attr('disabled', true);
    } else if ($('.availability-msg').length > 0) {
        $('#add-to-cart').attr('disabled', false);
    }
    if (!$('#disabledShipToStore').length) {
        var $shipToStoreContainer = $('#shipToStoreContainer');
        var $shipGoLocalContainer = $('#shipGoLocalContainer');
        if ($('.availability-msg').find('.not-available-msg').length > 0) {
            $shipToStoreContainer.hide();
            $shipGoLocalContainer.hide();
        } else if ($('.availability-msg').length > 0) {
            $shipToStoreContainer.show();
            $shipGoLocalContainer.show();
        }
    }

    var $wishContainer = $('.product-actions .wish-container');
    if ($wishContainer.length && !$('.wish-container--placeholder > .wish-container').length) {
        $wishContainer.appendTo($('.wish-container--placeholder'));
    }

    $('.read-less').click(function() {
        $('.read-less').removeClass('close-up');
        $('.read-more').addClass('close-down');
        $(this).closest('.main-description').find('.more-text').removeClass('active');
    });

    $('.main-description .read-more').click(function() {
        $(this).closest('.main-description').find('.more-text').addClass('active');
        $('.read-more').removeClass('close-down');
        $('.read-less').addClass('close-up');
    });
    // Add to Wishlist and Add to Gift Registry links behaviors
    $pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
        var data = util.getQueryStringParams($('.pdpForm').serialize());
        if (data.cartAction) {
            delete data.cartAction;
        }
        var url = util.appendParamsToUrl(this.href, data);
        this.setAttribute('href', url);
    });

    // Wishlist links behaviors on PDP
    $pdpMain.on('click', 'a.social-sharing', function (e) {
        e.preventDefault();
        $('div.socialsharing').toggle();
    });

    // product options
    $pdpMain.on('change', '.product-options select', function () {
        var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
        var selectedItem = $(this).children().filter(':selected').first();
        salesPrice.text(selectedItem.data('combined'));
    });

    // prevent default behavior of thumbnail link and add this Button
    $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });

    $('#pdpMain').on('change', '.pdpForm .classQuantity', function (e) {
        e.preventDefault();
        var selectedQuantity = Number($(this).val());
        var availableCountClasses = Number($('input[name="availableCountClasses"]').val());

        if (availableCountClasses > 0){
            const currentBasketQuantity = Number($('.currentBasketQuantity').val());
            const totalAttendees = currentBasketQuantity + selectedQuantity;

            if (selectedQuantity > availableCountClasses) {
                $('.invalid-quantity-classes').removeClass('hide');
                $('button[class$="add-attendees"]').attr('disabled', 'disabled');
                $('.invalid-quantity-seat').remove();
            } else if (currentBasketQuantity >= availableCountClasses) {
                showMaxAttendeesReachedError();
            } else if (totalAttendees > availableCountClasses) {
                showMaxAttendeesCalculatedError(currentBasketQuantity, availableCountClasses);
            }  else {
                $('.invalid-quantity-seat').remove();
                $('.invalid-quantity-classes').addClass('hide');
                $('button[class$="add-attendees"]').removeAttr('disabled');
            }
        }
    });

    $('#pdpMain').on('keyup', '.pdpForm .classQuantity', function (e) {
        e.preventDefault();
        var classQty = $('.classQuantity').val();
        if (classQty.length > 0) {
            if (isNaN(classQty)) {
                $('.classQuantity').val('1');
            } else {
                var qtyVal = parseInt(classQty,0);
                if (qtyVal < 1) {
                    $('.classQuantity').val('1');
                }
            }
        }
    });

    let allowStickyToDisplay = true;

    const blockStickyToShow = () => {
        allowStickyToDisplay = false;
        const stickyDiv = document.querySelector('.sticky-book-now');
        stickyDiv.style.display = 'none';
    }

    $('.classAttendees').on('click', '.add-attendees', function(e) {
        e.preventDefault();
        blockStickyToShow();

        $('.dw-apple-pay-button').removeClass('hide');
        const isDisabled = !!$('#add-attendees').data('disabled');
        if (!isDisabled) {
            const availableCountClasses = Number($('input[name="availableCountClasses"]').val());
            const currentBasketQuantity = Number($('.currentBasketQuantity').val());

            if (currentBasketQuantity >= availableCountClasses) {
                showMaxAttendeesReachedError();
            } else {
                util.displayAddattendeeform();
            }
            return
        }

        const selectedStore = $('#selectedStore').val();
        const displayTimes = $('#sessionDisplayDatesTime').val();
        const orderableClass = $('#orderableClass').val();
        const cancelledClass = $('#cancelledClass').val();

        const isSelectLocationDateError = (selectedStore ==='null' || displayTimes ==='null') && (orderableClass === 'true' && cancelledClass === 'null');
        if (isSelectLocationDateError) {
            $('.select-location-and-date-error').removeClass('hide');
        }
    });

    $('#add-attendees-sticky').on('click', function(e) {
        e.preventDefault();
        util.displayAddattendeeform();
        $('.classAttendees').get(0).scrollIntoView({behavior : 'smooth'});
        blockStickyToShow();
    });

    document.addEventListener('scroll', function () {
        const stickyDiv = document.querySelector('.sticky-book-now');

        if (!allowStickyToDisplay) {
            stickyDiv.style.display = 'none';
            return;
        }

        const bookNowButton = document.querySelector('button#add-attendees');
        const globalNav = document.querySelector('.global-nav');

        if (!bookNowButton || !globalNav) {
            return;
        }

        const buttonBottomPosition = bookNowButton.getBoundingClientRect().bottom;
        const navBottomPosition = globalNav.getBoundingClientRect().bottom;
        if (buttonBottomPosition < navBottomPosition) {
            stickyDiv.style.display = 'flex';
            stickyDiv.style.top = navBottomPosition + 'px';
        } else {
            stickyDiv.style.display = 'none';
        }
    });

    $(document).ready(function() {
        $('.occeventbyimage').addClass('hide');
    });

    $('.size-chart-link a').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });
}

function showMaxAttendeesReachedError() {
    const maxAttendeesReachMsg = String.format(Resources.MAX_ATTENDEES_REACHED);
    if ($('.invalid-quantity-seat').length === 0) {
        $('.classAttendees').append('<div class="invalid-quantity-seat">' + maxAttendeesReachMsg + '</div>');
    }
    util.hideAddAttendeeForm();
    $('.invalid-quantity-classes').addClass('hide');
    $('button[class$="add-attendees"]').attr('disabled', 'disabled');
}

/**
 * @description Show max attendees calculated error
 * @param {number} currentBasketQuantity
 * @param {number} availableCountClasses
 */
function showMaxAttendeesCalculatedError(currentBasketQuantity, availableCountClasses) {
    const maxAttendeesMsg = String.format(Resources.MAX_ATTENDEES_CALCULATED, currentBasketQuantity, availableCountClasses - currentBasketQuantity, availableCountClasses);
    if ($('.invalid-quantity-seat').length === 0) {
        $('.classAttendees').append('<div class="invalid-quantity-seat">' + maxAttendeesMsg + '</div>');
    }

    util.hideAddAttendeeForm();
    $('button[class$="add-attendees"]').attr('disabled', 'disabled');
    $('.invalid-quantity-classes').addClass('hide');
}

function updateExtendIFrameStyle() {
    var updateInterval = setInterval(function () {
        $('#extend-offer iframe').contents().find('.button-group').css({
            'width': '99%'
        });
        $('#extend-offer iframe').contents().find('.caption-text').css({
            'font-family': 'Lato ,Nunito Sans ,Arial',
            'font-style': 'normal',
            'font-weight': 'normal',
            'font-size': '16px',
            'line-height': '130%',
            'letter-spacing': '0.25px',
            'color': '#555555'
        });
        $('#extend-offer iframe').contents().find('.info-button').css({
            'font-family': 'Lato ,Nunito Sans ,Arial',
            'font-style': 'normal',
            'font-weight': 'normal',
            'font-size': '16px',
            'line-height': '130%',
            'letter-spacing': '0.25px',
            'color': '#555555',
            'text-decoration-line':'underline'
        });
        $('#extend-offer iframe').contents().find('.btn-offer').css({
            'height' : '50px',
            'background': 'white',
            'border-color': '#999999',
            'box-shadow': 'none',
            'border-radius': '0'
        });
        $('#extend-offer iframe').contents().find('.btn-offer').on('click', function () {
            $('#extend-offer iframe').contents().find('.btn-offer').css({
                'background-color':'#ffffff','border-color': '#555555'
            });
            $('#extend-offer iframe').contents().find('.term-length, .plan-price').css({
                'color': '#555555'
            });
            if ($(this).hasClass('active')) {
                $(this).css({
                    'background-color':'#1E1E1E',
                    'box-shadow': 'none',
                    'border-color': 'white'
                });
                $(this).find('.term-length, .plan-price').css({
                    'color': '#ffffff'
                });
            }
        });
        $('#extend-offer iframe').contents().find('.divider').css({
            'display' : 'none'
        });
        $('#extend-offer iframe').contents().find('.term-length').css({
            'display' : 'block',
            'font-family': 'Lato ,Nunito Sans ,Arial',
            'font-style': 'normal',
            'font-weight': 'normal',
            'font-size': '14px',
            'line-height': '100%',
            'letter-spacing': '0.25px',
            'color': '#555555',
            'text-transform': 'capitalize',
            'text-align': 'center'

        });
        $('#extend-offer iframe').contents().find('.info-button .info-icon').css({
            'display': 'none'
        });
        $('#extend-offer iframe').contents().find('.info-button').append(
            '<svg class="info-icon" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0.0307617C2.68661 0.0307617 0 2.71737 0 6.03076C0 9.34415 2.68661 12.0308 6 12.0308C9.31339 12.0308 12 9.34415 12 6.03076C12 2.71737 9.31339 0.0307617 6 0.0307617ZM6 11.0129C3.24911 11.0129 1.01786 8.78165 1.01786 6.03076C1.01786 3.27987 3.24911 1.04862 6 1.04862C8.75089 1.04862 10.9821 3.27987 10.9821 6.03076C10.9821 8.78165 8.75089 11.0129 6 11.0129Z" fill="#777777"/><path d="M5.25 3.2527C5.25 3.45364 5.32902 3.64635 5.46967 3.78844C5.61032 3.93053 5.80109 4.01035 6 4.01035C6.19891 4.01035 6.38968 3.93053 6.53033 3.78844C6.67098 3.64635 6.75 3.45364 6.75 3.2527C6.75 3.05176 6.67098 2.85905 6.53033 2.71696C6.38968 2.57487 6.19891 2.49505 6 2.49505C5.80109 2.49505 5.61032 2.57487 5.46967 2.71696C5.32902 2.85905 5.25 3.05176 5.25 3.2527ZM6.375 5.02056H5.625C5.55625 5.02056 5.5 5.07738 5.5 5.14683V9.4402C5.5 9.50965 5.55625 9.56648 5.625 9.56648H6.375C6.44375 9.56648 6.5 9.50965 6.5 9.4402V5.14683C6.5 5.07738 6.44375 5.02056 6.375 5.02056Z" fill="#777777"/></svg>'
        );
        $('#extend-offer iframe').contents().find('.plan-price').css({
            'font-family': 'Lato ,Nunito Sans ,Arial',
            'font-style': 'normal',
            'font-weight': 'bold',
            'font-size': '16px',
            'line-height': '100%',
            'letter-spacing': '0.25px',
            'color': '#555555',
            'text-align': 'center'
        });
        $('#extend-offer iframe').contents().find('.button.active').css({
            'background-color':'#1E1E1E',
            'box-shadow': 'none',
            'border-color': 'white'
        });

        if ($('#extend-offer > div:not([style*="display: none"])').length > 0) {
            const iFrameHeight = $('#extend-offer iframe').contents().find('body').height();
            $('#extend-offer iframe').height(iFrameHeight);
            $('.extend-offer-accordion').removeClass('hide_extends_offers');
            clearInterval(updateInterval);
        }
    }, 500);
}
function readMore() {
    if ($(window).width() < 767) {
        var maxLength = 300;
        $('.main-description .left-section p').each(function() {
            var myStr = $(this).text();
            if ($.trim(myStr).length > maxLength) {
                var newStr = myStr.substring(0, maxLength);
                var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
                $(this).empty().html(newStr);
                $(this).append('<span class="more-text">' + removedStr + '</span>');
                $(this).append(' <a href="javascript:void(0);" class="read-more close-down">...Read More</a>');
                $(this).append(' <a href="javascript:void(0);" class="read-less">Read Less</a>');
            }
        });
    }
}

function handleCarouselSlider(module) {
    let slickSliderInitialized = false;
    const $defaulValuesClp = {
        infinite: true,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 5
    };
    const $responsiveClp = {
        dots: true,
        infinite: true
    };
    const images = document.querySelectorAll(`.${module.replaceAll(' ', '.')} .clp-category-listing .search-result-items`);
    if (images.length) {
        slickSlider.init(images[0], $defaulValuesClp, $responsiveClp);
        slickSliderInitialized = true;
    }
    return slickSliderInitialized;
}

function pdpFunctionalities() {

    image.pdpSlickFunctionalities();

    //PDP tabs
    function pdpTabInit() {
        if (window.innerWidth > 1023) {
            $('.product-info').css('height', ($('.tabs .tab.active').find('.tab-content').height() + 100) + 'px');
        } else {
            $('.product-info').css('height', 'auto');
        }
    }
    pdpTabInit();

    $('.tabs .tab').on('click', function() {
        if (window.innerWidth > 1023) {
            $('.product-info').css('height', ($(this).find('.tab-content').height() + 100) + 'px');
        }
    });

    $('.tabs .tab .tab-label').on('click', function() {
        if ($(this).parent().hasClass('active')) {
            if (window.innerWidth < 1024) {
                $(this).parent().removeClass('active');
            }
        } else {
            $('.tabs .tab').removeClass('active');
            $(this).parent().addClass('active');
        }
    });

    $(window).on('resize', function() {
        pdpTabInit();
    });

    //Stores
    $(document).on('click','.selected-store .store-name', function() {
        if ($(this).hasClass('closed')) {
            $(this).addClass('open').removeClass('closed');
            $(this).next().removeClass('hide');
        } else {
            $(this).addClass('closed').removeClass('open');
            $(this).next().addClass('hide');
        }
    });

    var slickModules = [
        'every-thing-you-need',
        'similar-items bloomreach-recommend',
        'recommendation-carousel bloomreach-recommend',
        'you-may-also-like',
        'classes-carousel'
    ];
    slickModules.forEach(function (module) {
        const sliders = document.getElementsByClassName(module);
        if (sliders.length) {
            if (!handleCarouselSlider(module)) {
                const observer = new MutationObserver(function() {
                    if (handleCarouselSlider(module)) {
                        observer.disconnect();
                    }
                });
                observer.observe(sliders[0], {childList: true, subtree: true});
            }
        }
    });

    $('.text-ellipsis').ellipsis();
}

var product = {
    initializeEvents: initializeEvents,
    init: function () {
        initializeDom();
        initializeEvents();
    }
};

module.exports = product;

},{"../../dialog":13,"../../radar":62,"../../slickSlider":67,"../../storeinventory/product":75,"../../tooltip":77,"../../util":78,"./addToCart":36,"./applepay":37,"./availability":38,"./image":39,"./pdpLocationDialog":41,"./photo-grid/photo-grid-fe":43,"./productNav":45,"./productSet":46,"./recommendations":47,"./variant":49}],41:[function(require,module,exports){
'use strict';

var _ = require('lodash');
var dialog = require('../../dialog');
var radar = require('../../radar');
var goLocal = require('../../goLocal');

const ID_DIALOG = 'pdp-location-dialog';
var radarSearchTerm = '';
var userAddress = null;

var onSuccessSetUserAddress = function (response) {
    if (response.success) {
        goLocal.checkEligibilityForPDP(userAddress);
    } else {
        userAddress = null;

        $('.GoLocalOption.GoLocalOption__Eligible').removeClass('hidden');
        $('.GoLocalOption.GoLocalOption__Eligible .GoLocalOption__Pair').addClass('hidden');
        $('.GoLocalOption.GoLocalOption__NotEligible').addClass('hidden');
        $('#golocal-pdp-delivery-to-value').text('').parent().addClass('hidden');
        $('#golocal-pdp-enter-your-location').removeClass('hidden');
        $('#golocal-pdp-shipping').removeClass('not-eligible');
        $('[name="shipOption"][value="shipGoLocal"]').attr('disabled', false);
    }
};

var updateUserAddress = function() {
    goLocal.updateStore(userAddress, onSuccessSetUserAddress);
}

var resetAddressList = function(goLocalAddressList) {
    goLocalAddressList.empty();
    goLocalAddressList.addClass('hidden');
};

var updateAddressList = function(input, goLocalAddressList, addresses) {
    resetAddressList(goLocalAddressList);

    if (!addresses.length) {
        return;
    }

    var searchTerm = radarSearchTerm.toLowerCase();

    addresses.filter(function(address) {
        return !!address.postalCode;
    }).forEach(function(address){
        var formattedAddress = address.formattedAddress;
        var startIndex = formattedAddress.toLowerCase().indexOf(searchTerm);

        if (startIndex > -1) {
            var startAddress = formattedAddress.substring(0,startIndex);
            var matchAddress = formattedAddress.substring(startIndex, startIndex + searchTerm.length);
            var endAddress = formattedAddress.substring(startIndex + searchTerm.length);

            formattedAddress = startAddress + '<span class="address-match">' + matchAddress + '</span>' + endAddress;
        }

        var li = $('<li/>').addClass('address-list-item').html(formattedAddress);
        li.on('click', function() {
            radarSearchTerm = address.formattedAddress;
            $(input).val(address.formattedAddress);
            resetAddressList(goLocalAddressList);
            userAddress = address;
        });
        li.appendTo(goLocalAddressList);
    });

    goLocalAddressList.removeClass('hidden');
}

var searchOnRadar = function(input, goLocalAddressList) {
    if (radarSearchTerm === input.value) {
        return;
    }

    radarSearchTerm = input.value;

    radar.autocomplete({
        query: input.value,
        limit: 5,
        layers: 'fine',
        countryCode: 'US'
    }).then((result) => {
        updateAddressList(input, goLocalAddressList, result && result.addresses ? result.addresses : []);
    });
}

var pdpLocation = {

    init: function () {
        if (!this.exists()) {
            this.$container = $('<div/>').attr('id', ID_DIALOG).appendTo(document.body);
        }
    },

    show: function () {
        this.init();

        var dialogContainer = $('div.GoLocalOption.GoLocalOption__Container');
        var html = dialogContainer.html();

        var getWidth = function() {
            return window.innerWidth > 768 ? 464 : '100%';
        };
        var getPosition = function() {
            return window.innerWidth > 768 ? {my: 'center', at: 'center', collision: 'flipfit'} : {my: 'bottom', at: 'bottom', collision: 'fit'};
        };
        var onWindowResize = _.throttle(function() {
            setTimeout(() => {
                dialog.option('width', getWidth());
                dialog.option('position', getPosition());
            }, 0);
        }.bind(this), 500);
        $(window).on('resize', onWindowResize);

        var validatePostalCode = function() {
            if (!$('input[name="goLocalPostalCode"]').val()) {
                $('[name="shipOption"]').prop('checked','false');
                $('[name="shipOption"][value="shipToAdress"]').prop('checked','true').change();
            }
        }

        var title = $('#golocal-pdp-shipping-title').text() + ' ' + Resources.LOCATION;
        dialog.open({
            target: this.$container,
            html: html,
            options: {
                position: getPosition(),
                width: getWidth(),
                title: title,
                dialogClass: 'GoLocalOption__Modal',
                draggable: false,
                open: function() {
                    $('body').addClass('disable-scroll');

                    var goLocalAddressList = this.$container.find('#goLocalAddressList');

                    var onSearch = _.debounce(function(e) {
                        if (e.target.value.length > 0) {
                            searchOnRadar(e.target, goLocalAddressList);
                        } else {
                            resetAddressList(goLocalAddressList);
                        }
                    }, 1000);

                    var onClose = function() {
                        resetAddressList(goLocalAddressList);

                        validatePostalCode();

                        dialog.close();
                    };
                    
                    var onConfirm = function() {
                        updateUserAddress();
                        onClose();
                    }

                    this.$container.find('#goLocalAddressInput').off('keyup').on('keyup', onSearch);
                    this.$container.find('#goLocalUseMyLocationButton').off('click').on('click', onConfirm);
                    this.$container.find('#goLocalCancelButton').off('click').on('click', onClose);
                    this.$container.find('#goLocalConfirmButton').off('click').on('click', onConfirm);
                }.bind(this),
                close: function () {
                    $(window).off('resize', onWindowResize);
                    $('body').removeClass('disable-scroll');

                    validatePostalCode();
                }.bind(this)
            }
        });

        this.$container.parent().find('.ui-dialog-titlebar-close').attr('data-testid', 'cart-modal-close-button');
    },

    exists: function () {
        return this.$container && (this.$container.length > 0);
    }

};

module.exports = pdpLocation;

},{"../../dialog":13,"../../goLocal":17,"../../radar":62,"lodash":94}],42:[function(require,module,exports){
'use strict';

function setupTouchGestures(element) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Pointer_events/Pinch_zoom_gestures
    const evCache = new Array();
    const doubleTapCache = new Array();
    let mode = null;
    let startDistance = 0;
    let startScale = 0;
    let offsetX = 0;
    let offsetY = 0;
    let panXDirection = 0;
    let panYDirection = 0;
    function getImageInfo() {
        const style = $(element).get(0).style;
        const xCssVar = style
            .getPropertyValue('--zoom-asset-translate-x')
            .split('px');
        const yCssVar = style
            .getPropertyValue('--zoom-asset-translate-y')
            .split('px');
        const scale = style.getPropertyValue('--zoom-asset-scale');
        let x = 0;
        if (xCssVar && xCssVar.length) {
            x = Number(xCssVar[0]);
        }
        let y = 0;
        if (yCssVar && yCssVar.length) {
            y = Number(yCssVar[0]);
        }
        return {
            x: x,
            y: y,
            scale: scale
        };
    }
    function pointerDownListener(ev) {
        evCache.push(ev);
        doubleTapCache.push({
            pointerId: ev.pointerId,
            startX: ev.clientX,
            startY: ev.clientY,
            timestamp: Date.now()
        });

        // If cache has only one pointer, then it's image panning mode
        if (evCache.length === 1) {
            mode = 'PAN';
            const imageInfo = getImageInfo();
            offsetX = Math.abs(imageInfo.x - ev.clientX);
            offsetY = Math.abs(imageInfo.y - ev.clientY);

            panXDirection = ev.clientX < imageInfo.x;
            panYDirection = ev.clientY < imageInfo.y;
        }

        // If cache has two pointers, then it's pinch and zoom mode
        if (evCache.length === 2) {
            mode = 'PINCHZOOM';
            startDistance = Math.hypot(
                evCache[0].clientX - evCache[1].clientX,
                evCache[0].clientY - evCache[1].clientY
            );
            startScale = $(element)
                .get(0)
                .style.getPropertyValue('--zoom-asset-scale');
        }
    }
    function pointerMoveListener(ev) {
        for (var i = 0; i < evCache.length; i++) {
            if (ev.pointerId === evCache[i].pointerId) {
                evCache[i] = ev;
                break;
            }
        }

        if (evCache.length === 1 && mode == 'PAN') {
            const x = panXDirection
                ? `${ev.clientX + offsetX}px`
                : `${ev.clientX - offsetX}px`;

            const y = panYDirection
                ? `${ev.clientY + offsetY}px`
                : `${ev.clientY - offsetY}px`;

            const style = $(element).get(0).style;
            style.setProperty('--zoom-asset-translate-x', x);
            style.setProperty('--zoom-asset-translate-y', y);
        }

        // If two pointers are down, check for pinch gestures
        if (evCache.length === 2 && mode === 'PINCHZOOM') {
            // Calculate the distance between the two pointers
            var curDiff = Math.hypot(
                evCache[0].clientX - evCache[1].clientX,
                evCache[0].clientY - evCache[1].clientY
            );

            const zoomRatio = curDiff / startDistance;

            $(element)
                .get(0)
                .style.setProperty(
                    '--zoom-asset-scale',
                    zoomRatio * startScale
                );
        }
    }

    function removePointerEvent(ev) {
        // Remove this event from the target's cache
        for (var i = 0; i < evCache.length; i++) {
            if (evCache[i].pointerId === ev.pointerId) {
                evCache.splice(i, 1);
                break;
            }
        }
    }

    let currentTimerId = null;
    function pointerUpListener(ev) {
        // Remove this pointer from the cache
        removePointerEvent(ev);

        // If the number of pointers down is less than two then reset diff tracker
        if (evCache.length < 2) {
            startDistance = 0;
            startScale = 0;
        }

        // Check on double tap to zoom to 1.5x or 2x
        if (doubleTapCache.length > 0) {
            // We need to be able to determine if the pointer was a tap, by checking it's starting coordinate. Start and end should be the same.
            for (let i = 0; i < doubleTapCache.length; i++) {
                if (ev.pointerId === doubleTapCache[i].pointerId) {
                    if (
                        doubleTapCache[i].startX !== ev.clientX ||
                        doubleTapCache[i].startY !== ev.clientY
                    ) {
                        doubleTapCache.splice(i, 1);
                    }
                    break;
                }
            }

            // If there's a timer already attached, we cancel it
            if (currentTimerId) {
                clearTimeout(currentTimerId);
            }

            // Timer will only allow two taps to register within 500ms
            currentTimerId = setTimeout(function () {
                doubleTapCache.splice(0, doubleTapCache.length);
            }, 500);

            if (doubleTapCache.length > 1) {
                doubleTapCache.splice(0, doubleTapCache.length);

                const style = $(element).get(0).style;
                const scale = style.getPropertyValue('--zoom-asset-scale');
                if (scale < 1.5) {
                    style.setProperty('--zoom-asset-scale', 1.5);
                    return;
                }
                if (scale < 2) {
                    style.setProperty('--zoom-asset-scale', 2);
                    return;
                }
                if (scale >= 2) {
                    style.setProperty('--zoom-asset-scale', 1);
                    return;
                }
            }
        }
    }

    offsetX = 0;
    offsetY = 0;
    panXDirection = 0;
    panYDirection = 0;
    $(element).get(0).style.setProperty('--zoom-asset-translate-x', 0);
    $(element).get(0).style.setProperty('--zoom-asset-translate-y', 0);
    $(element).get(0).style.setProperty('--zoom-asset-scale', 1);
    $(element)
        .on('pointerdown', pointerDownListener)
        .on('pointermove', pointerMoveListener)
        .on('pointerup', pointerUpListener);

    return function () {
        $(element)
            .off('pointerdown', pointerDownListener)
            .off('pointermove', pointerMoveListener)
            .off('pointerup', pointerUpListener);
        $(element).get(0).style.setProperty('--zoom-asset-translate-x', 0);
        $(element).get(0).style.setProperty('--zoom-asset-translate-y', 0);
        $(element).get(0).style.setProperty('--zoom-asset-scale', 1);
    };
}

module.exports = {
    setupTouchGestures: setupTouchGestures
};

},{}],43:[function(require,module,exports){
'use strict';

const dialog = require('../../../dialog');
const zoomUtils = require('./zoom-utils');

const state = {
    originalDom: undefined,
    lastSelectedAssetId: undefined
};

let photoGridSelfDestroy = undefined;
function init() {
    if (photoGridSelfDestroy) {
        photoGridSelfDestroy();
    }
    const isMobile = $(window).width() < 1024;

    const imageCount = Number(
        $('input[type=hidden][name=photoGridImageCount]').val()
    );

    const visibleAncestor = $(
        '.photo-grid__container,.photo-grid__single-asset'
    )
        .parent()
        .filter(':visible');

    state.originalDom = visibleAncestor.prop('outerHTML');

    if (state.lastSelectedAssetId) {
        showZoom(visibleAncestor, state.lastSelectedAssetId, imageCount);
    }

    const singleAsset = visibleAncestor.find('.photo-grid__single-asset');

    singleAsset.on('click', (e) => {
        showZoom(
            singleAsset.parent(),
            e.currentTarget.dataset.assetId,
            imageCount
        );
    });

    visibleAncestor.find('.photo-grid__asset-container').on('click', (e) => {
        showZoom(visibleAncestor, e.currentTarget.dataset.assetId, imageCount);
    });

    const mobileContainer = visibleAncestor.find(
        '.photo-grid__container.photo-grid__container--mobile'
    );
    const desktopContainer = visibleAncestor.find(
        '.photo-grid__container.photo-grid__container--desktop'
    );

    if (isMobile) {
        mobileContainer.not('.slick-initialized').slick({
            slidesToShow: 1,
            dots: true,
            arrows: false,
            dotsClass: 'photo-grid__slider__dots',
            mobileFirst: true,
            accessibility: false,
            variableWidth: true
        });
    }

    if (!isMobile && imageCount > 6) {
        const photoGridColumnContainer = $(desktopContainer).find(
            '.photo-grid__columns'
        );

        photoGridColumnContainer.removeClass('photo-grid__container--hide');
        const firstColumn = photoGridColumnContainer.find(
            '.photo-grid__column:first-child'
        );
        const fullHeight = $(photoGridColumnContainer).height();
        let collapsedHeight = 0;
        const firstColumnChildren = $(firstColumn).children();

        const imagesToShow = 3;
        for (let i = 0; i < imagesToShow; i++) {
            collapsedHeight += $(firstColumnChildren[i]).height();
        }
        // Consider for the gaps between images
        collapsedHeight += (imagesToShow - 1) * 8; // gap is 0.5rem (8px)

        $(photoGridColumnContainer).css('max-height', collapsedHeight);
        const showMoreButton = visibleAncestor.find('.accordion-button');
        const buttonChevron = showMoreButton.find('.accordion-button__image');
        const buttonCaption = showMoreButton.find('.accordion-button__caption');
        showMoreButton.off('click').on('click', function () {
            if (buttonChevron.hasClass('accordion-button__image--toggled')) {
                $(photoGridColumnContainer).css('max-height', collapsedHeight);
                buttonChevron.removeClass('accordion-button__image--toggled');
                buttonCaption.text(Resources.PHOTOGRID_SHOW_MORE);
                $(window).scrollTop(0);
            } else {
                $(photoGridColumnContainer).css('max-height', fullHeight);
                buttonChevron.addClass('accordion-button__image--toggled');
                buttonCaption.text(Resources.PHOTOGRID_SHOW_LESS);
            }
        });
    }

    photoGridSelfDestroy = function () {
        state.lastSelectedAssetId =
            $('.zoom__dialog-target .zoom__thumbnail-container--selected')
                .filter(':visible')
                .data('asset-id') || undefined;

        visibleAncestor.replaceWith(state.originalDom);
        state.originalDom = undefined;
    };
}

function showZoom(commonAncestor, assetId, imageCount) {
    let target = $('.zoom__dialog-target');
    if (!target.length) {
        target = $('<div class="zoom__dialog-target">').appendTo('body');
    }
    target.empty();

    let destroy;
    const dialogOptions = {
        dialogClass: 'zoom__dialog',
        open: function () {
            $('body').addClass('zoom--disable-scroll');
            destroy = zoomUtils.init(target, assetId, imageCount);
        },
        close: function () {
            state.lastSelectedAssetId = undefined;
            if (destroy) {
                destroy();
            }
            $('body').removeClass('zoom--disable-scroll');
        }
    };

    const dimensions = zoomUtils.getSettings();
    if (dimensions) {
        dialogOptions.width = dimensions.width;
        dialogOptions.height = dimensions.height;
    }

    dialog.open({
        html: $(commonAncestor).find('.zoom--hidden').clone().html(),
        target: target,
        options: dialogOptions
    });
    $('.ui-widget-overlay').on('click', function () {
        dialog.close();
    });
}

module.exports = {
    init: init
};

},{"../../../dialog":13,"./zoom-utils":44}],44:[function(require,module,exports){
'use strict';

const gestures = require('./gestures');

function getBreakpoints() {
    return {
        '375px': {
            width: window.innerWidth,
            height: window.innerHeight,
            photosToShow: 4,
            px: 375
        },
        '768px': {
            width: window.innerWidth,
            height: window.innerHeight,
            photosToShow: 4,
            px: 768
        },
        '1024px': {
            width: window.innerWidth * 0.8,
            height: window.innerHeight * 0.8,
            photosToShow: 7,
            px: 1024
        },
        '1440px': {
            width: window.innerWidth * 0.8,
            height: window.innerHeight * 0.8,
            photosToShow: 9,
            px: 1440
        }
    };
}

function getSettings() {
    const dimensions = Object.entries(getBreakpoints()).find(
        (entry) => window.matchMedia(`(max-width: ${entry[0]})`).matches
    );
    if (dimensions && dimensions.length) {
        return dimensions[1];
    }
    return getBreakpoints()['1440px'];
}

function getMediaElement(assetType, assetUrl) {
    if (assetType === 'YOUTUBE') {
        return (
            '<iframe class="zoom__asset zoom__asset--youtube" src="https://www.youtube.com/embed/' +
            assetUrl +
            '?&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
        );
    }
    if (assetType === 'VERTICAL_VIDEO') {
        return (
            '<video controls autoplay class="zoom__asset zoom__asset--vertical-video"><source src="' +
            assetUrl +
            '" type="video/mp4" />'
        );
    }

    return (
        '<img class="zoom__asset zoom__asset--image" src="' + assetUrl + '" />'
    );
}

function mouseMoveListener(e) {
    // It will only change the position if the mouse is over the image.
    if (!$(e.target).is('img')) {
        return;
    }

    var bbox = e.target.getBoundingClientRect();

    var mouseX = e.clientX - bbox.left;
    var mouseY = e.clientY - bbox.top;

    var xPercent = (mouseX / bbox.width) * 100;
    var yPercent = (mouseY / bbox.height) * 100;

    document.body.style.setProperty('--mouse-x', `${xPercent}%`);
    document.body.style.setProperty('--mouse-y', `${yPercent}%`);
}

let gesturesTearDown = null;
function setMedia(zoomInstance, assetType, assetUrl) {
    const imageContainer = $(zoomInstance).find('.zoom__asset-container');
    imageContainer.empty().html(getMediaElement(assetType, assetUrl));
    let zoomLevel = 0;
    if (assetType === 'IMAGE' && window.innerWidth >= 1024) {
        imageContainer.on('click', function () {
            const img = imageContainer.find('img');
            img.removeClass('zoom__asset--image--1x zoom__asset--image--2x');
            if (zoomLevel === 0) {
                img.addClass('zoom__asset--image--1x');
                zoomLevel = 1;
                imageContainer.off('mousemove', mouseMoveListener);
                imageContainer.on('mousemove', mouseMoveListener);
                return;
            }
            if (zoomLevel === 1) {
                img.addClass('zoom__asset--image--2x');
                zoomLevel = 2;
                return;
            }
            zoomLevel = 0;
            imageContainer.off('mousemove', mouseMoveListener);
        });
    }
    if (assetType === 'IMAGE' && window.innerWidth < 1024) {
        if (gesturesTearDown) {
            gesturesTearDown();
        }
        gesturesTearDown = gestures.setupTouchGestures(imageContainer);
    }
}
let slickSlider = null;

function keyboardListener(zoomInstance) {
    return function (e) {
        const imagesContainer = $(zoomInstance).find('.zoom__thumbnails');
        const images = imagesContainer.find('.zoom__thumbnail-container');
        const selected = imagesContainer.find(
            '.zoom__thumbnail-container--selected'
        );
        const currentSlideIndex = slickSlider.slick('slickCurrentSlide');
        const originalSlidesCount =
            slickSlider.slick('getSlick').$slides.length;

        if (e.keyCode == 37) {
            let prev = selected.prev();
            let prevSlideIndex = currentSlideIndex - 1;

            if (!prev.length) {
                prev = images.last();
            }

            if (prevSlideIndex < 0) {
                prevSlideIndex = originalSlidesCount - 1;
            }

            $('.zoom__photo-grid--slider .slick-slide').removeClass(
                'zoom__thumbnail-container--selected'
            );
            $(
                '.zoom__photo-grid--slider .slick-slide[data-slick-index="' +
                    prevSlideIndex +
                    '"]'
            ).addClass('zoom__thumbnail-container--selected');
            slickSlider.slick('slickPrev');
            const assetUrl = $(prev).data('assetUrl') || $(prev).attr('src');
            const assetType = $(prev).data('assetType');
            setMedia(zoomInstance, assetType, assetUrl);
        }
        if (e.keyCode == 39) {
            let next = selected.next();
            let nextSlideIndex = currentSlideIndex + 1;

            if (!next.length) {
                next = images.first();
            }

            if (nextSlideIndex >= originalSlidesCount) {
                nextSlideIndex = 0;
            }

            $('.zoom__photo-grid--slider .slick-slide').removeClass(
                'zoom__thumbnail-container--selected'
            );
            $(
                '.zoom__photo-grid--slider .slick-slide[data-slick-index="' +
                    nextSlideIndex +
                    '"]'
            ).addClass('zoom__thumbnail-container--selected');
            slickSlider.slick('slickNext');
            const assetUrl = $(next).data('assetUrl') || $(next).attr('src');
            const assetType = $(next).data('assetType');
            setMedia(zoomInstance, assetType, assetUrl);
        }
        selected.removeClass('zoom__thumbnail-container--selected');
    };
}

function init(zoomInstance, assetId, imageCount) {
    $(zoomInstance).css('overflow', 'hidden');
    $(zoomInstance)
        .find('.zoom__thumbnail-container--selected')
        .removeClass('zoom__thumbnail-container--selected');

    const selectedThumbnail = $(zoomInstance)
        .find('[data-asset-id="' + assetId + '"].zoom__thumbnail-container')
        .addClass('zoom__thumbnail-container--selected');
    const assetUrl =
        $(selectedThumbnail).data('assetUrl') ||
        $(selectedThumbnail).attr('src');
    const assetType = $(selectedThumbnail).data('assetType');
    setMedia(zoomInstance, assetType, assetUrl);

    $(zoomInstance)
        .find('.zoom__thumbnail-container')
        .on('click', function () {
            $(zoomInstance)
                .find('.zoom__thumbnail-container--selected')
                .removeClass('zoom__thumbnail-container--selected');
            $(this).addClass('zoom__thumbnail-container--selected');

            const assetUrl = $(this).data('assetUrl') || $(this).attr('src');
            const assetType = $(this).data('assetType');

            setMedia(zoomInstance, assetType, assetUrl);
        });

    const settings = getSettings();
    document.body.style.setProperty(
        '--zoom-thumbnails-count',
        settings.photosToShow
    );

    if (imageCount > settings.photosToShow) {
        const grid = $(zoomInstance).find('.zoom__photo-grid-container > div');

        grid.removeClass('zoom__photo-grid--regular').addClass(
            'zoom__photo-grid--slider'
        );

        slickSlider = grid
            .find('.zoom__thumbnails')
            .not('.slick-initialized')
            .slick({
                arrows: true,
                variableWidth: true,
                mobileFirst: true,
                prevArrow: grid.find('.zoom__slider-arrow--left'),
                nextArrow: grid.find('.zoom__slider-arrow--right'),
                accessibility: false,
                infinite: true,
                speed: 100,
                responsive: Object.keys(getBreakpoints()).map((k) => ({
                    breakpoint: getBreakpoints()[k].px,
                    settings: {
                        slidesToShow: getBreakpoints()[k].photosToShow
                    }
                }))
            });
    }

    const listener = keyboardListener(zoomInstance);
    $(document).on('keydown', listener);

    return function (zoomInstance) {
        $(zoomInstance).css('overflow', '');
        $(document).off('keydown', listener);
        $(zoomInstance).find('.zoom__asset-container').empty();
        $(zoomInstance)
            .find('.zoom__thumbnails.slick-initialized')
            .slick('unslick');

        // Stops videos being played
        $('.zoom__asset--youtube').attr('src', '');
        $('.zoom__asset--vertical-video').trigger('pause');
    };
}

module.exports = {
    init: init,
    getSettings: getSettings
};

},{"./gestures":42}],45:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    util = require('../../util');

/**
 * @description loads product's navigation
 **/
module.exports = function () {
    var $pidInput = $('.pdpForm input[name="pid"]').last(),
        $navContainer = $('#product-nav-container');
    // if no hash exists, or no pid exists, or nav container does not exist, return
    if (window.location.hash.length <= 1 || $pidInput.length === 0 || $navContainer.length === 0) {
        return;
    }

    var pid = $pidInput.val(),
        hash = window.location.hash.substr(1),
        url = util.appendParamToURL(Urls.productNav + (Urls.productNav.indexOf('?') > 0 ? '&' : '?') + hash, 'pid', pid);

    ajax.load({
        url: url,
        target: $navContainer
    });
};

},{"../../ajax":2,"../../util":78}],46:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    tooltip = require('../../tooltip'),
    util = require('../../util');

module.exports = function () {
    var $addToCart = $('#add-to-cart'),
        $addAllToCart = $('#add-all-to-cart'),
        $productSetList = $('#product-set-list');

    var updateAddToCartButtons = function () {
        if ($productSetList.find('.add-to-cart[disabled]').length > 0) {
            $addAllToCart.attr('disabled', 'disabled');
            // product set does not have an add-to-cart button, but product bundle does
            $addToCart.attr('disabled', 'disabled');
        } else {
            $addAllToCart.removeAttr('disabled');
            $addToCart.removeAttr('disabled');
        }
    };

    if ($productSetList.length > 0) {
        updateAddToCartButtons();
    }
    // click on swatch for product set
    $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
        e.preventDefault();
        if ($(this).parents('li').hasClass('unselectable')) { return; }
        var url = Urls.getSetItem + this.search;
        var $container = $(this).closest('.product-set-item');
        var qty = $container.find('form input[name="Quantity"]').first().val();

        ajax.load({
            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
            target: $container,
            callback: function () {
                updateAddToCartButtons();
                tooltip.init();
            }
        });
    });
};

},{"../../ajax":2,"../../tooltip":77,"../../util":78}],47:[function(require,module,exports){
'use strict';

/**
 * @description Creates product recommendation carousel using jQuery jcarousel plugin
 **/
module.exports = function () {
    var $carousel = $('#carousel-recommendations');
    if (!$carousel || $carousel.length === 0 || $carousel.children().length === 0) {
        return;
    }
    $carousel.jcarousel();
    $('#carousel-recommendations .jcarousel-prev')
        .on('jcarouselcontrol:active', function () {
            $(this).removeClass('inactive');
        })
        .on('jcarouselcontrol:inactive', function () {
            $(this).addClass('inactive');
        })
        .jcarouselControl({
            target: '-=1'
        });

    $('#carousel-recommendations .jcarousel-next')
        .on('jcarouselcontrol:active', function () {
            $(this).removeClass('inactive');
        })
        .on('jcarouselcontrol:inactive', function () {
            $(this).addClass('inactive');
        })
        .jcarouselControl({
            target: '+=1'
        });
};

},{}],48:[function(require,module,exports){
'use strict';

var _ = require('lodash');

var ttTabHeaders = $('.tt-tab-header');
var ttAccordionHeaders = $('.tt-accordion-header');
var ttContents = $('.tt-content');
var isMobile = screen.width < 768;
var isMobileOrTablet = screen.width < 1024;
var isDesktop = screen.width >= 1440;
var turnToWidgetsContainer = $('.turnto-widgets-container');

ttContents.not('.active').hide();

var updateMargins = function() {
    if (isMobile) {
        turnToWidgetsContainer.css('margin-right', 0);
        turnToWidgetsContainer.css('margin-left', 0);
    } else if (isDesktop) {
        var margin = '';
        var width = parseInt(turnToWidgetsContainer.css('width'), 10);

        if (width < 1440) {
            margin = Math.ceil((1440 - width) / 2);
            margin = '-' + margin + 'px';
        }

        turnToWidgetsContainer.css('margin-right', margin);
        turnToWidgetsContainer.css('margin-left', margin);
    } else {
        const mainContainer = $('.primary-content.pdp-main-container');
        var marginLeft = mainContainer.css('padding-left');
        var marginRight = mainContainer.css('padding-right');

        turnToWidgetsContainer.css('margin-right', '-' + marginLeft);
        turnToWidgetsContainer.css('margin-left', '-' + marginRight);
    }
};
updateMargins();

$(window).on('resize', _.debounce(function() {
    isMobile = screen.width < 768;
    isMobileOrTablet = screen.width < 1024;
    isDesktop = screen.width >= 1440;

    updateMargins();
    updateCustomerPhotosTitle();
}, 300));

var initTeaser = function() {
    // data-testid
    $('a.tt-c-teaser__link').attr('data-testid', 'pdp-title-reivew-count');
    $('button.tt-c-teaser__write-review').attr('data-testid', 'pdp-title-writereview');
};

var initTabHeaders = function() {
    ttTabHeaders.on('click', function() {
        var tab = $(this);
        var dataContentId = tab.attr('data-content-id');
        var tabContent = $('#' + dataContentId);

        ttTabHeaders.not(tab).removeClass('active');
        tab.addClass('active');

        ttContents.not(tabContent).hide();
        tabContent.show();
    });
};

var initAccordionHeaders = function() {
    ttAccordionHeaders.on('click', function() {
        var accordion = $(this);
        var dataContentId = accordion.attr('data-content-id');
        var tabContent = $('#' + dataContentId);

        ttAccordionHeaders.not(accordion).removeClass('active');
        accordion.toggleClass('active');

        ttContents.not(tabContent).slideUp();
        tabContent.slideToggle();
    });
};

var updateCustomerPhotosTitle = function() {
    var customerPhotosHeader = $('.tt-c-gallery__heading');
    var customerPhotosHeaderText = customerPhotosHeader.text();
    var matches = customerPhotosHeaderText.match(/\d+/);

    if (matches) {
        var photosQty = matches[0];
        var customerPhotosContent = $('.tt-c-gallery__wrap');
        customerPhotosHeaderText = customerPhotosHeaderText.replace(/\(*\d+\)*/g, '');
    
        if (isMobileOrTablet) {
            customerPhotosContent.hide();
    
            customerPhotosHeaderText += String.format(' ({0})', photosQty);
        } else {
            customerPhotosHeaderText = String.format('{0} {1}', photosQty, customerPhotosHeaderText);
        }
    
        customerPhotosHeader.text(customerPhotosHeaderText);
    
        customerPhotosHeader.off('click').on('click', function() {
            if (isMobileOrTablet) {
                customerPhotosHeader.toggleClass('active');
                customerPhotosContent.slideToggle();
            }
        });
    }
};

var initReviewSummary = function() {
    setTimeout(updateCustomerPhotosTitle, 800);

    // data-testid
    $('div.tt-c-reviews-summary__heading').attr('data-testid', 'pdp-review-widget-count');
    $('span.tt-c-reviews-summary__rating-number').attr('data-testid', 'pdp-review-widget-rating');
    $('div.tt-c-reviews-summary__stars').attr('data-testid', 'pdp-review-widget-stars');
    $('button.tt-c-reviews-summary__write-review').attr('data-testid', 'pdp-review-widget-writereview');
    $('div.tt-c-reviews-summary__gallery').attr('data-testid', 'pdp-review-widget-imagegallary');
    $('img.tt-o-media-thumb__image').attr('data-testid', 'pdp-review-widget-gallary-image');
    $('button.tt-o-pagination__back').attr('data-testid', 'pdp-review-widget-imagescrollleft');
    $('button.tt-o-pagination__next').attr('data-testid', 'pdp-review-widget-imagescrollright');
    $('div.tt-c-ratings-breakdown__table').attr('data-testid', 'pdp-review-widget-bar-widget');
    $($('div.tt-c-ratings-breakdown__bar-wrap')[0]).attr('data-testid', 'pdp-review-widget-bar-1star');
    $($('div.tt-c-ratings-breakdown__bar-wrap')[1]).attr('data-testid', 'pdp-review-widget-bar-2star');
    $($('div.tt-c-ratings-breakdown__bar-wrap')[2]).attr('data-testid', 'pdp-review-widget-bar-3star');
    $($('div.tt-c-ratings-breakdown__bar-wrap')[3]).attr('data-testid', 'pdp-review-widget-bar-4star');
    $($('div.tt-c-ratings-breakdown__bar-wrap')[4]).attr('data-testid', 'pdp-review-widget-bar-5star');
};

var updateReviewersName = function() {
    $('.tt-l-grid__col--1 .tt-c-review__byline').each(function() {
        var reviewer = $(this);
        var reviewText = reviewer.siblings('.tt-c-review__text');

        if (isMobile) {
            // Move reviewer's name after the review text.
            if (reviewer.index() < reviewText.index()) {
                reviewer.insertAfter(reviewText);
            }
        } else {
            // Copy reviewer's name from column 1 to column 2.
            var col2 = reviewer.parent().next();
            reviewer.appendTo(col2);
        }
    });
};

var updateReviewersPhotos = function() {
    $('.tt-o-expander__button').trigger('click');
};

var initReviewList = function() {
    setTimeout(function() {
        updateReviewersName();
        updateReviewersPhotos();
    }, 500);

    // data-testid
    $('div.tt-c-reviews-toolbar__sort button.tt-o-listbox__btn').attr('data-testid', 'pdp-review-sortby');
    $('input.tt-o-search-field__input').attr('data-testid', 'pdp-review-search');
    $('div.tt-c-review-filters button.tt-o-listbox__btn').attr('data-testid', 'pdp-review-filter');
    $('div.tt-c-reviews-list__content').attr('data-testid', 'pdp-review-lines');
    $('div.tt-c-review__rating').attr('data-testid', 'pdp-review-line-stars');
    $('div.tt-c-review__purchased').attr('data-testid', 'pdp-review-line-purchasedate');
    $('div.tt-c-review__media img.tt-o-media-thumb__image').attr('data-testid', 'pdp-review-line-image');
    $('div.tt-c-review__date').attr('data-testid', 'pdp-review-line-date');
    $('span.tt-o-byline__author').attr('data-testid', 'pdp-review-line-reviewby');
    $('div.tt-c-review__heading-text').attr('data-testid', 'pdp-review-line-title');
    $('a.tt-c-product-about__link').attr('data-testid', 'pdp-review-line-sku-title');
    $('img.tt-o-product__image').attr('data-testid', 'pdp-review-line-skuimage');
    $('span.tt-c-review__text-content').attr('data-testid', 'pdp-review-line-description');
    $('span.tt-c-review-toolbar__likes-number').parent().attr('data-testid', 'pdp-review-line-helpfulyes');
    $('span.tt-c-review-toolbar__dislikes-number').parent().attr('data-testid', 'pdp-review-line-helpfulno');
    $('button.tt-c-review-toolbar__action--flag').attr('data-testid', 'pdp-review-line-flag');
    $('button.tt-c-reviews-list__show-more-btn').attr('data-testid', 'pdp-review-widget-showmore');
};

var initQuestionsAnswers = function() {
    var askLabel = $('.tt-c-ask .tt-c-ask__label');
    var searchFieldInput = $('.tt-c-ask .tt-c-ask__field .tt-o-search-field__input');
    askLabel.on('click', function() {
        searchFieldInput.trigger('focus');
    });
    searchFieldInput.focus(function() {
        askLabel.css('display', 'none');
    });
    searchFieldInput.blur(function() {
        if (!$(this).text().length) {
            askLabel.css('display', 'block');
        }
    });

    $('.tt-c-questions__list .tt-c-question__answers .tt-c-question__actions-show').on('mouseup', function() {
        var button = $(this);
        var expanded = button.attr('aria-expanded') === 'true';
        var votesElement = button.parentsUntil('.tt-c-questions__list').find('.tt-c-question__votes');

        if (expanded) {
            votesElement.css('top', '82px');
            votesElement.css('left', '228px');
        } else {
            votesElement.css('top', '67px');
            votesElement.css('left', '246px');
        }
    });

    // data-testid
    $('div.tt-o-search-field__input').attr('data-testid', 'pdp-review-qa-search');
    $('div.tt-c-ask-results__text').attr('data-testid', 'pdp-review-qa-searchresult');
    $('div.tt-c-ask-result-list').attr('data-testid', 'pdp-review-qa-searchresult-list');
    $('button.tt-c-instant-answers__submit-question').attr('data-testid', 'pdp-review-qa-submitnew');
    $('button.tt-c-questions__list-show-more-btn').attr('data-testid', 'pdp-review-qa-showmore');
};

module.exports = {
    init: function() {
        initTeaser();
        initTabHeaders();
        initAccordionHeaders();
        initReviewSummary();
        initReviewList();
    },
    onReviewListUpdate: function() {
        updateReviewersName();
        updateReviewersPhotos();
    },
    onQAFinish: function() {
        initQuestionsAnswers();
    }
};

},{"lodash":94}],49:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    image = require('./image'),
    progress = require('../../progress'),
    applepay = require('./applepay'),
    util = require('../../util'),
    wishlist = require('./wishlist'),
    radar = require('../../radar'),
    goLocal = require('../../goLocal'),
    wunderkind = require('../../wunderkind');

var photoGrid = require('./photo-grid/photo-grid-fe');

var splitUrlParameters = function (href) {
    var parts = href.split('/')
    var parametersPart = parts[parts.length-1];
    parametersPart = parametersPart.split('&');
    var variantValue = parametersPart[1].split('=');

    return decodeURIComponent(variantValue[1]);
}

/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 **/
var updateContent = function(href) {
    var $pdpForm = $('.pdpForm');
    var qty = $pdpForm.find('input[name="Quantity"]').first().val();
    var slickIndex = parseInt($('.giftcard-variations .thumbnail-slick').slick('slickCurrentSlide'), 0);
    var giftMessageList = [];
    var recipientEmail;
    var recipientEmailConfirm;
    var recipientname;
    var sendername;
    var selectedAmount;
    var selectedAmountIndex = -1;
    if ($('[name="electronic"]').val() == 'true' || $('[name="physical"]').val() == 'true') {
        selectedAmountIndex = $('ul.swatches.amount').find('.selected').index();
        selectedAmount = $('.giftcard-custom-amount input').val();
        if ($('[name="electronic"]').val() == 'true') {
            recipientEmail = $('.giftcard-recipient-email input').val();
            recipientEmailConfirm = $('.giftcard-recipient-emailconfirm input').val();
            recipientname = $('.giftcard-recipientname input').val();
            sendername = $('.giftcard-sendername input').val();
        }
        for (var i = 0; i < $('.giftcard-giftmessage input').length; i++) {
            giftMessageList[i] = $('.giftcard-giftmessage input')[i].value
        }
    }
    var params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        nocachets: String(Date.now()), // Adding this here to also avoid browser cache.
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
    };

    if ($('.class-variation-model').length > 0) {
        $('.class-variation-model').remove();
    }

    progress.show($('#pdpMain'));
    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $('#product-content'),
        callback: function(response) {
            var sessionDisplayDateTimeList = $(response).find('[data-session-display-date-time]')

            if (sessionDisplayDateTimeList.length === 1) {
                $('#sticky-data-time-and-timezone').html(sessionDisplayDateTimeList[0].dataset.sessionDisplayDateTime);
            }


            var productId = $('.turntoteaserProductID').val();
            if ($('.qv-rating-section').length > 0) {
                $('.qv-rating-section .product-number .prodSku').html(productId);
            } else {
                $('#product-teasers .product-number .prodSku').html(productId);
            }

            wunderkind.updateProduct();

            if (productId && SitePreferences.turntoUseVariants) {
                TurnToCmd('set', {'sku': productId}); // eslint-disable-line
                if (SitePreferences.turntoVisualGalleryEnable) {
                    TurnToCmd('gallery.set', {skus: [productId]}); // eslint-disable-line
                }
            }

            if ($('.instructor-name') && $('.product-instructor').first().find('.product-instructor-class')[0]){
                $('.instructor-name').empty().append($('.product-instructor').first().find('.product-instructor-class')[0].outerText)
            }
            if ($('[name="electronic"]').val() == 'true' || $('[name="physical"]').val() == 'true') {
                $($('ul.swatches.amount li').find('a')[selectedAmountIndex]).trigger('click');
                if (selectedAmount != null || selectedAmount != '') {
                    if (selectedAmountIndex > -1 && $($('ul.swatches.amount li')[selectedAmountIndex]).hasClass('selected')) {
                        $($('ul.swatches.amount li')[selectedAmountIndex]).removeClass('selected');
                    }
                    if (selectedAmount != $('.giftcard-custom-amount input').val()) {
                        $('.giftcard-custom-amount input').val(selectedAmount);
                        $('.giftcard-custom-amount input').focusout();
                    }
                }
                for (var i = 0; i < $('.giftcard-giftmessage input').length; i++) {
                    $('.giftcard-giftmessage input')[i].value = giftMessageList[i];
                    $($('.giftcard-giftmessage input')[i]).blur();
                }
                if ($('[name="electronic"]').val() == 'true') {
                    $('.giftcard-recipient-email input').val(recipientEmail);
                    $('.giftcard-recipient-emailconfirm input').val(recipientEmailConfirm);
                    $('.giftcard-recipientname input').val(recipientname);
                    $('.giftcard-sendername input').val(sendername);
                    if ($('.giftcard-recipient-email input').val() != '' || $('.giftcard-recipient-emailconfirm input').val() != '') {
                        $('.giftcard-recipient-email input').focusout();
                        $('.giftcard-recipient-emailconfirm input').focusout();
                    }
                    $('.giftcard-recipientname input').focusout();
                    $('.giftcard-sendername input').focusout();
                }
            }

            // Deferring the execution of the following function to after this callback
            setTimeout(photoGrid.init, 0);

            // call wishlist
            wishlist();
            image.replaceImages();
            image.imageClick();
            goLocal.updateStore({isIPAddress: true});
            $('#Quantity').trigger('change'); //'Not Available' message is not displaying when more than Available Qty entered in Qty field.
            // tooltip.init();
            image.pdpSlickFunctionalities();
            $('.giftcard-variations .thumbnail-slick').first().slick('slickGoTo', slickIndex, false);
            util.datePicker();
            $('.classAttendees').on('click', '.add-attendees', function(e) {
                e.preventDefault();
                util.displayAddattendeeform();
            });
            if (isGTMEnabled) {
                require('../../gtm').variantClick();
                if ($('.class-variations').length) {
                    // Extract the new variant SKU from the raw AJAX response string via regex.
                    // The hidden input #pid in the response carries the freshly selected variant ID
                    // (this is the same source wunderkind.updateProduct reads from). Regex avoids
                    // DOM-parsing fragility and any post-AJAX timing that affects jQuery selectors.
                    var newVariantSku = '';
                    if (typeof response === 'string') {
                        var pidMatch = response.match(/<input[^>]*\bid=['"]pid['"][^>]*\bvalue=['"]([^'"]+)['"]/i)
                            || response.match(/<input[^>]*\bvalue=['"]([^'"]+)['"][^>]*\bid=['"]pid['"]/i);
                        if (pidMatch) {
                            newVariantSku = pidMatch[1].trim();
                        }
                        var skuMatch = response.match(/<span class=['"]prodSku[^'"]*['"][^>]*>\s*([^<\s][^<]*?)\s*<\/span>/);
                        if (!newVariantSku && skuMatch) {
                            newVariantSku = skuMatch[1].trim();
                        }
                    }
                    if (!newVariantSku) {
                        newVariantSku = $('#product-content #pid').val() || $('#product-content .product-number .prodSku').first().text().trim();
                    }
                    require('../../gtm').selectVariant(newVariantSku);
                }
            }
            if (window.EXT_GLOBAL_SWITCH) {
                window.extendPDP();
            }
            updateExtendFrameForVariantProduct();
            var $productWishContainer = $('.wish-container--placeholder > .wish-container');
            if ($productWishContainer.length) {
                $productWishContainer.remove();
            }
            applepay();

            var $wishContainer = $('.product-actions .wish-container');
            if ($wishContainer.length) {
                $wishContainer.appendTo($('.wish-container--placeholder'));
            }

            radar.updateFromRadar();

            $('button#add-to-cart.pdp-enabled').removeAttr('disabled');
            $('button#add-to-cart.pdp-enabled').removeClass('pdp-enabled');

        }
    });
};

function updateExtendFrameForVariantProduct() {
    var updateInterval = setInterval(function () {
        $('#extend-offer iframe').contents().find('.button-group').css({
            'width': '99%'
        });
        $('#extend-offer iframe').contents().find('.caption-text').css({
            'font-family': 'Lato ,Nunito Sans ,Arial',
            'font-style': 'normal',
            'font-weight': 'normal',
            'font-size': '16px',
            'line-height': '130%',
            'letter-spacing': '0.25px',
            'color': '#555555'
        });
        $('#extend-offer iframe').contents().find('.info-button').css({
            'font-family': 'Lato ,"Nunito Sans ,Arial',
            'font-style': 'normal',
            'font-weight': 'normal',
            'font-size': '16px',
            'line-height': '130%',
            'letter-spacing': '0.25px',
            'color': '#555555',
            'text-decoration-line':'underline'
        });
        var allButtons = $('#extend-offer iframe').contents().find('.btn-offer');
        var activeButtons = $('#extend-offer iframe').contents().find('.btn-offer.active');
        allButtons.css({
            'height' : '50px',
            'background-color':'#ffffff',
            'border-color': '#555555',
            'box-shadow': 'none',
            'border-radius': '0'
        });
        allButtons.find('.term-length, .plan-price').css({
            'color': '#555555'
        });
        allButtons.on('click', function () {
            allButtons.css({
                'background-color':'#ffffff',
                'border-color': '#555555'
            });
            allButtons.find('.term-length, .plan-price').css({
                'color': '#555555'
            });

            activeButtons = $('#extend-offer iframe').contents().find('.btn-offer.active');
            activeButtons.css({
                'background-color':'#1E1E1E',
                'border-color': 'white'
            });
            activeButtons.find('.term-length, .plan-price').css({
                'color': '#ffffff'
            });
        });
        $('#extend-offer iframe').contents().find('.divider').css({
            'display' : 'none'
        });
        $('#extend-offer iframe').contents().find('.term-length').css({
            'display' : 'block',
            'font-family': 'Lato ,Nunito Sans ,Arial',
            'font-style': 'normal',
            'font-weight': 'normal',
            'font-size': '14px',
            'line-height': '100%',
            'letter-spacing': '0.25px',
            'color': '#555555',
            'text-transform': 'capitalize',
            'text-align': 'center'

        });
        $('#extend-offer iframe').contents().find('.info-button .info-icon').css({
            'display': 'none'
        });
        $('#extend-offer iframe').contents().find('.info-button').append(

            '<svg class="info-icon" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0.0307617C2.68661 0.0307617 0 2.71737 0 6.03076C0 9.34415 2.68661 12.0308 6 12.0308C9.31339 12.0308 12 9.34415 12 6.03076C12 2.71737 9.31339 0.0307617 6 0.0307617ZM6 11.0129C3.24911 11.0129 1.01786 8.78165 1.01786 6.03076C1.01786 3.27987 3.24911 1.04862 6 1.04862C8.75089 1.04862 10.9821 3.27987 10.9821 6.03076C10.9821 8.78165 8.75089 11.0129 6 11.0129Z" fill="#777777"/><path d="M5.25 3.2527C5.25 3.45364 5.32902 3.64635 5.46967 3.78844C5.61032 3.93053 5.80109 4.01035 6 4.01035C6.19891 4.01035 6.38968 3.93053 6.53033 3.78844C6.67098 3.64635 6.75 3.45364 6.75 3.2527C6.75 3.05176 6.67098 2.85905 6.53033 2.71696C6.38968 2.57487 6.19891 2.49505 6 2.49505C5.80109 2.49505 5.61032 2.57487 5.46967 2.71696C5.32902 2.85905 5.25 3.05176 5.25 3.2527ZM6.375 5.02056H5.625C5.55625 5.02056 5.5 5.07738 5.5 5.14683V9.4402C5.5 9.50965 5.55625 9.56648 5.625 9.56648H6.375C6.44375 9.56648 6.5 9.50965 6.5 9.4402V5.14683C6.5 5.07738 6.44375 5.02056 6.375 5.02056Z" fill="#777777"/></svg>'
        );
        $('#extend-offer iframe').contents().find('.plan-price').css({
            'font-family': 'Lato ,Nunito Sans ,Arial',
            'font-style': 'normal',
            'font-weight': 'bold',
            'font-size': '16px',
            'line-height': '100%',
            'letter-spacing': '0.25px',
            'color': '#555555',
            'text-align': 'center'
        });
        $('#extend-offer iframe').contents().find('.button.active').css({
            'background-color':'#1E1E1E',
            'box-shadow': 'none',
            'border-color': 'white'
        });

        if ($('#extend-offer > div:not([style*="display: none"])').length > 0) {
            const iFrameHeight = $('#extend-offer iframe').contents().find('body').height();
            $('#extend-offer iframe').height(iFrameHeight);
            $('.extend-offer-accordion').removeClass('hide_extends_offers');
            clearInterval(updateInterval);
        }
    }, 500);

}
module.exports = function () {


    var $pdpMain = $('#pdpMain');
    // hover on swatch - should update main image with swatch image
    $pdpMain.on('mouseenter mouseleave', '.swatchanchor', function () {
        var largeImg = $(this).data('lgimg'),
            $imgZoom = $pdpMain.find('.main-image'),
            $mainImage = $pdpMain.find('.primary-image');

        if (!largeImg) { return; }
        // store the old data from main image for mouseleave handler
        $(this).data('lgimg', {
            hires: $imgZoom.attr('href'),
            url: $mainImage.attr('src'),
            alt: $mainImage.attr('alt'),
            title: $mainImage.attr('title')
        });
        // set the main image
        image.setMainImage(largeImg);
    });

    // click on swatch - should replace product content with new variant
    $pdpMain.on('click', '.product-detail .swatchanchor', function (e) {
        e.preventDefault();
        if ($(this).parents('li').hasClass('unselectable')) { return; }
        var variantValue = splitUrlParameters(this.href);
        if (variantValue === undefined || variantValue === '') {
            return;
        }
        $('.swatches').find('li:first').removeClass('selected');
        updateContent(this.href);
    });

    // change drop down variation attribute - should replace product content with new variant
    $pdpMain.on('change', '.variation-select', function () {
        if ($(this).val().length === 0) { return; }
        updateContent($(this).val());

    });

    $(document).on('click', '.class-variations .set-variation-select', function(e) {
        e.preventDefault();
        $('.class-variation-model').toggleClass('hide');
        $('.class-variation-model').dialog({
            width: 761,
            dialogClass: 'class-variation-popup',
            modal: true,
            open: function() {
                $('input[name="variation-radio"]').on('click change', function() {
                    $('.class-variation-model-change-date').attr('href', $('input[name="variation-radio"]:checked').val());
                    $('.class-variation-model-change-date').removeAttr('disabled');
                });

                $('.class-variation-model-change-date').on('click change', function(e) {
                    e.preventDefault();
                    if (!($('.class-variation-model-change-date').is('[disabled=disabled]'))) {
                        updateContent($('.class-variation-model-change-date').attr('href'));
                        $('.class-variation-model').dialog('close');
                    }
                });

                $('.class-variation-model-cancel').on('click', function() {
                    $('.class-variation-model').dialog('close');
                });

                $('.month-head').on('click', function() {
                    $(this).toggleClass('active');
                    $(this).next('ul').toggle();
                });
                $('.month-head.class-date-expand').trigger('click');
            }
        });
    });

    if ($('.product-detail #product-content .selectable .swatchanchor').parents('li.selected').length == 0) {
        var swatchOptions = $('.product-detail #product-content:not(.giftcard-content) .selectable .swatchanchor');
        if (swatchOptions.length > 0) {
            $(swatchOptions[0]).click();
        }
    }

};

},{"../../ajax":2,"../../goLocal":17,"../../gtm":18,"../../progress":59,"../../radar":62,"../../util":78,"../../wunderkind":80,"./applepay":37,"./image":39,"./photo-grid/photo-grid-fe":43,"./wishlist":50}],50:[function(require,module,exports){
'use strict';
var dialog = require('../../dialog');
var util = require('../../util');
var progress = require('../../progress');
var minicart = require('../../minicart');
var wishlists = [];
var updatedWishlistsName = [];
var deletedWishlistsArray = [];


// check if find wishlist email address valid or not 
function isEmail(email) {
    var EmailRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return EmailRegex.test(email);
}

// determine if we are in PDP or PLP page 
// var isPDP = ($(document).find('#pdpMain').length > 0) && ($(document).find('.recommendation-carousel').length == 0 && $(document).find('.similar-items').length == 0);

function checkIfItemInSimilerSection (current) {
    return (current.closest('.recommendation-carousel').length > 0 || current.closest('.similar-items').length > 0);
}
// function to compare product pricess 


function comparePriceLawToHeight (price1, price2) {
    price1 = price1.split('-')[0];
    price2 = price2.split('-')[0];
    price1 = parseInt(price1, 10);
    price2 = parseInt(price2, 10);
    
    if (price1 >= price2) return 1;
    if (price1 < price2) return -1;
}

function comparePriceHeightToLow (price1, price2) {
    price1 = price1.split('-')[0];
    price2 = price2.split('-')[0];
    price1 = parseInt(price1, 10);
    price2 = parseInt(price2, 10);
    if (price1 <= price2) return 1;
    if (price1 > price2) return -1;
}

/**
 * this method for display list of available wishlists 
 * 
 */
function wishLists() {
    var wishTemplate = '';
    wishlists.forEach(function (wishlist) {
        wishTemplate += '<div class="wishlist-container">';
        wishTemplate += '<div class="wishlists-item">';
        wishTemplate += '<div class="wishlist-title " >'+wishlist.name+'</div>';
        wishTemplate += '<div class="wishlist-item-actions"><div class="wish-list-link"><a href="'+wishlist.link+'" class="view-wish-list-link">'+Resources.VIEW+'</a></div>';
        wishTemplate += '<div class="select-wishlist-btn"><input type="radio" class="wishlist-radio" name="wishlist-select" id="'+wishlist.id+'" value="'+wishlist.id+'"   /><label for="'+wishlist.id+'" class="select-list-radio"></label></div></div>'
        wishTemplate += '</div></div>';
    });
    return wishTemplate;
}

/**
 * 
 * @description render wish list dialog html template 
 *  
 */
function wishListDialogTemplate (e) {
    var productImageSrc = '';
    var productVariation = ''; 
    var productName = '';
    var productPrice = '';
    var productQty = '';
    var replaceUrl = '';
    var createWishlistUrl = '';
    var wishContainer = e.closest('.wish-container');
    var isPDP = wishContainer.data('ispdp');
    if (!isPDP) {
        productQty = Resources.QTY+' 1';
        productImageSrc =  $(e).closest('.product-tile').find('.product-image img').attr('src');
        productName = $(e).closest('.product-tile').find('.product-name .name-link ').text();
        productPrice = '<div class="plp-product-price">'; 
        productPrice += $(e).closest('.product-tile').find('.product-price').html();
        productPrice += '</div>';
        productVariation = $(e).closest('.product-tile').find('.product-swatches');
        if (productVariation.length > 0) {
            var isSelectedVaraint = $(e).closest('.product-tile').find('.swatch-list a.selected');
            if (isSelectedVaraint.length > 0) {
                productVariation =  Resources.COLOR+': ' + $(e).closest('.product-tile').find('.swatch-list a.selected .swatch-name').val();
                replaceUrl = $(e).closest('.product-tile').find('.swatch-list a.selected .replaceWishlistUrlVariant').val();
                createWishlistUrl = $(e).closest('.product-tile').find('.swatch-list a.selected .createNewWishlistUrlVariant').val();
            } else {
                productVariation = Resources.COLOR+': ' + $(e).closest('.product-tile').find('.swatch-list .swatch-name').val();
                replaceUrl = $(e).closest('.product-tile').find('.swatch-list .replaceWishlistUrlVariant').val();
                createWishlistUrl = $(e).closest('.product-tile').find('.swatch-list .createNewWishlistUrlVariant').val();
            }
        } else {
            productVariation = '';
            replaceUrl = $(e).closest('.product-tile').find('#replaceWishlistUrl').val();
            createWishlistUrl = $(e).closest('.product-tile').find('#createNewWishlistUrl').val();
        }
    } else {
        productImageSrc = $('.photo-grid__asset').attr('src');
        productVariation = $('.product-variations .first-attr .label').html();
        productName = $('.product-detail').children('.product-name').text();
        productPrice = $('.product-price').html();
        productQty = Resources.QTY + $('#Quantity').val();
        createWishlistUrl = wishContainer.find('#createNewWishlistUrl').val();
        replaceUrl = wishContainer.find('#replaceWishlistUrl').val();
    }
    if (productVariation === undefined) {
        productVariation = '';
    }
    var template = '<div class="wish-list-dialog-container">';
    template += '<input type="hidden" value="'+replaceUrl+'" class="dialogReplaceUrl"/>';
    template += '<input type="hidden" value="'+createWishlistUrl+'" class="dialogCreateNewWishlistUrl" />';
    template += '<div class="favorite-product-details"><div class="favorite-image-container"><img src='+productImageSrc+' /></div>';
    template += '<div class="favorite-details-container"><div class="favorite-product-name">'+productName+'</div><div class="favorite-product-price">'+productPrice+'</div><div class="favorite-product-variations">'+productVariation+'</div><div class="favorite-product-qty">'+productQty+'</div></div></div>';
    template += '<div class="favorite-wishlist-details">';
    template += '<div class="favorite-dialog-title">'+Resources.FAVORITE_TITLE+'</div>';
    
    if (wishlists.length > 4) {
        template += '<div class="favorite-wishlists-container fixed-height">'+wishLists()+'</div>';
    } else {
        template += '<div class="favorite-wishlists-container">'+wishLists()+'</div>';
    }
    template += '<div class="favorite-add-new-wishlist-container">';
    template += '<input type="text" class="add-new-wishlist-box" id="wishlist-add-new-box" placeholder="'+Resources.wishlistInputPlaceHolder+'" >';
    template += '<div class="add-container"><button class="add-new-wishlist-action-btn">'+Resources.ADDNEWWISHLIST+'</button></div>'
    template += '</div></div>';
    template += '</div>';

    return template;
}

// add wishlist template 
function addNewWishList (newWishListName) {
    var newWishlistObject = createNewWishlist(newWishListName);
    var wishlistId = '';
    var wishlistLink = '';
    if (!$.isEmptyObject(newWishlistObject)) {
        var wishlistDetails = newWishlistObject.allWishlists;
        wishlistDetails = wishlistDetails[wishlistDetails.length-1];
        
        wishlistId = wishlistDetails.id;
        wishlistLink = wishlistDetails.link;
    }


    $('.added-message').remove();
    $('.removed-message').remove();
    wishlists.splice(2, 0, newWishListName);
    wishlists.join();
    $('.selected-wishlist').closest('.wishlist-container').append('<div class="removed-message">'+ Resources.ITEM_REMOVED_MESSAGE +'</div>');
    $('.wishlist-title').removeClass('selected-wishlist');
    $('.view-wish-list-link').removeClass('selected-wishlist-cta');
    $('.wishlist-radio').prop('checked', false);
    var newWishList = '<div class="wishlist-container"><div class="wishlists-item"><div class="wishlist-title selected-wishlist" >'+newWishListName+'</div>';
    newWishList += '<div class="wishlist-item-actions"><div class="wish-list-link"><a href="'+wishlistLink+'" class="view-wish-list-link selected-wishlist-cta">'+Resources.VIEW+'</a></div>';
    newWishList += '<div class="select-wishlist-btn"><input type="radio" class="wishlist-radio" name="wishlist-select" id="wish'+newWishListName+'" value="'+ wishlistId+'"  checked /><label for="wish'+newWishListName+'" class="select-list-radio"></label></div></div></div><div class="added-message">'+Resources.ITEM_ADDED_MESSAGE+'</div></div>'
    $('.favorite-wishlists-container').append(newWishList);

    $('#wishlist-add-new-box').val('');
    setTimeout(function() {
        $('.added-message').remove();
        $('.removed-message').remove();
    }, 5000);
}

function openWishlistsDialog(current){
    var wishContainer = current.closest('.wish-container');
    var isPDP = wishContainer.data('ispdp');
    dialog.open({
        html:wishListDialogTemplate(current),
        options: {
            title: '',
            dialogClass:'pdp-wish-list-panel',
            width: 586,
            height: 'auto',
            draggable: false,
            open: function() {
                window.scrollTo(0,0);
                $('#wishlist-add-new-box').blur();
                $('.wishlist-container').first().find('.wishlist-title').addClass('selected-wishlist');
                $('.wishlist-container').first().find('.view-wish-list-link').addClass('selected-wishlist-cta');
                $('.wishlist-container').first().find('.wishlist-radio').prop('checked', true);
                $('.wishlist-container').first().append('<div class="default-added-message">'+Resources.ITEM_ADDED_MESSAGE+'</div>');
                setTimeout(function() {
                    $('.default-added-message').remove();
                }, 5000);
                var wishListClicks = new Array();
                wishListClicks[0] = wishlists[0].id;
                $(document).on('change', 'input[type="radio"][name="wishlist-select"]', function () {
                    var current = $(this);
                    wishListClicks.push(current.val());

                    var fromWishlistId = wishListClicks[wishListClicks.length-2];
                    var toWishlistId = this.value;
                    replaceWishlist(fromWishlistId, toWishlistId);
                    
                    $('.added-message').remove();
                    $('.default-added-message').remove();
                    $('.removed-message').remove();
                    $('#'+wishListClicks[wishListClicks.length-2]).closest('.wishlist-container').append('<div class="removed-message">'+Resources.ITEM_REMOVED_MESSAGE+'</div>');
                    $('.wishlist-title').removeClass('selected-wishlist');
                    $('.view-wish-list-link').removeClass('selected-wishlist-cta');
                    $(this).closest('.wishlists-item').find('.wishlist-title').addClass('selected-wishlist');
                    $(this).closest('.wishlists-item').find('.view-wish-list-link').addClass('selected-wishlist-cta');
                    $(this).closest('.wishlist-container').append('<div class="added-message">'+Resources.ITEM_ADDED_MESSAGE+'</div>');
                    setTimeout(function() {
                        $('.added-message').remove();
                        $('.removed-message').remove();
                    }, 5000);
                });
                
                $(document).on('keypress', '#wishlist-add-new-box', function (e) {
                    
                    $('.default-added-message').remove();
                    $('#wishlist-add-new-box').removeClass('input-error');
                    $('.favorite-add-new-wishlist-container').find('.input-error-msg').remove();
                    if (e.which == 13) {
                        $('.add-new-wishlist-action-btn').trigger('click');
                    }
                });
                $(document).on('click', '.add-new-wishlist-action-btn', function () {
                    $('.default-added-message').remove();
                    $('#wishlist-add-new-box').removeClass('input-error');
                    $('.favorite-add-new-wishlist-container').find('.input-error-msg').remove();
                    if (wishlists.length > 4) {
                        if (!$('.favorite-wishlists-container').hasClass('fixed-height')) {
                            $('.favorite-wishlists-container').addClass('fixed-height');
                        }
                    }
                    if (wishlists.length > 9) {
                        $('#wishlist-add-new-box').addClass('input-error');
                        $('.favorite-add-new-wishlist-container').append('<div class="input-error-msg">'+ Resources.MAXIMUM_WISHLISTS_EXCEDED_MSG +'</div>');
                        return;
                    }
                    var newWishListName = $('#wishlist-add-new-box').val();
                    if (newWishListName.trim() === '' || newWishListName === undefined) {
                        $('#wishlist-add-new-box').addClass('input-error');
                        $('.favorite-add-new-wishlist-container').append('<div class="input-error-msg">'+ Resources.WISHLIST_REQUIRED_FEILD_MSG +'</div>');
                        return;
                    }
                    addNewWishList(newWishListName);
                    var container = $('.favorite-wishlists-container');
                    container.scrollTop(container.prop('scrollHeight'));
                });
            },
            close : function () {
                if (!isPDP) {
                    progress.show($('#main'));
                    updateWishlistIconImage('add', current);
                    if ($('.favorite-product-variations').text() != '') {
                        $('#wishlistedArray').val();
                    }
                    setTimeout(function(){ progress.hide() }, 1000);
                } else {
                    progress.show($('#pdpMain'));
                    updateWishlistIconImage('add', current);
                    setTimeout(function(){ progress.hide() }, 1000);
                }
            }
        }
    });
}


// ajax call to save the product on wishlist 
function addProductToWishList(addToWishlistURL, current) {
    var wishContainer = current.closest('.wish-container');
    var isPDP = wishContainer.data('ispdp');
    var url = util.appendParamToURL(addToWishlistURL, 'isAjax', true);
    $.ajax({
        type: 'GET',
        url: url,
        success: function(data) {
            if (data.success) {
                //var isInSimlarSection = checkIfItemInSimilerSection(current);
                if (!isPDP) {
                    var pid = data.pId;
                    var wishlistedArray = $('#wishlistedArray').val();
                    wishlistedArray = wishlistedArray.split(',');
                    var newWishlistedArray = [];
                    for (var i = 0; i < wishlistedArray.length; i++) {
                        newWishlistedArray.push(wishlistedArray[i]);
                    }
                    newWishlistedArray.push(pid);
                    $('#wishlistedArray').val(newWishlistedArray);
                }
                wishlists = data.allWishlists;
                openWishlistsDialog(current);
            }
        }
    })
}

// ajax call to add new wishlist, this will return : wishlistObject {id, link , name}
function createNewWishlist(newWishListName, isMyListsPage) {
    var addWishlistURL = '';
    var wishlistObject = new Object;

    if (isMyListsPage) {
        addWishlistURL = $('#createNewWishlistUrl').val();
    } else {
        addWishlistURL = $('.dialogCreateNewWishlistUrl').val();
    }
    var url = util.appendParamsToUrl(addWishlistURL, {
        'isAjax': true,
        'wishlistName': newWishListName
    });

    $.ajax({
        async: false,
        type: 'GET',
        url: url,
        success: function(data) {
            if (data.success) {
                if (isMyListsPage) {
                    var defaultImageUrl = $('#defaultImageUrl').val();
                    var deleteIcon = $('#wishlistboxdeleteicon').val();
                    var arrowLink = $('.wishlist-box .link-section img').attr('src');
                    var newWishlist = '<div class="wishlist-box" data-wishlistid="'+data.newWishlistId+'">';
                    newWishlist += '<button class="delete-wishlist-btn"><img src="'+deleteIcon+'" alt="delete-icon" /></button>';
                    newWishlist += '<div class="img-section"><img src="'+defaultImageUrl+'"></div>';
                    newWishlist += '<div class="details-section"><div class="name-count-section"><a href="'+data.newWishlistLink+'"><div class="wishlist-name"><span>'+newWishListName+'</span></div></a><div class="wishlist-count"><span>0 '+Resources.ITEMS+'</span></div></div>';
                    newWishlist += '</div><div class="link-section"><img width="6.68" height="12" src="'+arrowLink+'"/></div></div>';

                    $('.wishlists-container').append(newWishlist);
                }
                wishlistObject = data;
            }
        }
    });

    return wishlistObject;
}

// ajax call to move item from wishlist to another
function replaceWishlist(fromWishlistId, toWishlistId) {
    var replaceWishlistURL = '';
    replaceWishlistURL = $('.dialogReplaceUrl').val();
    var url = util.appendParamsToUrl(replaceWishlistURL, {
        'isAjax': true,
        'fromWishlistId': fromWishlistId,
        'toWishlistId': toWishlistId
    });
    var newWishlistId ='';
    $.ajax({
        type: 'GET',
        url: url,
        success: function(data) {
            if (data.success) {
                newWishlistId = data.newWishlistId;
            }
        }
    });

    return newWishlistId;
}

//ajax call to change the wishlist privacy
function changePrivacy(currentWishlistId,privacy) {
    var url = util.appendParamsToUrl(Urls.setPrivacy, {
        'isAjax': true,
        'WishListID': currentWishlistId,
        'privacy': privacy
    });
    var result = '';
    $.ajax({
        type: 'GET',
        url: url,
        success: function(data) {
            if (data.success) {
                result = true;
            }
        }
    });
    return result;
}
// ajax call to rename wishlist by wishlist ID, this will return : true or false
function renameWishlistById(wishlistId, wishlistName) {
    var renameWishlistUrl = $('#renameWishlistUrl').val();

    var url = util.appendParamsToUrl(renameWishlistUrl, {
        'isAjax': true,
        'WishListID': wishlistId,
        'WishListName': wishlistName
    });

    var result = false;

    $.ajax({
        type: 'GET',
        url: url,
        success: function(data) {
            if (data.success) {
                result = true;
            }
        }
    });

    return result;
}

// ajax call to rename wishlist by wishlist ID, this will return : true or false
function findWishlists(firstName, lastName, email) {
    var findWishliststUrl = $('#findWishlistsUrl').val();

    var url = util.appendParamsToUrl(findWishliststUrl, {
        'FirstName': firstName,
        'LastName': lastName,
        'Email': email
    });

    var result = false;

    $.ajax({
        type: 'GET',
        url: url,
        success: function(data) {
            if (data.success && data.results && data.results >0) {
                window.location.href = data.ContinueURL;
            } else {
                if ($('.find-wishlist-container .title-section span').length == 0) {
                    $('.find-wishlist-container .title-section').append('<span>'+Resources.WISHLISTNORESULTFOUND+'</span>');
                } 
            }
        }
    });

    return result;
}

// ajax call to save changes
function saveManageWishlists() {
    var saveManageWishliststUrl = $('#saveManageWishliststUrl').val();

    var url = util.appendParamsToUrl(saveManageWishliststUrl, {
        'isAjax': true,
        'RenameWishlists': JSON.stringify(updatedWishlistsName),
        'DeleteWishlists': deletedWishlistsArray
    });

    var result = false;

    $.ajax({
        type: 'GET',
        url: url,
        success: function(data) {
            if (data.success) {
                for (var i = 0; i < deletedWishlistsArray.length; i++) {
                    $('.wishlists-container').find('.wishlist-box[data-wishlistid='+deletedWishlistsArray[i]+']').remove();
                }
                updatedWishlistsName = [];
                deletedWishlistsArray = [];
                $('.ui-dialog-titlebar-close').trigger('click');
            }
        }
    });

    return result;
}

// update the wishlist wihshed / unwished 
function updateWishlistIconImage(type, e) {
    var wishContainer = e.closest('.wish-container');
    var isPDP = wishContainer.data('ispdp');
    var imgSrc = '';
    if (type === 'add') {
        
        imgSrc = $('#addedWishlistImage').val();
        if (!isPDP) {
            $(e).closest('.product-tile').find('.wish-container .add-to-wish-btn').removeClass('add-to-wish-list');
            $(e).closest('.product-tile').find('.wish-container .add-to-wish-btn').addClass('wishlist-added');
            $(e).closest('.product-tile').find('.wish-container .add-to-wish-btn .wish-floating-button').attr('src', imgSrc);
        } else {
            $('.wish-container--placeholder').find('.wish-container .add-to-wish-btn').removeClass('add-to-wish-list');
            $('.wish-container--placeholder').find('.wish-container .add-to-wish-btn').addClass('wishlist-added');
            $('.wish-container--placeholder .wishlist-added img').attr('src', imgSrc);
        }
    } else {
        imgSrc = $('#notAddedWishlistImage').val();
        if (!isPDP) {
            $(e).closest('.product-tile').find('.wish-container .add-to-wish-btn').removeClass('wishlist-added');
            $(e).closest('.product-tile').find('.wish-container .add-to-wish-btn').addClass('add-to-wish-list');
            $(e).closest('.product-tile').find('.wish-container .add-to-wish-btn .wish-floating-button').attr('src', imgSrc);
        } else {
            $('.wish-container--placeholder').find('.wish-container .add-to-wish-btn').removeClass('wishlist-added');
            $('.wish-container--placeholder').find('.wish-container .add-to-wish-btn').addClass('add-to-wish-list');
            $('.wish-container--placeholder .wish-container .add-to-wish-btn .wish-floating-button').attr('src', imgSrc);
        }
    }
}

// this method used to remove the item from wishlist 
function removeProductFromWishList(removeFromWishlistURL, current) {
    if (removeFromWishlistURL) {
        var url = util.appendParamToURL(removeFromWishlistURL, 'isAjax', true);
        $.ajax({
            type: 'GET',
            url: url,
            success: function(data) {
                if (data && !data.error) {
                    if ($(document).find('#pdpMain').length == 0) {
                        var pid = data.pId;
                        var wishlistedArray = $('#wishlistedArray').val();
                        wishlistedArray = wishlistedArray.replace('"', '');
                        wishlistedArray = wishlistedArray.replace('[','');
                        wishlistedArray = wishlistedArray.replace(']', '');
                        wishlistedArray = wishlistedArray.split(',');
                        var newWishlistedArray = [];
                        for (var i = 0; i < wishlistedArray.length; i++) {
                            newWishlistedArray.push(wishlistedArray[i]);
                        }
                        const index = newWishlistedArray.indexOf(pid);
                        if (index > -1) {
                            newWishlistedArray.splice(index, 1);
                        }
                        $('#wishlistedArray').val(newWishlistedArray);
                    }
                    progress.hide();
                    updateWishlistIconImage('remove', current);
                }
                // success
            },
            error: function() {
                progress.hide();
            }
        });
    }
}

// this method to create new wishlist dialog template in wishlist LP 

function createWishlistDialogTemplate () {
    
    var defaultWishlistName = $('.wishlist-header').text();
    defaultWishlistName = defaultWishlistName.trim();

    var template = '<div class="wishlist-create-container">';
    template += '<div class="create-dialog-title">'+Resources.CREATENEWWISHLIST+'</div>';
    template += '<div class="main-container">';
    template += '<div class="items-list">';
    template += '<div class="wishlist-item">';
    template += '<div class="item-container">';
    template += '<div class="first-Item">'+defaultWishlistName+'</div>'
    template += '</div>';
    template += '</div>';
    template += '</div>';
    template += '<div class="add-section"><input type="text" class="add-new-input" placeholder="'+Resources.wishlistInputPlaceHolder+'"/><a href="#" id="add-cta"><div class="add-cta">'+Resources.ADDNEWWISHLIST+'</div></a></div>';
    template += '</div></div>';

    return template;
}

// this method to render new wishlist 
function renderNewWishlist (isMainWishlistPage) {
    var width = $(window).width();
    var wishlistName = '';
    var numberOfWishlists = $('.wishlists-section .wishlist-box').length;
    if (isMainWishlistPage) {
        if (width > 1023) {
            wishlistName = $('.wishlists-search-box .search-wihlists-input').val();
        } else {
            wishlistName = $('.wishlist-heading-bar-mobile .wishlists-search-box .search-wihlists-input').val();
        }
        if (numberOfWishlists > 9) {
            $('.wishlists-search-box .search-wihlists-input').addClass('error');
            $('.wishlists-section .right-section').append('<div class="input-error-msg">'+ Resources.MAXIMUM_WISHLISTS_EXCEDED_MSG +' </div>');
            return;
        }
    } else {
        wishlistName = $('.addNewWishlist-box .wishlist-add-new-box').val();
        if (numberOfWishlists > 9) {
            $('.addNewWishlist-box .wishlist-add-new-box').addClass('error');
            $('.manage-wishlists-container .add-container').append('<div class="input-error-msg">'+ Resources.MAXIMUM_WISHLISTS_EXCEDED_MSG +' </div>');
            return false;
        }
    }
    if (wishlistName != '') {
        createNewWishlist(wishlistName, true); // newWishlistObject {id,name,link}
    }
    $('.wishlists-search-box .search-wihlists-input').val('');
    $('.addNewWishlist-box .wishlist-add-new-box').val('');
}

// function to render the find wishlist dialog 
function findWishlistsDialogTemplate () {
    var template = '<div class="find-wishlist-container">';
    template += '<div class="title-section">'+Resources.FINDWISHLISTTITLE+'</div>';
    template += '<div class="find-form-section">';
    template += '<div class="wishlist-email-finder">';
    template += '<div class="wishlist-email-label">'+Resources.SEARCHBYEMAIL+'</div>';
    template += '<div class="email-box"><input type="email" class="find-by-email" placeholder="'+Resources.EMAILADDRESS+' *" /></div>'
    template += '</div>';
    template += '<div class="search-btn-box"><button class="wishlist-finder-search">'+Resources.FINDLIST+'</button></div>';
    template += '</div></div>';

    return template;
}


function shareWishlistDialogTemplate () {
    var shareLink = $('#wishlistShareUrl').val();
    var template = '<div class="share-wishlist-container">';
    template += '<div class="header-container">';
    template += '<div class="title-section">'+Resources.SHARELISTTITLE+'</div>';
    template += '<div class="description-section">'+Resources.SHARELISTDESCRIPTION+'</div></div>';
    template += '<div class="sharelist-actions-container">';
    template += '<div class="link-list-share-section">';
    template += '<div class="share-via-link-msg">'+Resources.SHAREVIALINKMSG+'</div>';
    template += '<div class="link-share-buttons">';
    template += '<label class="share-link-label">'+Resources.COPYLINKTOSHARE+'</label>';
    template += '<input type="text" class="share-list-link-input" value="'+shareLink+'"/>';
    template += '<button class="copy-link-btn" >'+Resources.COPYLINK+'</button>'
    template += '</div></div>';
    template += '<div class="email-list-share-section">';
    template += '<div class="share-via-email-msg">'+Resources.SHAREVIAEMAILMSG+'</div>';
    template += '<div class="email-share-buttons">';
    template += '<input type="text" class="share-list-email-input" placeholder="'+Resources.ENTEREMAILADDRESS+'"/>';
    template += '<button class="send-email-btn" >'+Resources.SENDEMAIL+'</button>'
    template += '</div></div>';
    template += '</div>';
    template += '</div>';

    return template;
} 

function singleWishlistManageDialogTemplate () {
    var wishlistName = $('.wishlist-header ').text();
    //var isDefaultWishlist = $('#isDefaultWishlist').val();
    var template = '<div class="single-wishlist-manage-container">';
    template += '<div class="dialog-header">'+wishlistName+'</div>';
    template += '<div class="edit-wishlist-container">';
    template += '<label class="edit-wishlist-name">'+Resources.EDITWISHLISTNAME+'</label>';
    template += '<input type="text" class="wishlist-name-edit-input" value="'+wishlistName+'"/>';
    template += '</div>';
    template += '<div class="privacy-container">';
    template += '<div class="privacy-section-title">'+Resources.SELECTPRIVACYMSG+'</div>';
    template += '<div class="privacy-sharable-section">';
    template += '<label class="radio-button-label">'+Resources.SHAREABLE+'';
    template += '<input type="radio" class="privacy-radio-input" name="privacy" value="shareable" >';
    template += '<span></span></label>';
    template += '<div class="privacy-item-description">'+Resources.SHERABLEDESCRIPTION+'</div>';
    template += '</div>';
    template += '<div class="privacy-sharable-section">';
    template += '<label class="radio-button-label">'+Resources.PUBLIC+'';
    template += '<input type="radio" class="privacy-radio-input" name="privacy" value="public"  checked>';
    template += '<span></span></label>';
    template += '<div class="privacy-item-description">'+Resources.PUBLICDESCRIPTION+'</div>';
    template += '</div>';
    template += '<div class="privacy-sharable-section">';
    template += '<label class="radio-button-label">'+Resources.PRIVATE+'';
    template += '<input type="radio" class="privacy-radio-input" name="privacy" value="private">';
    template += '<span></span></label>';
    template += '<div class="privacy-item-description">'+Resources.PRIVATEDESCRIPTION+'</div>';
    template += '</div>';
    template += '</div>';
    template += '<div class="manage-actions-container">';
    template += '<button class="save-manage-action">'+Resources.SAVECHANGES+'</button>';
    template += '<button class="cancel-manage-action">'+Resources.CANCEL+'</button>';
    template += '</div>';
    template += '</div>';

    return template;
}

// function to do fillteration by price 

function priceFiltters (type) {
    var items = $('.wishlist-products');
    var parent = $('.item-list');
    var SortElements = new Object();
    for (var i = 0; i< items.length; i++) {
        var itemValue = parseInt($(items[i]).find('.item-dashboard .product-list-item  .price-sales').text().replace('$', '').replace(/\s+/g, ''), 10);
        SortElements[itemValue+'-'+i] = {'element': items[i], 'index': i};
    }

    var keys = Object.keys(SortElements);
    if (type === 'LOWTOHEIGHT') {
        keys.sort(comparePriceLawToHeight);
    } else {
        keys.sort(comparePriceHeightToLow);
    }
    
    for (var j = 0; j< keys.length; j++) {
        parent.append(SortElements[keys[j]].element);
    }
}

// function to render the delete wishlist dialog template 
function deleteWishListTemplate (wishlistID) {
    var template = '<div class="delete-wishlist-container">';
    template += '<input type="hidden" id="wishlistIDToRemove" value="'+wishlistID+'"/>';
    template += '<div class="title-section"><div class="confirmation-msg">'+Resources.AREYOUSUREMSG+'</div><div class="description-msg">'+Resources.DELETECONFIRMATIONMSG+'</div></div>';
    template += '<div class="actions-section"><button class="cancel-delete-btn">'+Resources.CANCEL+'</button><button class="delete-list-btn">'+Resources.DELETELIST+'</button></div>';
    template += '</div>';

    return template;
}
module.exports = function () {

    var elementWidth = $('.item-dashboard').width();
    $('.item-dashboard').css('width', elementWidth);
    $('.wishlists-container').on('click', '.delete-wishlist-btn', function () {
        var wishlistID = $(this).closest('.wishlist-box').data('wishlistid');
        dialog.open({
            html:deleteWishListTemplate(wishlistID),
            options: {
                title: '',
                dialogClass:'delete-wishlist-panel',
                width: 462,
                height: 'auto',
                draggable: false,
                open: function() {

                    $(document).on('click', '.cancel-delete-btn', function () {
                        $('.ui-dialog-titlebar-close').trigger('click');
                    });

                    $(document).on('click', '.delete-list-btn', function () {
                        var deletedWishlistID = $('#wishlistIDToRemove').val();
                        deletedWishlistsArray = [];
                        deletedWishlistsArray.push(deletedWishlistID);
                        $('.ui-dialog-titlebar-close').trigger('click');
                    });
                },
                close: function () {
                    saveManageWishlists();
                }
            }    
        });
    });
    var orginalListsItemOrder = $('.wishlist-products');

    // update qty value for wishlisted item 
    $('.Quantity .wishlist-qty').on('change', function (e) {
        e.preventDefault();
        var current = $(this);
        // var maxProductCanBeAdded = parseFloat(current.closest('.quantity-field').find($('.max-product-can-be-added')).val());
        var newQty = parseFloat(current.closest('.quantity-field').find($('.wishlist-qty')).val());
        if (newQty > 0){
            updateQTY(newQty, current);
        }
    });
    function updateQTY(newQty, current){
        var wishlistID = current.closest('.quantity-field').find('.wishlist-ID').val();
        var prodcutID = current.closest('.quantity-field').find('.product-ID').val(); 
        var standardPrice = current.closest('.quantity-field').find('#standard-price-wish-list').val();
        var salesPrice = current.closest('.quantity-field').find('#sales-price-wish-list').val(); 
        var url = util.appendParamsToUrl(Urls.UpdateQTY, {
            newQty: newQty,
            wishlistID: wishlistID,
            prodcutID: prodcutID,
            format: 'isAjax'
        });
        $.ajax({
            dataType: 'json',
            url: url,
            success: function(response) {
                if (response.result.success){
                    current.closest('.quantity-field').find($('.Quantity .wishlist-qty')).val(newQty); 
                    current.closest('.wishlist-products').find('.product-list-item .price-sales').text('$'+(salesPrice*newQty).toFixed(2));
                    current.closest('.wishlist-products').find('.product-list-item .price-standard').text('$'+(standardPrice*newQty).toFixed(2));
                    var allItems = $('.item-dashboard .product-list-item');
                    var allPrices = 0;
                    if (allItems.length == 0) {
                        $('#totalItemsPrice').text('$0');
                    } else {
                        for (var i = 0; i < allItems.length; i++) {
                            var price = $(allItems[i]).find('.price .price-sales').text();
                            if (price != '') {
                                price = price.replace('$', '');
                                allPrices += parseFloat(price);
                            }           
                        }
                        allPrices = allPrices.toFixed(2);
                        $('#totalItemsPrice').text('$'+allPrices);
                    }
                }
            }
        });
    }

    // select propirity jquery select
    setTimeout(function () {
        $('.option-priority select').selectmenu({
            icons: {button: 'custom-icon'},
            position: {my : 'top+10', at: 'left+28'},
            change () {
                var wishlistID = $(this).closest('.field-wrapper').find('.wishlist-ID').val();
                var selectedValue = $(this).val();
                var prodcutID = $(this).closest('.field-wrapper').find('.product-ID').val();
                setListPriority(selectedValue, wishlistID, prodcutID);
            }
        }).selectmenu('menuWidget');
        $('.option-priority').addClass('show-priority');
        $('.ui-selectmenu-menu').addClass('priority-select-menu');
        $('.priority-select-menu .ui-menu').addClass('priority-custome-list');

        if ($('.show-priority .input-select').hasClass('disable-dropdown-menu')) {
            $('.show-priority .input-select').attr('disabled', 'disabled');
            $('.show-priority .custom-icon').css('display', 'none');
        }
        // set fillters menu 
        $('.sort-items .sort-list').selectmenu({
            icons: {button: 'custom-icon'},
            position: {my : 'top+10', at: 'left+48'},
            change () {
                
                var selectedValue = $('.sort-items .sort-list option:selected').val();
                if (selectedValue == 1) {
                    $('.item-list').append(orginalListsItemOrder)
                } else if (selectedValue == 2) {
                    priceFiltters('LOWTOHEIGHT');
                } else if (selectedValue == 3) {
                    priceFiltters('HEIGHTTOLOW');
                }
            }
        }).selectmenu('menuWidget');
        $('.sort-items').addClass('show-sort-items');
        $('.ui-selectmenu-menu').addClass('sortlist-select-menu');

        // sort items for mobile
        $('.mobile-sort-items .sort-list').selectmenu({
            icons: {button: 'custom-icon'},
            position: {my : 'top+10', at: 'left+85'},
            change () {
                
                var selectedValue = $('.mobile-sort-items .sort-list option:selected').val();
                if (selectedValue == 1) {
                    $('.item-list').append(orginalListsItemOrder)
                } else if (selectedValue == 2) {
                    priceFiltters('LOWTOHEIGHT');
                } else if (selectedValue == 3) {
                    priceFiltters('HEIGHTTOLOW');
                }
            }
        }).selectmenu('menuWidget');
        $('.mobile-sort-items').addClass('mobile-show-sort-items');
        $('.ui-selectmenu-menu').addClass('sortlist-select-menu');
    }, 100);
    function setListPriority(selectedValue, wishlistID, prodcutID){
        var url = util.appendParamsToUrl(Urls.UpdatePriority, {
            newPriority: selectedValue,
            wishlistID: wishlistID,
            prodcutID: prodcutID,
            format: 'isAjax'
        });
        $.ajax({
            dataType: 'json',
            url: url,
            success: function(response) {
                if (response.result.success){
                   // current.closest('.quantity-field').find($('.Quantity .wishlist-qty')).val(newQty); 
                }
            }
        });
    }
    // Calculate all items price 
    var allItems = $('.item-dashboard .product-list-item');
    var allPrices = 0;
    if (allItems.length == 0) {
        $('#totalItemsPrice').text('$0');
    } else {
        for (var i = 0; i < allItems.length; i++) {
            var price = $(allItems[i]).find('.price .price-sales').text();
            if (price != '') {
                price = price.replace('$', '');
                allPrices += parseFloat(price);
            }           
        }
        allPrices = allPrices.toFixed(2);
        $('#totalItemsPrice').text('$'+allPrices);
    }
    
    // Single wishlist manage actions
    $('.single-wishlist-manage').on('click', function () {
        dialog.open({
            html:singleWishlistManageDialogTemplate(),
            options: {
                title: '',
                dialogClass:'single-wishlists-manage-panel',
                width: 384,
                height: 'auto',
                draggable: false,
                open: function() {
                    var privacyValue = $('#wishlistPrivacy').val();
                    $('input[name=privacy][value="' + privacyValue + '"]').prop('checked', true);
                    $(document).on('keypress', '.wishlist-name-edit-input', function (e) {
                        $('.edit-wishlist-container .error-msg').remove();
                        $(this).removeClass('error');
                        if (e.which == 13) {
                            var oldName = $('.wishlist-header').text();
                            var newName = $(this).val();
                            var currentWishlistId = $('#currentWishlistId').val();
                            if (newName == '') {
                                $(this).addClass('error');
                                $('.edit-wishlist-container').append('<span class="error-msg">'+Resources.VALIDATE_REQUIRED+'</span>');
                                return;
                            }
                            if (newName != oldName) { 
                                renameWishlistById(currentWishlistId, newName);
                                $('.wishlist-header').text(newName);
                                $('.ui-dialog-titlebar-close').trigger('click');
                            }

                        }
                    });
                    $(document).on('focusout', '.wishlist-name-edit-input', function () {
                        if ($(this).val() == '') {
                            if ($('.edit-wishlist-container span.error-msg').length < 1){
                                $(this).addClass('error');
                                $('.edit-wishlist-container').append('<span class="error-msg">'+Resources.VALIDATE_REQUIRED+'</span>');
                            }
                            return;
                        }
                    });
                    $(document).on('click', '.save-manage-action', function () {
                        $('.edit-wishlist-container .error-msg').remove();
                        $('.wishlist-name-edit-input').removeClass('error');
                        var privacy = $('.privacy-radio-input:checked').val();
                        var oldName = $('.wishlist-header').text();
                        var newName = $('.wishlist-name-edit-input').val();
                        var currentWishlistId = $('#currentWishlistId').val();
                        if (newName == '') {
                            $('.wishlist-name-edit-input').addClass('error');
                            $('.edit-wishlist-container').append('<span class="error-msg">'+Resources.VALIDATE_REQUIRED+'</span>');
                            return;
                        }
                        if (oldName != newName) {
                            renameWishlistById(currentWishlistId, newName);
                            $('.wishlist-header').text(newName);
                        }
                        changePrivacy(currentWishlistId,privacy);
                        $('#wishlistPrivacy').val(privacy);
                        if (privacy == 'private') {
                            $('.wishlist-share').closest('li').addClass('hide-share-btn');
                            $('.wishlist-heading-bar-mobile .wishlist-share').closest('li').addClass('hide-share-btn');
                        } else {
                            $('.wishlist-share').closest('li').removeClass('hide-share-btn');
                            $('.wishlist-heading-bar-mobile .wishlist-share').closest('li').removeClass('hide-share-btn');
                        }
                        $('.ui-dialog-titlebar-close').trigger('click');
                    });
                    $(document).on('click', '.cancel-manage-action', function () {
                        $('.ui-dialog-titlebar-close').trigger('click');
                    });
                }
            }    
        });
    });
    // Share Wishlist in wishlist page
    $('.wishlist-share').on('click', function () {
        dialog.open({
            html:shareWishlistDialogTemplate(),
            options: {
                title: '',
                dialogClass:'share-wishlists-panel',
                width: 462,
                height: 'auto',
                draggable: false,
                open: function() {


                    $(document).on('click', '.copy-link-btn', function () {
                        var wishlistLink = $('.share-list-link-input');
                        wishlistLink.select();              
                        document.execCommand('copy');
                    });
                    $(document).on('click', '.send-email-btn', function () {
                        $('.email-share-buttons').find('.email-search-error').remove();
                        $('.share-list-email-input').removeClass('error');
                        var shareEmail = $('.share-list-email-input').val();
                        if (shareEmail != '') {
                            var title = $('#wishListShareTitle').val();
                            var url = $('#wishlistShareUrl').val();
    
                            window.location.href = 'mailto:'+shareEmail+'?subject='+title+'&body='+url+'';
                        } else {
                            $('.share-list-email-input').addClass('error');
                            $('.email-share-buttons').append('<span class="email-search-error">'+Resources.VALIDATE_REQUIRED+'</span>')
                            return;
                        }
                    });
                    $(document).on('keypress', '.share-list-email-input', function () {
                        $('.share-list-email-input').removeClass('error');
                        $('.email-share-buttons').find('.email-search-error').remove();
                    });
                }
            }    
        });
    });
    $('.move-to-cart').on('click', function (e) {
        e.preventDefault();
        progress.show($('.wishlist-continer'));
        var wishlistID = $(this).closest('.move-tocart-section').find('.wishListID').val();
        var url = util.appendParamsToUrl(Urls.moveAllCart, {
            wishlistID: wishlistID,
            format: 'isAjax'
        });
        $.ajax({
            url: url
        }).then(function (response) {
            progress.hide();
            minicart.show(response);
        });
    });

    $('.wishlis-add-to-cart').on('click', function (e) {
        e.preventDefault();
        progress.show($('.wishlist-continer'));
        var prodcutID = $(this).closest('.addto-cart').find('.product-ID').val();
        var quantity = $(this).closest('.addto-cart').find('.quantity').val();
        var wishlistID = $(this).closest('.addto-cart').find('.wishlist-ID').val();
        var url = util.appendParamsToUrl(Urls.addWishListedToCart, {
            prodcutID: prodcutID,
            quantity: quantity,
            wishlistID: wishlistID,
            format: 'isAjax'
        });
        $.ajax({
            url: url
        }).then(function (response) {
            progress.hide();
            minicart.show(response);
        });
    });
    // Find wishlist dialog 
    $('.find-wishlist-btn').on('click', function () {
        dialog.open({
            html:findWishlistsDialogTemplate(),
            options: {
                title: '',
                dialogClass:'find-wishlists-panel',
                width: 384,
                height: 'auto',
                draggable: false,
                open: function() {
                    $('.find-by-email').blur();
                    $(document).on('click', '.wishlist-finder-search', function () {
                        $('.wishlist-email-finder').find('.error-msg').remove();
                        $('.find-wishlist-container .title-section').find('span').remove();
                        $('.find-wishlist-container .find-by-email').removeClass('error');
                        var emailaddress = $('.find-wishlist-container .find-by-email').val();
                        var firstName = $('.find-wishlist-container .find-by-first-name').val();
                        var lastName = $('.find-wishlist-container .find-by-last-name').val();
                        if (emailaddress == '' || isEmail(emailaddress) == false) {
                            $('.find-wishlist-container .find-by-email').addClass('error');
                            $('.wishlist-email-finder').append('<div class="error-msg">'+Resources.INVALIDEMAILADDRESS+'</div>');
                            return;
                        }

                        // do your backend work here and please if the search result error is empty add the fowlloing code on ajax response 
                        findWishlists(firstName, lastName, emailaddress);
                    });
                    $(document).on('keypress', '.find-wishlist-container .find-by-email', function (e) {
                        $('.wishlist-email-finder').find('.error-msg').remove();
                        $('.find-wishlist-container .find-by-email').removeClass('error');
                        $('.find-wishlist-container .title-section').find('span').remove();
                        if (e.which == 13) {
                            if ($(this).val() != '') {
                                $('.wishlist-finder-search').trigger('click');
                            }
                        }
                    });
                }
            }    
        });
    });

    // Search for wihslist 
    $('.wishlist-heading-bar #search-for-wishlist, .wishlist-heading-bar-mobile .search-wishlist-input').on('keypress keyup', function (e) {
        var wishlistName = $(this).val();
        if (wishlistName == '') {
            $('.wishlists-container .wishlist-box').removeClass('hide-wishlist-box');
        }
        if (e.which == 13) {
            if (wishlistName != '') {
                var wishlists = $('.wishlists-container').children();
                for (var i = 0; i < wishlists.length; i++) {
                    var existWishlistName = $(wishlists[i]).find('.details-section .wishlist-name span').text();
                    existWishlistName = existWishlistName.toLowerCase();
                    wishlistName = wishlistName.toLowerCase();
                    if (!existWishlistName.includes(wishlistName)) {
                        $(wishlists[i]).addClass('hide-wishlist-box');
                    }
                }
            }
        }
    });

    // create new wishlist 
    $('.addWishlist-btn').on('click', function () {
        $('.wishlists-search-box .search-wihlists-input').focus();
        renderNewWishlist(true);
    });
    $('.wishlists-search-box .search-wihlists-input').on('keypress', function (e) {
        $(this).removeClass('error');
        $('.wishlists-section .right-section').find('.input-error-msg').remove();
        if (e.which == 13) {
            renderNewWishlist(true);
        }
    });
    $('.wishlists-search-box .search-wihlists-input').on('focus', function () {
        $(this).addClass('addNew-box-typing');
    });
    $('.wishlists-search-box .search-wihlists-input').on('focusout', function () {
        $(this).removeClass('addNew-box-typing');
        $(this).removeClass('error');
        $('.wishlists-section .right-section').find('.input-error-msg').remove();
    });
    
    // wishlist page click to add new wish list
    $(document).on('click', '#add-cta', function () {
        var inputValue = $('.add-new-input').val();
        if (inputValue != '') {
            var template = '<div class="wishlist-item">';
            template += '<div class="item-container">';
            template += '<div class="item-actions"><div class="item-label">'+Resources.EDITWISHLISTNAME+'</div><div class="item-remove">'+Resources.DELETE+'</div></div>'
            template += '<input type="text" class="add-new-wishlist-box" id="wishlist-add-new-box" value="'+inputValue+'" placeholder="'+Resources.wishlistInputPlaceHolder+'" >';
            template += '</div></div>';
            $('.items-list').append(template);
            $('.add-new-input').val('');
        } else {
            $('.add-section .add-new-input').addClass('input-error');
        }

    });
    $(document).on('keypress', '.add-new-input', function (e) {
        $(this).removeClass('input-error');
        var value = $(this).val();
        if (e.which == 13) {
            if (value != '') {
                var template = '<div class="wishlist-item">';
                template += '<div class="item-container">';
                template += '<div class="item-actions"><div class="item-label">'+Resources.EDITWISHLISTNAME+'</div><div class="item-remove">'+Resources.DELETE+'</div></div>'
                template += '<input type="text" class="add-new-wishlist-box" id="wishlist-add-new-box" value="'+value+'" placeholder="'+Resources.wishlistInputPlaceHolder+'" >';
                template += '</div></div>';
                $('.items-list').append(template);
                $('.add-new-input').val('');
            } else {
                $('.add-section .add-new-input').addClass('input-error');
            }
        }
    });
    // this event to remove wishlist from create dialog in LP
    $(document).on('click', '#remove-wishlist', function () {
        // code to remove wishlist 
    });
    $(document).on('focus', '.add-new-input', function () {
        $(this).addClass('typing-class');
    });
    $(document).on('focusout', '.add-new-input', function () {
        $(this).removeClass('typing-class');
    });
    
    // PDP & PLP wish icon click to open dialog
    $(document).off('click', '.add-to-wish-list').on('click', '.add-to-wish-list', function (e) {
        e.preventDefault();
        var current = $(this);
        var wishContainer = current.closest('.wish-container');
        var addToWishlistURL = '';
        var isPDP = wishContainer.data('ispdp');
        if (checkIfItemInSimilerSection($(this))) {
            addToWishlistURL = $(this).data('url');
        } else if (isPDP) {
            addToWishlistURL = $(this).closest('.wish-container').find('#wishlistUrl').val();
        } else {
            addToWishlistURL = $(this).closest('.product-tile').find('#wishlistUrl').val();
        }
        addProductToWishList(addToWishlistURL, current);
    });


    // PDP & PLP remove item from wishlist
    $(document).on('click', '.wish-container .wishlist-added', function () {
        var current = $(this);
        var wishContainer = current.closest('.wish-container');
        var isPDP = wishContainer.data('ispdp');
        if (!isPDP) {
            progress.show($('#main'));
            updateWishlistIconImage('remove', current);
            var plpRemoveFromWishlistURL = current.closest('.wish-container').find('#plpremoveFromWishlistUrl').val();
            removeProductFromWishList(plpRemoveFromWishlistURL, current);
            setTimeout(function(){ progress.hide() }, 1000);
        } else {
            progress.show($('#pdpMain'));
            var removeFromWishlistURL = $(this).closest('.wish-container').find('#removeFromWishlistUrl').val();
            removeProductFromWishList(removeFromWishlistURL, current);
        }
    });

    // click to add new wishlist from wishlist LP
    $('.create-wishlist-btn').on('click', function () {
        dialog.open({
            html: createWishlistDialogTemplate(),
            options: {
                title: '',
                dialogClass:'pl-dialog-wishlist-create',
                height: 'auto',
                width: 358,
                draggable:false,
                open: function () {
                    $(document).on('keypress', '.add-section .add-new-input', function (e) {
                        $(this).removeClass('error');
                        $('.add-section').find('a.input-error-msg').remove();
                        var currentValue = $(this).val(); 
                        if (e.which == 13) {
                            if (currentValue == '') {
                                $(this).addClass('error');
                                $('.add-section').append('<span class="input-error-msg">'+Resources.WISHLIST_REQUIRED_FEILD_MSG+'</span>');
                                return;
                            } else {
                                $('.add-cta').trigger('click');
                            }
                        }
                    });
                    $(document).on('click', '.add-cta', function () {
                        var wishlistName = $('.add-section .add-new-input').val();
                        if (wishlistName == '') {
                            $(this).addClass('error');
                            $('.add-section').append('<span class="input-error-msg">'+Resources.WISHLIST_REQUIRED_FEILD_MSG+'</span>');
                            return;
                        } else {
                            createNewWishlist(wishlistName, true);                            
                            $('.ui-dialog-titlebar-close').trigger('click');
                            $('.add-section .add-new-input').val('');
                        }
                    });
                },
                close: function () {
                    saveManageWishlists();
                    location.reload();
                }
            }
        });
    });
    

    // Handle wishlisted item add / remove when variant change
    $(document).on('click', '.product-swatches .swatch', function () {

        var variantSku = $(this).find('.varaintproductId').val();
        var wishlistedArray = $('#wishlistedArray').val();
        var addToWishlistLink = $(this).find('.variantWishlistAddUrl').val();
        var removeFromWishlistLink = $(this).find('.variantRemoveFromWishlistUrl').val();
        var createNewWishlistLink = $(this).find('.createNewWishlistUrlVariant').val();
        var replaceWishlistUrl = $(this).find('.replaceWishlistUrlVariant').val();
        $(this).closest('.product-tile').find('#replaceWishlistUrl').val(replaceWishlistUrl);
        $(this).closest('.product-tile').find('#plpremoveFromWishlistUrl').val(removeFromWishlistLink);
        $(this).closest('.product-tile').find('#wishlistUrl').val(addToWishlistLink);
        $(this).closest('.product-tile').find('#createNewWishlistUrl').val(createNewWishlistLink);
        if (wishlistedArray.includes(variantSku)) {
            $(this).find('.add-to-wish-btn').removeClass('.add-to-wish-list');
            $(this).find('.add-to-wish-btn').addClass('.wishlist-added');
            // $(this).find('.add-to-wish-btn').attr('data-url', removeFromWishlistLink);
            progress.show($('#main'));
            updateWishlistIconImage('add', $(this));
            setTimeout(function(){ progress.hide() }, 1000);
        } else {
            $(this).closest('.product-tile').find('.add-to-wish-btn').addClass('.add-to-wish-list');
            $(this).closest('.product-tile').find('.add-to-wish-btn').removeClass('.wishlist-added');
            progress.show($('#main'));
            updateWishlistIconImage('remove', $(this));
            setTimeout(function(){ progress.hide() }, 1000);
        }
    });

}

},{"../../dialog":13,"../../minicart":21,"../../progress":59,"../../util":78}],51:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    login = require('../login'),
    quickview = require('../quickview'),
    util = require('../util'),
    progress = require('../progress'),
    dialog = require('../dialog');

/**
 * @function
 * @description Loads address details to a given address and fills the address form
 * @param {String} addressID The ID of the address to which data will be loaded
 */
function populateForm(addressID, $form) {
    // load address details
    var url = Urls.giftRegAdd + addressID;
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data || !data.address) {
                window.alert(Resources.REG_ADDR_ERROR);
                return false;
            }
            // fill the form
            $form.find('[name$="_addressid"]').val(data.address.ID);
            $form.find('[name$="_firstname"]').val(data.address.firstName);
            $form.find('[name$="_lastname"]').val(data.address.lastName);
            $form.find('[name$="_address1"]').val(data.address.address1);
            $form.find('[name$="_address2"]').val(data.address.address2);
            $form.find('[name$="_city"]').val(data.address.city);
            $form.find('[name$="_country"]').val(data.address.countryCode).trigger('change');
            $form.find('[name$="_postal"]').val(data.address.postalCode);
            $form.find('[name$="_state"]').val(data.address.stateCode);
            $form.find('[name$="_phone"]').val(data.address.phone);
        }
    });
}

/**
 * @private
 * @function
 * @description Initializes events for the gift registration
 */
function initializeEvents() {
    $('.event-info > div:lt(3)').wrapAll('<div class="event-info-three"></div>');
    var $dateConvrt = $('[id$="giftregistry_event_date"]');
    if ($dateConvrt.length > 0 && $dateConvrt.val() != '') {
        var $val = convertDate($dateConvrt.val());
        $dateConvrt.val($val);
    }
    function convertDate(str) {
        var date = new Date(str);
        var utcDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000));
        var mnth = ('0' + (utcDate.getMonth() + 1)).slice(-2);
        var day = ('0' + utcDate.getDate()).slice(-2);
        return [mnth, day, utcDate.getFullYear()].join('-');
    }

    var $eventAddressForm = ($('form[name$="_giftregistry"]').length > 0) ? $('form[name$="_giftregistry"]') : $('form[name$="_kioskgiftregistry"]'),
        $beforeAddress = $eventAddressForm.find('fieldset[name="address-before"]'),
        $afterAddress = $eventAddressForm.find('fieldset[name="address-after"]');

    $('.usepreevent').on('click', function () {
        // filter out storefront toolkit
        $(':input', $beforeAddress).not('[id^="ext"]').not('select[name$="_addressBeforeList"]').each(function () {
            var fieldName = $(this).attr('name'),
                $afterField = $afterAddress.find('[name="' + fieldName.replace('Before', 'After') + '"]');
            $afterField.val($(this).val()).trigger('change');
        });
    });

    //Knot Check box
    $('.knot-check-box').off().on('click', function () {
        var productListID = $('input[name=productListID]').val();
        var url = Urls.knotBox;
        url = util.appendParamsToUrl(url, {
            'productListID': productListID
        });
        progress.show($('.list-share'));

        $.ajax({
            type: 'POST',
            url: url,
            success: function() {
                progress.hide();
            }
        });
       
    });

    $('.gift-print').on('click', function(e) {
        e.preventDefault();
        window.print();
    });

    $eventAddressForm.on('change', 'select[name$="_addressBeforeList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $beforeAddress);
    })
    .on('change', 'select[name$="_addressAfterList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $afterAddress);
    });

    $('.item-list').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        var productListID = $('input[name=productListID]').val();
        quickview.show({
            url: e.target.href,
            source: 'giftregistry',
            productlistid: productListID
        });
    });
    
 // Handling Quantity field in giftregistry-page up and down buttons
    $('.next-value').on('click', function() {
        $(this).addClass('active');
        var qty = $(this).closest('.quantity-box').find('.qty_value').val();
        qty = parseInt(qty,0);
        $(this).closest('.quantity-box').find('.qty_value').val(qty + 1);
        $(this).addClass('active');
        $(this).closest('.quantity-box').find('.prev-value').addClass('active');
        if (qty >= 99) {
            $(this).closest('.quantity-box').find('.qty_value').val(99);
            $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.prev-value').addClass('active');
        }
    });
    $('.prev-value').on('click', function() {
        var qty = $(this).closest('.quantity-box').find('.qty_value').val();
        qty = parseInt(qty,0);
        $(this).closest('.quantity-box').find('.qty_value').val(qty - 1);
        if (qty <= 2) {
            $(this).removeClass('active');
            $(this).closest('.quantity-box').find('.qty_value').val(1);
            $(this).closest('.quantity-box').find('.prev-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.next-value').addClass('active');
        } 
    });

    $('body').on('keydown','.qty-field input', function(e) {
        if ((90 >= e.which && e.which >= 65) || (111 >= e.which && e.which >= 107) || (192 >= e.which && e.which >= 186) || e.which==16 || (222 >= e.which && e.which >= 219) || (41 >= e.which && e.which >= 33)) {
            e.preventDefault();
        }
    });
    //KIOSK Events
    if ($('.kisok-success-popup').length > 0) {
        $('.kisok-success-popup').removeClass('hide');
        var popupData = $('.kisok-success-popup');
        dialog.open({
            html: popupData,
            options: {
                title: '',
                dialogClass: 'successmessage',
                width: 760,
                height: 'auto',
                open: function() {
                    $('.kisok-success-popup .add-event-and-ship-button').click(function() {
                        $('.giftregistry-event-tab').trigger('click');
                    });
                    $('.iwilldoit-later, .ui-widget-overlay').click(function() {
                        dialog.close();
                    });
                }
            }
        });
    }

    if ($('.list-customobjects').length > 0) {
        $('.list-customobjects').removeClass('hide');
        var htmlContent = $('.list-customobjects');
        dialog.open({
            html: htmlContent,
            options: {
                title: '',
                dialogClass: 'gr-customobjects',
                width: 675,
                height: 'auto',
                open: function() {
                    pickupfeatures();
                    $('.ui-widget-overlay').click(function() {
                        dialog.close();
                    });
                }
            }
        });
    }

    $('form[id$="_giftregistry_search"]').on('submit', function(e) {
        var _this = $(this);
        var firstName = _this.find('input[name$="_registrantFirstName"]').val();
        var lastName = _this.find('input[name$="_registrantLastName"]').val();
        var validationMsg = _this.find('.sub.required');

        if (!firstName && !lastName) {
            e.preventDefault();
            validationMsg.css('display', 'block');
        } else {
            validationMsg.css('display', 'none');
        }
    });
}

function pickupfeatures() {
    $(document).off('click', '.products-view').on('click', '.products-view', function(e) {
        e.preventDefault();
        var currentCoKey = $(this).attr('data-cokey');
        var day = $(this).attr('data-day');
        var creationTime = $(this).attr('data-creationtime');
        var url = Urls.viewCoProducts;

        url = util.appendParamsToUrl(url, {
            'customobjectkey': currentCoKey,
            'daystatus': day,
            'creationtime': creationTime
        });

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: url,
            success: function(response) {
                $('.list-customobjects').html(response);
                initializePickupfeatures();
            }
        });
    });
}

function initializePickupfeatures() {
    $(document).off('click', '.gr-backtolist').on('click', '.gr-backtolist', function() {
        var storeID = $('input[id=storeid]').val();
        var kioskID = $('input[id=kioskid]').val();
        var sourceLocation = $('input[id=sourcelocation]').val();

        var url = Urls.pickupWhereILeftOff;
        url = util.appendParamsToUrl(url, {
            'storeid': storeID,
            'kioskid': kioskID,
            'sourcelocation': sourceLocation
        });

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: url,
            success: function(response) {
                var $myresponse = $(response);
                $myresponse.find('.list-customobjects').removeClass('hide');
                var $updatedResponse = $myresponse.find('.list-customobjects');
                $('.list-customobjects').html($updatedResponse);
            }
        });
    });
}

function initializeComponents() {
    $('input[id$="addressBeforeEvent_address1"]').radarAutoComplete({
        onSelectAddress: function(address) {
            var address1 = address.number ? `${address.number} ${address.street}` : address.street;
            $('input[id$="addressBeforeEvent_address1"]').val(address1);
            $('input[id$="addressBeforeEvent_address2"]').val('');
            $('input[id$="addressBeforeEvent_city"]').val(address.city);
            $('input[id$="addressBeforeEvent_postal"]').val(address.postalCode);
            $('select[id$="addressBeforeEvent_states_state"]').val(address.stateCode);
            $('select[id$="addressBeforeEvent_country"]').val(address.countryCode);
        }
    });
    $('input[id$="addressAfterEvent_address1"]').radarAutoComplete({
        onSelectAddress: function(address) {
            var address1 = address.number ? `${address.number} ${address.street}` : address.street;
            $('input[id$="addressAfterEvent_address1"]').val(address1);
            $('input[id$="addressAfterEvent_address2"]').val('');
            $('input[id$="addressAfterEvent_city"]').val(address.city);
            $('input[id$="addressAfterEvent_postal"]').val(address.postalCode);
            $('select[id$="addressAfterEvent_states_state"]').val(address.stateCode);
            $('select[id$="addressAfterEvent_country"]').val(address.countryCode);
        }
    });
}

exports.init = function () {
    initializeEvents();
    initializeComponents();
    addProductToCart();
    login.init();
    util.setDeleteConfirmation('.item-list', String.format(Resources.CONFIRM_DELETE, Resources.TITLE_GIFTREGISTRY));
    require('../addressvalidation').init();
};

},{"../addressvalidation":1,"../ajax":2,"../dialog":13,"../login":20,"../progress":59,"../quickview":61,"../util":78,"./product/addToCart":36}],52:[function(require,module,exports){
'use strict';

var compareWidget = require('../compare-widget'),
    productTile = require('../product-tile'),
    progress = require('../progress'),
    slickSlider = require('../slickSlider'),
    classStoreFinder = require('../storeinventory/classStoreFinder'),
    util = require('../util'),
    ajax = require('../ajax'),
    imagesLoaded = require('imagesloaded'),
    compareProducts = require('../compare-products');

function infiniteScroll() {
    // getting the hidden div, which is the placeholder for the next page
    var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
    // get url hidden in DOM
    var gridUrl = loadingPlaceHolder.attr('data-grid-url');

    if (loadingPlaceHolder.length === 1 && util.elementInViewport(loadingPlaceHolder.get(0), 250)) {
        // switch state to 'loading'
        // - switches state, so the above selector is only matching once
        // - shows loading indicator
        loadingPlaceHolder.attr('data-loading-state', 'loading');
        loadingPlaceHolder.addClass('infinite-scroll-loading');


        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
        var fillEndlessScrollChunk = function(html) {
            loadingPlaceHolder.removeClass('infinite-scroll-loading');
            loadingPlaceHolder.attr('data-loading-state', 'loaded');
            $('div.search-result-content').append(html);
        };

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: gridUrl,
            success: function(response) {
                // put response into cache
                try {
                    sessionStorage['scroll-cache_' + gridUrl] = response;
                } catch (e) {
                    // nothing to catch in case of out of memory of session storage
                    // it will fall back to load via ajax
                }
                // update UI
                fillEndlessScrollChunk(response);
                productTile.init();
            }
        });
    }
}
var isPagination = false;

// SLTBE-8873: rewrite a CLP grid URL emitted from ProductSearchResult.url('Search-Show')
// (which renders as either the raw Search-Show controller path or the /search storefront
// alias) to the dedicated un-aliased Search-ClassGrid action (Urls.classGridSearch), which
// the PWA proxy does not intercept. The incoming query string (prefn/prefv, date filters,
// paging start) is carried over verbatim; both actions dispatch to the same showClassGrid
// handler. `cgid` is passed in explicitly (from getClpCgid()) and re-appended when the
// source link carried it in the SEO path rather than the query string — dropping the path
// would otherwise fetch an unscoped/empty grid. Only the two CLP grid call sites use this;
// callers like the Calendar View Apply button fetch their own URL un-rewritten.
function toClassGridUrl(url, cgid) {
    var queryIndex = url.indexOf('?');
    var rebuilt = queryIndex > -1
        ? Urls.classGridSearch + url.slice(queryIndex)
        : Urls.classGridSearch;
    if (cgid && !(/[?&]cgid=/).test(rebuilt)) {
        rebuilt = util.appendParamToURL(rebuilt, 'cgid', cgid);
    }
    return rebuilt;
}

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url, container) {
    //if (!url || url === window.location.href) {
    if (!url) {
        return;
    }
    progress.show($('#main'));
    if (container.closest('div.tab-content.classes-tab-content').length > 0) {
        container.load(util.appendParamToURL(url, 'format', 'renderclasses-ajax'), function() {
            compareWidget.init();
            productTile.init();
            progress.hide();
            history.pushState(undefined, '', window.location.href);
            brandmaterialShowlinks();
            categorySync();
            refinementsSync();
            $('div.classes-tab-content #secondary .category-refinement .toggle').click();
            updateSeatAvailability();
        });
    } else if (container.closest('div.tab-content.product-tab-content').length > 0) {
        container.load(util.appendParamToURL(url, 'format', 'ajax'), function() {
            compareWidget.init();
            productTile.init();
            progress.hide();
            brandmaterialShowlinks();
            categorySync();
            refinementsSync();
            $('div.product-tab-content #secondary .category-refinement .toggle').click();
            if ($('.pagination').data('pagination') === isPagination) {
                $('html, body').animate({
                    scrollTop: 0
                }, 0);
            }
            updateSeatAvailability();
        });
    } else {
        var startdate = $('.startdate').val();
        var enddate = $('.enddate').val();
        if (container.closest('div.tab-content.recipe-tab-content').length > 0) {
            url = util.appendParamToURL(url, 'format', 'renderrecipe-ajax');
        } else {
            url = util.appendParamToURL(url, 'format', 'ajax');
        }
        container.load(url, function() {
            compareWidget.init();
            productTile.init();
            progress.hide();
            brandmaterialShowlinks();
            categorySync();
            refinementsSync();
            $('#secondary .refinement.category-refinement .toggle').click();
            util.datePicker();

            if (typeof(startdate) != 'undefined' && typeof(enddate) != 'undefined') {
                if (startdate.length > 0 && enddate.length > 0) {
                    $('.startdate').val(startdate);
                    $('.enddate').val(enddate);
                }
            }
            dropDownEllipse();
            $('.text-ellipsis').ellipsis();
            if ($('.pagination').data('pagination') === isPagination) {
                $('html, body').animate({
                    scrollTop: 0
                }, 0);
            }
            $('.class-out-of-stock').each(function() {
                var oldUrl = $(this).find('.thumb-link').attr('href');
                $(this).find('.thumb-link').closest('.product-tile').find('a.pdp-class-link').attr('href', oldUrl);
            });
            updateSeatAvailability();
        });
    }
}

function getTabLabelFromProductTypeFromUrl(url) {
    var productType = util.getURLRefinementValue(url || location.href, 'productType');
    var productTypeToTabSelector = {
        HardGood: '.products-tablabel',
        Culinary: '.classes-tablabel',
        Recipe: '.recipe-tablabel'
    };
    return $(productTypeToTabSelector[productType] || '.products-tablabel');
}

function getTabFromProductTypeFromUrl(url) {
    var q = util.getParamValue(url || location.href, 'q');
    if (!q) return $('#main');
    var productType = util.getURLRefinementValue(url || location.href, 'productType');
    var productTypeToTabSelector = {
        HardGood: '.tab-content.product-tab-content .tab-content-wrapper',
        Recipe: '.tab-content.recipe-tab-content .tab-content-wrapper',
        Culinary: '.tab-content.classes-tab-content .tab-content-wrapper'
    };
    var tabSelector = productTypeToTabSelector[productType] || '.tab-content[aria-hidden="false"] .tab-content-wrapper';
    return $(tabSelector);
}

window.addEventListener('popstate', function() {
    // SLTBE-8873: the culinary CLP (identified by .class-location-select) also has a
    // .pagination bar, so it would otherwise fall into the block below and be re-fetched
    // via updateProductListing -> the /search alias -> the PWA proxy (the exact bug the
    // grid fixes avoid). Intercept CLP Back/Forward here: re-fetch the grid for the target
    // URL through the un-aliased Search-ClassGrid action and swap it into the grid in place,
    // keeping the address bar and the grid in sync. Returns before the generic block runs.
    if (pageContext && pageContext.ns == 'search' && $('.class-location-select').length > 0) {
        var clpBackContainer = $('.plp-class').find('.class-tiles-container');
        if (clpBackContainer.length > 0) {
            // Pick the first candidate that actually carries a CLP scoping param, rather than
            // trusting history.state blindly. On the store-present render the doc.ready
            // handler at ~line 461 legitimately replaces state with the bare window.location.href
            // (no query string), which is truthy — so a plain `history.state || …` would use
            // that unscoped href and Back would re-fetch an all-store grid under the selected-
            // store label. A store-scoped URL (the paging pushUrl, or the scoped .currentPageUrl)
            // carries cgid/prefn params, so UTM-only URLs do not beat the scoped fallback.
            var clpBackUrl = [history.state, $('.currentPageUrl').val(), window.location.href]
                .filter(function(u) { return u && (/[?&](cgid|prefn\d*)=/).test(u); })[0] || window.location.href;
            var clpCgid = String($('.class-location-select').data('cgid') || '');
            updateclassListing(toClassGridUrl(clpBackUrl, clpCgid), clpBackContainer, $('.startdate').val(), $('.enddate').val(), true);
        }
        return;
    }
    if (pageContext && pageContext.ns == 'search' && $('.pagination').length > 0) {
        var url = history.state;
        var historyUrlParams = history.state;
        var urlParams = $('.currentPageUrl').val();
        var backurl;
         // preparing the back url if there are refinements selected
        if (historyUrlParams && urlParams && urlParams.indexOf('q') < -1 && (urlParams.indexOf('prefn') > -1 || urlParams.indexOf('srule') > -1 || urlParams.indexOf('pmin') > -1 || urlParams.indexOf('sz') > -1)) {
            backurl = historyUrlParams.split('?')[0];
            var startParam = historyUrlParams.split('?')[1].split('&');
            var urlQueryParam = urlParams.split('?')[1].split('&');
            var queryString = new Array();
            var queryString1 = new Array();
            urlQueryParam.forEach(function(value) {
                if (value.indexOf('prefn') > -1) {
                    queryString.push(value);
                }
                if (value.indexOf('prefv') > -1) {
                    queryString.push(value);
                }
                if (value.indexOf('pmin') > -1) {
                    queryString.push(value);
                }
                if (value.indexOf('pmax') > -1) {
                    queryString.push(value);
                }
                if (value.indexOf('srule') > -1) {
                    queryString.push(value);
                }
                if (value.indexOf('sz') > -1) {
                    queryString.push(value);
                }
            });
            backurl += '?' + queryString.join('&');
            startParam.forEach(function(value1) {
                if (value1.indexOf('start') > -1) {
                    queryString1.push(value1);
                }
            });
            backurl += '&' + queryString1.join('&');
        }
        if (backurl) {
            updateProductListing(backurl, getTabFromProductTypeFromUrl(backurl));
        } else {
            updateProductListing(url, getTabFromProductTypeFromUrl(url));
        }
    }
});
window.addEventListener('popstate', function(e) {
    // SLTBE-8873: guard on e.state (mirrors the class-calendar handler below). On a
    // fresh navigation e.state/history.state is null; without this guard the CLP
    // store-picker "use my location" click (an href="#" that mutates history) fires
    // popstate with null state and appendParamToURL(null, ...) throws
    // "Cannot read properties of null (reading 'indexOf')", killing the store flow.
    if (pageContext && pageContext.ns == 'search' && $('.class-calendar').length == 0  && $('.pagination').length == 0 && e.state) {
        var url = e.state;
        url = util.appendParamToURL(url, 'format', 'ajax');
        var historyUrlParams = util.getURLParam(history.state);
        var urlParams = util.getURLParam($('.currentPageUrl').val());
        var storeId;
        var historyStoreId;
        urlParams.forEach(function(value) {
            if (value.paramValue == 'storeId') {
                var paramKey = value.paramKey;
                if (paramKey.indexOf('prefn') > -1) {
                    var refinementIndex = paramKey.slice(paramKey.indexOf('prefn') + 5);
                    storeId = util.getParamValue($('.currentPageUrl').val(), 'prefv' + refinementIndex);
                }
            }
        });
        historyUrlParams.forEach(function(value) {
            if (value.paramValue == 'storeId') {
                var paramKey = value.paramKey;
                if (paramKey.indexOf('prefn') > -1) {
                    var refinementIndex = paramKey.slice(paramKey.indexOf('prefn') + 5);
                    historyStoreId = util.getParamValue(history.state, 'prefv' + refinementIndex);
                }
            }
        });

        if (url != null && (!storeId && !historyStoreId) || (storeId == historyStoreId)) {
            updatePage(url);
        }
    }
});


window.addEventListener('popstate', function(e) {
    if (pageContext && pageContext.ns == 'search' && $('.class-calendar').length > 0 && e.state) {
        var url = e.state;
        
        // Prevent AJAX call with invalid history state
        if (!url || url.indexOf('cgid=') === -1) {
            // Invalid history state — reload to restore correct parameters
            window.location.reload();
            return;
        }
        
        var appliedFilterClass = $('#appliedFilterClass').val();
        var appliedFilterCuisine = $('#appliedFilterCuisine').val();
        if (appliedFilterClass != '' && appliedFilterClass != undefined){
            url = url+appliedFilterClass;
        }
        if (appliedFilterCuisine != '' && appliedFilterCuisine != undefined){
            url = url+appliedFilterCuisine;
        }
        progress.show($('.class-calendar'));
        ajax.load({
            url: url,
            target: $('.class-calendar'),
            callback: function() {
                var formattedDate = $('input[class="class-formatted-date"]').val();
                var startDate = $('input[class="class-start-date"]').val();
                var endDate = $('input[class="class-end-date"]').val();
                $('input[class="formated-date"]').val(formattedDate);
                $('input[class="start-date"]').val(startDate);
                $('input[class="end-date"]').val(endDate);
                initializeEvents();
                progress.hide();
            }
        });
    }
});

$(document).ready(function() {
    var filtersString = '';
    var pricAttribute = '';
    var newStateUrl = '';

    //TEB-304
    if (history.state == null && $('.currentPageUrl').length > 0 && $('.currentPageUrl').val() != '' && pageContext.ns == 'search') {
        url = $('.currentPageUrl').val();
        history.replaceState(url, '', window.location.href);
    }

    if (this.location.pathname.indexOf('Calendar') < 0 && this.location.pathname.indexOf('calendar') < 0 && $('#wrapper.pt_product-search-result') && $('#wrapper.pt_product-search-result').length) {
        var filters = this.location.search.replace(/%20/gi, '+');
        var q;
        if (filters.split('q=').length > 1) {
            q = filters.split('q=')[1].split('&')[0];
        }
        filters = filters.split('prefv');
        var pmin = this.location.search.split('pmin=').length > 1 ? this.location.search.split('pmin=')[1].split('&')[0] : '';
        var pmax = this.location.search.split('pmax=').length > 1 ? this.location.search.split('pmax=')[1].split('&')[0] : '';
        var seperator = q ? '&' : '?';
        pricAttribute = pmin && pmax ? seperator + 'pmin=' + pmin + '&pmax=' + pmax : '';
        filtersString = filters.length > 1 ? 'filters/' : '';
        for (var filterIndex = 1; filterIndex < filters.length; filterIndex++) {
            filtersString += filters[filterIndex].replace(/.=/gi, '').split('&')[0].replace(/%7C/gi, '/') + '/';
        }
        //UTM parameter in PLP page
        var utms = this.location.search.split('utm'),
            utmString = '';
        for (var utmIndex = 1; utmIndex < utms.length; utmIndex++) {
            utmString += 'utm' + utms[utmIndex].split('&')[0] + '&';
        }
        utms = this.location.search.split('UTM');
        for (var UTMIndex = 1; UTMIndex < utms.length; UTMIndex++) {
            utmString += 'UTM' + utms[UTMIndex].split('&')[0] + '&';
        }
        if (q) {
            newStateUrl = this.location.origin + this.location.pathname + '?q=' + q + '/' + filtersString + pricAttribute + '&' + utmString;
        } else {
            newStateUrl = this.location.origin + this.location.pathname + filtersString + pricAttribute;
            if (newStateUrl.indexOf('?') > -1 && utmString) {
                newStateUrl += '&' + utmString;
            } else if (utmString) {
                newStateUrl += '?' + utmString;
            }
        }
    }
    var url = '';
    if (history.state == null && $('.currentPageUrl').length > 0 && $('.currentPageUrl').val() != '' && pageContext.ns == 'search') {
        url = $('.currentPageUrl').val();
        url = util.appendParamToURL(url, 'format', 'ajax');
        if (!newStateUrl) {
            history.replaceState(url, '', window.location.href);
        }
    } else if (history.state != null && $('.currentPageUrl').length > 0 && $('.currentPageUrl').val() != '' && $('.currentPageUrl').val() != history.state && pageContext.ns == 'search') {
        var historyUrlParams = util.getURLParam(history.state);
        var urlParams = util.getURLParam($('.currentPageUrl').val());
        var storeId;
        var historyStoreId;
        urlParams.forEach(function(value) {
            if (value.paramValue == 'storeId') {
                var paramKey = value.paramKey;
                if (paramKey.indexOf('prefn') > -1) {
                    var refinementIndex = paramKey.slice(paramKey.indexOf('prefn') + 5);
                    storeId = util.getParamValue($('.currentPageUrl').val(), 'prefv' + refinementIndex);
                }
            }
        });
        historyUrlParams.forEach(function(value) {
            if (value.paramValue == 'storeId') {
                var paramKey = value.paramKey;
                if (paramKey.indexOf('prefn') > -1) {
                    var refinementIndex = paramKey.slice(paramKey.indexOf('prefn') + 5);
                    historyStoreId = util.getParamValue(history.state, 'prefv' + refinementIndex);
                }
            }
        });


        if ((storeId != undefined && historyStoreId != undefined) && (storeId == historyStoreId)) {
            updatePage(history.state);
        }

        if (historyUrlParams != null && (!storeId && !historyStoreId) && history.state.indexOf('format=ajax') != -1) {
            var container = $('#main');
            if ($('.product-tab-content .tab-content-wrapper').length > 0) {
                container = $('.product-tab-content .tab-content-wrapper');
            }
            updateProductListing(history.state, container);
            //updatePage(historyUrlParams);
        }

    }
    if (!newStateUrl) {
        history.replaceState(url, document.title, newStateUrl);
        setTimeout(function() {
            if ($('.class-calendar').length > 0) {
                $(window).scrollTop(0);
            }
        }, 2000);
    }
    if (history.state == null && $('.class-calendar').length > 0) {
        var cgid = $('input[class="class-cgid"]').val();
        var storeID = $('input[class="class-storeid"]').val();
        var previousUrl = util.appendParamsToUrl(Urls.previousMonthCalendar, {
            'cgid': cgid,
            'storeId': storeID
        });
        if ($('.class-month-count') && $('.class-month-count').length > 0 && $('.class-month-count').val() != '') {
            previousUrl = util.appendParamsToUrl(previousUrl, {
                'monthCount': $('.class-month-count').val()
            });
        }
        history.replaceState(previousUrl, '', window.location.href);
    } else if (history.state != null && $('.class-calendar').length > 0 && $('.class-month-count').length > 0 &&
        $('.class-month-count').val() != '') {
        var monthCount = $('.class-month-count').val();
        var monthUrl = history.state;
        var historyMonthCount = util.getParamValue(monthUrl, 'monthCount');
        if (historyMonthCount != null && historyMonthCount.trim() != '' && historyMonthCount != monthCount) {
            progress.show($('.class-calendar'));
            ajax.load({
                url: monthUrl,
                target: $('.class-calendar'),
                callback: function() {
                    var formattedDate = $('input[class="class-formatted-date"]').val();
                    var startDate = $('input[class="class-start-date"]').val();
                    var endDate = $('input[class="class-end-date"]').val();
                    $('input[class="formated-date"]').val(formattedDate);
                    $('input[class="start-date"]').val(startDate);
                    $('input[class="end-date"]').val(endDate);
                    initializeEvents();
                    progress.hide();
                }
            });
        }
    }
    if (history.state == '' && $('.pagination').length > 0){
        history.replaceState(window.location.href,'',window.location.href);
    }
});


function updatePage(url) {

    if ($('.product-tab-content .tab-content-wrapper').length > 0) {
        var container = $('.product-tab-content .tab-content-wrapper');
        eventsInProductSection(url, container)
    } else {
        $('#main').load(url, function() {
            var startdate = $('.startdate').val();
            var enddate = $('.enddate').val();
            compareWidget.init();
            productTile.init();
            progress.hide();
            brandmaterialShowlinks();
            categorySync();
            refinementsSync();
            $('#secondary .refinement.category-refinement .toggle').click();
            util.datePicker();
            if (typeof(startdate) != 'undefined' && typeof(enddate) != 'undefined') {
                if (startdate.length > 0 && enddate.length > 0) {
                    $('.startdate').val(startdate);
                    $('.enddate').val(enddate);
                }
            }
            dropDownEllipse();
            $('.text-ellipsis').ellipsis();
            $('html, body').animate({
                scrollTop: 0
            }, 0);
            $('.class-out-of-stock').each(function() {
                var oldUrl = $(this).find('.thumb-link').attr('href');
                $(this).find('.thumb-link').closest('.product-tile').find('a.pdp-class-link').attr('href', oldUrl);
            });
            updateSeatAvailability();
        });
    }
}

function categorySync() {
    var $shopProd = $('.category-product-slots .classes-slot-image-width-noslider .classes-slot-image');
    if ($shopProd.length > 0) {
        imagesLoaded('.category-product-slots').on('done', function() {
            $shopProd.syncHeight();
        });
    }
}

function refinementsSync() {
    $('.refinement').each(function() {
        if ($(this).find('ul li').hasClass('selected')) {
            $(this).find('ul li.selected').closest('.refinement').find('.left-refine').addClass('active');
            $(this).find('ul li.selected').closest('.refinement').find('ul').css('display','block');
        }
    });
}

function dropDownEllipse() {
    if ($(window).width() < 500 && $('#grid-sort-header').length > 0) {
        var $selectedText = $('#grid-sort-header option:selected').text();
        if ($selectedText.length > 12) {
            $('#grid-sort-header option:selected').text($selectedText.substr(0, 12) + '…');
        }
    }
}

function updatedSelectedSortingList() {
    var sortingDropDown = $('#grid-sort-header');
    var selectedSorting = $('#selectedSoring');
    if (sortingDropDown.length > 0 && selectedSorting && selectedSorting.val() != '' &&
        selectedSorting.val() != sortingDropDown.find('option:selected').val()) {
        sortingDropDown.val(selectedSorting.val());
    }
}

function updatedSelectedPageSize() {
    var pagingDropDown = $('.grid-paging-header');
    var selectedPageSize = $('.selectedPageSize');
    if (pagingDropDown.length > 0 && selectedPageSize && selectedPageSize.val() != '' &&
        selectedPageSize.val() != pagingDropDown.find('option:selected').val()) {
        for (var i = 0; i < pagingDropDown.length; i++) {
            pagingDropDown[i].value = selectedPageSize.val();
        }
    }
}

function updateQueryString(key, value, url) {
    var re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi'),
        hash;

    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null) {
            return url.replace(re, '$1' + key + '=' + value + '$2$3');
        } else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        }
    } else {
        if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        } else {
            return url;
        }
    }
}

function resetClassFilter() {
    if ($('.plp-class').find('.refinements').length > 0) {
        $('.plp-class').find('.refinements').find('#sessionstartdate').val('');
        $('.plp-class').find('.refinements').find('#sessionenddate').val('');
        $('.plp-class').find('.refinements').find('#Cuisine').prop('selectedIndex', 0);
        $('.plp-class').find('.refinements').find('#ClassType').prop('selectedIndex', 0);
    }
}

function classcalendarnextmonth() {

    $('.class-calendar .next-month').on('click', function(e) {
        e.preventDefault();
        var cgid = $('input[class="class-cgid"]').val();
        var storeID = $('input[class="class-storeid"]').val();
        // SLTBE-8287: empty + literal-string "null" both treated as no-store; previous fallback
        // misread cgid token from URL and injected it as bogus storeId, producing empty-state calendar.
        if (!storeID || storeID === 'null') {
            storeID = '';
        }

        var url = util.appendParamsToUrl(Urls.nextMonthCalendar, {
            'cgid': cgid,
            'storeId': storeID
        });

        var refinements = $('.refinslist select');
        var refinementName, refinementVal;
        var refinementObj = {};
        if (refinements.length > 0) {
            refinements.each(function() {
                refinementName = $(this).data('attributeid');
                refinementVal = $(this).val();
                if (refinementName && refinementName != '' && refinementVal && refinementVal != '') {
                    refinementObj[refinementName] = refinementVal;
                    url = util.appendParamsToUrl(url, refinementObj);
                }
            });
        }

        if (history.state && util.removeParamFromURL(history.state, 'monthCount') === url) {
            history.forward();
            //return;
        }
        progress.show($('.class-calendar'));

        ajax.load({
            url: url,
            target: $('.class-calendar'),
            callback: function() {
                var previousUrl = util.appendParamsToUrl(Urls.previousMonthCalendar, {
                    'cgid': cgid,
                    'storeId': storeID
                });
                if ($('.class-month-count') && $('.class-month-count').length > 0 && $('.class-month-count').val() != '') {
                    var monthCount = $('.class-month-count').val();
                    previousUrl = util.appendParamsToUrl(previousUrl, {
                        'monthCount': monthCount
                    });
                }
                if (history.state == null || history.state != url) {
                    history.pushState(previousUrl, '', window.location.href);
                }
                var formattedDate = $('input[class="class-formatted-date"]').val();
                var startDate = $('input[class="class-start-date"]').val();
                var endDate = $('input[class="class-end-date"]').val();
                $('input[class="formated-date"]').val(formattedDate);
                $('input[class="start-date"]').val(startDate);
                $('input[class="end-date"]').val(endDate);
                initializeEvents();
                progress.hide();
                var monthnameval = $('.class-month-name').val();
                var monthcount = $('.class-month-count').val();
                var orgURL = window.location.href;
                var monthvalinURL = orgURL.split('&month=')[1];
                var monthcountinURL = orgURL.split('&count=')[1];
                if (monthvalinURL != undefined){
                    if (monthvalinURL != '' && monthvalinURL != undefined){
                        orgURL = util.removeParamFromURL(orgURL,'month');
                    }
                }
                if (monthcountinURL != undefined){
                    if (monthcountinURL != '' && monthcountinURL != undefined){
                        orgURL = util.removeParamFromURL(orgURL,'count');
                    }
                }
                if (monthnameval != ''  && monthnameval != undefined){
                    orgURL = orgURL+'&month='+monthnameval;
                }
                if (monthcount != '' && monthcount != undefined){
                    orgURL = orgURL+'&count='+monthcount;
                }
                history.replaceState(history.state, '',orgURL);

            }
        });
    });
}

function classcalendarpreviousmonth() {

    $('.class-calendar .previous-month').on('click', function(e) {
        e.preventDefault();
        var cgid = $('input[class="class-cgid"]').val();
        var storeID = $('input[class="class-storeid"]').val();
        // SLTBE-8287: empty + literal-string "null" both treated as no-store; previous fallback
        // misread cgid token from URL and injected it as bogus storeId, producing empty-state calendar.
        if (!storeID || storeID === 'null') {
            storeID = '';
        }


        var url = util.appendParamsToUrl(Urls.previousMonthCalendar, {
            'cgid': cgid,
            'storeId': storeID
        });

        if (history.state && util.removeParamFromURL(history.state, 'monthCount') === url) {
            history.back();
            return;
        }

        var refinements = $('.refinslist select');
        var refinementName, refinementVal;
        var refinementObj = {};
        if (refinements.length > 0) {
            refinements.each(function() {
                refinementName = $(this).data('attributeid');
                refinementVal = $(this).val();
                if (refinementName && refinementName != '' && refinementVal && refinementVal != '') {
                    refinementObj[refinementName] = refinementVal;
                    url = util.appendParamsToUrl(url, refinementObj);
                }
            });
        }

        progress.show($('.class-calendar'));

        ajax.load({
            url: url,
            target: $('.class-calendar'),
            callback: function() {
                var nextUrl = util.appendParamsToUrl(Urls.nextMonthCalendar, {
                    'cgid': cgid,
                    'storeId': storeID
                });
                if ($('.class-month-count') && $('.class-month-count').length > 0 && $('.class-month-count').val() != '') {
                    var monthCount = $('.class-month-count').val();
                    nextUrl = util.appendParamsToUrl(nextUrl, {
                        'monthCount': monthCount
                    });
                }
                if (history.state == null || history.state != url) {
                    history.pushState(nextUrl, '', window.location.href);
                }
                var formattedDate = $('input[class="class-formatted-date"]').val();
                var startDate = $('input[class="class-start-date"]').val();
                var endDate = $('input[class="class-end-date"]').val();
                $('input[class="formated-date"]').val(formattedDate);
                $('input[class="start-date"]').val(startDate);
                $('input[class="end-date"]').val(endDate);
                initializeEvents();
                progress.hide();
                var monthnameval = $('.class-month-name').val();
                var monthcount = $('.class-month-count').val();
                var orgURL = window.location.href;
                var monthvalinURL = orgURL.split('&month=')[1];
                var monthcountinURL = orgURL.split('&count=')[1];
                if (monthvalinURL != undefined){
                    if (monthvalinURL != '' && monthvalinURL != undefined){
                        orgURL = util.removeParamFromURL(orgURL,'month');
                    }
                }
                if (monthcountinURL != undefined){
                    if (monthcountinURL != '' && monthcountinURL != undefined){
                        orgURL = util.removeParamFromURL(orgURL,'count');
                    }
                }

                if (monthnameval != ''  && monthnameval != undefined){
                    orgURL = orgURL+'&month='+monthnameval;
                }
                if (monthcount != '' && monthcount != undefined){
                    orgURL = orgURL+'&count='+monthcount;
                }
                history.replaceState(history.state, '',orgURL);
            }
        });
    });
}


function updateclassListing(url, container, startdate, enddate, isPaging, pushUrl) {
    if (!url || url === window.location.href) {
        return;
    }

    // SLTBE-8873: fetch `url` verbatim. This function is shared: the CLP grid Apply and
    // pagination callers pre-rewrite their URL to the un-aliased Search-ClassGrid action
    // via toClassGridUrl() before calling here, but the Calendar View Apply button
    // (.applyrefinementlist-bt) also calls this with a Search-IncludeCalendar URL that
    // must NOT be rewritten — rewriting unconditionally here would break calendar filtering.
    $.ajax({
        url: util.appendParamToURL(url, 'format', 'class-ajax')
    })
        .done(function(response) {
            if (response.result == 'no-result') {
                if ($('.no-class-found').hasClass('hide')) {
                    $('.no-class-found').removeClass('hide');
                }
                $(container).empty();
                util.datePicker();
            } else {
                if (!$('.no-class-found').hasClass('hide')) {
                    $('.no-class-found').addClass('hide');
                }
                $(container).empty().html(response);
                $('.text-ellipsis').ellipsis();
                $('.startdate').val(startdate);
                $('.enddate').val(enddate);
                util.datePicker();
                updateSeatAvailability();
                // SLTBE-8873: only after the paged grid actually rendered, push the
                // browser-facing URL as history state (this codebase stores the URL string
                // in history.state; the CLP popstate branch reads it back to re-sync the grid
                // on Back/Forward). Pushing here — not eagerly and not on the no-result branch
                // — keeps the address bar from ever claiming a page that was not rendered.
                if (isPaging && pushUrl && pushUrl !== window.location.href) {
                    history.pushState(pushUrl, '', pushUrl);
                }
            }
            // SLTBE-8873: on Apply/refine, close the mobile filter panel the user just
            // used (<1024px). On pagination there is no open panel to close — instead
            // scroll back to the grid top so the newly loaded page is in view.
            if (isPaging) {
                $('html, body').animate({scrollTop: $(container).offset().top}, 200);
            } else if ($(window).width() < 1024) {
                $('.plp-class').find('span.filter-class').trigger('click');
            }
            classcalendarnextmonth();
            classcalendarpreviousmonth();
        });
}

$(document).ready(function() {
    classcalendarnextmonth();
    classcalendarpreviousmonth();
});

// Similar to updateProductListing() to update mobile refinement bar
function updateMobileRefinementbar(url, container) {
    container.load(util.appendParamToURL(url, 'format', 'mobile-ajax'), function() {
        compareWidget.init();
        // history.pushState(undefined, '', window.location.href);
        brandmaterialShowlinks();
        categorySync();
        refinementsSync();
        $('.refinement').each(function() {
            if ($(this).find('ul li').hasClass('selected')) {
                $(this).find('ul li.selected').closest('.refinement').find('.left-refine').addClass('active');
                $(this).find('ul li.selected').closest('.refinement').find('ul').css('display', 'block');
            }
        });
    });
}

// Update refine bar on selection event from class tab
function updateMobileClassRefinementbar(url, container) {
    container.load(util.appendParamToURL(url, 'format', 'mobile-ajax'), function() {
        compareWidget.init();
        history.pushState(undefined, '', window.location.href);
        openStateFilterAjax(url);
        brandmaterialShowlinks();
        categorySync();
        refinementsSync();
    });
}

//Update refine bar on selection event from product tab
function updateMobileProductRefinementbar(url, container) {
    container.load(util.appendParamToURL(url, 'format', 'mobile-ajax'), function() {
        compareWidget.init();
        //if (!$('div.product-tab-content').find('div.clear-refinement').is(":visible") && $('div.product-tab-content').find('.breadcrumb-refinement').length > 0) {
        //$('div.product-tab-content').find('div.clear-applyBtn').show();
        //}
        openStateFilterAjax(url);
        brandmaterialShowlinks();
        categorySync();
        refinementsSync();
    });
}

//Similar to updateProductListing() to apply selected filters
function applyMobileFilters(url, container) {
    if (!url) {
        return;
    }
    progress.show($('#main'));
    container.load(util.appendParamToURL(url, 'format', 'ajax'), function() {
        compareWidget.init();
        productTile.init();
        progress.hide();
     //   history.pushState(undefined, '', window.location.href);
        brandmaterialShowlinks();
        categorySync();
        refinementsSync();
    });
}

function eventsInProductSection(url, container) {
    if (!url) {
        return;
    }
    url = util.appendParamToURL(url, 'format', 'renderproducts-ajax'); // &prefn1=productType&prefv1=Product|Recipe
    url = util.appendParamToURL(url, 'prefn1', 'productType');
    url = util.appendParamToURL(url, 'prefv1', 'HardGood');
    progress.show($('#main'));
    container.load(util.appendParamToURL(url, 'format', 'ajax'), function() {
        compareWidget.init();
        productTile.init();
        progress.hide();
        brandmaterialShowlinks();
        categorySync();
        refinementsSync();
        $('.product-tab-content #secondary .category-refinement .toggle').click();
    });
}

function eventsInClassessection(url, container) {
    if (!url) {
        return;
    }
    url = util.appendParamToURL(url, 'format', 'renderclasses-ajax'); // &prefn1=productType&prefv1=Product|Recipe
    url = util.appendParamToURL(url, 'prefn1', 'productType');
    url = util.appendParamToURL(url, 'prefv1', 'Culinary');
    progress.show($('#main'));
    container.load(util.appendParamToURL(url, 'format', 'ajax'), function() {
        compareWidget.init();
        productTile.init();
        progress.hide();
     //   history.pushState(undefined, '', window.location.href);
        brandmaterialShowlinks();
        categorySync();
        refinementsSync();
        $('.classes-tab-content #secondary .category-refinement .toggle').click();
    });
}

function eventsInRecipesection(url, container) {
    if (!url) {
        return;
    }
    url = util.appendParamToURL(url, 'format', 'renderrecipe-ajax');
    url = util.appendParamToURL(url, 'prefn1', 'productType');
    url = util.appendParamToURL(url, 'prefv1', 'Recipe');
    progress.show($('#main'));
    container.load(util.appendParamToURL(url, 'format', 'ajax'), function() {
        compareWidget.init();
        productTile.init();
        progress.hide();
       // history.pushState(undefined, '', window.location.href);
        brandmaterialShowlinks();
        categorySync();
        refinementsSync();
        $('.recipe-tab-content #secondary .category-refinement .toggle').click();
    });
}

//Selected filter open state After Ajax call.This is not working when SEO url is enable
function openStateFilterAjax(url) {
    if (url.indexOf('cgid=') > -1) {
        $('#secondary .refinement.category-refinement .toggle').click();
    }
    if (url.indexOf('size&pref') > -1) {
        $('#secondary .refinement.size .toggle').click();
    }
    if (url.indexOf('brand&pref') > -1) {
        $('#secondary .refinement.brand .toggle').click();
    }
    if (url.indexOf('isNew&') > -1) {
        $('#secondary .refinement.isNew .toggle').click();
    }
    if (url.indexOf('refinementColor&pref') > -1) {
        $('#secondary .refinement.refinementColor .toggle').click();
    }
    if (url.indexOf('&pmin') > -1) {
        $('#secondary .refinement.priceFilter .toggle').click();
    }
    categorySync();
    refinementsSync();
}

function brandmaterialShowlinks() {
    var $brandLength = $('.refinement.brand .scrollable li');
    if ($brandLength.length > 5) {
        $('.refinement.brand .scrollable li:not(".showmore-brands"):gt(4)').addClass('hide');
    }
    var $materialLength = $('.refinement.material .scrollable li');
    if ($materialLength.length > 5) {
        $('.refinement.material .scrollable li:not(".showmore-material"):gt(4)').addClass('hide');
    }
    $(document).on('click', '.showmore-material', function() {
        var $lastIndex = $('.refinement.material .scrollable li:not(".showmore-material"):visible:last').index();
        $('.refinement.material .scrollable li').slice($lastIndex, $lastIndex + 6).removeClass('hide');
        var $liHide = $('.refinement.material .scrollable li:not(".showmore-material"):visible');
        if ($liHide.length == $('.refinement.material .scrollable li').length - 1) {
            $(this).hide();
        } else {
            return;
        }
    });
    $(document).off('click', '.showmore-brands').on('click', '.showmore-brands', function() {
        var $lastIndex = $('.refinement.brand .scrollable li:not(".showmore-brands"):visible:last').index();
        $('.refinement.brand .scrollable li').slice($lastIndex, $lastIndex + 6).removeClass('hide');
        var $liHide = $('.refinement.brand .scrollable li:not(".showmore-brands"):visible');
        if ($liHide.length == $('.refinement.brand .scrollable li').length - 1) {
            $(this).hide();
        } else {
            return;
        }
    });
}

function filterPosition($this) {
    var $secondaryPos = $this.closest('.plp-tablet-filters').find('#secondary');
    var $showFilterPos = $this.closest('.plp-tablet-filters').find('.show-filter');
    //$secondaryPos.removeAttr('style');
    if ($secondaryPos.length > 0 && $showFilterPos.length > 0) {
        $secondaryPos.css('top', 0);
        var $pos = Math.abs($secondaryPos.offset().top - $showFilterPos.offset().top);
        $secondaryPos.css('top', $pos + 50);
    }
}

// check availability for each class and update available seats
function updateSeatAvailability() {
    if ($('span.available-seats-cont').length > 0) {
        var data = [];
        var prodID;
        $('span.available-seats-cont').each(function() {
            prodID = $(this).attr('data-prodID');
            if (prodID != '' && prodID != 'undefined') {
                data.push(prodID);
            }
        });
        $.ajax({
            type: 'GET',
            data: {
                'prodList': JSON.stringify(data)
            },
            url: window.Urls.GetAvailableSeatsURL,
            success: function(res) {
                var response = $.parseJSON(res);
                if (response.error != 'true') {
                    $.each(response, function(key) {
                        var seatContainer = $('#available-seats-cont-' + response[key].ID);
                        if (seatContainer.length > 0) {
                            seatContainer.html(response[key].inventory + ' ' + window.Resources.SEAT_AVAILABILITY_MSG);
                        }

                    });
                }
            },
            error: function() {
                // error
            }

        });
    }
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    var $main = $('#main');
    // mini menue hover
    $('.complete-content').hover(function() {
        if (!util.isMobile()) {
            $(this).find('.menue_popup').show();
        }
    },
        function() {
            if (!util.isMobile()) {
                $(this).find('.menue_popup').hide();
            }
        });
    // compare checked
    $main.on('click', 'input[type="checkbox"].compare-check', function() {
        var cb = $(this);
        var tile = cb.closest('.product-tile');

        var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
        var itemImg = tile.find('.product-image a img').first();
        func({
            itemid: tile.data('itemid'),
            uuid: tile[0].id,
            img: itemImg,
            cb: cb
        });

    });

    $('.refinement').each(function() {
        if ($(this).find('ul li').hasClass('selected')) {
            $(this).find('ul li.selected').closest('.refinement').find('.left-refine').addClass('active');
            $(this).find('ul li.selected').closest('.refinement').find('ul').css('display', 'block');
        }
    });

    $('.class-out-of-stock').each(function() {
        var oldUrl = $(this).find('.thumb-link').attr('href');
        $(this).find('.thumb-link').closest('.product-tile').find('a.pdp-class-link').attr('href', oldUrl);
    });

    $main.on('click', '.filter-class', function() {
        $(this).toggleClass('active');
        $(this).closest('.plp-class').find('.refinements').toggle();
    });

    // handle toggle refinement blocks
    $main.on('click', '.refinement .left-refine', function() {
        $(this).toggleClass('expanded active')
            .siblings('ul').toggle();
        categorySync();
        refinementsSync();
    });

    $main.on('click', '#category-level-1 li .arrow-catg', function() {
        if ($(this).closest('li').hasClass('active')) {
            $(this).closest('li').siblings().removeClass('active').find('.category-level-2, #category-level-2').slideUp();
            $(this).closest('li').toggleClass('active');
            $(this).closest('li').find('.category-level-2 , #category-level-2').slideToggle();
        } else if ($(this).closest('li').find('ul').length > 0) {
            $(this).closest('li').siblings().removeClass('active').find('.category-level-2, #category-level-2').slideUp();
            $(this).closest('li').toggleClass('active');
            $(this).closest('li').find('.category-level-2 , #category-level-2').slideToggle();
        }
    });

    $('#secondary .category-refinement .toggle').click();

    $(document).on('click', '.applyrefinementlist-bt', function(e) {
        e.preventDefault();
        var container = $(this).closest('.clearfix').find('.class-calendar');
        var url = this.href;
        var refinements = $('.refinslist select');
        var refinementName, refinementVal, count;
        if (refinements.length > 0) {
            count = (url.match(/prefn/g) || []).length;
            count = count + 1;
            refinements.each(function() {
                refinementName = $(this).data('attributeid');
                refinementVal = $(this).val();
                if (refinementVal != '') {
                    url = util.appendParamToURL(url, 'prefn' + count, refinementName);
                    url = util.appendParamToURL(url, 'prefv' + count, refinementVal);
                    count = count + 1;
                } else {
                    url = util.removeParamFromURL(url, 'prefv' + count);
                }
            });
        }
        updateclassListing(url, container);
        var classtypeval = $('#classType').val();
        var cousineval = $('#cuisine').val();
        var originalURL = decodeURIComponent(window.location.href);
        var historyURL = history.state;
        var prefn2 = originalURL.split('&')[2];
        var prefn3 = originalURL.split('&')[3];
        var monthvalinURL = originalURL.split('&month=')[1];
        var monthcountinURL = originalURL.split('&count=')[1];
        var prefattributeID,filtvalue3,filtvalue2,prefv2,prefv3;
        if (prefn2 != undefined){
            prefattributeID = prefn2.split('=')[0];
            filtvalue2 = decodeURIComponent(prefn2.split('=')[1]);
            if (filtvalue2 != cousineval && filtvalue2 != classtypeval){
                prefv2 = prefattributeID;
            }
        }
        if (prefn3 != undefined){
            prefattributeID = prefn3.split('=')[0];
            filtvalue3 = decodeURIComponent(prefn3.split('=')[1]);
            if (filtvalue3 != cousineval &&  filtvalue3 != classtypeval){
                prefv3 = prefattributeID;
            }
        }
        if (prefv2 != '' && prefv2 != undefined){
            originalURL = util.removeParamFromURL(originalURL,prefv2);
        }
        if (prefv3 != '' && prefv3 != undefined){
            originalURL = util.removeParamFromURL(originalURL,prefv3);
        }

        if (classtypeval != ''  && filtvalue3 != classtypeval  && filtvalue2 != classtypeval){
            originalURL = originalURL+'&prefn2='+classtypeval;
            // historyURL = historyURL+'&classType='+classtypeval;
            $('#appliedFilterClass').val('&classType='+classtypeval);
        }
        if (classtypeval == ''){
            $('#appliedFilterClass').val('&classType='+classtypeval);
        }
        if (cousineval == ''){
            $('#appliedFilterCuisine').val('&classType='+cousineval);
        }
        if (cousineval != ''  && filtvalue3 != cousineval  && filtvalue2 != cousineval){
            //  historyURL = historyURL+'&cuisine='+cousineval;
            originalURL =originalURL+'&prefn3='+cousineval;
            $('#appliedFilterCuisine').val('&cuisine='+cousineval);
        }
        if (monthvalinURL != '' && monthvalinURL != undefined){
            originalURL = util.removeParamFromURL(originalURL,'month');
        }
        if (monthcountinURL != '' && monthcountinURL != undefined){
            originalURL = util.removeParamFromURL(originalURL,'count');
        }
        if (monthvalinURL != ''  && monthvalinURL != undefined){
            originalURL = originalURL+'&month='+monthvalinURL;
        }
        history.replaceState(historyURL, '',originalURL);
    });

    $(window).on('load', function() {
        var monthCount = $('.class-month-count').val();
        var cgid = $('input[class="class-cgid"]').val();
        if (monthCount >= 0 && (cgid == 'virtual-cooking-classes' || cgid == 'in-store-classes')) {
            $('.applyrefinementlist-bt').trigger('click');
        }
    });

    //Only for in-store classes when customer apply the refinement on Class Landing Page
    $main.on('click', '.refinements a.class-applyrefinement:not(:disabled)', function(e) {
        e.preventDefault();
        var container = $(this).closest('.plp-class').find('.class-tiles-container');
        var startdate = $('.startdate').val();
        var enddate = $('.enddate').val();
        var refinmentSelected = false;
        var daterange = '';
        if (startdate == '' && enddate == '') {
            daterange = '';
        } else {
            refinmentSelected = true;
            daterange = startdate + '|' + enddate;
        }
        var url = this.href;
        var refinements = $('.refinements select');
        var refinementName, refinementVal, count;
        if (refinements.length > 0) {
            count = (url.match(/prefn/g) || []).length;
            count = count + 1;
            refinements.each(function() {
                refinementName = $(this).data('attributeid');
                refinementVal = $(this).val();
                if (refinementVal != '') {
                    refinmentSelected = true;
                    url = util.appendParamToURL(url, 'prefn' + count, refinementName);
                    url = util.appendParamToURL(url, 'prefv' + count, refinementVal);
                    count = count + 1;
                } else {
                    refinmentSelected = true;
                    url = util.removeParamFromURL(url, 'prefv' + count);
                }
            });

        }
        if (!refinmentSelected) return;
        url = util.appendParamToURL(url, 'daterange', daterange);
        if ($('#nearestStore').length > 0 && $('#nearestStore').val() != '') {
            url = util.appendParamToURL(url, 'nearestStore', $('#nearestStore').val());
        }
        // SLTBE-8873: route the CLP grid fetch through the un-aliased Search-ClassGrid action.
        updateclassListing(toClassGridUrl(url, getClpCgid()), container, startdate, enddate);

        // GTM: Fire clp_page_view when class filter is applied
        if (isGTMEnabled) {
            var clpClassType = $('select[data-attributeid="classType"]').val() || '';
            var clpStoreId = $('.set-preferred-location').data('store-id');
            var clpStoreName = $('.set-preferred-location').data('store-name');
            require('../gtm').onCLPPageView(clpClassType, clpStoreId, clpStoreName);
        }

        var filters = this.search.replace(/%20/gi, '+');
        var q;
        if (filters.split('q=').length > 1) {
            q = filters.split('q=')[1].split('&')[0];
        }
        filters = filters.split('prefv');
        var filtersString = filters.length > 1 ? 'filters/' : '';
        var seperator = q ? '&' : '?';
        var pmin = this.search.split('pmin=').length > 1 ? this.search.split('pmin=')[1].split('&')[0] : '';
        var pmax = this.search.split('pmax=').length > 1 ? this.search.split('pmax=')[1].split('&')[0] : '';
        var pricAttribute = pmin && pmax ? seperator + 'pmin=' + pmin + '&pmax=' + pmax : '';
        for (var filterIndex = 1; filterIndex < filters.length; filterIndex++) {
            filtersString += filters[filterIndex].replace(/.=/gi, '').split('&')[0].replace(/%7C/gi, '/') + '/';
        }
        var newStateUrl;
        //UTM parameter in PLP page on load refinements
        var utms = window.location.href.split('utm'),
            utmString = '';
        for (var utmIndex = 1; utmIndex < utms.length; utmIndex++) {
            utmString += 'utm' + utms[utmIndex].split('&')[0] + '&';
        }
        utms = window.location.href.split('UTM');
        for (var UTMndex = 1; UTMndex < utms.length; UTMndex++) {
            utmString += 'UTM' + utms[UTMndex].split('&')[0] + '&';
        }
        if (q) {
            newStateUrl = this.origin + this.pathname + '?q=' + q + '/' + filtersString + pricAttribute + '&' + utmString;
        } else {
            newStateUrl = this.origin + this.pathname + filtersString + pricAttribute;
            if (newStateUrl.indexOf('?') > -1 && utmString) {
                newStateUrl += '&' + utmString;
            } else if (utmString) {
                newStateUrl += '?' + utmString;
            }
        }
        window.history.replaceState(window.history.state, document.title, url);
    });

    // handle events for updating grid
    $main.on('click', '.refinements a:not(".class-applyrefinement"), .pagination a', function(e) {
        // don't intercept for category and folder refinements, as well as unselectable
        if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
            return;
        }
        if ($(this).parents('.changeDate').length > 0) {
            return;
        }
        e.preventDefault();
        var container = $(this).closest('.tab-content').find('.tab-content-wrapper');
        var url = this.href;
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            url = window.encodeURI(url);
        }
        // SLTBE-8873: on the culinary CLP (the only page with .class-location-select),
        // paging-bar links land here with no .tab-content ancestor and would otherwise
        // fall through to updateProductListing → the /search alias → the PWA proxy →
        // React document injected into the grid. Route CLP pagination through the class
        // handler instead, which fetches the un-aliased Search-ClassGrid fragment and
        // swaps it into .class-tiles-container in place (same as filter/apply).
        if ($('.class-location-select').length > 0) {
            var clpContainer = $(this).closest('.plp-class').find('.class-tiles-container');
            if (clpContainer.length > 0) {
                // Fetch the grid fragment from the un-aliased action; on success the browser-
                // facing `url` is pushed to history (as state) so Back/Forward re-sync the grid
                // via the CLP popstate branch. Pushing only after render avoids a URL that
                // claims a page which failed or returned no results.
                updateclassListing(toClassGridUrl(url, getClpCgid()), clpContainer, $('.startdate').val(), $('.enddate').val(), true, url);
                return;
            }
        }
        if ($(window).width() < 768) {
            if (typeof($(this).attr('class')) != 'undefined' && $(this).attr('class').indexOf('applyallrefinement') > -1) {
                // Apply the selected filters
                if (container.length < 1) {
                    container = $('#main');
                    applyMobileFilters(url, container);
                } else {
                    if ($(this).closest('div.tab-content.classes-tab-content').length > 0) {
                        eventsInClassessection(url, container);
                    } else if ($(this).closest('div.tab-content.product-tab-content').length > 0) {
                        eventsInProductSection(url, container);
                    } else {
                        eventsInRecipesection(url, container);
                    }
                }
            } else if (typeof($(this).attr('class')) != 'undefined' && $(this).attr('class').indexOf('clearallrefinement') > -1) {
                // Handle Clear refinement event.
                if (container.length < 1) {
                    container = $('#main');
                    applyMobileFilters(url, container);
                } else {
                    if ($(this).closest('div.tab-content.classes-tab-content').length > 0) {
                        eventsInClassessection(url, container);
                    } else if ($(this).closest('div.tab-content.product-tab-content').length > 0) {
                        eventsInProductSection(url, container);
                    } else {
                        eventsInRecipesection(url, container);
                    }
                }
            } else {
                // select and update refinement list by identifying the tabing(search result) or PLP structure
                if (container.length < 1) {
                    //PLP Mobile
                    container = $(this).closest('.plp-tablet-filters').find('#secondary');
                    updateMobileRefinementbar(url, container);
                } else {
                    // Tabing (search result) Mobile
                    container = $(this).closest('.plp-tablet-filters').find('#secondary');
                    if ($(this).closest('div.tab-content.classes-tab-content').length > 0) {
                        updateMobileClassRefinementbar(url, container);
                    } else {
                        updateMobileProductRefinementbar(url, container);
                    }

                }
            }
        } else if ($(this).closest('div.tab-content.classes-tab-content').length > 0) {
            container = $(this).closest('#tabs').find('.classes-tab-content .tab-content-wrapper');
            eventsInClassessection(url, container);
        } else if ($(this).closest('div.tab-content.product-tab-content').length > 0) {
            container = $(this).closest('#tabs').find('.product-tab-content .tab-content-wrapper');
            eventsInProductSection(url, container);
        } else if ($(this).closest('div.tab-content.recipe-tab-content').length > 0) {
            container = $(this).closest('#tabs').find('.recipe-tab-content .tab-content-wrapper');
            eventsInRecipesection(url, container);
        } else {
            // Need to handle both the scenarios for PLP and Search result page which includes tabing.
            if (container.length < 1) {
                container = $('#main');
                updateProductListing(url, container);
            } else {
                updateProductListing(url, container);
            }
        }
        var filters = this.search.replace(/%20/gi, '+');
        var q;
        if (filters.split('q=').length > 1) {
            q = filters.split('q=')[1].split('&')[0];
        }
        filters = filters.split('prefv');
        var filtersString = filters.length > 1 ? 'filters/' : '';
        var seperator = q ? '&' : '?';
        for (var filterIndex = 1; filterIndex < filters.length; filterIndex++) {
            filtersString += filters[filterIndex].replace(/.=/gi, '').split('&')[0].replace(/%7C/gi, '/') + '/';
        }
        var pmin = this.search.split('pmin=').length > 1 ? this.search.split('pmin=')[1].split('&')[0] : '';
        var pmax = this.search.split('pmax=').length > 1 ? this.search.split('pmax=')[1].split('&')[0] : '';
        var pricAttribute = pmin && pmax ? seperator + 'pmin=' + pmin + '&pmax=' + pmax : '';
        var newStateUrl;
        var utms = window.location.href.split('utm'),
            utmString = '';
        for (var utmIndex = 1; utmIndex < utms.length; utmIndex++) {
            utmString += 'utm' + utms[utmIndex].split('&')[0] + '&';
        }
        utms = window.location.href.split('UTM');
        for (var UTMndex = 1; UTMndex < utms.length; UTMndex++) {
            utmString += 'UTM' + utms[UTMndex].split('&')[0] + '&';
        }
        if (q) {
            newStateUrl = this.origin + this.pathname + '?q=' + q;
            if (filtersString || pricAttribute) {
                newStateUrl += '/' + filtersString + pricAttribute;
            }
            newStateUrl += '&' + utmString;
        } else {
            newStateUrl = this.origin + this.pathname + filtersString + pricAttribute;
            if (newStateUrl.indexOf('?') > -1 && utmString) {
                newStateUrl += '&' + utmString;
            } else if (utmString) {
                newStateUrl += '?' + utmString;
            }
        }

        var parentPageData = $(this).closest('.pagination').data('pagination');
        var pageData = $('.pagination').data('pagination');
        if ($(window).width() >= 768 || pageData !== parentPageData) {
            window.history.pushState(url, document.title, url);
        }
    });

    // handle event on pagination and for cancel refinement in mobile device
    $main.on('click', '.pagination a, .breadcrumb-refinement-value a', function(e) {
        e.preventDefault();
        var url = this.href;
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            url = window.encodeURI(url);
        }
        // SLTBE-8873: CLP pagination is fully handled by the class-routing branch in the
        // '.refinements a, .pagination a' handler above (which fetches the un-aliased
        // Search-ClassGrid fragment). Bail here so this mobile product-path handler does
        // not also fetch the /search alias for the same click.
        if ($('.class-location-select').length > 0) {
            return;
        }
        // check if event is from search or PLP
        var container = $(this).closest('.tab-content').find('.tab-content-wrapper');
        isPagination = $(this).closest('.pagination').data('pagination');
        if ($('.pagination').data('pagination') === isPagination) {
            $('html, body').animate({
                scrollTop: 0
            }, 0);
        }
        if ($(window).width() < 768) {
            history.pushState(url, undefined, url);
            if (container.length < 1) {
                container = $('#main');
                updateProductListing(url, container);
            } else {
                updateProductListing(url, container);
            }
        }
    });

    // handle events item click. append params.
    $main.on('click', '.product-tile a:not("#quickviewbutton")', function() {
        var a = $(this);
        // get current page refinement values
        var wl = window.location;

        var qsParams = (wl.search.length > 1) ? util.getQueryStringParams(wl.search.substr(1)) : {};
        var hashParams = (wl.hash.length > 1) ? util.getQueryStringParams(wl.hash.substr(1)) : {};

        // merge hash params with querystring params
        var params = $.extend(hashParams, qsParams);
        if (!params.start) {
            params.start = 0;
        }
        // get the index of the selected item and save as start parameter
        var tile = a.closest('.product-tile');
        var order=($('.pagination .current-page').index()-2)*parseInt($('.PageSize').val(),10);
        var idx = tile.data('idx') ? +(tile.data('idx')+1)+order : 0;

        // convert params.start to integer and add index
        params.start = (+params.start) + (idx + 1);
        // set the hash and allow normal action to continue
        if (a.attr('href') !== a.data('pwaurl')) {
            var updatedHref = updateQueryString('start', idx, a.attr('href'));
            a.attr('href', updatedHref);
        }
    });

    // handle sorting change
    $main.on('change', '.sort-by select', function(e) {
        e.preventDefault();
        var container = $(this).closest('.tab-content').find('.tab-content-wrapper');

        // Need to handle both the scenarios for PLP and Search result page which includes tabing.
        var url = $(this).find('option:selected').val();
        history.pushState(url, undefined, url);
        if (container.length < 1) {
            container = $('#main');
            updateProductListing(url, container);
        } else {
            container = $(this).closest('.tab-content').find('div.tab-content-wrapper');
            updateProductListing(url, container);
        }
    })
        .on('change', '.items-per-page select', function() {
            var refineUrl = $(this).find('option:selected').val();
            var container = $(this).closest('.tab-content').find('.tab-content-wrapper');
            if (refineUrl === 'INFINITE_SCROLL') {
                $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
            } else {
                $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');

                // Need to handle both the scenarios for PLP and Search result page which includes tabing.
                history.pushState(refineUrl, undefined, refineUrl);
                if (container.length < 1) {
                    container = $('#main');
                    updateProductListing(refineUrl, container);
                } else {
                    container = $(this).closest('.tab-content').find('div.tab-content-wrapper');
                    updateProductListing(refineUrl, container);
                }
            }
            var newurl = history.state.replace(history.state.substring(history.state.lastIndexOf('&start')),'');
            window.history.replaceState(window.history.state,document.title,newurl);
        });

    if ($(window).width() < 1024) {
        var $showFilter = $('body').find('.mobile-show.show-filter');
        if ($showFilter.length > 0) {
            var $showFilterWidth = $showFilter.width();
            $('body').find('#tabs ul.ui-helper-reset').css('width', ($showFilterWidth * 2) + 1);
            $('body').find('.sort-by .custom-select').css('width', $showFilterWidth + 1);
        }
    }

    // handle show filters feature in mobile devices
    $main.on('click', '.show-filter', function() {
        $(this).toggleClass('active');
        $(this).closest('div.plp-tablet-filters').find('#secondary.refinements').css('width', ($(this).width() * 2) + 1);
        $(this).closest('div.plp-tablet-filters').find('#secondary.refinements').toggleClass('active').slideToggle();
        if ($(this).text().trim().indexOf(Resources.HIDE_FILTER) > -1) {
            $(this).text(Resources.SHOW_FILTER);
        } else if ($(this).text().trim().indexOf(Resources.SHOW_FILTER) > -1) {
            var noOfSelectedFilters = $(this).closest('div.plp-tablet-filters').find('#secondary.refinements .breadcrumb-refinement').length;
            $(this).text(Resources.HIDE_FILTER + '  (' + noOfSelectedFilters + ')');
        }
        filterPosition($(this));
    });

    $main.on('click', '#grid-sort-header', function() {
        var $activeFilter = $(this).closest('.search-result-options').find('.show-filter');
        if ($activeFilter.hasClass('active')) {
            $activeFilter.click();
        }
    });

    $('a.brand-link-list').click(function() {
        if ($(window).width() > 1024) {
            $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top - 100
            }, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top - 75
            }, 1000);
        }
        return false;
    });

    brandmaterialShowlinks();
    categorySync();
    refinementsSync();
    $(document).ajaxComplete(function() {
        categorySync();
        refinementsSync();
    });

    $(window).resize(function() {
        if ($(window).width() < 1024) {
            filterPosition($(this));
        }
    });

    // Click of RecipeTabs in Search result page
    $main.on('click', 'div#tabs a.products-tablabel', function() {
        if ($(this).closest('#tabs').find('div.product-tab-content .search-result-content').length < 1) {
            var urlData = util.urlStringToData(window.location.href);
            var url = util.urlDataToString({
                baseUrl: urlData.baseUrl,
                params: {
                    q: urlData.params.q
                },
                refinements: {
                    productType: ['HardGood']
                }
            });
            var container = $(this).closest('#tabs').find('.product-tab-content .tab-content-wrapper');
            eventsInProductSection(url, container);
        }
    });

    // Click of ClassesTabs in Search result page
    $main.on('click', 'div#tabs a.classes-tablabel', function() {
        if ($(this).closest('#tabs').find('div.classes-tab-content .search-result-content').length < 1) {
            var urlData = util.urlStringToData(window.location.href);
            var url = util.urlDataToString({
                baseUrl: urlData.baseUrl,
                params: {
                    q: urlData.params.q
                },
                refinements: {
                    productType: ['Culinary']
                }
            });
            var container = $(this).closest('#tabs').find('.classes-tab-content .tab-content-wrapper');
            eventsInClassessection(url, container);
            brandmaterialShowlinks();
            categorySync();
            refinementsSync();
        }
    });

    // Click of RecipeTabs in Search result page
    $main.on('click', 'div#tabs a.recipe-tablabel', function() {
        if ($(this).closest('#tabs').find('div.recipe-tab-content .search-result-content').length < 1) {
            var urlData = util.urlStringToData(window.location.href);
            var url = util.urlDataToString({
                baseUrl: urlData.baseUrl,
                params: {
                    q: urlData.params.q
                },
                refinements: {
                    productType: ['Recipe']
                }
            });
            var container = $(this).closest('#tabs').find('.recipe-tab-content .tab-content-wrapper');
            history.pushState(url, null, window.location.href);
            eventsInRecipesection(url, container);
            brandmaterialShowlinks();
            categorySync();
            refinementsSync();
        }
    });

    util.datePicker();

    $(document).on('click', '.class-location-select .set-preferred-store', function(e) {
        e.preventDefault();
        classStoreFinder.selectStorePrompt();
    });

    // SLTBE-8826 / SLTBE-8873: reconcile the remembered store (per-tab sessionStorage,
    // cross-surface source of truth shared with the PWA) into the CLP on load.
    //
    // The remembered store is the ABSOLUTE source of truth: if this tab remembers a
    // store that differs from whatever the server rendered, seed the SG session and
    // reload the CLP scoped to it — REGARDLESS of whether the server render was empty.
    // A stale URL storeId (?prefn=storeId&prefv=<id>) makes the render non-empty, so
    // the old "server rendered empty" gate skipped reconcile and the correct
    // sessionStorage store was silently discarded. The decision is delegated to the
    // pure clpStoreLoadResolver so it can be unit tested. With no remembered store we
    // resolve from `slt_user_city` when the shopper has picked a city on either
    // surface, and only fall back to the browser geolocation prompt when they have
    // not; the picker modal opens only on a manual "Change" click.
    var classStorePreference = require('../storeinventory/classStorePreference');
    var clpStoreLoadResolver = require('../storeinventory/clpStoreLoadResolver');
    var radar = require('../radar');
    // SLTBE-8979: retired. Written once per tab and never cleared, it made every
    // later CLP load in that tab resolve to 'none' over a freshly rendered EMPTY
    // shell — the spinner stayed up and the grid was never fetched. Removed here so
    // tabs carrying one from a previous release stop showing it in devtools.
    var RETIRED_RECONCILE_SENTINEL = 'slt_clp_store_reconciled';

    function getRenderedStore() {
        var renderedStore = $('.set-preferred-location').data('store-id');
        // The hidden nearestStoreAvailable input mirrors pdict.nearestStore.
        if (!renderedStore) {
            var hidden = $('input[name="nearestStoreAvailable"]').val();
            if (hidden && hidden !== 'null') {
                renderedStore = hidden;
            }
        }
        return (renderedStore === undefined || renderedStore === null || renderedStore === '')
            ? null
            : String(renderedStore);
    }

    function dropRetiredReconcileSentinel() {
        try {
            if (window.sessionStorage) {
                window.sessionStorage.removeItem(RETIRED_RECONCILE_SENTINEL);
            }
        } catch (e) {
            // Best-effort cleanup only — proceed regardless.
        }
    }

    // SLTBE-8979: the "Your Class Location" header stays hidden behind its spinner
    // for as long as the store is unresolved — on the storeless shell there is
    // nothing to show yet, and on a store-present render (a return trip from the
    // PWA) whatever the server rendered may be about to be replaced. Showing the
    // previous store and then swapping it a moment later read as the page changing
    // the shopper's location on its own. The `is-resolving` class on
    // `.class-location-select` is the single switch; the ISML sets it at first paint
    // and every terminal path below clears it.
    function beginClpLocationLoading() {
        $('.class-location-select').addClass('is-resolving');
    }

    function endClpLocationLoading() {
        $('.class-location-select').removeClass('is-resolving');
    }

    function showClpStoreLoader() {
        $('.clp-store-loading').removeClass('hide');
        $('.no-class-found, .no-class-nearby').addClass('hide');
        beginClpLocationLoading();
        progress.show($('.plp-class'));
    }

    function hideClpStoreLoader() {
        $('.clp-store-loading').addClass('hide');
        endClpLocationLoading();
        progress.hide();
    }

    function openClpStorePicker() {
        hideClpStoreLoader();
        $('.class-location-select .set-preferred-store').trigger('click');
    }

    // SLTBE-8873: resolve the cgid for building the class-ajax grid/refine-bar URLs.
    // The storeless shell exposes it via .class-location-select[data-cgid]; the
    // store-present render carries it in the change-store link href.
    function getClpCgid() {
        var cgid = $('.class-location-select').data('cgid');
        if (cgid) {
            return String(cgid);
        }
        var href = $('.class-location-select .set-preferred-store a').attr('href') || '';
        var match = href.match(/[?&]cgid=([^&]+)/);
        return match ? decodeURIComponent(match[1]) : '';
    }

    // SLTBE-8873: build a Search-* class-ajax URL scoped to `storeId`, carrying the
    // store as a prefn/prefv refinement (the class-ajax server paths read the store
    // from prefn=storeId, NOT session). No change to the browser URL.
    function buildClassAjaxUrl(baseUrl, cgid, storeId) {
        var url = util.appendParamToURL(baseUrl, 'cgid', cgid);
        url = util.appendParamToURL(url, 'prefn1', 'storeId');
        url = util.appendParamToURL(url, 'prefv1', storeId);
        // Mirror the refinements includeCLP() applies server-side (Search.js ~1200)
        // so the in-place render matches the server render exactly.
        url = util.appendParamToURL(url, 'prefn2', 'productType');
        url = util.appendParamToURL(url, 'prefv2', 'Culinary');
        url = util.appendParamToURL(url, 'prefn3', 'cancelledClass');
        url = util.appendParamToURL(url, 'prefv3', 'false');
        return util.appendParamToURL(url, 'format', 'class-ajax');
    }

    // SLTBE-8873: render the CLP class grid for `storeId` IN PLACE — no redirect, no
    // ?nearestStore param, URL stays put. Fetches the grid partial (Search-Show ->
    // showClassGrid -> classgridwrapper) and the refine bar (Search-IncludeCLP ->
    // updateclassRefineBar), DOM-swaps them into the empty shell, and updates the
    // "Your Class Location" label + #nearestStore hidden input so the store is
    // reflected and the legacy refinement path (search.js ~1190) stays scoped.
    // `storeMeta` is optional { storeName, city, stateCode } from the geo resolve.
    //
    // Store identity flows through one place — $label — which owns three things kept
    // in lockstep: the store-id attr (both .attr for the legacy path and .data for
    // GTM), the visible name, and the city/state sibling. writeStoreLabel() is the
    // ONLY writer; the GTM fire at the end reads back from $label. Everything here is
    // DOM-only — this function NEVER persists to sessionStorage (a manual modal pick
    // does that, elsewhere).
    function renderClpGridForStore(storeId, storeMeta) {
        var cgid = getClpCgid();
        var $container = $('.class-tiles-container');
        if (!cgid || $container.length === 0) {
            // No shell to populate (e.g. store-present render or a non-CLP page).
            return false;
        }

        var $locations = $('.class-location-select .set-preferred-location');
        var $label = $locations.first();
        var $cityState = $locations.eq(1);
        var originalLabel = {
            storeId: $label.attr('data-store-id'),
            storeName: $label.attr('data-store-name'),
            text: $label.text(),
            hidden: $label.hasClass('hide'),
            cityStateHtml: $cityState.html(),
            cityStateHidden: $cityState.hasClass('hide')
        };

        // Set store-id up front (attr + data in sync) and mirror it into #nearestStore
        // so the legacy refinement append (search.js ~1190) is scoped before the fetch.
        $label.attr('data-store-id', storeId).data('store-id', storeId);
        $('#nearestStore').val(storeId);

        // Write the store name + city/state, or clear both when `name` is blank
        // (blank avoids showing the server-rendered store's stale details next to a
        // swapped grid). City/state go into per-value <span>s via .text() (XSS-safe),
        // with a comma only when both parts are present.
        function writeStoreLabel(name, city, stateCode) {
            if (!name) {
                $label.text('').removeAttr('data-store-name').removeData('store-name').addClass('hide');
                $cityState.empty().addClass('hide');
                return;
            }
            $label.text(name).attr('data-store-name', name).data('store-name', name).removeClass('hide');
            var separator = (city && stateCode) ? ',' : '';
            $cityState
                .html($('<span/>').text((city || '') + separator))
                .append($('<span/>').text(stateCode || ''))
                .removeClass('hide');
            // SLTBE-8889: writeStoreLabel is the single point where the real store
            // label lands, so it is the single source of truth for turning the
            // label spinner off once there is something to show in its place.
            endClpLocationLoading();
        }

        function restoreStoreLabel() {
            if (originalLabel.storeId === undefined) {
                $label.removeAttr('data-store-id').removeData('store-id');
            } else {
                $label.attr('data-store-id', originalLabel.storeId).data('store-id', originalLabel.storeId);
            }
            if (originalLabel.storeName === undefined) {
                $label.removeAttr('data-store-name').removeData('store-name');
            } else {
                $label.attr('data-store-name', originalLabel.storeName).data('store-name', originalLabel.storeName);
            }
            $label.text(originalLabel.text).toggleClass('hide', originalLabel.hidden);
            $cityState.html(originalLabel.cityStateHtml).toggleClass('hide', originalLabel.cityStateHidden);
            $('#nearestStore').val(originalLabel.storeId || '');
        }

        // Geo path knows the name up front; reconcile path clears now and fills the
        // label from the grid response's .clp-store-meta once the swap lands.
        var hasGeoMeta = !!(storeMeta && storeMeta.storeName);
        writeStoreLabel(
            hasGeoMeta ? storeMeta.storeName : '',
            hasGeoMeta ? storeMeta.city : '',
            hasGeoMeta ? storeMeta.stateCode : ''
        );

        $('.class-location-select').removeClass('hide');
        $('.no-class-nearby').addClass('hide');
        $('.clp-store-loading').removeClass('hide');

        progress.show($container);

        // Refine bar (best-effort — filters degrade gracefully if this fails). The
        // 'no-result' guard avoids rendering the sentinel object as [object Object].
        var refineReq = $.ajax({
            url: buildClassAjaxUrl(Urls.classRefineBar, cgid, storeId)
        }).done(function(refineHtml) {
            if (refineHtml && refineHtml.result !== 'no-result') {
                $('#secondary.refinements').html(refineHtml);
                // .startdate/.enddate inputs live in this partial; rebind regardless
                // of which response (grid or refine bar) lands first.
                util.datePicker();
            }
        });

        // Grid — the actual class tiles. Swap into the container in place.
        var gridRendered = false;
        var gridReq = $.ajax({
            url: buildClassAjaxUrl(Urls.classGridSearch, cgid, storeId)
        }).done(function(response) {
            hideClpStoreLoader();
            if (response && response.result === 'no-result') {
                // SLTBE-8873: no-result carries no .clp-store-meta markup (the grid
                // template never renders). Refill the label from the store meta the
                // server put on the JSON payload so a genuinely-resolved store with
                // zero classes still shows its name/city/state — the reconcile path
                // blanked it up front. Geo already wrote the label, so skip there.
                $container.empty();
                if (!hasGeoMeta && response.storeName) {
                    writeStoreLabel(response.storeName, response.city, response.stateCode);
                }
                $('.no-class-found').removeClass('hide');
            } else {
                $('.no-class-found').addClass('hide');
                $container.html(response);
                // Reconcile path only: fill the label from the store name/city/state
                // the server embedded in .clp-store-meta (classgridwrapper.isml).
                if (!hasGeoMeta) {
                    var $meta = $container.find('.clp-store-meta').first();
                    if ($meta.length && $meta.attr('data-store-name')) {
                        writeStoreLabel(
                            $meta.attr('data-store-name'),
                            $meta.attr('data-store-city'),
                            $meta.attr('data-store-state')
                        );
                    }
                }
                if ($('.text-ellipsis').length) {
                    $('.text-ellipsis').ellipsis();
                }
                util.datePicker();
                updateSeatAvailability();
                // SLTBE-8873: seed the initial (page-1) history entry with the SCOPED grid
                // URL as state. The injected grid fragment (classgridwrapper.isml) renders the
                // paging bar, whose .currentPageUrl hidden input carries the full scoped query
                // string (storeId/productType/cancelledClass refinements) — mirroring the
                // TEB-304 seed at document.ready. window.location.href is only the bare CLP SEO
                // path (no query string) on this in-place reconcile path, so seeding it would
                // make Back-to-page-1 re-fetch an unscoped grid (all stores + cancelled classes)
                // under a label still naming the selected store. When the paging bar's hidden
                // input is absent (single page, or infinite scroll suppressing the page links),
                // fall back to the scoped grid URL just fetched — never the bare SEO path.
                //
                // Guard is !history.state (falsy), NOT `== null`: the $(document).ready
                // handler above (~line 416) runs synchronously before this AJAX .done and, on
                // the CLP wrapper (pt_classes-search-result, not pt_product-search-result),
                // clobbers history.state to the empty string '' via replaceState('', ..., '').
                // So by the time this runs history.state is '' — not null — and a `== null`
                // guard would skip the seed, leaving Back to re-fetch an unscoped grid.
                if (!history.state) {
                    var seedUrl = $('.currentPageUrl').length > 0 && $('.currentPageUrl').val()
                        ? $('.currentPageUrl').val()
                        : buildClassAjaxUrl(Urls.classGridSearch, cgid, storeId);
                    history.replaceState(seedUrl, '', window.location.href);
                }
            }
            gridRendered = true;
        }).fail(function() {
            hideClpStoreLoader();
            restoreStoreLabel();
            // Grid fetch failed — fall back to the manual picker.
            openClpStorePicker();
        });

        // Re-fire the load-time GTM event once BOTH requests settle, and only if the
        // grid rendered. app.js fires this on ready with a pre-swap (blank/stale)
        // store; the in-place render replaced the reload that made that correct.
        // Waiting for both is required: the classType <select> read below is injected
        // by the refine-bar response, so firing off the grid alone would read '' when
        // the grid lands first. Args are || '' guarded against undefined.
        $.when(refineReq, gridReq).always(function() {
            if (!gridRendered) {
                return;
            }
            require('../gtm').onCLPPageView(
                $('select[data-attributeid="classType"]').val() || '',
                $label.data('store-id') || '',
                $label.data('store-name') || ''
            );
        });
        return true;
    }

    // Scope the CLP to the remembered/session `storeId` IN PLACE. Seeds the SG session
    // (kept for consistency with any later full navigation) and renders the grid via a
    // DOM swap — no reload, no ?nearestStore param, URL unchanged.
    //
    // SLTBE-8979: no longer records a sentinel. The decision is made once per page
    // load and the swap does not reload, so there is nothing to loop on — while a
    // sentinel that outlived the page load suppressed the reconcile on every later
    // visit to the CLP in the same tab.
    function reloadClpScopedToStore(storeId) {
        if ($('.class-tiles-container').length === 0) {
            return false;
        }
        showClpStoreLoader();
        // Seed the SG session before the first grid fetch. The grid URL is also scoped
        // by prefn/prefv, but waiting removes the first-load race where refresh works
        // only after the server session finally catches up.
        $.ajax({
            type: 'POST',
            url: Urls.setSelectedCalssStore,
            data: {selectedclassstore: storeId}
        }).always(function() {
            if (!renderClpGridForStore(storeId, null)) {
                openClpStorePicker();
            }
        });
        return true;
    }

    // Resolve the nearest cooking-class store from coordinates and render its
    // CLP grid IN PLACE — WITHOUT writing sessionStorage (no manual pick happened),
    // WITHOUT any redirect/param, and WITHOUT popping the modal. Falls back to the
    // manual picker if geo yields nothing or the resolve fails.
    function resolveStoreFromGeo(coords) {
        showClpStoreLoader();
        $.ajax({
            type: 'POST',
            url: Urls.getNearestStoreCLP,
            data: {
                cgid: getClpCgid(),
                latitude: coords.latitude,
                longitude: coords.longitude
            }
        }).done(function(stores) {
            if (stores && stores.length && stores[0].storeId) {
                var store = stores[0];
                // The server may already have rendered this exact store (e.g. a
                // remembered city whose nearest store matches a session/geo-IP
                // render) — skip the redundant grid swap and just reveal the header.
                if (String(store.storeId) === getRenderedStore()) {
                    hideClpStoreLoader();
                    return;
                }
                var swapped = renderClpGridForStore(store.storeId, {
                    storeName: store.storeName,
                    city: store.city,
                    stateCode: store.stateCode
                });
                if (swapped) {
                    return;
                }
            }
            // No nearby store (or no shell to populate) — let the user pick manually.
            openClpStorePicker();
        }).fail(function() {
            openClpStorePicker();
        });
    }

    // SLTBE-8979: coordinates of the city the shopper picked (`slt_user_city`, the
    // same entry the PWA writes on a city pick). getUserCity() already validates
    // shape (isValidCity) and returns null for anything malformed, which is what
    // sends the resolver on to the browser-geo prompt.
    function getRememberedCityCoords() {
        var city = classStorePreference.getUserCity();
        return city ? {
            latitude: city.coordinates.latitude,
            longitude: city.coordinates.longitude
        } : null;
    }

    function runClpStoreLoad() {
        // Scope to the actual CLP: `.class-location-select` only exists in
        // categoryclasshitsinclude.isml. initializeEvents() (and this load handler)
        // runs on every search page, so without this guard the resolver fires on
        // plain PLPs/product searches too — wasting a geo-lookup AJAX on a page with
        // no class grid to render it into.
        if (!$('.class-location-select').length) {
            return;
        }

        dropRetiredReconcileSentinel();

        var rememberedStore = classStorePreference.getPreferredStore();
        var renderedStore = getRenderedStore();
        var cityCoords = getRememberedCityCoords();

        function decide(geoCoords) {
            var action = clpStoreLoadResolver.resolveLoadAction({
                rememberedStore: rememberedStore,
                renderedStore: renderedStore,
                cityCoords: cityCoords,
                geoCoords: geoCoords
            });

            if (action.type === 'reconcile') {
                if (!reloadClpScopedToStore(action.storeId)) {
                    // No grid shell to populate (e.g. a zero-result store render):
                    // nothing to reconcile into, so reveal the header we hid.
                    hideClpStoreLoader();
                }
            } else if (action.type === 'geo') {
                resolveStoreFromGeo(action.coords);
            } else if (action.type === 'modal') {
                openClpStorePicker();
            } else {
                // 'none' -> leave the current render untouched, but reveal the
                // location header the ISML rendered behind its spinner.
                hideClpStoreLoader();
            }
        }

        // The browser-geo prompt is the LAST resort: it is only needed when nothing
        // is remembered — no store and no picked city — and the render is empty.
        // Everything else decides synchronously, without asking for location.
        if (!rememberedStore && !cityCoords && renderedStore === null
            && radar && radar.isEnabled && typeof radar.getGeoLocation === 'function') {
            showClpStoreLoader();
            radar.getGeoLocation().then(function(address) {
                var coords = (address
                    && typeof address.latitude === 'number'
                    && typeof address.longitude === 'number')
                    ? {latitude: address.latitude, longitude: address.longitude}
                    : null;
                decide(coords);
            }).catch(function() {
                decide(null);
            });
        } else {
            decide(null);
        }
    }

    $(window).on('load', function() {
        runClpStoreLoad();
        if ($('input[name="participateInCulinary"]').val() != 'true') {
            $('.class-location-select .set-preferred-store').trigger('click');
        }
    });

    // SLTBE-8979: a trip into the PWA (CDP / calendar) and back can restore this page
    // from the bfcache, where `load` does not fire again — the shopper would be
    // looking at the store this tab resolved before they left, while sessionStorage
    // has since moved on. `pageshow` with `persisted` is the only signal for that
    // restore, so re-run the same resolution: it is a no-op ('none') when the store
    // on the page still matches what is remembered.
    // Namespaced so repeated initializeEvents() calls (pagination/refinement AJAX
    // callbacks) replace this binding instead of stacking another one — jQuery does
    // not dedupe anonymous handlers, and unlike `load` above, `pageshow` genuinely
    // re-fires on every bfcache restore.
    $(window).off('pageshow.clpStoreLoad').on('pageshow.clpStoreLoad', function(e) {
        var originalEvent = e.originalEvent || e;
        if (originalEvent && originalEvent.persisted) {
            runClpStoreLoad();
        }
    });

    //Classes Calendar View Events
    $main.on('click', '.class-print', function(e) {
        e.preventDefault();
        window.print();
    });

    $('.class-calendar .next-month').on('click', function(e) {
        e.preventDefault();
        var cgid = $('input[class="class-cgid"]').val();
        var storeID = $('input[class="class-storeid"]').val();
        // SLTBE-8287: empty + literal-string "null" both treated as no-store; previous fallback
        // misread cgid token from URL and injected it as bogus storeId, producing empty-state calendar.
        if (!storeID || storeID === 'null') {
            storeID = '';
        }

        var url = util.appendParamsToUrl(Urls.nextMonthCalendar, {
            'cgid': cgid,
            'storeId': storeID
        });
        var refinements = $('.refinslist select');
        var refinementName, refinementVal;
        var refinementObj = {};
        if (refinements.length > 0) {
            refinements.each(function() {
                refinementName = $(this).data('attributeid');
                refinementVal = $(this).val();
                if (refinementName && refinementName != '' && refinementVal && refinementVal != '') {
                    refinementObj[refinementName] = refinementVal;
                    url = util.appendParamsToUrl(url, refinementObj);
                }
            });
        }

        if (history.state && util.removeParamFromURL(history.state, 'monthCount') === url) {
            history.forward();
            // return;
        }
        progress.show($('.class-calendar'));

        ajax.load({
            url: url,
            target: $('.class-calendar'),
            callback: function() {
                var previousUrl = util.appendParamsToUrl(Urls.previousMonthCalendar, {
                    'cgid': cgid,
                    'storeId': storeID
                });
                if ($('.class-month-count') && $('.class-month-count').length > 0 && $('.class-month-count').val() != '') {
                    var monthCount = $('.class-month-count').val();
                    previousUrl = util.appendParamsToUrl(previousUrl, {
                        'monthCount': monthCount
                    });
                }
                if (history.state == null || history.state != url) {
                    history.pushState(previousUrl, '', window.location.href);
                }
                var formattedDate = $('input[class="class-formatted-date"]').val();
                var startDate = $('input[class="class-start-date"]').val();
                var endDate = $('input[class="class-end-date"]').val();
                $('input[class="formated-date"]').val(formattedDate);
                $('input[class="start-date"]').val(startDate);
                $('input[class="end-date"]').val(endDate);
                initializeEvents();
                progress.hide();
                var monthnameval = $('.class-month-name').val();
                var monthcount = $('.class-month-count').val();
                var orgURL = window.location.href;
                var monthvalinURL = orgURL.split('&month=')[1];
                var monthcountinURL = orgURL.split('&count=')[1];
                if (monthvalinURL != undefined){
                    if (monthvalinURL != '' && monthvalinURL != undefined){
                        orgURL = util.removeParamFromURL(orgURL,'month');
                    }
                }
                if (monthcountinURL != undefined){
                    if (monthcountinURL != '' && monthcountinURL != undefined){
                        orgURL = util.removeParamFromURL(orgURL,'count');
                    }
                }

                if (monthnameval != ''  && monthnameval != undefined){
                    orgURL = orgURL+'&month='+monthnameval;
                }
                if (monthcount != '' && monthcount != undefined){
                    orgURL = orgURL+'&count='+monthcount;
                }
                history.replaceState(history.state, '',orgURL);
            }
        });
    });


    $('.class-calendar .previous-month').on('click', function(e) {
        e.preventDefault();
        var cgid = $('input[class="class-cgid"]').val();
        var storeID = $('input[class="class-storeid"]').val();
        // SLTBE-8287: empty + literal-string "null" both treated as no-store; previous fallback
        // misread cgid token from URL and injected it as bogus storeId, producing empty-state calendar.
        if (!storeID || storeID === 'null') {
            storeID = '';
        }


        var url = util.appendParamsToUrl(Urls.previousMonthCalendar, {
            'cgid': cgid,
            'storeId': storeID
        });

        if (history.state && util.removeParamFromURL(history.state, 'monthCount') === url) {
            history.back();
          //  return;
        }

        var refinements = $('.refinslist select');
        var refinementName, refinementVal;
        var refinementObj = {};
        if (refinements.length > 0) {
            refinements.each(function() {
                refinementName = $(this).data('attributeid');
                refinementVal = $(this).val();
                if (refinementName && refinementName != '' && refinementVal && refinementVal != '') {
                    refinementObj[refinementName] = refinementVal;
                    url = util.appendParamsToUrl(url, refinementObj);
                }
            });
        }

        progress.show($('.class-calendar'));

        ajax.load({
            url: url,
            target: $('.class-calendar'),
            callback: function() {
                var nextUrl = util.appendParamsToUrl(Urls.nextMonthCalendar, {
                    'cgid': cgid,
                    'storeId': storeID
                });
                if ($('.class-month-count') && $('.class-month-count').length > 0 && $('.class-month-count').val() != '') {
                    var monthCount = $('.class-month-count').val();
                    nextUrl = util.appendParamsToUrl(nextUrl, {
                        'monthCount': monthCount
                    });
                }
                if (history.state == null || history.state != url) {
                    history.pushState(nextUrl, '', window.location.href);
                }
                var formattedDate = $('input[class="class-formatted-date"]').val();
                var startDate = $('input[class="class-start-date"]').val();
                var endDate = $('input[class="class-end-date"]').val();
                $('input[class="formated-date"]').val(formattedDate);
                $('input[class="start-date"]').val(startDate);
                $('input[class="end-date"]').val(endDate);
                initializeEvents();
                progress.hide();
                var monthnameval = $('.class-month-name').val();
                var monthcount = $('.class-month-count').val();
                var orgURL = window.location.href;
                var monthvalinURL = orgURL.split('&month=')[1];
                var monthcountinURL = orgURL.split('&count=')[1];
                if (monthvalinURL != undefined){
                    if (monthvalinURL != '' && monthvalinURL != undefined){
                        orgURL = util.removeParamFromURL(orgURL,'month');
                    }
                }
                if (monthcountinURL != undefined){
                    if (monthcountinURL != '' && monthcountinURL != undefined){
                        orgURL = util.removeParamFromURL(orgURL,'count');
                    }
                }
                if (monthnameval != ''  && monthnameval != undefined){
                    orgURL = orgURL+'&month='+monthnameval;
                }
                if (monthcount != '' && monthcount != undefined){
                    orgURL = orgURL+'&count='+monthcount;
                }
                history.replaceState(history.state, '',orgURL);
            }
        });
    });

    var calendarStartDate = $('input[class="calendar-start-date"]').val();
    var calendarEndDate = $('input[class="calendar-end-date"]').val();
    if (calendarStartDate != undefined && calendarStartDate != 'null' && calendarEndDate != undefined && calendarEndDate != 'null') {
        $('.startdate').val(calendarStartDate);
        $('.enddate').val(calendarEndDate);
    }
    dropDownEllipse();
}
window.updateSeatAvailability = updateSeatAvailability;
exports.init = function() {
    compareWidget.init();
    var $videoContainer = $('<div/>').attr('id', 'VideoViewDialog').attr('class', 'video-view').appendTo(document.body);
    $('div.cms-section-main div#videos-container div.video a').click(function(e) {
        e.preventDefault();
        var videoUrl = $(this).attr('href');
        var videoFrame = '<iframe src="' + videoUrl + '" width="100%" height="100%" frameborder="0" allow="autoplay;"></iframe>';
        $videoContainer.html(videoFrame).dialog({
            dialogClass: 'video-container'
        });
        $('.video-container').css({
            'width': $(window).width(),
            'height': $(window).height(),
            'left': '0px',
            'top': '0px'
        });
        $('.video-container iframe').css({
            'height': $(window).height() - 100
        });
    });
    $(document).on('click', '.video-container .ui-dialog-titlebar-close', function() {
        var src = $(this).closest('.video-container').find('iframe').attr('src');
        $(this).closest('.video-container').find('iframe').attr('src', src);
    });
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $(window).on('scroll', infiniteScroll);
    }
    productTile.init();
    categorySync();
    refinementsSync();
    //Initialize category landing  Product section
    var $defaulValuesClp = {
        infinite: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 4
    };
    var $responsiveClp = {
        dots: true,
        infinite: true
    };
    slickSlider.init('.clpSlickSlider', $defaulValuesClp, $responsiveClp);

    //Initialize Brand landing  Product section

    var $defaulValues = {
        infinite: true,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 5
    };
    var $responsive = {
        dots: true,
        infinite: true
    };
    slickSlider.init('.globalSlickSlider', $defaulValues, $responsive);
    slickSlider.init('.no-hits-SlickSlider', $defaulValues, $responsive);
    $('.text-ellipsis').ellipsis();
    initializeEvents();

    resetClassFilter();
    updatedSelectedSortingList();
    updatedSelectedPageSize();
    $(document).ready(function() {
        var classTab = $('.classes-tablabel');
        if (classTab && classTab.hasClass('selected')) {
            classTab.click();
        } else {
            var recipeTab = $('.recipe-tablabel');
            var isRecipe = $('#isRecipe').val();
            if (recipeTab && (isRecipe === 'true' || recipeTab.hasClass('selected'))) {
                recipeTab.click();
            } else {
                var productType = util.getURLRefinementValue(location.href, 'productType');
                if (productType !== 'HardGood') {
                    var $tab = getTabLabelFromProductTypeFromUrl(location.href);
                    if ($tab.length > 0) {
                        $tab.addClass('selected');
                        $tab.click();
                    }
                }
            }
        }
        updatedSelectedSortingList();
        updatedSelectedPageSize();
    });

    compareProducts.init();
};

$(document).on('click', '.refinements .refinement ul li a,.clear-applyBtn', function() {
    $(window).scrollTop($('.breadcrumb').offset().top -142);
})

$(document).on('click','.next-month,.previous-month', function() {
    $(window).scrollTop($('.month-rotate').offset().top -117);
})

},{"../ajax":2,"../compare-products":7,"../compare-widget":8,"../gtm":18,"../product-tile":57,"../progress":59,"../radar":62,"../slickSlider":67,"../storeinventory/classStoreFinder":70,"../storeinventory/classStorePreference":71,"../storeinventory/clpStoreLoadResolver":73,"../util":78,"imagesloaded":93}],53:[function(require,module,exports){
'use strict';

var producttile = require('../product-tile');
var slickSlider = require('../slickSlider');
var ajax = require('../ajax');


exports.init = function() {

    $('.trigger-load').each(function() {
        $(this).nextAll().slice(0, 3).hide();
    });

    function sltlazyload() {
        var fixheight = 558;
        var wt = $(window).scrollTop() + fixheight;
        $('.trigger-load').each(function() {
            //* top of object (i.e. slot div)
            var ot = $(this).offset().top - 160;
            if (wt >= ot) {
                $(this).nextAll().slice(0, 3).fadeIn('slow');
            }
        });
    }

    $(window).scroll(function() {
        sltlazyload();
    })

    $('body').on('click', '.giftcard-checkbalance', function(e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var url = form.attr('action');
        var giftcardNumberval = $('input[name*="giftcard_cardnumber"]').val();
        var PinNumberval = $('input[name*="giftcard_pin"]').val();
        $('.giftcard-balance-field-pinerror').hide();
        $('.giftcard-balance-fielderror').hide();
        $('.giftcard-balance-pinerror').hide();
        if ((giftcardNumberval == '' || giftcardNumberval == undefined) && (PinNumberval == '' || PinNumberval == undefined)) {
            $('.giftcard-balance-field-pinerror').show();
            return;
        } else if (giftcardNumberval == '' || giftcardNumberval == undefined) {
            $('.giftcard-balance-fielderror').show();
            return;
        } else if (PinNumberval == '' || PinNumberval == undefined) {
            $('.giftcard-balance-pinerror').show();
            return;
        }

        if (form.find('input[name$="giftcard_cardnumber"]').val() == '' || form.find('input[name$="giftcard_pin"]').val() == '') {
            $('.giftcard-balance-results').hide();
            $('.giftcard-balance-error').addClass('error');
            return;
        }
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
        form.validate();
        if (!form.valid()) {
            return;
        }
        if ($('#custom-gift-recaptcha-response').length > 0) {
            var siteKey = $('#custom-gift-recaptcha-response').data('sitekey');
            var action = $('#custom-gift-recaptcha-response').data('action') || '';
            if (siteKey && siteKey != '') {
                window.grecaptcha.ready(function() {
                    window.grecaptcha.execute(siteKey, {
                        action: action
                    }).then(function(token) {
                        $('#custom-gift-recaptcha-response').val(token);
                        ajax.load({
                            url: url,
                            method: 'POST',
                            data: form.serialize(),
                            callback: function(data) {
                                $('.giftcard-balance-error').removeClass('error');
                                $('.giftcard-recaptcha-error').removeClass('error');
                                var responseVal = $(data).filter('input[name="balance-found"]').val();
                                if (responseVal === 'true') {
                                    $('.giftcard-balance-results').html(data);
                                    $('.giftcard-balance-results').show();
                                } else {
                                    var recaptchaMessage = $(data).filter('input[name="recaptchaErrorResponse"]').val();
                                    if (recaptchaMessage && recaptchaMessage != 'null') {
                                        $('.giftcard-recaptcha-error').empty().append(recaptchaMessage);
                                        $('.giftcard-balance-results').hide();
                                        $('.giftcard-recaptcha-error').addClass('error');
                                    } else {
                                        $('.giftcard-balance-results').hide();
                                        $('.giftcard-balance-error').addClass('error');
                                    }
                                }
                            }
                        });
                    });
                });
            } else {
                return false;
            }
        } else {
            ajax.load({
                url: url,
                method: 'POST',
                data: form.serialize(),
                callback: function(data) {
                    var responseVal = $(data).filter('input[name="balance-found"]').val();
                    if (responseVal === 'true') {
                        $('.giftcard-balance-results').html(data);
                        $('.giftcard-balance-results').show();
                        $('.giftcard-balance-error').removeClass('error');
                    } else {
                        $('.giftcard-balance-results').hide();
                        $('.giftcard-balance-error').addClass('error');
                    }
                }
            });
        }
    });

    // Initialize quick view in homepagefeatureprduct section
    producttile.init();

    //Initialize Home-Page Featured Product section
    var $defaulValues = {};
    var $responsive = {
        dots: true,
        draggable: true,
        infinite: true
    };
    slickSlider.init('.homepage-feature-product-listing-3x2', $defaulValues, $responsive);
    $('.text-ellipsis').ellipsis();
};

},{"../ajax":2,"../product-tile":57,"../slickSlider":67}],54:[function(require,module,exports){
'use strict';
var dialog = require('../dialog');
var ajax = require('../ajax');
var slickSlider = require('../slickSlider');

exports.init = function () {
    $('.store-details-link').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });
    
    $(document).off('click', '.browse-heading span.heading-icon').on('click', '.browse-heading span.heading-icon', function (e) {
        e.preventDefault();
        $('.browse-head-sec').toggleClass('active');
        if ($(this).hasClass('active')) {
            $('.browse-heading span.heading-icon').removeClass('active');
            $('.browse-bystate .class-heading').addClass('hide');
            $('.browse-bystate .browse-result').addClass('hide');
            return;
        } else {
            $('.browse-heading span.heading-icon').addClass('active');
            $('.browse-bystate .class-heading').removeClass('hide');
            $('.browse-bystate .browse-result').removeClass('hide');
            return;
        }
    });
    
    $(document).off('click', '.view-allstores').on('click', '.view-allstores', function(e) { 
        e.preventDefault();
       
        if ($('.browse-heading span.heading-icon').hasClass('active')) {
            $('html, body').animate({
                scrollTop: $('.browse-bystate').offset().top
            }, 1000);
            return;
        }
        if ($('.browse-bystate .browse-result').hasClass('active')) {
            $('.browse-heading span.heading-icon').addClass('active');
            $('.browse-bystate .class-heading').removeClass('hide');
            $('.browse-bystate .browse-result').removeClass('hide');
            $('html, body').animate({
                scrollTop: $('.browse-bystate').offset().top
            }, 1000);
            return;
        } else {
            var url = Urls.storesByState;
            ajax.load({
                url: url, 
                type: 'GET',
                callback: function (data) {
                    $('.browse-heading span.heading-icon').addClass('active');
                    $('.browse-bystate .class-heading').removeClass('hide');
                    $('.browse-bystate .browse-result').removeClass('hide');
                    $('.browse-bystate .browse-result').addClass('active');
                    $('.browse-bystate .allstores-bystate').html(data);
                    $('html, body').animate({
                        scrollTop: $('.browse-bystate').offset().top
                    }, 2000);
                }
            });
        }
    });
    
    $(document).off('change', 'input[name$="storelocator_cookingClass"]').on('change', 'input[name$="storelocator_cookingClass"]', function(e) { 
        e.preventDefault();
        var searchString = $('input[name="SearchString"]').val();
        if (searchString == '') {
            return;
        }
        $('button[name$="storelocator_findcookingclass"]').trigger('click');
    });
    
    $(document).off('click', 'button[name$="_storelocator_findbyrawstring"]').on('click', 'button[name$="_storelocator_findbyrawstring"]', function(e) { 
        var searchString = $('input[name$="_storelocator_rawString"]').val();
        if (searchString == '') {
            e.preventDefault();
            return;
        }

    });
    
    /* "storeMap" is a global function that will be passed as callback function for google maps API. See below
     * <script src="//maps.googleapis.com/maps/api/js?callback=storeMap" async defer></script> 
     */
    window.storeMap = function() {

        //Create map
        var mapCanvas = document.getElementById('map');
        var mapOptions = {
            center: new google.maps.LatLng(37.09024, -95.712891),
            zoom: 10,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        var map = new google.maps.Map(mapCanvas, mapOptions);

        var stores = $('.storeJSON').data('storejson'),
            markers = [],
            bounds = new google.maps.LatLngBounds(),
            store, marker, storeCenter, markerContent, mapLink,
            storeName, storePhone, storAddress1, storeCity, storeStateCode, storePostalCode, storeEmail, storeCountryCode;

        //Create markers and info window and add them to map.
        var tempIndex = 0;
        if (stores.length > 0) {
            for (var index in stores) {
                store = stores[index];
                if (!store.latitude || !store.longitude) {
                    continue;
                }
                storeCenter = new google.maps.LatLng(store.latitude.toFixed(6), store.longitude.toFixed(6));
                storeName = store.name ? store.name : '';
                storePhone = store.phone ? store.phone : '';
                storAddress1 = store.address1 ? store.address1 : '';
                storeCity = store.city ? store.city : '';
                storeStateCode = store.stateCode ? store.stateCode : '';
                storePostalCode = store.postalCode ? store.postalCode : '';
                storeEmail = store.email ? store.email : '';
                storeCountryCode = store.countryCode ? store.countryCode : '';

                mapLink = 'http://maps.google.com/maps?hl=en&f=q&q=' +
                    storAddress1 +
                    ',' + storeCity +
                    ',' + storeStateCode +
                    ',' + storePostalCode +
                    ',' + storeCountryCode;

                markerContent = '<div class="store-infowindow">' +
                    '<h2>' + storeName + '</h2>' +
                    '<p>' + storAddress1 + '<br/>' + storeCity + ',' + storeStateCode + storePostalCode + '</p>' +
                    '<div class="storephone">' + storePhone + '<br/>' + storeEmail + '</div>' +
                    '<div class="storemap"><a class="googlemap" href="' + mapLink + '" target="_blank">View on larger map</a></div>' + '</div>';
                
                var MapPinIcon = Urls.GOOGLEMAPMARKERURL;
                tempIndex = tempIndex + 1;
                marker = new google.maps.Marker({
                    position: storeCenter,
                    title: store.name,
                    content: markerContent,
                    icon: MapPinIcon,
                    label: {
                        text: '' + tempIndex + '',
                        color: '#fff'
                    }
                });

                bounds.extend(storeCenter);
                marker.setMap(map);
                markers.push(marker);
            }

            var infowindow = new google.maps.InfoWindow({
                content: ''
            });

            for (var i = 0; i < markers.length; i++) {
                marker = markers[i];
                marker.index = i;
                google.maps.event.addListener(marker, 'click', function() {
                    infowindow.setContent(this.content);
                    map.setZoom(9);
                    infowindow.open(map, this);
                });
            }
        }

        map.fitBounds(bounds);

        $('.store-click').each(function(i) {
            jQuery(this).bind('click', function(e) {
                e.preventDefault();
                google.maps.event.trigger(markers[i], 'click');
            });
        });
        $('.store-pin-click').each(function(i) {
            jQuery(this).bind('click', function(e) {
                e.preventDefault();
                google.maps.event.trigger(markers[i], 'click');
            });
        });
    }
    var $defaulValues = {
        infinite: true,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 5
    };
    var $responsive = {
        dots: true,
        infinite: true
    };
    slickSlider.init('.globalSlickSlider', $defaulValues, $responsive);    
};

},{"../ajax":2,"../dialog":13,"../slickSlider":67}],55:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    page = require('../page'),
    login = require('../login'),
    util = require('../util');

exports.init = function() {
    addProductToCart();
    $('#editAddress').on('change', function() {
        page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
    });
    
    //add js logic to remove the , from the qty feild to pass regex expression on client side
    $('.option-quantity-desired input').on('focusout', function() {
        $(this).val($(this).val().replace(',', ''));
    });

    login.init();
    
    //logic to handle Qty field in wishlist page
    $('input.wishlist-qty').on('change keyup', function() {
        var qty = parseInt($(this).closest('.option-add-to-cart').find('.wishlist-qty').val(),0);
        var key = event.which || event.keyCode || event.charCode;
        if (key == 8 && isNaN(qty)) {
            return;
        }
        var pdtATS = parseInt($(this).closest('.option-add-to-cart').find('input[class="productATS"]').val(),0);

        if (pdtATS <= 0) {
            $(this).closest('.option-add-to-cart').find('.wishlist-qty').val(1);
            $(this).closest('form').find('.quantityerr').show();
            $(this).closest('form').find('span.cart-dynamic-availability').text(pdtATS +' ');
            $(this).closest('form').find('button.wishlis-add-to-cart').attr('disabled', 'disabled');
        } else if (qty == 1 || qty < 1 || isNaN(qty)) {
            if (pdtATS >= 1) {
                $(this).closest('.option-add-to-cart').find('.quantityerr').hide();
                $(this).closest('.option-add-to-cart').find('button.wishlis-add-to-cart').removeAttr('disabled');
            } else {
                $(this).closest('.option-add-to-cart').find('.quantityerr').show();
                $(this).closest('.option-add-to-cart').find('span.cart-dynamic-availability').text(pdtATS +' ');
                $(this).closest('.option-add-to-cart').find('button.wishlis-add-to-cart').attr('disabled', 'disabled');
            }
        } else if (qty > pdtATS) {
            $(this).closest('.option-add-to-cart').find('.quantityerr').show();
            $(this).closest('.option-add-to-cart').find('span.cart-dynamic-availability').text(pdtATS +' ');
            $(this).closest('.option-add-to-cart').find('button.wishlis-add-to-cart').attr('disabled', 'disabled');
        } else {
            $(this).closest('.option-add-to-cart').find('.quantityerr').hide();
            $(this).closest('.option-add-to-cart').find('button.wishlis-add-to-cart').removeAttr('disabled');
        }
    });
    $('body').on('keydown','input.wishlist-qty', function(e) {
        if ((90 >= e.which && e.which >= 65) || (111 >= e.which && e.which >= 107) || (192 >= e.which && e.which >= 186) || e.which==16 || (222 >= e.which && e.which >= 219) || (41 >= e.which && e.which >= 33)) {
            e.preventDefault();
        }
    });
    // Handling up and down buttons in wishlist page
    $('div.wishlist-products .next-value').on('click', function() {
        $(this).addClass('active');
        var qty = $(this).closest('.quantity-box').find('.qty_value').val();
        var pdtATS = parseInt($(this).closest('form').find('input[class="productATS"]').val(),0);
        qty = parseInt(qty,0);
        var newqty = qty + 1;

        if (newqty > pdtATS) {
            $(this).closest('form').find('.quantityerr').show();
            $(this).closest('form').find('span.cart-dynamic-availability').text(pdtATS +' ');
            $(this).closest('form').find('button.update-item').attr('disabled', 'disabled');
            $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.prev-value').addClass('active');
        } else {
            $(this).closest('form').find('button.update-item').removeAttr('disabled');
            $(this).closest('.quantity-box').find('.qty_value').val(newqty);
            $(this).closest('form').find('.quantityerr').hide();
            $(this).closest('.quantity-box').find('.next-value').addClass('active');
        }
    });
    $('div.wishlist-products .prev-value').on('click', function() {
        var qty = $(this).closest('.quantity-box').find('.qty_value').val();
        var pdtATS = parseInt($(this).closest('form').find('input[class="productATS"]').val(),0);
        qty = parseInt(qty,0);
        var newqty = qty - 1;

        if (pdtATS <= 0) {
            $(this).closest('.quantity-box').find('.qty_value').val(1);
            $(this).closest('form').find('.quantityerr').show();
            $(this).closest('form').find('span.cart-dynamic-availability').text(pdtATS +' ');
            $(this).closest('form').find('button.update-item').attr('disabled', 'disabled');
            $(this).closest('.quantity-box').find('.prev-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
        } else if (newqty < 1) {
            $(this).removeClass('active');
            $(this).closest('.quantity-box').find('.qty_value').val(1);
            $(this).closest('.quantity-box').find('.prev-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.next-value').addClass('active');
        } else if (newqty <= pdtATS) {
            if (newqty == pdtATS) {
                $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
                $(this).closest('.quantity-box').find('.prev-value').addClass('active');
            } else {
                $(this).closest('.quantity-box').find('.next-value').addClass('active');
                $(this).closest('.quantity-box').find('.prev-value').addClass('active');
            }
            $(this).closest('.quantity-box').find('.qty_value').val(newqty);
            $(this).closest('form').find('.quantityerr').hide();
            $(this).closest('form').find('button.update-item').removeAttr('disabled');
        } else if (newqty > pdtATS) {
            $(this).closest('.quantity-box').find('.qty_value').val(newqty);
            $(this).closest('form').find('.quantityerr').show();
            $(this).closest('form').find('span.cart-dynamic-availability').text(pdtATS +' ');
            $(this).closest('form').find('button.update-item').attr('disabled', 'disabled');
            $(this).closest('.quantity-box').find('.next-value.active').removeClass('active');
            $(this).closest('.quantity-box').find('.prev-value').addClass('active');
        }
    });

};

},{"../login":20,"../page":22,"../util":78,"./product/addToCart":36}],56:[function(require,module,exports){
'use strict';

var _ = require('lodash');
var dialog = require('./dialog');
const freeShipping = require('./pages/checkout/freeShipping')
var util = require('./util');

var timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

var buildGiftCardPriceContainer = function(dialogContainer) {
    var price = $('.giftcard-custom-amount input').val();
    var priceContainer = dialogContainer.find('.item:not(.item-extend) .regular-price');
    
    if (!priceContainer.length) {
        priceContainer = dialogContainer.find('.item:not(.item-extend) .cart-item-info.cart-item-info-price');
        priceContainer.addClass('regular-price');
    }

    var html = $('<span>').addClass('label').text(Resources.GLOBAL_PRICE)[0].outerHTML 
                    + ':'
                    + $('<span>').addClass('price').text(price)[0].outerHTML;
    priceContainer.html(html);
};

var handleClassAttendees = function(dialogContainer) {
    var isClass = $('input[name=isClass]').val() === 'true';

    if (!isClass) {
        return;
    }

    /**
     * Attendees
     */
    var attendeesContainer = dialogContainer.find('.details.attendees');
    var attendees = $('.attendee-input:not(input[type=checkbox]).firstname,.lastname');

    attendeesContainer.empty();

    for (var i = 0; i < attendees.length; i += 2) {
        var atendeeContainer = $('<div>').addClass('atendee').appendTo(attendeesContainer);

        $('<div>')
            .addClass('atendee-label')
            .text(Resources.GLOBAL_ATTENDEE + ' #' + attendeesContainer.children().length)
            .appendTo(atendeeContainer);

        var name = attendees[i].value + ' ' + attendees[i + 1].value;
        $('<div>')
            .addClass('atendee-name')
            .text(name)
            .appendTo(atendeeContainer);
    }
};

var handleGiftCard = function (dialogContainer) {
    var isEletronicGiftCard = $('input[name=electronic]').val() === 'true';
    var isPhysicalGiftCard = $('input[name=physical]').val() === 'true';

    if (!isEletronicGiftCard && !isPhysicalGiftCard) {
        return;
    }

    /**
     * Price
    */
    buildGiftCardPriceContainer(dialogContainer);

    /**
     * Message
     */
    var message = $('textarea[id$=giftcard_giftMessage]').val().replace(/\n/g, '<br>');
    if (message.length > 0) {
        dialogContainer.find('#cart-message-value').html(message);
        dialogContainer.find('#cart-message-value').parent().removeClass('hidden');
    } else {
        dialogContainer.find('#cart-message-value').parent().addClass('hidden');
    }
};

var handleExtendWarranty = function(dialogContainer, quantity, extendPlan) {
    var extendContainer = dialogContainer.find('div.item.item-extend');

    /**
     * Extend Warranty
     */
    if (!extendPlan) {
        extendContainer.addClass('hidden');
        return;
    }

    var extendSku = util.getExtendProductId(extendPlan.term, false);

    /**
     * Extend Name
     */
    var extendName = $(String.format('input[name={0}-name]', extendSku)).val();
    extendContainer.find('#cart-name-extend').html(extendName);

    /**
     * Extend Image
     */
    var extendImageSrc = $(String.format('input[name={0}-image-url]', extendSku)).val();
    extendContainer.find('#cart-image-extend').attr('src', extendImageSrc);
    extendContainer.find('#cart-image-extend').attr('alt', extendSku);
    extendContainer.find('#cart-image-extend').attr('title', extendSku);

    /**
     * Extend SKU
     */
    extendContainer.find('#cart-sku-extend-value').text(extendSku);

    /**
     * Extend Quantity
     *
     * The extend quantity added to cart its the same as the quantity of the product.
     */
    extendContainer.find('#cart-quantity-extend-value').text(quantity);

    dialogContainer.find('#cart-title-quantity').text(quantity * 2);

    /**
     * Extend Price
     *
     * The extend price added to cart its the same as the selected warranty price.
     */
    extendContainer.find('#cart-price-extend-value').text('$' + (extendPlan.price / 100).toFixed(2));

    extendContainer.removeClass('hidden');
};

var handleSubtotal = function(dialogContainer) {
    var cartQty = parseInt($('input[type=hidden][name=cartQty]').val(), 10);
    var cartTotal = parseFloat($('input[type=hidden][name=cartTotal]').val().replace(/[^\d.-]/g, '')).toFixed(2);
    var cartTotalShipmentQty = parseInt($('input[type=hidden][name=cartTotalShipmentQty]').val(), 10);
    var subtotal = String.format(Resources.BAG_SUBTOTAL, cartQty, '$' + cartTotal);

    dialogContainer.find('#cart-subtotal').text(subtotal);


    // If there is no item to ship, hide the processbar.
    if (cartTotalShipmentQty <= 0) {
        dialogContainer.find('#processbar-container').addClass('hidden');
        return;
    }
    
    const percentComplete = parseFloat($('input[type=hidden][name=percentComplete]').val());
    const thresoldShippingAmount = parseFloat($('input[type=hidden][name=thresoldShippingAmount]').val());
    const cartNeededForFreeShipping = parseFloat($('input[type=hidden][name=cartNeededForFreeShipping]').val());
    freeShipping.update(percentComplete, thresoldShippingAmount, cartNeededForFreeShipping);
};

var addedToCart = {

    init: function () {
        if (!this.exists()) {
            this.$container = $('<div/>').attr('id', 'added-to-cart-dialog').appendTo(document.body);
        }
    },

    show: function (options) {
        this.init();

        var isClass = $('input[name=isClass]').val() === 'true';

        var dialogContainer = $('div.added-to-cart-container-hidden');

        /**
         * Quantity
         *
         * Eletronic Gift Card does not have quantity, so it is always 1.
         * For classes, we always consider a single class but with, possibly, multiple attendees.
         */
        var quantity = $('#Quantity').val() || 1;
        dialogContainer.find('#cart-title-quantity').text(isClass ? 1 : quantity);
        dialogContainer.find('#cart-quantity-value').text(quantity);

        handleGiftCard(dialogContainer);

        handleClassAttendees(dialogContainer);

        handleExtendWarranty(dialogContainer, quantity, options.extendPlan);

        handleSubtotal(dialogContainer);

        var html = dialogContainer.html();

        var width = window.innerWidth > 768 ? 588 : '100%';
        var height = window.innerWidth > 1024 ? Math.min(window.innerHeight, 800) : window.innerWidth > 768 ? Math.min(window.innerHeight, 660) : window.innerHeight;
        var onWindowResize = _.throttle(function() {
            setTimeout(() => {
                var width = window.innerWidth > 768 ? 588 : '100%';
                var height = window.innerWidth > 1024 ? Math.min(window.innerHeight, 800) : window.innerWidth > 768 ? Math.min(window.innerHeight, 660) : window.innerHeight;
                dialog.option('width', width);
                dialog.option('height', height);
            }, 0);
        }.bind(this), 500);
        $(window).on('resize', onWindowResize);
        $('.ui-dialog.added-to-cart-container').removeClass('dialog-updated');
        dialog.open({
            target: this.$container,
            html: html,
            options: {
                width: width,
                height: height,
                title: '',
                dialogClass: 'added-to-cart-container',
                draggable: false,
                open: function () {
                    if (window.innerWidth > 1023) {
                        addedToCart.showPopUp(options.extendPlan);
                    }
                    this.$container.animate({
                        scrollTop: 0
                    }, 100);
                    this.$container.find('#added-to-cart-dialog').animate({
                        scrollTop: 0
                    }, 100);
                    this.$container.find('.added-to-cart-container__content').animate({
                        scrollTop: 0
                    }, 100);
                    this.$container.find('#cart-continue-shoppin').off('click').on('click', function() {
                        dialog.close();
                    });
                    $('body').addClass('disable-scroll');
                    var $defaulValuesClp = {
                        adaptiveHeight: true,
                        infinite: true,
                        arrows: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 1023,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    };
                    this.$container.find('.atc-recommendations .search-result-items').not('.slick-initialized').slick($defaulValuesClp);
                }.bind(this),
                close: function () {
                    $(window).off('resize', onWindowResize);
                    $('body').removeClass('disable-scroll');
                    var addToCartButton = $('#add-to-cart');
                    var addToCartButtonText = addToCartButton.text();
                    addToCartButton.text('');
                    addToCartButton.addClass('item-added-to-cart');

                    if (window.innerWidth <= 1023) {
                        addedToCart.showPopUp(options.extendPlan);
                    }

                    timer.clear();
                    timer.start(3000, function() {
                        addedToCart.$popUp.slideUp(1000);

                        addToCartButton.removeClass('item-added-to-cart');
                        addToCartButton.text(addToCartButtonText);
                    });
                }.bind(this)
            }
        });
        this.$container.parent().find('.ui-dialog-titlebar-close').attr('data-testid', 'cart-modal-close-button');
    },

    exists: function () {
        return this.$container && (this.$container.length > 0);
    },

    showPopUp: function(extendPlan) {
        var popUpParrent = $(window.innerWidth >= 1024 ? '.mini-cart-total' : '.header-main');
        this.$popUp = $('.pdp-add-to-cart-pop-up').clone();
        this.$popUp.removeClass('hidden');

        popUpParrent.find('.pdp-add-to-cart-pop-up').remove();
        popUpParrent.append(this.$popUp);

        // Eletronic Gift Card does not have quantity, so it is always 1.
        // For classes, we always consider a single class but with, possibly, multiple attendees.
        var isClass = $('input[name=isClass]').val() === 'true';
        var quantity = isClass ? 1 : $('#Quantity').val() || 1;
        // If it has Extend Warranty, the qty is the product qty + extend qty which is the same as the product.
        if (extendPlan) {
            quantity *= 2;
        }
        this.$popUp.find('.message').text(quantity + ' ' + Resources.MINICART_ADDED_TO_BAG);

        this.$popUp.slideDown('slow');
    }

};

module.exports = addedToCart;

},{"./dialog":13,"./pages/checkout/freeShipping":30,"./util":78,"lodash":94}],57:[function(require,module,exports){
'use strict';

var imagesLoaded = require('imagesloaded'),
    quickview = require('./quickview');

function initQuickViewButtons() {
    $('.tiles-container:not(.recipetile) .product-image').on('mouseenter', function () {
        var $link = $(this).find('.thumb-link');
        var sfccProductUrl = $link.data('quickviewurl');
        var quickviewId = Math.random().toString(36).substring(7);
        var newId = 'quickviewbutton' + quickviewId;
        var $qvButton = $('#' + newId);
        if ($qvButton.length === 0) {
            $qvButton = $('<a id="' + newId + '" class="quickview">' + Resources.QUICK_VIEW + '</a>');
        }


        $qvButton.attr({
            'href': sfccProductUrl,
            'title': $link.attr('title')
        }).appendTo(this);

        $qvButton.on('click', function (e) {
            e.preventDefault();
            quickview.showproduct({
                url: sfccProductUrl,
                source: 'quickview'
            });
        });
    });
}

function gridViewToggle() {
    $('.toggle-grid').on('click', function () {
        $('.search-result-content').toggleClass('wide-tiles');
        $(this).toggleClass('wide');
    });
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
    initQuickViewButtons();
    gridViewToggle();
    $('.swatch-list').on('mouseleave', function () {
        // Restore current thumb image
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $thumb.data('current');

        if (data) {
            $thumb.attr({
                src: data.src,
                alt: data.alt,
                title: data.title
            });
        }
    });
    $('.swatch-list .swatch').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('selected')) { return; }

        var $tile = $(this).closest('.product-tile');
        $(this).closest('.swatch-list').find('.swatch.selected').removeClass('selected');
        $(this).addClass('selected');
        $tile.find('.thumb-link').attr('href', $(this).attr('href'));
        $tile.find('.name-link').attr('href', $(this).attr('href'));
        $tile.find('.thumb-link').data('pwaurl', $(this).data('pwaurl'));
        $tile.find('.name-link').data('pwaurl', $(this).data('pwaurl'));

        var data = $(this).children('img, .swatch-hex').filter(':first').data('thumb');
        var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
        var currentAttrs = {
            src: data.src,
            alt: data.alt,
            title: data.title
        };
        $thumb.attr(currentAttrs);
        $thumb.data('current', currentAttrs);
    }).on('mouseenter', function () {
        // get current thumb details
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img, .product-image .thumb-link .swatch-hex').eq(0),
            data = $(this).children('img, .swatch-hex').filter(':first').data('thumb'),
            current = $thumb.data('current');

        // If this is the first time, then record the current img
        if (!current) {
            $thumb.data('current', {
                src: $thumb[0].src,
                alt: $thumb[0].alt,
                title: $thumb[0].title
            });
        }

        // Set the tile image to the values provided on the swatch data attributes
        if (data) {
            $thumb.attr({
                src: data.src,
                alt: data.alt,
                title: data.title
            });
        }
    });

    $('.show-more span').click(function() {
        var elem = $('.show-more span').text();
        if (elem == 'Show More') {
            $('.show-more span').text('Show Less');
            $('.show-more span').css('border-bottom', '1px solid #D5D5D5');
            $('.para-text').addClass('para-more-text');
        } else {
            $('.show-more span').text('Show More');
            $('.show-more span').css('border-bottom', '1px solid #D5D5D5');
            $('.para-text').removeClass('para-more-text');
        }
    });

    $('.more-link').on('click', function() {
        $(this).closest('.blp-alpha-mrg-bottom').find('.more-hidden-text').removeClass('more-hidden-text');
        $(this).hide();
    })
    $('.more-link-mobile').on('click', function() {
        $(this).closest('.blp-alpha-mrg-bottom').find('.blp-alpha-left-mrg').removeClass('blp-alpha-left-mrg');
        $(this).hide();
    })
}

exports.init = function () {
    var $tiles = $('.tiles-container .product-tile');
    if ($tiles.length === 0) { return; }

    if ($('body').find('.category-product-slots').length > 0) {
        $('.category-product-slots').insertAfter('.breadcrumb');
        $('.calloutMsg').insertAfter('.search-result-options');
        if ($('.category-products-hits-banner-one').find('.html-slot-container').length > 0) {
            $('.category-products-hits-banner-one').insertBefore('.header-category');
        }
    }
    if ($('.shop-by-category').length > 0) {
        $('.classes-slot-image-width-noslider').not('.slick-initialized').slick({
            dots: false,
            infinite: false,
            slidesToShow: 7.21,
            slidesToScroll: 1,
            initialSlide:0,
            cssEase: 'linear',
            variableWidth: false,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: false,
                        infinite:false
                    }
                }
            ]
        });
    }
    var updateCategoryList = setInterval(function () {
        var categoryHeight = Math.round($('.shop-by-category').height());
        if (categoryHeight == 68 || categoryHeight == 42) {
            if ($('.classes-slot-image-width-noslider').hasClass('slick-initialized')) {
                $('.classes-slot-image-width-noslider').slick('refresh');
            }
            $('.shop-by-category').removeClass('hide-category-list');
            clearInterval(updateCategoryList);
        }
    }, 50);
    var $shopProd = $('.category-product-slots .classes-slot-image-width-noslider .classes-slot-image');
    if ($shopProd.length > 0) {
        imagesLoaded('.category-product-slots').on('done', function () {
            $shopProd.syncHeight();
        });
    }
    initializeEvents();
};

},{"./quickview":61,"imagesloaded":93}],58:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    _ = require('lodash'),
    imagesLoaded = require('imagesloaded');

var dialog = {
    /**
     * This file is same as dialog.js (SURI-235)
     */
    create: function (params) {
        var $target, id;

        if (_.isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
            } else {
                $target = $('#' + params.target);
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else {
            $target = $('#dialog-container');
        }

        // if no element found, create one
        if ($target.length === 0) {
            if ($target.selector && $target.selector.charAt(0) === '#') {
                id = $target.selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(_.merge({}, this.settings, params.options || {}));
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function (params) {
        // close any open dialog except during product QV because we have handle BOPIS in QV
        //this.close();
        this.create(params);
        this.replace(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params) {
        var content, position, callback;

        if (!this.$container) { return; }
        content = params.content || params.html;
        if (!content) { return; }
        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }
        if (!position) {
            position = this.settings.position;
        }
        imagesLoaded(this.$container).on('done', function () {
            this.$container.dialog('option', 'position', position);
        }.bind(this));

        callback = (typeof params.callback === 'function') ? params.callback : function () {};
        callback();
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function (response) {
                    params.content = response;
                    this.openWithContent(params);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function () {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        resizable: false,
        title: '',
        width: '800',
        close: function () {
            $(this).dialog('close');
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

module.exports = dialog;

},{"./ajax":2,"./util":78,"imagesloaded":93,"lodash":94}],59:[function(require,module,exports){
'use strict';

var $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var show = function (container) {
    var target = (!container || $(container).length === 0) ? $('body') : $(container);
    $loader = $loader || $('.loader');

    if ($loader.length === 0) {
        $loader = $('<div/>').addClass('loader')
            .append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
    }
    return $loader.appendTo(target).show();
};
/**
 * @function
 * @description Hides an AJAX-loader
 */
var hide = function () {
    if ($loader) {
        $loader.hide();
    }
};

exports.show = show;
exports.hide = hide;

},{}],60:[function(require,module,exports){
'use strict';

var initialized = false;

/**
 * Validates that a URL is safe to use (prevents XSS via javascript: or data: URLs)
 * @param {string} url - The URL to validate
 * @returns {boolean} True if URL is safe to use
 */
function isValidUrl(url) {
    if (!url || typeof url !== 'string') return false;

    // Trim whitespace
    var trimmedUrl = url.trim();

    // Allow relative URLs starting with /
    if (trimmedUrl.indexOf('/') === 0) return true;

    // Allow absolute https URLs
    if (trimmedUrl.indexOf('https://') === 0) return true;

    // Allow absolute http URLs (for dev environments)
    if (trimmedUrl.indexOf('http://') === 0) return true;

    // Reject everything else (javascript:, data:, vbscript:, etc.)
    return false;
}

/**
 * Updates links with data-pwa-registry-url attribute to use PWA URLs when PWA Gift Registry is enabled
 */
function updateRegistryLinks() {
    if (typeof window === 'undefined') return;
    if (!window.SitePreferences || !window.SitePreferences.enablePwaGiftRegistry) return;
    if (initialized) return;

    initialized = true;

    // Find all links with data-pwa-registry-url that haven't been processed
    var links = document.querySelectorAll('a[data-pwa-registry-url]:not([data-pwa-processed])');

    for (var i = 0; i < links.length; i++) {
        var link = links[i];
        var pwaUrl = link.getAttribute('data-pwa-registry-url');

        // Mark as processed first to prevent reprocessing
        link.setAttribute('data-pwa-processed', 'true');

        // Only update if PWA URL is provided and is valid (prevents XSS)
        if (pwaUrl && isValidUrl(pwaUrl)) {
            link.href = pwaUrl;
        }
    }
}

module.exports = {
    /**
     * Initialize the PWA registry links functionality
     * Runs on page load and after AJAX content updates
     */
    init: function() {
        // Only add listener if DOM is still loading, otherwise execute immediately
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', updateRegistryLinks);
        } else {
            // DOM already loaded, execute immediately
            updateRegistryLinks();
        }
    },

    /**
     * Manually trigger update of registry links
     * Useful for AJAX-loaded content
     */
    update: updateRegistryLinks
};

},{}],61:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    productdialog = require('./productdialog'),
    product = require('./pages/product'),
    util = require('./util'),
    _ = require('lodash');


var makeUrl = function (url, source, productListID) {
    if (source) {
        url = util.appendParamToURL(url, 'source', source);
    }
    if (productListID) {
        url = util.appendParamToURL(url, 'productlistid', productListID);
    }
    return url;
};

var removeParam = function (url) {
    if (url.indexOf('?') !== -1) {
        return url.substring(0, url.indexOf('?'));
    } else {
        return url;
    }
};

var quickview = {
    init: function () {
        if (!this.exists()) {
            this.$container = $('<div/>').attr('id', 'QuickViewDialog').attr('class', 'quick-view').appendTo(document.body);
        }
        this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
            return $(thumbLink).data('quickviewurl');
        });
    },

    setup: function (qvUrl) {
        var $btnNext = $('.quickview-next'),
            $btnPrev = $('.quickview-prev');

        product.initializeEvents();

        this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
            return removeParam(url) === removeParam(qvUrl);
        });

        // hide the buttons on the compare page or when there are no other products
        if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
            $btnNext.hide();
            $btnPrev.hide();
            return;
        }

        if (this.productLinkIndex === this.productLinks.length - 1) {
            $btnNext.attr('disabled', 'disabled');
        }
        if (this.productLinkIndex === 0) {
            $btnPrev.attr('disabled', 'disabled');
        }

        $btnNext.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(1);
        }.bind(this));
        $btnPrev.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(-1);
        }.bind(this));
    },

    /**
     * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
     */
    navigateQuickview: function (step) {
        // default step to 0
        this.productLinkIndex += (step ? step : 0);
        var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
        productdialog.replace({
            url: url,
            callback: this.setup.bind(this, url)
        });
    },

    /**
     * @description show quick view dialog
     * @param {Object} options
     * @param {String} options.url - url of the product details
     * @param {String} options.source - source of the dialog to be appended to URL
     * @param {String} options.productlistid - to be appended to URL
     * @param {Function} options.callback - callback once the dialog is opened
     */
    show: function (options) {
        var url;
        if (!this.exists()) {
            this.init();
        }
        url = makeUrl(options.url, options.source, options.productlistid);

        dialog.open({
            target: this.$container,
            url: url,
            options: {
                width: 1153,
                dialogClass: 'quick-view',
                title: Resources.QUICK_VIEW_POPUP,
                open: function () {
                    this.setup(url);
                    if (typeof options.callback === 'function') { options.callback(); }
                }.bind(this)
            }
        });
    },

    /**
     * @description In QV we need to show BOPIS functionality. Below function is written in-order to avoid product QV popup
     * @param {Object} Below function is same as show: function (options)
     * SURI-235 - Issue-5
     */
    showproduct: function (options) {
        var url;
        if (!this.exists()) {
            this.init();
        }
        url = makeUrl(options.url, options.source, options.productlistid);

        productdialog.open({
            target: this.$container,
            url: url,
            options: {
                width: 1153,
                dialogClass: 'quick-view',
                position: {
                    my: 'top',
                    at: 'top',
                    of: window
                },
                title: Resources.QUICK_VIEW_POPUP,
                open: function () {
                    this.setup(url);
                    if (typeof options.callback === 'function') { options.callback(); }
                    $('#QuickViewDialog').addClass('quick-view-update');
                    $('body').find('.wish-floating-button').css('left','unset');
                  
                }.bind(this),
                close: function () {
                    $('#QuickViewDialog').removeClass('quick-view-update');
                }
            }
        });
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    }
};

module.exports = quickview;

},{"./dialog":13,"./pages/product":40,"./productdialog":58,"./util":78,"lodash":94}],62:[function(require,module,exports){
'use strict';

/**
 * radar.js — Geolocation for SiteGenesis pages.
 *
 * SLTBE-8126: Geolocation source for the header "My Store" display.
 *
 * Previously this file called SFCC's GoLocal-IpLocation endpoint, which used
 * request.getGeolocation() — a black-box SFCC platform API that returns
 * Wichita, KS (US centroid) for IPs with low MaxMind confidence.
 *
 * Now: browser geolocation (free, GPS-accurate) is the primary source.
 * The result (coords or error info) is sent to GoLocal-GeoLocate, an SFCC
 * pipeline that proxies to the BFF server-side (no CORS, no API key in browser).
 * Same pattern as the PWA hook (useCustomerGeoLocation.tsx).
 *
 * No Radar API calls are made for geolocation. Radar is still used for
 * autocomplete (store finder) and trackOnce (cooking class pages) — those
 * are unchanged.
 */

var util = require('./util');
var goLocal = require('./goLocal');
var edd = require('./edd');
var gtm = require('./gtm');

var COOKIE_RADAR_COORDINATE = 'slt_radar_coordinate';
var CLIENT_IP_CACHE_KEY = 'slt_client_ip';
var CLIENT_IP_TTL_MS = 60 * 60 * 1000; // 1 hour

// GeolocationPositionError codes from the Web API spec.
// Matches the GeoLocationError enum in useCustomerGeoLocation.tsx.
var GEO_ERRORS = {
    1: 'PERMISSION_DENIED',
    2: 'POSITION_UNAVAILABLE',
    3: 'TIMEOUT'
};

/**
 * Get the customer's real public IP via Cloudflare's cdn-cgi/trace endpoint.
 * Cached in localStorage for 1 hour. Shared cache key with PWA
 * (useCustomerGeoLocation.tsx).
 *
 * Advantages over the previous ipify.org approach:
 *   - Same domain (surlatable.com) — no CORS, no CSP changes needed
 *   - Never blocked by corporate firewalls (Cisco, Bitdefender block ipify)
 *   - Operated by Cloudflare (enterprise SLA) not a hobby project
 *   - Zero third-party dependency — SLT already pays for Cloudflare
 *
 * The trace endpoint returns plaintext key=value pairs; we parse the "ip=" line.
 */
function getClientIp() {
    try {
        var cached = localStorage.getItem(CLIENT_IP_CACHE_KEY);
        if (cached) {
            var data = JSON.parse(cached);
            if (Date.now() - data.timestamp < CLIENT_IP_TTL_MS) {
                return Promise.resolve(data.ip);
            }
        }
    } catch (e) {
        // localStorage not available
    }

    var timeout = new Promise(function(_, reject) {
        setTimeout(function() { reject(new Error('timeout')); }, 3000);
    });

    return Promise.race([fetch('/cdn-cgi/trace'), timeout])
        .then(function(response) { return response.text(); })
        .then(function(text) {
            var lines = text.split('\n');
            var ip = null;
            for (var i = 0; i < lines.length; i++) {
                if (lines[i].indexOf('ip=') === 0) {
                    ip = lines[i].substring(3);
                    break;
                }
            }
            if (ip) {
                try {
                    localStorage.setItem(CLIENT_IP_CACHE_KEY, JSON.stringify({
                        ip: ip,
                        timestamp: Date.now()
                    }));
                } catch (e) {
                    // localStorage not available
                }
            }
            return ip;
        })
        .catch(function() { return null; });
}

var COORDS_CACHE_KEY = 'slt_geo_coords';
var COORDS_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

// Separate key for the denial record. Stores an absolute expiry timestamp
// (not a timestamp-plus-TTL pair). Kept in its own key so the existing
// slt_geo_coords shape is untouched — paired with the PWA hook in
// slt-sfcc-react/app/hooks/useCustomerGeoLocation.tsx.
var DENIED_CACHE_KEY = 'slt_geo_denied_until';
var DENIED_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

/**
 * Which client-side cache path produced the outgoing GoLocal-GeoLocate call.
 * Logged in the BFF as `cacheSource` for telemetry.
 */
var lastCacheSource = 'miss';

/**
 * Browser Geolocation outcome + resolved city/zip for the geolocation_captured
 * Heap KPI (SLTBE-8783). city/zipCode come from whatever GoLocal-GeoLocate
 * resolves, whether that's via browser GPS or its IP fallback — see the two
 * branches in getGeoLocation() below.
 */
var lastGeoPermission = null;
var lastCity = null;
var lastZipCode = null;

// Maps the browser error codes above (plus UNSUPPORTED) to the Heap
// geoPermission KPI's enum values.
var GEO_PERMISSION_MAP = {
    PERMISSION_DENIED: 'denied',
    POSITION_UNAVAILABLE: 'unavailable',
    TIMEOUT: 'timeout',
    UNSUPPORTED: 'unsupported'
};

/**
 * Get the customer's browser coordinates.
 * Checks localStorage cache first to avoid triggering the browser permission
 * prompt on every page load (Safari re-prompts each time).
 * Rejects with {code: 0} if navigator.geolocation is absent,
 * or with a GeolocationPositionError (codes 1-3) on denial/timeout.
 */
function getBrowserCoords() {
    // Denial-cache check runs first. When the user taps "Don't Allow" we
    // record an expiry timestamp here; on the next page load we reject with
    // code 1 without calling getCurrentPosition(). That's the only way to
    // suppress Safari's re-prompt on every navigation.
    try {
        var deniedUntilRaw = localStorage.getItem(DENIED_CACHE_KEY);
        if (deniedUntilRaw !== null) {
            var deniedUntil = Number(deniedUntilRaw);
            if (isFinite(deniedUntil) && Date.now() < deniedUntil) {
                lastCacheSource = 'denied';
                return Promise.reject({code: 1});
            }
        }
    } catch (e) {
        // localStorage unavailable — fall through to browser API
    }

    // Grant-cache check — avoids the permission prompt on every page load.
    // Note: We intentionally do NOT use navigator.permissions.query() here.
    // Safari reports 'denied' when the state is actually 'prompt' (undecided),
    // which would cause us to skip getCurrentPosition() and never obtain coords.
    try {
        var cached = localStorage.getItem(COORDS_CACHE_KEY);
        if (cached) {
            var parsed = JSON.parse(cached);
            if (Date.now() - parsed.timestamp < COORDS_TTL_MS) {
                lastCacheSource = 'granted';
                return Promise.resolve({
                    coords: {latitude: parsed.lat, longitude: parsed.lng}
                });
            }
        }
    } catch (e) {
        // Corrupted cache — fall through to browser API
    }

    lastCacheSource = 'miss';

    if (!navigator.geolocation) {
        return Promise.reject({code: 0});
    }

    return new Promise(function(resolve, reject) {
        navigator.geolocation.getCurrentPosition(
            function(position) {
                // Clear the denial BEFORE writing the grant cache, in its own
                // try/catch. If a QuotaExceededError on setItem shared the
                // catch with removeItem, a stale denial could survive and
                // short-circuit the user back to 'denied' for the full 24h.
                try {
                    localStorage.removeItem(DENIED_CACHE_KEY);
                } catch (e) {
                    // Storage unavailable — proceed without caching
                }
                try {
                    localStorage.setItem(COORDS_CACHE_KEY, JSON.stringify({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                        timestamp: Date.now()
                    }));
                } catch (e) {
                    // Storage unavailable — proceed without caching
                }
                resolve(position);
            },
            function(err) {
                if (err && err.code === 1) {
                    try {
                        localStorage.setItem(
                            DENIED_CACHE_KEY,
                            String(Date.now() + DENIED_TTL_MS)
                        );
                    } catch (e) {
                        // Storage unavailable — proceed without caching
                    }
                }
                reject(err);
            },
            {timeout: 5000, maximumAge: 300000}
        );
    });
}

/**
 * POST geolocation data to the SFCC GoLocal-GeoLocate pipeline.
 * This endpoint proxies to the BFF via Bff.ds (server-side),
 * or resolves directly via internal controller call when clientIp is present.
 */
function postGeoLocate(body) {
    var url = Urls.GeoLocate;
    return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)
    }).then(function(response) {
        if (!response.ok) {
            return {};
        }
        return response.json();
    });
}

// Captures the resolved city/zip from a GoLocal-GeoLocate response for the
// geolocation_captured KPI, regardless of whether that response came from
// the browser-coords branch or the IP-fallback branch below.
function captureResolvedCityZip(address) {
    lastCity = (address && address.city) || null;
    lastZipCode = (address && address.postalCode) || null;
    return address;
}

/**
 * Try browser geolocation, then call the SFCC GeoLocate endpoint.
 * When browser geo fails, fetches the customer's real IP from Cloudflare
 * cdn-cgi/trace and includes it in the request so SFCC can resolve correctly.
 * Wrapped in singleExecutionPromise — deduplicates concurrent calls (e.g. init + updateFromRadar).
 */
var getGeoLocation = util.singleExecutionPromise(function() {
    // Always fetch clientIp — BFF needs it for non-US coords enrichment
    return getClientIp().then(function(ip) {
        return getBrowserCoords().then(
            function(position) {
                var body = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    cacheSource: lastCacheSource
                };
                if (ip) {
                    body.clientIp = ip;
                }
                lastGeoPermission = 'granted';
                return postGeoLocate(body).then(captureResolvedCityZip);
            },
            function(err) {
                var errorCode = err.code === 0 ? 'UNSUPPORTED' : (GEO_ERRORS[err.code] || 'POSITION_UNAVAILABLE');
                var body = {
                    error: errorCode,
                    cacheSource: lastCacheSource
                };
                if (ip) {
                    body.clientIp = ip;
                }
                lastGeoPermission = GEO_PERMISSION_MAP[errorCode] || 'unsupported';
                return postGeoLocate(body).then(captureResolvedCityZip);
            }
        );
    });
});

// Defensive guard against firing geolocation_captured more than once per page.
// Today only init() calls pushGeolocationCaptured() (once, on either its
// .then or .catch branch, which are mutually exclusive), so this doesn't
// currently deduplicate anything — it protects against a future caller
// (e.g. updateFromRadar(), which does not push this KPI today) triggering
// a second push on the same page.
var geoDataPushed = false;

/**
 * Pushes the geolocation_captured Heap KPI once per page view (SLTBE-8783).
 */
function pushGeolocationCaptured() {
    if (geoDataPushed) {
        return;
    }
    geoDataPushed = true;
    gtm.onGeolocationCaptured(lastGeoPermission || 'unsupported', lastCity, lastZipCode);
}

function loadHeaderNearestStore(data) {
    var url = Urls.headerNearestStore;
    var keys = Object.keys(data);

    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        url = util.appendParamToURL(url, key, data[key]);
    }

    $.get(url, function(data){
        $('ul.menu-utility-header .stores').remove();
        $('ul.menu-utility-header').append(data);
    });
}

function loadFooterNearestStore(data) {
    var url = Urls.footerNearestStore;
    var keys = Object.keys(data);

    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        url = util.appendParamToURL(url, key, data[key]);
    }

    $('#footerNearestStore').load(url);
}

function loadNearestStore(coordinate) {
    var data = {};

    var params = new window.URLSearchParams(window.location.search);
    var locationId = params.get('location_id');

    if (locationId) {
        data.locationId = locationId;
    } else {
        data.latitude = coordinate.latitude;
        data.longitude = coordinate.longitude;
    }

    loadHeaderNearestStore(data);
    loadFooterNearestStore(data);
}

function updateFromAddress(address) {
    goLocal.updateStore(address);

    // Only update Go Local address if there is no selected address.
    var postalCode = $('input[name="goLocalPostalCode"]').val();
    if (!postalCode) {
        goLocal.checkEligibilityForPDP(address);
    }

    var $zip = $('#user-input-text-zipcode');
    if ($zip.length) {
        var reg = /^(\d{5})(-\d{4})?$/;
        if (address && address.postalCode && reg.test(address.postalCode)) {
            var groups = reg.exec(address.postalCode);
            $zip.val(groups[1]);
        } else if (window.SitePreferences && window.SitePreferences.eddDefaultToZipCode) {
            $zip.val(window.SitePreferences.eddDefaultToZipCode);
        }
        edd();
    }
}

function updateZipCodeFromAddress(address) {
    var $zip = $('#user-input-text-zipcode');
    if ($zip.length) {
        var reg = /^(\d{5})(-\d{4})?$/;
        if (address && address.postalCode && reg.test(address.postalCode)) {
            var groups = reg.exec(address.postalCode);
            $zip.val(groups[1]);
        } else if (window.SitePreferences && window.SitePreferences.eddDefaultToZipCode) {
            $zip.val(window.SitePreferences.eddDefaultToZipCode);
        }
        edd();
    }
}

function initialize() {
    // Pages that don't need autocomplete/trackOnce skip loading the Radar SDK
    // (e.g. homepage). Geolocation runs via the BFF and doesn't need Radar.
    if (typeof Radar === 'undefined') {
        // With impPerfRadarPerPage=true the Radar <script> has `defer`, so it
        // has not yet executed when this runs from app.js:init(). Bind to the
        // script element's load event and retry once the SDK is ready.
        // Without this retry Radar.initialize(KEY) is never called, leaving
        // the SDK loaded-but-unauthenticated — every SDK call then fails with
        // RadarPublishableKeyError.
        var sdkScript = document.querySelector('script[src*="js.radar.com"]');
        if (sdkScript) {
            sdkScript.addEventListener('load', function onRadarSdkReady() {
                sdkScript.removeEventListener('load', onRadarSdkReady);
                initialize();
            });
        }
        return;
    }
    if (!window.IsRadarInitialized) {
        window.IsRadarInitialized = true;
        Radar.initialize(SitePreferences.radarPublishable);
    }
    var customerNo = $('input[name="customerNo"]').val();
    if (customerNo) {
        Radar.setUserId(customerNo);
        Radar.setDescription($('input[name="customerEmail"]').val());
    }
}

/**
 * Called by the EDD widget to refresh the ZIP code from geolocation.
 */
function updateFromRadar() {
    if (!SitePreferences.radarEnabled) {
        edd();
        return;
    }
    getGeoLocation().then(function(address) {
        updateZipCodeFromAddress(address);
    }).catch(function() {
        edd();
    });
}

// Lazy delegate — resolves `Radar.autocomplete` at call time, not at module-eval
// time. Module-eval-time capture would permanently bind to the no-op when
// impPerfRadarPerPage=true (defer'd SDK has not parsed yet at module eval),
// even after the SDK finishes loading. Calling lazily lets the first user
// interaction find the now-loaded SDK and delegate correctly.
function autocomplete() {
    if (typeof Radar !== 'undefined' && typeof Radar.autocomplete === 'function') {
        return Radar.autocomplete.apply(null, arguments);
    }
    // SDK not available (radarEnabled=false, or called before defer'd SDK
    // parsed — rare, since user interaction happens after DCL). Return
    // undefined to preserve the prior no-op semantics.
}

function init() {
    if (!SitePreferences.radarEnabled) {
        return;
    }

    initialize();

    goLocal.init();

    // SLTBE-8126: Delete the old slt_radar_coordinate cookie if it exists.
    // This cookie cached CDN-derived coordinates (often Wichita) for 7 days.
    // We no longer store location in cookies — geolocation resolves fresh each page load.
    if (document.cookie.indexOf(COOKIE_RADAR_COORDINATE) !== -1) {
        document.cookie = COOKIE_RADAR_COORDINATE + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    }
    if (document.cookie.indexOf('slt_user_address') !== -1) {
        document.cookie = 'slt_user_address=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    }

    getGeoLocation().then(function(address) {
        var coordinate = {};

        if (address) {
            coordinate.latitude = address.latitude;
            coordinate.longitude = address.longitude;
        }

        loadNearestStore(coordinate);
        updateFromAddress(address);
        pushGeolocationCaptured();
    }).catch(function() {
        loadNearestStore({});
        pushGeolocationCaptured();
    });
}

module.exports = {
    autocomplete: autocomplete,
    isEnabled: SitePreferences.radarEnabled,
    updateFromRadar: updateFromRadar,
    // SLTBE-8873: expose the shared browser-geo resolution so the cooking-class CLP
    // can resolve a store from the customer's location on load (same source the
    // header "My Store" uses) instead of auto-popping the store-picker modal.
    getGeoLocation: getGeoLocation,
    init: init
};

},{"./edd":14,"./goLocal":17,"./gtm":18,"./util":78}],63:[function(require,module,exports){
'use strict';

var _ = require('lodash');
var radar = require('./radar');

var resetAddressList = function(addressList) {
    addressList.empty();
    addressList.addClass('hidden');
};

var updateAddressList = function(widget, addresses) {
    resetAddressList(widget.addressList);

    if (!addresses.length) {
        return;
    }

    var searchTerm = widget.searchTerm.toLowerCase();

    addresses.filter(function(address) {
        return !!address.postalCode;
    }).forEach(function(address){
        var formattedAddress = address.formattedAddress;
        var startIndex = formattedAddress.toLowerCase().indexOf(searchTerm);

        if (startIndex > -1) {
            var startAddress = formattedAddress.substring(0,startIndex);
            var matchAddress = formattedAddress.substring(startIndex, startIndex + searchTerm.length);
            var endAddress = formattedAddress.substring(startIndex + searchTerm.length);

            formattedAddress =
                startAddress +
                '<span class="radar-auto-complete__address-list__item__match">' +
                    matchAddress +
                '</span>' +
                endAddress;
        }

        var li = $('<li/>').addClass('radar-auto-complete__address-list__item').html(formattedAddress);
        li.on('click', function() {
            widget.searchTerm = address.formattedAddress;
            widget.userAddress = address;
            resetAddressList(widget.addressList);
            widget.options.onSelectAddress(address, widget.element);
        });
        li.appendTo(widget.addressList);
    });

    widget.addressList.removeClass('hidden');
}

var init = function () {
    $.widget('custom.radarAutoComplete', {
        // default options
        options: {
            /**
             * Default behavior set the address in the input.
             */
            onSelectAddress: function(address, input) {
                input.val(address.formattedAddress);
            }
        },

        // The constructor
        _create: function () {
            var widget = this;
            this.container = this.element.parent();
            this.searchTerm = '';
            this.userAddress = null;

            this.element.addClass('radar-auto-complete__input');
            this.element.attr('placeholder', 'Search address');
            this.element.attr('autocomplete', 'off');

            this.container.addClass('radar-auto-complete');

            this.addressList = $('<ul>', {
                class: 'radar-auto-complete__address-list hidden'
            }).appendTo(this.container);

            var onSearch = _.debounce(function(e) {
                if (e.target.value.length > 0) {

                    if (widget.searchTerm === e.target.value) {
                        return;
                    }
                
                    widget.searchTerm = e.target.value;

                    radar.autocomplete({
                        query: widget.searchTerm,
                        limit: 5,
                        layers: 'fine',
                        countryCode: 'US'
                    }).then((result) => {
                        updateAddressList(widget, result && result.addresses ? result.addresses : []);
                    });
                } else {
                    resetAddressList(widget.addressList);
                }
            }, 1000);

            this.element.off('keyup').on('keyup', onSearch);
        },

        // Events bound via _on are removed automatically
        // revert other modifications here
        _destroy: function () {
            this.element.remove();
            this.container.remove();
        },

        // _setOptions is called with a hash of all options that are changing
        // always refresh when changing options
        _setOptions: function () {
            // _super and _superApply handle keeping the right this-context
            this._superApply(arguments);
        },

        // _setOption is called for each individual option that is changing
        _setOption: function (key, value) {
            this._super(key, value);
        }
    });
};

module.exports = {
    init: init
};

},{"./radar":62,"lodash":94}],64:[function(require,module,exports){
'use strict';

/**
 * copied from https://github.com/darkskyapp/string-hash
 */
function hashFn(str) {
    var hash = 5381,
        i = str.length;

    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    * integers. Since we want the results to be always positive, convert the
    * signed int to an unsigned by doing an unsigned bitshift. */
    return hash >>> 0;
}

/**
 * Create rating based on hash ranging from 2-5
 * @param pid
 */
function getRating(pid) {
    return hashFn(pid.toString()) % 30 / 10 + 2;
}

module.exports = {
    init: function () {
        $('.product-review').each(function (index, review) {
            var pid = $(review).data('pid');
            if (!pid) {
                return;
            }
            // rating range from 2 - 5
            var rating = getRating(pid);
            var baseRating = Math.floor(rating);
            var starsCount = 0;
            for (var i = 0; i < baseRating; i++) {
                $('.rating', review).append('<i class="fa fa-star"></i>');
                starsCount++;
            }
            // give half star for anything in between
            if (rating > baseRating) {
                $('.rating', review).append('<i class="fa fa-star-half-o"></i>');
                starsCount++;
            }
            if (starsCount < 5) {
                for (var j = 0; j < 5 - starsCount; j++) {
                    $('.rating', review).append('<i class="fa fa-star-o"></i>');
                }
            }
        });
    }
};

},{}],65:[function(require,module,exports){
'use strict';

/**
 * @private
 * @function
 * @description Binds event to the place holder (.blur)
 */
function initializeEvents() {
    $('#q').focus(function () {
        var input = $(this);
        if (input.val() === input.attr('placeholder')) {
            input.val('');
        }
    })
    .blur(function () {
        var input = $(this);
        if (input.val() === '' || input.val() === input.attr('placeholder')) {
            input.val(input.attr('placeholder'));
        }
    })
    .blur();
}

exports.init = initializeEvents;

},{}],66:[function(require,module,exports){
'use strict';

var util = require('./util');

var DEFAULT_DEBOUNCE_DELAY = 500;
var MIN_QUERY_LENGTH = 3;

var runningRequest = null,
    listTotal = -1,
    listCurrent = -1,
    $resultsContainer;
/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    switch (keyCode) {
        case 38:
            // keyUp
            listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
            break;
        case 40:
            // keyDown
            listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
            break;
        default:
            // reset
            listCurrent = -1;
            return false;
    }

    $resultsContainer.children().removeClass('selected').eq(listCurrent).addClass('selected');
    $('input[name="q"]').val($resultsContainer.find('.selected .suggestionterm').first().text());
    return true;
}

/**
 * Call the function only if it has been more than 'wait' milliseconds without being called.
 * 'func' will be actually called with the last arguments passed.
 *
 * @param func the actual function to call
 * @param wait the timelapse
 * @returns {(function(): void)|*}
 */
function debounce(func, wait) {
    var timeout;
    var delay = typeof wait === 'number' && wait >= 0 ? wait : DEFAULT_DEBOUNCE_DELAY;
    var debounced = function() {
        var context = this;
        var args = arguments;
        var funcCall = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(funcCall, delay);
    };
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = null;
    };
    return debounced;
}

var searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function (container, defaultValue) {
        var $searchContainer = $(container);
        var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
        var $searchField = $searchForm.find('input[name="q"]');
        var $submitButton = $searchForm.find('button.searchheadersubmit');
        var debounceDelay = DEFAULT_DEBOUNCE_DELAY;

        if (typeof window !== 'undefined' &&
            window.SitePreferences &&
            window.SitePreferences.pwaSearchDebounceTime !== null &&
            typeof window.SitePreferences.pwaSearchDebounceTime !== 'undefined') {
            var parsedDelay = parseInt(window.SitePreferences.pwaSearchDebounceTime, 10);
            if (!isNaN(parsedDelay) && parsedDelay >= 0) {
                debounceDelay = parsedDelay;
            }
        }

        // disable browser auto complete
        $searchField.attr('autocomplete', 'off');

        // on focus listener (clear default value)
        $searchField.focus(function () {
            if (!$resultsContainer) {
                // create results container if needed
                $resultsContainer = $('<div/>').attr('id', 'search-suggestions').appendTo($searchContainer);
            }
            if ($searchField.val() === defaultValue) {
                $searchField.val('');
            }
        });

        $(document).on('click', 'a.search-suggest-result', function(e) {
            e.preventDefault();
            var linkElement = $(e.target).closest('a.search-suggest-result');
            if (isGTMEnabled) {
                var searchTerm = $searchField.val().trim();
                var searchSuggestion = linkElement.data('searchsuggest');
                if (searchSuggestion) {
                    require('./gtm').onSearchSuggestionClick(searchTerm, String(searchSuggestion).trim());
                }
            }
            var url = linkElement[0].href;
            window.location.href = url;
        });

        $(document).on('click', function (e) {
            // Fly out needs to closed if user clicks any where except flyout
            if (!$searchContainer.is(e.target) && $(e.target).closest('div.search-sug-inner-wrapper').length < 1) {
                setTimeout(this.clearResults, 200);
            }
        }.bind(this));
        /**
         * @function
         * @description Convert the query to URL query format, use + for spaces
         * @param {String} query the query to convert
         * @returns {String} the converted query
         */
        var toURLQueryFormat = function(query) {
            return encodeURIComponent((query || '').trim()).replace(/%20/g, '+');
        };

        // on key up listener
        $searchField.keyup(function (e) {

            // get keyCode (window.event is for IE)
            var keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            // check for an ENTER or ESC
            if (keyCode === 13) {
                e.preventDefault();
                this.clearResults();
                var param = $searchField.val();
                if (param === '' || param === 'What are you looking for?'){
                    return false;
                } else {
                    var url = $searchForm.attr('action');
                    url = util.appendParamToURL(url, 'q', toURLQueryFormat(param), true);
                    window.location.href = url;
                }
            } else if (keyCode === 27) {
                this.clearResults();
            }
        }.bind(this));

        var debouncedSuggest = debounce(this.suggest.bind(this), debounceDelay);
        $searchField.on('input', function (e) {
            var query = $(e.target).val().trim();

            if (query.length >= MIN_QUERY_LENGTH) {
                debouncedSuggest(query);
                return;
            }

            if (typeof debouncedSuggest.cancel === 'function') {
                debouncedSuggest.cancel();
            }
            if (runningRequest !== null) {
                runningRequest.abort();
                runningRequest = null;
            }
            this.clearResults();
        }.bind(this));

        $submitButton.click(function (e) {
            e.preventDefault();
            this.clearResults();
            var param = $searchField.val();
            if (param === '' || param === 'What are you looking for?'){
                return false;
            } else {
                if (isGTMEnabled) {
                    require('./gtm').onSearch(param);
                }
                var url = $searchForm.attr('action');
                url = util.appendParamToURL(url, 'q', toURLQueryFormat(param), true);
                window.location.href = url;
            }
        }.bind(this));

    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function (q) {
        if (runningRequest !== null) {
            runningRequest.abort();
            runningRequest = null;
        }

        // if it's empty or shorter than the minimum clear the results box and return
        if (!q || q.length < MIN_QUERY_LENGTH) {
            this.clearResults();
            return;
        }

        var paramUrl = document.URL;
        var paramRefUrl = document.referrer;

        // build the request url
        var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', q);
        reqUrl = util.appendParamToURL(reqUrl, 'url', paramUrl);
        reqUrl = util.appendParamToURL(reqUrl, 'refUrl', paramRefUrl);
        // execute server call
        runningRequest = $.get(reqUrl, function (data) {
            var suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            if (isGTMEnabled) {
                require('./gtm').onSearch(q);
            }

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
            } else {
                // update the results div
                $resultsContainer.html(suggestionHTML).fadeIn(200);
                $('body').addClass('noscroll-device');
                setTimeout(function() {
                    if ($('#search-suggestions').is(':visible')) {
                        var mobileFixedblocks = $('.header-main').height() + $('.header-search').height();
                        var headerHeight = window.innerHeight - (mobileFixedblocks);
                        if (window.matchMedia('(max-width: 1025px)').matches) {
                            $('#search-suggestions').css('height', headerHeight);
                        }
                    }
                }, 900);
                // Check if we do not have product in any section then remove tabing div
                setTimeout(function () {
                    if ($('input[class="removeProductClassDiv"]').val() == 'true' && $('input[class="removeCulinaryClassDiv"]').val() == 'true' && $('input[class="removeRecipeClassDiv"]').val() == 'true') {
                        $('div.product-suggestions').remove();
                    }
                }, 10);
                $('#tabs').tabs();
                //$('.product-suggestions .tab-switch:checked').trigger('click');
            }
            this.hideLeftPanel();
        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function () {
        if (!$resultsContainer) { return; }
        $resultsContainer.fadeOut(200, function () {
            $resultsContainer.empty();
        });
        $('body').removeClass('noscroll-device');
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function () {
        //hide left panel if there is only a matching suggested custom phrase
        if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
            $('.search-suggestion-left-panel').css('display', 'none');
            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
        }
    }
};

module.exports = searchsuggest;

},{"./gtm":18,"./util":78}],67:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function($selector, $defaulValues, $responsive) {

    $($selector).not('.slick-initialized').slick({
        arrows: typeof $defaulValues.arrows === 'undefined' ? false : true,
        infinite: typeof $defaulValues.arrows === 'undefined' ? false : $defaulValues.infinite,
        dots: typeof $defaulValues.dots === 'undefined' ? false : true,
        swipe: typeof $defaulValues.swipe === 'undefined' ? false : true,
        draggable: typeof $defaulValues.draggable === 'undefined' ? false : true,
        slidesToShow: typeof $defaulValues.slidesToShow === 'undefined' ? 1 : $defaulValues.slidesToShow,
        slidesToScroll: typeof $defaulValues.slidesToScroll === 'undefined' ? 1 : $defaulValues.slidesToScroll,
        vertical: typeof $defaulValues.vertical === 'undefined' ? false : $defaulValues.vertical,
        verticalSwiping: typeof $defaulValues.verticalSwiping === 'undefined' ? false : true,
        centerMode: typeof $defaulValues.centerMode === 'undefined' ? false : $defaulValues.centerMode,
        useTransform: typeof $defaulValues.useTransform === 'undefined' ? false : $defaulValues.useTransform,
        speed: typeof $defaulValues.speed === 'undefined' ? false : $defaulValues.speed,
        responsive: [

            {
                breakpoint: 1024,
                settings: {
                    arrows: typeof $responsive.arrows === 'undefined' ? false : true,
                    infinite: typeof $responsive.infinite === 'undefined' ? false : true,
                    dots: typeof $responsive.dots === 'undefined' ? false : true,
                    draggable: typeof $responsive.draggable === 'undefined' ? false : true,
                    swipe: typeof $responsive.swipe === 'undefined' ? true : false,
                    slidesToShow: typeof $responsive.slidesToShow === 'undefined' ? 3 : $responsive.slidesToShow,
                    slidesToScroll: typeof $responsive.slidesToScroll === 'undefined' ? 3 : $responsive.slidesToScroll
                }
            },
            {
                breakpoint: 769,
                settings: {
                    arrows: typeof $responsive.arrows === 'undefined' ? false : true,
                    infinite: typeof $responsive.infinite === 'undefined' ? false : true,
                    dots: typeof $responsive.dots === 'undefined' ? false : true,
                    draggable: typeof $responsive.draggable === 'undefined' ? false : true,
                    swipe: typeof $responsive.swipe === 'undefined' ? true : false,
                    slidesToShow: typeof $responsive.slidesToShow === 'undefined' ? 2 : $responsive.slidesToShow,
                    slidesToScroll: typeof $responsive.slidesToScroll === 'undefined' ? 2 : $responsive.slidesToScroll
                }

            },
            {
                breakpoint: 500,
                settings: {
                    arrows: typeof $responsive.arrows === 'undefined' ? false : true,
                    infinite: typeof $responsive.infinite === 'undefined' ? false : true,
                    dots: typeof $responsive.dots === 'undefined' ? false : true,
                    draggable: typeof $responsive.draggable === 'undefined' ? false : true,
                    swipe: typeof $responsive.swipe === 'undefined' ? true : false,
                    slidesToShow: typeof $responsive.slidesToShowMobile === 'undefined' ? 1 : $responsive.slidesToShowMobile,
                    slidesToScroll: typeof $responsive.slidesToScrollMobile === 'undefined' ? 1 : $responsive.slidesToScrollMobile
                }
            }
        ]

    })
}

},{}],68:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    progress = require('./progress'),
    checkout = require('./pages/checkout'),
    util = require('./util'),
    tooltip = require('./tooltip'),
    validator = require('./validator'),
    login = require('./login'),
    dialog = require('./dialog'),
    giftPackaging = require('./pages/checkout/giftpackage'),
    couponCode = require('./pages/checkout/couponCodeModule'),
    minicart = require('./minicart');

var $cache = {},
    isSPCLogin = false,
    isSPCShipping = false,
    isSPCMultiShipping = false,
    isSPCBilling = false;
window.showCheckoutLoader = function() {
    progress.show($cache.primary);
}

function saveBillingForm() {
    var jsonData = {};
    var formError = false;
    $('form#dwfrm_billing fieldset.addressFieldset input,form#dwfrm_billing fieldset.addressFieldset select').each(function() {
        if (($(this).hasClass('required') && $(this).val() == '') || $(this).hasClass('error')) {
            formError = true;
            return;
        }
        if ($(this).val() != '' && $(this).val() != null) {
            var name = $(this).attr('name');
            if ($(this).attr('type') == 'checkbox') {
                jsonData[name] = $(this).is(':checked') ? true : false;
            } else if ($(this).prop('type')=='select-one') {
                jsonData[name] = $(this).find(':selected').val();
            } else {
                jsonData[name] = $(this).val();
            }
        }
    });
    if (!formError) {
        $.ajax({
            type: 'POST',
            url: window.Urls.PreSaveBillingAddress,
            data: jsonData,
            async: false,
            dataType: 'JSON',
            success: function() {
                // data saved
            }
        });
    }
}
window.saveBillingFormGlobal = saveBillingForm;


function persistShippingFormState() {
    var jsonData = {};
    var formError = false;
    $('form#dwfrm_singleshipping_shippingAddress fieldset input, form#dwfrm_singleshipping_shippingAddress fieldset select').each(function() {
        if ($(this).val() != '' && $(this).val() != null) {
            var name = $(this).attr('name');
            if ($(this).attr('type') == 'checkbox') {
                jsonData[name] = $(this).is(':checked') ? true : false;
            } else if ($(this).prop('type')=='select-one') {
                jsonData[name] = $(this).find(':selected').val();
            } else {
                jsonData[name] = $(this).val();
            }
        }
    });
    if (!formError) {
        $.ajax({
            type: 'POST',
            url: window.Urls.PersistShippingFormState,
            data: jsonData,
            async: false,
            dataType: 'JSON',
            success: function() {
                // data saved
            }
        });
    }
}
window.persistShippingFormStateGlobal = persistShippingFormState;


function initializeCache() {
    $cache = {
        main: $('#main'),
        primary: $('#primary'),
        secondary: $('#secondary')
    };
}

function initializeDom() {
    isSPCLogin = $('.spc-login').length > 0;
    isSPCShipping = $('.spc-shipping').length > 0;
    isSPCMultiShipping = $('.spc-multi-shipping').length > 0;
    isSPCBilling = $('.spc-billing').length > 0;
}

function initializeEvents() {

    if (isSPCLogin) {
        loadSPCLogin();
        login.init();
    } else if (isSPCShipping) {
        loadSPCShipping();
        giftPackaging.init();
    } else if (isSPCMultiShipping) {
        loadSPCMultiShipping();
        giftPackaging.init();

    } else if (isSPCBilling) {
        loadSPCBilling();

    }
    
    var checkA = $('.spc-billing .checkout-billing').find('input[name$="_shippingAddress_useAsBillingAddress"]').val();
    var checkB = $('.checkout-billing').find('.input-text.email').val();
    if (checkA === 'true' && checkB === '') {
        $('.checkout-billing').find('.input-text.email').addClass('email-focus');
        $('.checkout-billing').find('.input-text.email.email-focus').focus();
        $('.header-main').addClass('fixed');
        var headerHeight = $('.header-main.fixed .global-nav').outerHeight() + $('.header-main.fixed .header-banner').outerHeight();
        $('.header-main').removeClass('fixed');
        if (window.matchMedia('(min-width: 1365px)').matches) {
            $('html, body').animate({scrollTop : $('.checkout-billing .form-row.email').offset().top - headerHeight},0);
        } else {
            $('html, body').animate({scrollTop : $('.checkout-billing .form-row.email').offset().top - headerHeight - 60},0);
        }
    }

    $('.pt_checkout').ajaxError(function () {
        window.location.href = Urls.cartShow;
    });
 
    $('.privacy-policy').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                height: 600
            }
        });
    });

    $cache.primary.on('click', '.checkout-tab-head[data-href]', function (e) {
        e.preventDefault();
        progress.show($cache.primary);
        ajax.load({
            url: $(this).data('href'),
            type: 'POST',
            callback: function (data) {
                $cache.primary.html(data);
                handleBasketError();
                initSPC();
                validator.init();
                if ($cache.primary.find('.spc-login').length === 0) {
                   // tooltip.init();
                    util.limitCharacters();
                    checkout.init();
                }
                progress.hide();
                updateAnchor();
                updateSummary();
            }
        });
    });

    $cache.primary.on('click', '.checkout-tab-head.open[data-refreshurl]', function (e) {
        e.preventDefault();
        progress.show($cache.primary);
        ajax.load({
            url: $(this).data('refreshurl'),
            type: 'POST',
            callback: function (data) {
                $cache.primary.html(data);
                handleBasketError();
                initSPC();
                validator.init();
                if ($cache.primary.find('.spc-login').length === 0) {
                    tooltip.init();
                    util.limitCharacters();
                    checkout.init();
                }
                progress.hide();
               // updateSummary();
            }
        }); 
    });

    $cache.secondary.on('click', '.order-component-block a, .order-totals-table .order-shipping a', function (e) {
        e.preventDefault();
        progress.show($cache.primary);
        ajax.load({
            url: $(this).attr('href'),
            type: 'POST',
            callback: function (data) {
                $cache.primary.html(data);
                handleBasketError();
                initSPC();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
                updateAnchor();
            }
        });
    });

    $cache.primary.on('submit', 'form.address', function (e) {
        if ($(this).find('button[class$=-btn]').length > 0) {
            e.preventDefault();
            $(this).find('button[class$=-btn]').click();
        }
    });
    
    //Event for shipment edit button in review & place order
    $cache.primary.on('click', '.shipment-edit-link', function (e) {
        e.preventDefault();
        var curobj = $(this).data('href');
        progress.show($cache.primary);
        ajax.load({
            url: curobj, 
            type: 'POST',
            callback: function (data) {
                $cache.primary.html(data);
                handleBasketError();
                updateSummary();
                initSPC();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
                updateAnchor();
            }
        });
    });

    //Giftpack Toggle 
    $('#wrapper').off('click').on('click', '#gift-packaging .checkout-subtitle', function() {
        $(this).closest('#gift-packaging').toggleClass('active');
    });

    window.addEventListener('popstate', function(e) {
        if (e.state && ($('.checkout-billing').length > 0 || $('#review-order').length == 1 || $('.checkout-shipping').length == 1)) {
            progress.show($cache.primary);
            ajax.load({
                url: e.state,
                type: 'POST',
                callback: function (data) {
                    $cache.primary.html(data);
                    handleBasketError();
                    initSPC();
                    validator.init();
                    if ($cache.primary.find('.spc-login').length === 0) {
                       // tooltip.init();
                        util.limitCharacters();
                        checkout.init();
                    }
                    progress.hide();
                    updateAnchor();
                    updateSummary();
                }
            });
        }
    });

    $('select[name$="_addressFields_states_state"]').on('change', function () {
        var state = $(this).val();
        var parentWrapper = $(this).closest('.field-wrapper');
        var form =  $('form.checkout-shipping.address');
        if (state == 'HI' || state == 'AK') {

            var excludedShippingSku = $('#AKHINoShippingProduct').val();

            $('.order-summary-content .mini-cart-right').each(function () {
                var lineItemSku = $(this).data('productitemid');
                if (excludedShippingSku.includes(lineItemSku)) {

                    setTimeout(() => {
                        form.find('select[id*="state"]').addClass('error');
                    }, 200);
                    $(this).closest('.mini-cart-product').addClass('remove-product-padding');
                    $(this).closest('.mini-cart-container').addClass('has-error-msg');
                    if ($(this).closest('.mini-cart-container').find('.item-shipment-exclusion').length == 0) {
                        $(this).closest('.mini-cart-container').append('<div class="item-shipment-exclusion"><span class="error">'+Resources.ITEMSHIPMENTEXCLUSIONMSG+'</span></div>');
                    }
                    if ($('#state-shipment-exclusion-msg').length == 0) {
                        parentWrapper.append('<span id="state-shipment-exclusion-msg" class="error">'+Resources.StateShipmentExclusionMSG+'</span>');
                    }
                }
            });
        } else {
            $('.mini-cart-container').find('.item-shipment-exclusion').remove();
            $('#state-shipment-exclusion-msg').remove();
            form.find('select[id*="state"]').removeClass('error');
        }
    });
    
    $('select[id*="_addressFields_states_state"]').on('blur', function () {
        var form =  $('form.checkout-shipping.address');
        if ($('#state-shipment-exclusion-msg').length == 1) {
            form.find('select[id*="state"]').addClass('error');
        }
    });
}
var prefVal = $('input[name="preferedAddressID"]').attr('value');
if (prefVal != undefined && prefVal != null && prefVal != '') {
    $('select[id*="_singleshipping_addressList"]').find('option').each(function() {
        if ($(this).val() == prefVal) {
            $(this).attr('selected', 'selected');
        }
    });
}

function loadSPCLogin() {
    updateSummary();
    $cache.primary.find('.spc-login').trigger('ready');
    $cache.primary.off('click', '.spc-login-btn:not(:disabled)').on('click', '.spc-login-btn:not(:disabled)', function(e) {
        e.preventDefault();
        var form = $(this).closest('form');
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
        form.validate();
        if (!form.valid()) {
            return false;
        }
        progress.show($cache.primary);
        var actionUrl = form.attr('action');
        if (actionUrl.indexOf('?') != -1) {
            actionUrl = actionUrl.concat('&format=ajax');
        } else {
            actionUrl = actionUrl.concat('?format=ajax');
        }
        $.ajax({
            url: actionUrl,
            data: form.serialize(),
            type: 'POST',
            success: function(data, status, xhr) {
                var ct = xhr.getResponseHeader('content-type') || '';
                if (ct.indexOf('json') != -1) {
                    window.location.href = data.passwordResetUrl;
                } else {
                    $cache.primary.html(data);
                    handleBasketError();
                    //initSPC();
                    updateSummary();
                    validator.init();
                    if ($cache.primary.find('.spc-login').length === 0) {
                        tooltip.init();
                        util.limitCharacters();
                        checkout.init();
                        updateCustomerInfo();
                        updateMiniCart();
                    }
                    progress.hide();
                    updateAnchor();
                }
            }
        });
    });

    $cache.primary.on('click', '.spc-guest-btn:not(:disabled)', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
        form.validate();
        if (!form.valid()) {
            return false;
        }
        progress.show($cache.primary);
        $('.intermediate-login-paypal').addClass('paypal-disabled');
        ajax.load({
            url: form.attr('action'),
            data: form.serialize(),
            type: 'POST',
            callback: function (data) {
                $cache.primary.html(data);
                handleBasketError();
                initSPC();
                updateSummary();
                validator.init();
                if ($cache.primary.find('.spc-login').length === 0) {
                    tooltip.init();
                    util.limitCharacters();
                    checkout.init();
                    history.replaceState(Urls.startCheckout, null, Urls.startCheckout);
                    history.pushState(Urls.startCheckout, null, Urls.startCheckout);
                }
                $('.intermediate-login-paypal').removeClass('paypal-disabled');
                progress.hide();
                updateAnchor();
            }
        });
    });
}

function loadSPCShipping() {
    $cache.primary.on('click', '.spc-shipping-btn:not(:disabled)', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
        form.validate();
        if (!form.valid()) {
            form.find('input.error').first().focus();
            if (window.matchMedia('(min-width: 1365px)').matches) {
                $('html, body').animate({scrollTop : form.find('input.error').first().parents('.form-row').offset().top - $('.header-main.fixed').outerHeight()},0);
            } else {
                $('html, body').animate({scrollTop : form.find('input.error').first().parents('.form-row').offset().top - $('.header-main.fixed').outerHeight() - 60},0);
            }
            return false;
        }
        var isGiftMsg = $('.gift-message-text').hasClass('hidden');
        if (isGiftMsg) {
            $('.gift-message-text').find('input').val('');
        }
        progress.show($cache.primary);
        ajax.load({
            url: form.attr('action'),
            data: form.serialize(),
            type: 'POST',
            callback: function (data) {
                $('html, body').animate({scrollTop : 0},0);
                $cache.primary.html(data);
                handleBasketError();
                updateSummary();
                initSPC();
               // tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
                if ($cache.primary.find('.spc-shipping').length === 0) {
                    updateAnchor();
                } else {
                    updateAnchor(true);
                }
                if ($('.checkout-billing').length > 0) {
                    history.replaceState(Urls.shipping, null, Urls.startCheckout);
                    history.pushState(Urls.shipping, null, Urls.startCheckout);
                }
            }
        });
    });
    // As per requirement country section is not needed.
    $('select[id*="_singleshipping_shippingAddress_addressFields_country"]').closest('.form-row').hide();

    $cache.primary.on('click', '.shiptomultiplebutton:not(:disabled)', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var url = util.appendParamToURL(form.attr('action'), $(this).attr('name'), true);
        url = util.appendParamToURL(url, form.find('input[name="csrf_token"]').attr('name'), form.find('input[name="csrf_token"]').attr('value'));
        progress.show($cache.primary);
        ajax.load({
            url: url,
            type: 'POST',
            callback: function (data) {
                $cache.primary.html(data);
                handleBasketError();
                updateSummary();
                initSPC();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
                updateAnchor();
            }
        });
    });
}

function loadSPCMultiShipping() {
    $cache.primary.on('click', '.spc-multi-shipping-btn:not(:disabled)', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
        form.validate();
        if (!form.valid()) {
            return false;
        }
        progress.show($cache.primary);
        ajax.load({
            url: form.attr('action'),
            data: form.serialize(),
            type: 'POST',
            callback: function(data) {
                $cache.primary.html(data);
                handleBasketError();
                updateSummary();
                initSPC();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
                updateAnchor();
            }
        });
    });

    $cache.primary.on('click', '.item-shipping-address a', function (e) {
        e.preventDefault();
        progress.show($cache.primary);
        ajax.load({
            url: $(this).attr('href'),
            type: 'POST',
            callback: function (data) {
                $cache.primary.html(data);
                handleBasketError();
                initSPC();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
                updateAnchor();
            }
        });
    });
    
    $cache.primary.on('click', '.shiptosinglebutton', function(e) {
        e.preventDefault();
        var form = $(this).closest('form');

        var url = util.appendParamToURL(form.attr('action'), $(this).attr('name'), true);
        if (form.find('input[name="csrf_token"]').attr('name') != undefined) {
            url = util.appendParamToURL(url, form.find('input[name="csrf_token"]').attr('name'), form.find('input[name="csrf_token"]').attr('value'));    
        }
        progress.show($cache.primary);
        ajax.load({
            url: url,
            type: 'POST',
            callback: function(data) {
                $cache.primary.html(data);
                handleBasketError();
                updateSummary();
                initSPC();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
                updateAnchor();
            }
        });
    });

}

function loadSPCBilling() {
    $cache.primary.on('change','.month .input-select ' , function() {
        if ($('.month').hasClass('expiration-error') || $('.year').hasClass('expiration-error')) {
            $('.month, .year').removeClass('expiration-error');
            $('.month .error-message').css('display', 'none');
        }
    });
    $cache.primary.on('click', '.spc-billing-btn:not(:disabled)', function(e) {
        if ($('input[name$=_selectedPaymentMethodID]:checked').val() === 'PayPal') {
            $(this).removeClass('spc-billing-btn');
            return true;
        }

        e.preventDefault();

        var form = $(this).closest('form');
        form.validate();
        if (!form.valid()) {
            form.find('input.error').first().focus();
            if (window.matchMedia('(min-width: 1365px)').matches) {
                $('html, body').animate({scrollTop : form.find('input.error').first().parents('.form-row').offset().top - $('.header-main.fixed').outerHeight()},0);
            } else {
                $('html, body').animate({scrollTop : form.find('input.error').first().parents('.form-row').offset().top - $('.header-main.fixed').outerHeight() - 60},0);
            }
            return false;
        }
        if ($('#custome-recaptcha-response').length > 0) {
            var siteKey = $('#custome-recaptcha-response').data('sitekey');
            var action = $('#custome-recaptcha-response').data('action') || '';
            if (siteKey && siteKey != '') {
                window.grecaptcha.ready(function() {
                    window.grecaptcha.execute(siteKey, {
                        action: action
                    }).then(function(token) {
                        $('#custome-recaptcha-response').text(token);
                        progress.show($cache.primary);
                        ajax.load({
                            url: form.attr('action'),
                            data: form.serialize(),
                            type: 'POST',
                            callback: function(data) {
                                $('html, body').animate({
                                    scrollTop: 0
                                }, 0);
                                if ($(data).find('.redirect-text .afterpayToken').length > 0) {
                                    var afterpayToken = $(data).find('.redirect-text .afterpayToken').val();
                                    var url = SitePreferences.afterPayRedirectUrl;
                                    url = url + afterpayToken;
                                    window.location.href = url;
                                }                                
                                $cache.primary.html(data);
                                handleBasketError();
                                initSPC();
                                if ($cache.primary.find('.spc-summary').length === 0) {
                                    //  tooltip.init();
                                    util.limitCharacters();
                                    validator.init();
                                }
                                checkout.init();
                                progress.hide();
                                if ($cache.primary.find('.spc-billing').length === 0) {
                                    updateSummary(5);
                                    updateAnchor();
                                } else {
                                    updateSummary(4);
                                    updateAnchor(true);
                                }
                                if ($('#review-order').length == 1) {
                                    history.replaceState(Urls.billing, null, Urls.startCheckout);
                                    history.pushState(Urls.billing, null, Urls.startCheckout);
                                }
                            }
                        });
                    });
                });
            } else {
                return false;
            }
        } else {
            progress.show($cache.primary);
            ajax.load({
                url: form.attr('action'),
                data: form.serialize(),
                type: 'POST',
                callback: function(data) {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 0);
                    if ($(data).find('.redirect-text .afterpayToken').length > 0) {
                        var afterpayToken = $(data).find('.redirect-text .afterpayToken').val();
                        var url = SitePreferences.afterPayRedirectUrl;
                        url = url + afterpayToken;
                        window.location.href = url;
                    }                    
                    $cache.primary.html(data);
                    handleBasketError();
                    initSPC();
                    if ($cache.primary.find('.spc-summary').length === 0) {
                        //  tooltip.init();
                        util.limitCharacters();
                        validator.init();
                    }
                    checkout.init();
                    progress.hide();
                    if ($cache.primary.find('.spc-billing').length === 0) {
                        updateSummary(5);
                        updateAnchor();
                    } else {
                        updateSummary(4);
                        updateAnchor(true);
                    }
                    if ($('#review-order').length == 1) {
                        history.replaceState(Urls.billing, null, Urls.startCheckout);
                        history.pushState(Urls.billing, null, Urls.startCheckout);
                    }
                }
            });
        }
    });
    // As per requirement country section is not needed.
    $('select[id*="_billing_billingAddress_addressFields_country"]').closest('.form-row').hide();
    
    $cache.primary.off('click', '.redemption.giftcert a.remove').on('click', '.redemption.giftcert a.remove', function (e) {
        e.preventDefault();
        progress.show($cache.primary);
        var url = $(this).attr('href');
        ajax.load({
            url: url,
            data: {},
            type: 'GET',
            callback: function (data) {
                $cache.primary.html(data);
                handleBasketError();
                updateSummary();
                initSPC();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
                
            }
        });
    });

    $('input[name*="giftcard_cardnumber"], input[name*="giftcard_pin"]').on('keyup', function () {
        var cardNumber = $('input[name*="giftcard_cardnumber"]').val();
        var pin = $('input[name*="giftcard_pin"]').val();

        if (cardNumber != '') {
            $('input[name*="giftcard_pin"]').prop('required',true);
        }
        if (cardNumber == '') {
            $('.pin-number .error').html('');
            $('input[name*="giftcard_pin"]').removeClass('error');
            $('input[name*="giftcard_pin"]').prop('required',false);
        }
        if (cardNumber == '' && pin == '') {
            $('input[name*="giftcard_pin"]').prop('required',false);
            var $error = $('.giftcert-error.error');
            $error.html('');
        }
    });
    $cache.primary.off('click', '#apply-giftcert').on('click', '#apply-giftcert', function(e) {
        e.preventDefault();
        var cardNumber = $('input[name*="giftcard_cardnumber"]').val();
        var pin = $('input[name*="giftcard_pin"]').val();
        var $error = $('.giftcert-error.error');
        if (cardNumber.trim() == '' && pin.trim() == '') {
            $error.html(Resources.GIFTCARD_NUMBER_FORMPIN_MISSING);
            return false;
        }
        if (cardNumber.trim() == '') {
            $error.html(Resources.GIFTCARD_NUMBER_FORM_MISSING);
            return false;
        }
        if (pin.trim() == '') {
            $error.html(Resources.GIFTCARD_NUMBER_PIN_MISSING);
            return false;
        }
        var url = util.appendParamsToUrl(Urls.applyGiftCard, {
            cardNumber: cardNumber,
            pin: pin,
            giftCardPin: 'ajax'
        });
        progress.show($cache.primary);
        if ($('#custom-gift-recaptcha-response').length > 0) {
            var siteKey = $('#custom-gift-recaptcha-response').data('sitekey');
            var action = $('#custom-gift-recaptcha-response').data('action') || '';
            if (siteKey && siteKey != '') {
                window.grecaptcha.ready(function() {
                    window.grecaptcha.execute(siteKey, {
                        action: action
                    }).then(function(token) {
                        $('#custom-gift-recaptcha-response').val(token);
                        url = util.appendParamsToUrl(url, {
                            'g-recaptcha-response': token
                        });
                        ajax.getJson({
                            url: url,
                            callback: function (data) {
                                var fail = false;
                                var errorMsg = Resources.BAD_RESPONSE;
                                if (!data) {
                                    errorMsg = Resources.BAD_RESPONSE;
                                    fail = true;
                                } else if (!data.giftCertificate.success) {
                                    if (data.giftCertificate.gRecaptchaError){
                                        errorMsg = data.giftCertificate.gRecaptchaError;
                                    } else if (data.giftCertificate.zerobalance != undefined && data.giftCertificate.zerobalance) {
                                        errorMsg = data.giftCertificate.responseMessage;
                                    } else {
                                        errorMsg = Resources.GIFTCARD_NUMBER_FORM_PIN_MISSING;
                                    }
                                    fail = true;
                                }
                                if (fail) {
                                    $error.html(errorMsg);
                                    progress.hide();
                                    return false;
                                } else {
                                    //$('.gift-cert-used').find('input[name$="_selectedPaymentMethodID"]').val('SVS_GIFT_CARD');
                                    saveBillingForm();
                                    if ($('.spc-express-checkout').length > 0) {
                                        $('.spc-express-checkout .express-billing-refresh[data-refreshurl]').trigger('click');
                                    } else {
                                        $('.spc-billing .checkout-tab-head.open[data-refreshurl]').trigger('click');
                                    }
                                }
                                handleBasketError();
                                updateSummary();
                                initSPC();
                                tooltip.init();
                                util.limitCharacters();
                                validator.init();
                                checkout.init();
                                progress.hide();
                            }
                        });
                    });
                });
            } else {
                return false;
            }
        } else {
            ajax.getJson({
                url: url,
                callback: function (data) {
                    var fail = false;
                    var errorMsg = Resources.BAD_RESPONSE;
                    if (!data) {
                        errorMsg = Resources.BAD_RESPONSE;
                        fail = true;
                    } else if (!data.giftCertificate.success) {
                        if (data.giftCertificate.zerobalance != undefined && data.giftCertificate.zerobalance) {
                            errorMsg = data.giftCertificate.responseMessage;
                        } else {
                            errorMsg = Resources.GIFTCARD_NUMBER_FORM_PIN_MISSING;
                        }
                        fail = true;
                    }
                    if (fail) {
                        $error.html(errorMsg);
                        progress.hide();
                        return false;
                    } else {
                        //$('.gift-cert-used').find('input[name$="_selectedPaymentMethodID"]').val('SVS_GIFT_CARD');
                        saveBillingForm();
                        if ($('.spc-express-checkout').length > 0) {
                            $('.spc-express-checkout .express-billing-refresh[data-refreshurl]').trigger('click');
                        } else {
                            $('.spc-billing .checkout-tab-head.open[data-refreshurl]').trigger('click');
                        }
                    }
                    handleBasketError();
                    updateSummary();
                    initSPC();
                    tooltip.init();
                    util.limitCharacters();
                    validator.init();
                    checkout.init();
                    progress.hide();
                }
            });
        }
    });

    $cache.primary.off('click', '.remove-applied-giftcard').on('click', '.remove-applied-giftcard', function(e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var $error = $('.giftcert-error.error');
        progress.show($cache.primary);
        ajax.getJson({
            url: url,
            callback: function (data) {
                if (!data) {
                    $error.html(Resources.BAD_RESPONSE);
                    progress.hide();
                    return false;
                } else if (!data.giftCertificate.success) {
                    $error.html(Resources.BAD_RESPONSE);
                    progress.hide();
                    return false;
                } else {
                    saveBillingForm();
                    if ($('.spc-express-checkout').length > 0) {
                        $('.spc-express-checkout .express-billing-refresh[data-refreshurl]').trigger('click');
                    } else {
                        $('.spc-billing .checkout-tab-head.open[data-refreshurl]').trigger('click');
                    }
                    progress.hide();
                    return true;
                }
                handleBasketError();
                updateSummary();
                initSPC();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
            }
        });
    });
    
    $cache.primary.off('click','#check-balance').on('click', '#check-balance', function(e) {
        e.preventDefault();
        var $balance = $('.balance');
        var cardNumber = $('input[name$="_checkoutgiftcard_cardnumber"]').val();
        var pin = $('input[name$="_checkoutgiftcard_pin"]').val();
        var $error = $('.giftcert-error.error');
        if (cardNumber.trim() == '' && pin.trim() == '') {
            $error.html(Resources.GIFTCARD_NUMBER_FORMPIN_MISSING);
            return false;
        }
        if (cardNumber.trim() == '') {
            $error.html(Resources.GIFTCARD_NUMBER_FORM_MISSING);
            return false;
        }
        if (pin.trim() == '') {
            $error.html(Resources.GIFTCARD_NUMBER_PIN_MISSING);
            return false;
        }
        var url = util.appendParamsToUrl(Urls.checkGiftCardBalance, {
            cardNumber: cardNumber,
            pin: pin,
            giftCardPin: 'ajax'
        });
        progress.show($cache.primary);
        if ($('#custom-gift-recaptcha-response').length > 0) {
            var siteKey = $('#custom-gift-recaptcha-response').data('sitekey');
            var action = $('#custom-gift-recaptcha-response').data('action') || '';
            if (siteKey && siteKey != '') {
                window.grecaptcha.ready(function() {
                    window.grecaptcha.execute(siteKey, {
                        action: action
                    }).then(function(token) {
                        $('#custom-gift-recaptcha-response').val(token);
                        url = util.appendParamsToUrl(url, {
                            'g-recaptcha-response': token
                        });
                        ajax.getJson({
                            url: url,
                            callback: function(data) {
                                var fail = false;
                                var errorMsg = Resources.BAD_RESPONSE;
                                if (!data) {
                                    errorMsg = Resources.BAD_RESPONSE;
                                    fail = true;
                                } else if (!data.giftCertificate.success) {
                                    if (data.giftCertificate.gRecaptchaError){
                                        errorMsg = data.giftCertificate.gRecaptchaError;
                                    } else {
                                        errorMsg = Resources.GIFTCARD_NUMBER_FORM_PIN_MISSING;
                                    }
                                    fail = true;
                                }
                                if (fail) {
                                    $error.html(errorMsg);
                                    $balance.html('');
                                    progress.hide();
                                    return false;
                                } else {
                                    $error.html('');
                                    $balance.html(Resources.GIFT_CARD_BALANCE + ' ' + data.giftCertificate.GiftCardBalance);
                                }
                                handleBasketError();
                                updateSummary();
                                initSPC();
                                tooltip.init();
                                util.limitCharacters();
                                validator.init();
                                checkout.init();
                                progress.hide();
                            }
                        });
                    });
                });
            } else {
                return false;
            }
        } else {
            ajax.getJson({
                url: url,
                callback: function(data) {
                    var fail = false;
                    var errorMsg = Resources.BAD_RESPONSE;
                    if (!data) {
                        errorMsg = Resources.BAD_RESPONSE;
                        fail = true;
                    } else if (!data.giftCertificate.success) {
                        errorMsg = Resources.GIFTCARD_NUMBER_FORM_PIN_MISSING;
                        fail = true;
                    }
                    if (fail) {
                        $error.html(errorMsg);
                        $balance.html('');
                        progress.hide();
                        return false;
                    } else {
                        $error.html('');
                        $balance.html(Resources.GIFT_CARD_BALANCE + ' ' + data.giftCertificate.GiftCardBalance);
                    }
                    handleBasketError();
                    updateSummary();
                    initSPC();
                    tooltip.init();
                    util.limitCharacters();
                    validator.init();
                    checkout.init();
                    progress.hide();
                }
            });
        }
    });
}

function updateSummary(checkoutStep) {
    var url = Urls.summaryRefreshURL;
    url = util.appendParamToURL(url, 'format', 'ajax');
    if (checkoutStep) {
        url = util.appendParamToURL(url, 'checkoutstep', checkoutStep);
    } else {
        url = url;
    }
    var summary = $('#secondary.summary');
    summary.load(url, function() {
        summary.find('.checkout-mini-cart .minishipment .header a').hide();
        summary.find('.order-totals-table .order-shipping .label a').hide();
        setTimeout(() => {
            couponCode.init($('.billing-coupon-code-sec'));
        }, 3000);
        
        $('.billing-coupon-code-sec input').on('keypress', function (e) {
            if (e.which === 13) {
                $('#add-coupon').trigger('click');
            }
        });

        // phone number formate code
        if ($('.phoneformat').length > 0) {
            var $curobjshipping = $('.phoneformat');
            $($curobjshipping).each(function(){
                var $updatedText = $(this).text().replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
                $(this).text($updatedText);
            });
        }
    });
}

function updateAnchor(noDefault) {
    var erroredElements = $cache.primary.find('.form-row.error:visible').filter(function (i, ele) {
        return $.trim($(ele).html()).length > 0;
    });

    if (erroredElements.length > 0) {
        jQuery('html, body').animate({
            scrollTop: erroredElements.first().position().top
        }, 500);

    } else if ($('.billing-error').length > 0) {
        jQuery('html, body').animate({
            scrollTop: $('.billing-error').position().top
        }, 500);
    } else if (!noDefault) {
        if ($('.spc-billing .checkout-billing').find('input[name$="_shippingAddress_useAsBillingAddress"]').val() !== 'true') {
            jQuery('html, body').animate({
                scrollTop: $('#navigation').position().top
            }, 500);
        }
    }
}

function handleBasketError() {
    if ($cache.primary.find('.pt_cart').length > 0) {
        window.location.href = Urls.cartShow;
    }
}

function updateCustomerInfo() {
    $.ajax({
        url: Urls.customerInfo,
        type: 'GET',
        async: false,
        success: function(data) {
            $('#navigation').find('.menu-utility-user').find('.basicUserInfo').remove();
            $('#navigation .menu-utility-user').append(data);
            $('#menuUtilityUser.menu-utility-user').find('.menu-utility-ul').find('.basicUserInfo').remove();
            $('#menuUtilityUser.menu-utility-user .menu-utility-ul').prepend(data);
            $('.user-account').on('click', function(e) {
                e.preventDefault();
                $(this).parent('.user-info').toggleClass('active');
            });
        }
    });
}

function updateMiniCart() {
    $.ajax({
        url: Urls.minicartShow,
        type: 'GET',
        async: false,
        success: function(data) {
            minicart.show(data);
        }
    });
}

function initSPC() {
    initializeCache();
    initializeDom();
    initializeEvents();
}
function checkValidState(){
    var state = $('select[name$="_addressFields_states_state"]').val();
    var parentWrapper = $('select[name$="_addressFields_states_state"]').closest('.field-wrapper');
    var form =  $('form.checkout-shipping.address');
    if (state == 'HI' || state == 'AK') {
        var excludedShippingSku = $('#AKHINoShippingProduct').val();
        $('.order-summary-content .mini-cart-right').each(function () {
            var lineItemSku =  $(this).data('productitemid');
            if (excludedShippingSku.includes(lineItemSku)) {
                setTimeout(() => {
                    form.find('select[id*="state"]').addClass('error');
                }, 200);
                $(this).closest('.mini-cart-product').addClass('remove-product-padding');
                $(this).closest('.mini-cart-container').addClass('has-error-msg');
                if ($(this).closest('.mini-cart-container').find('.item-shipment-exclusion').length == 0) {
                    $(this).closest('.mini-cart-container').append('<div class="item-shipment-exclusion"><span class="error">'+Resources.ITEMSHIPMENTEXCLUSIONMSG+'</span></div>');
                }
                if ($('#state-shipment-exclusion-msg').length == 0) {
                    parentWrapper.append('<span id="state-shipment-exclusion-msg" class="error">'+Resources.StateShipmentExclusionMSG+'</span>');
                }
            }
        });
    } else {
        $('.mini-cart-container').find('.item-shipment-exclusion').remove();
        $('#state-shipment-exclusion-msg').remove();
        form.find('select[id*="state"]').removeClass('error');
    }
}
exports.init = function () {
    checkValidState();
    initializeCache();
    initializeDom();
    initializeEvents();
};


},{"./ajax":2,"./dialog":13,"./login":20,"./minicart":21,"./pages/checkout":32,"./pages/checkout/couponCodeModule":28,"./pages/checkout/giftpackage":31,"./progress":59,"./tooltip":77,"./util":78,"./validator":79}],69:[function(require,module,exports){
'use strict';

var inventory = require('./');

var cartInventory = {
    setSelectedStore: function (storeId) {
        var $selectedStore = $('.store-tile.' + storeId),
            $lineItem = $('.cart-row[data-uuid="' + this.uuid + '"]'),
            storeAddress = $selectedStore.find('.store-details-left').html(),
            storeStatus = $selectedStore.find('.store-status').data('status'),
            storeStatusText = $selectedStore.find('.store-status').text();
        this.selectedStore = storeId;

        $lineItem.find('.instore-delivery .selected-store-address')
            .data('storeId', storeId)
            .attr('data-store-id', storeId)
            .html(storeAddress);
        $lineItem.find('.instore-delivery .selected-store-availability')
            .data('status', storeStatus)
            .attr('data-status', storeStatus)
            .text(storeStatusText);
        if ($.trim($lineItem.find('a.set-preferred-store').text()) == Resources.CHECKSTOREAVAILABILITY) {
            $lineItem.find('a.set-preferred-store').text(Resources.CHANGE_STORE_BOPIS);
        }
        $lineItem.find('.instore-delivery .delivery-option').removeAttr('disabled').trigger('click');
    },
    cartSelectStore: function (selectedStore) {
        var self = this;
        inventory.getStoresInventory(this.uuid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: selectedStore,
                selectedStoreText: Resources.SELECTED_STORE,
                continueCallback: function () {},
                selectStoreCallback: self.setSelectedStore.bind(self)
            });
        }).done();
    },
    setDeliveryOption: function (value, storeId) {
        // set loading state
        $('.item-delivery-options')
            .addClass('loading')
            .children().hide();

        var data = {
            plid: this.uuid,
            storepickup: (value === 'store' ? true : false)
        };
        if (value === 'store') {
            data.storepickup = true;
            data.storeid = storeId;
        } else {
            data.storepickup = false;
        }
        $.ajax({
            url: Urls.setStorePickup,
            data: data,
            success: function () {
                // remove loading state
                $('.item-delivery-options')
                    .removeClass('loading')
                    .children().show();
            }
        });
    },
    init: function () {
        var self = this;
        $('.item-delivery-options .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            self.uuid = $(this).data('uuid');
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.cartSelectStore(selectedStore);
                });
            } else {
                self.cartSelectStore(selectedStore);
            }
        });
        $('.item-delivery-options .delivery-option').on('click', function () {
            // reset the uuid
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            self.uuid = $(this).closest('.cart-row').data('uuid');
            self.setDeliveryOption($(this).val(), selectedStore);
        });
    }
};

module.exports = cartInventory;

},{"./":74}],70:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    progress = require('../progress'),
    dialog = require('../dialog'),
    radar = require('../radar'),
    classStorePreference = require('./classStorePreference');

var newLine = '\n';
var searchStoreText;

function getClpCgid() {
    var cgid = $('.class-location-select').data('cgid');
    if (cgid) {
        return String(cgid);
    }
    var href = $('.class-location-select .set-preferred-store a').attr('href') || '';
    var match = href.match(/[?&]cgid=([^&]+)/);
    return match ? decodeURIComponent(match[1]) : '';
}

var ClassStoreFinder = {

    selectStorePrompt: function() {
        var self = this;
        dialog.open({
            html: ClassStoreFinder.selectStorePromptTemplate(),
            options: {
                title: '',
                dialogClass: 'Pdp-pick-store-panel',
                width: 760,
                height: 'auto',
                open: function() {
                    $('body').addClass('modal-open');
                    $('.ui-dialog').addClass('culinary-dialog');
                    $('#user-input-text-store-class').on('keypress', function(e) {
                        if (e.which === 13) {
                            searchStoreText = $('#user-input-text-store-class').val();
                            self.getStoreByText(searchStoreText);
                        }
                    });
                    $('.find-in-store-search-class').on('click', function() {
                        searchStoreText = $('#user-input-text-store-class').val();
                        self.getStoreByText(searchStoreText);
                        
                    });
                    
                    $('.cdp-use-current-location').on('click', function() {
                        self.getNearestStore();  
                    });

                    if (radar.isEnabled) {
                        var resetClassLocationAddressList = function() {
                            $('#classLocationAddressList').empty();
                            $('#classLocationAddressList').addClass('hidden');
                        };
            
                        var userInputLocation = '';
                        $('body').on('keyup','#user-input-text-store-class', _.debounce(function(e) {
                            if (userInputLocation === e.target.value) {
                                return;
                            }

                            userInputLocation = e.target.value;
                            var classLocationAddressList = $('#classLocationAddressList');
                            if (e.target.value.length > 0) {
                                radar.autocomplete({
                                    query: e.target.value,
                                    limit: 5,
                                    layers: 'coarse',
                                    countryCode: 'US'
                                }).then((result) => {
                                    resetClassLocationAddressList();
            
                                    if (!result.addresses.length) {
                                        return;
                                    }
            
                                    result.addresses.forEach(function(address){
                                        $('<li/>')
                                            .addClass('location-search-address-list-item')
                                            .html(address.formattedAddress)
                                            .on('click', function() {
                                                userInputLocation = address.formattedAddress;
                                                $('#user-input-text-store-class').val(address.formattedAddress);
                                                resetClassLocationAddressList();
                                            })
                                            .appendTo(classLocationAddressList);
                                    });
            
                                    classLocationAddressList.removeClass('hidden');
                                });
                            } else {
                                resetClassLocationAddressList();
                            }
                        }, 1000));
                    }
                },
                close: function() {
                    $('body').removeClass('modal-open');   
                }
            }
        });
    },

    selectStorePromptTemplate: function() {
        return [
            '<div class="location-near-you store-near-you">' + Resources.LOCATION_NEAR_YOU + '</div>',
            '<div id="preferred-store-panel">',
            '<div id="preferred-current-location">',
            '<a href="#" class="cdp-use-current-location c1"><span class="location-icon"></span>'  + 'use my location' + '</a>',
            '</div>',
            '<label class="label" for="user-input-text-store-class">' + Resources.ENTER_LOCATION + '</label>',
            '<div class="location-search-container">',
            '<div>',
            '<input type="text" id="user-input-text-store-class" placeholder="' + Resources.ENTER_CITY_ZIP + '" name="zipCode" autocomplete="off"/>',
            '<button class="find-in-store-search-class Preferred-Store button-primary">' + Resources.FIND + '</button>',
            '</div>',
            '<ul id="classLocationAddressList" class="location-search-address-list hidden"></ul>',
            '</div>',
            '<div class="no-results hide">' + Resources.INVALID_CITY_ZIP + '</div>',
            '</div>'
        ].join(newLine);
    },
    
    getStoreByText: function(searchStoreText) {
        progress.show($('.Pdp-pick-store-panel'));
        $.ajax({
            type: 'POST',
            url: Urls.searchStoreByText,
            data: {
                searchStoreText: searchStoreText
            }
        })
        .done(function (data) {
            if (data.length > 0) {
                ClassStoreFinder.selectStoreDialog(data);
                progress.hide();
            } else {
                ClassStoreFinder.selectStorePrompt();
                progress.hide();
                $('.no-results').show();
            }
        });
    },
    
    getNearestStore: function() {
        progress.show($('.Pdp-pick-store-panel'));

        var getNearestStoreCLP = function(data) {
            $.ajax({
                type: 'POST',
                url: Urls.getNearestStoreCLP,
                data: data
            })
            .done(function (data) {
                if (data.length > 0) {
                    ClassStoreFinder.selectStoreDialog(data);
                    progress.hide();
                } else {
                    ClassStoreFinder.selectStorePrompt();
                    progress.hide();
                    $('.no-results').show();
                }
            });
        };

        var data = {
            cgid: getClpCgid()
        };
        if (radar && radar.isEnabled && typeof radar.getGeoLocation === 'function') {
            radar.getGeoLocation().then(function(address) {
                if (address && typeof address.latitude === 'number' && typeof address.longitude === 'number') {
                    data.latitude = address.latitude;
                    data.longitude = address.longitude;
                }
                getNearestStoreCLP(data);
            }).catch(function() {
                getNearestStoreCLP(data);
            });
        } else {
            getNearestStoreCLP(data);
        }
    },
    
    selectStoreDialog: function(stores) {
        var self = this;
        dialog.open({
            html: ClassStoreFinder.storeListTemplate(stores),
            options: {
                title: '',
                dialogClass: 'Pdp-pick-store-panel class-store-panel',
                width: 760,
                open: function() {
                    $('body').addClass('modal-open');
                    $('.ui-dialog').addClass('culinary-dialog');
                    $('.ui-dialog').addClass('dialog-updated');
                    $('#user-input-text-store-class').on('keypress', function(e) {
                        if (e.which === 13) {
                            searchStoreText = $('#user-input-text-store-class').val();
                            self.getStoreByText(searchStoreText);
                        }
                    });
                    
                    $('.find-in-store-search-class').on('click', function() {
                        searchStoreText = $('#user-input-text-store-class').val();
                        self.getStoreByText(searchStoreText);
                        
                    });
                    
                    $('.cdp-use-current-location').on('click', function() {
                        self.getNearestStore();  
                    });

                    $('.select-store-button').on('click', function(e) {
                        e.preventDefault();
                        var $button = $(this);
                        var storeId = $button.data('storeId');
                        // SLTBE-8826: persist to per-tab sessionStorage (replaces the old
                        // culinary_class_preferred_store cookie). Keys match the PWA exactly.
                        classStorePreference.setPreferredStore(String(storeId));
                        var latitude = parseFloat($button.attr('data-store-latitude'));
                        var longitude = parseFloat($button.attr('data-store-longitude'));
                        var city = $button.attr('data-store-city');
                        var stateCode = $button.attr('data-store-state');
                        if (city && !isNaN(latitude) && !isNaN(longitude)) {
                            classStorePreference.setUserCity({
                                label: stateCode ? city + ', ' + stateCode : city,
                                coordinates: {
                                    latitude: latitude,
                                    longitude: longitude
                                },
                                stateCode: stateCode || ''
                            });
                        }
                        self.setUserSelectedCalssStore(storeId);
                        dialog.close();
                        $('.class-location-select #reset-preferred-store')[0].click();
                    });
                },
                close: function() {
                    $('body').removeClass('modal-open');   
                }
            }
        });
    },
    
    storeListTemplate: function (stores) {
        if (stores && stores.length) {
            return [
                '<div class="location-near-you store-near-you">' + Resources.LOCATION_NEAR_YOU + '</div>',
                '<div id="preferred-store-panel">',
                '<div id="preferred-current-location">',
                '<a href="#" class="cdp-use-current-location c1"><span class="location-icon"></span>'  + 'use my location' + '</a>',
                '</div>',
                '<label class="label" for="user-input-text-store-class">' + Resources.ENTER_LOCATION + '</label>',
                '<div class="location-search-container">',
                '<div>',
                '<input type="text" id="user-input-text-store-class" placeholder="' + Resources.ENTER_CITY_ZIP + '" name="zipCode" autocomplete="off"/>',
                '<button class="find-in-store-search-class Preferred-Store button-primary">' + Resources.FIND + '</button>',
                '</div>',
                '<ul id="classLocationAddressList" class="location-search-address-list hidden"></ul>',
                '</div>',
                '</div>',            	
                '<div class="store-list-container">',
                '<ul class="store-list">',
                _.map(stores, function (store) {
                    return ClassStoreFinder.storeTemplate(store);
                }).join(newLine),
                '</ul>',
                '</div>',
                '<div class="store-list-pagination">',
                '</div>'
            ].join(newLine);
        } else {
            return '<div class="no-results">' + Resources.INVALID_CITY_ZIP + '</div>';
        }
    },
    
    storeTemplate: function (store) {
        return [
            '<li class="store-tile ' + store.storeId + '">',
            '<div class="store-details-classes">',
            '<span class="store-name">',
            '        ' + store.storeName,
            '</span>',
            '<span class="store-distance">',
            '        (' + (store.storeDistance).toFixed(2) + ' mi)',
            '</span>',
            '    <p class="store-address">',
            '        ' + store.address1 + '<br/>',
            '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode,
            '    </p>',
            '</div>',
            '<div class="store-button-classes">',
            '    <button class="select-store-button button-primary" data-store-id="' + store.storeId + '"'
                + ' data-store-city="' + (store.city || '') + '"'
                + ' data-store-state="' + (store.stateCode || '') + '"'
                + ' data-store-latitude="' + (store.latitude != null ? store.latitude : '') + '"'
                + ' data-store-longitude="' + (store.longitude != null ? store.longitude : '') + '"'
                + '>',
            '        ' + Resources.SELECT_LOCATION,
            '    </button>',
            '</div>',
            '</li>'
        ].join(newLine);
    },
    
    setUserSelectedCalssStore: function(storeId) {
        $.ajax({
            type: 'POST',
            async: false,
            url: Urls.setSelectedCalssStore,
            data: {
                selectedclassstore: storeId
            }
        });
    }
};

module.exports = ClassStoreFinder;

},{"../dialog":13,"../progress":59,"../radar":62,"./classStorePreference":71,"lodash":94}],71:[function(require,module,exports){
'use strict';

/**
 * SLTBE-8826 — per-tab persistence for the cooking-class "preferred store" and
 * "nearby city" that previously lived in the `culinary_class_preferred_store`
 * cookie. This module is the single client-side owner of that state; it mirrors
 * the PWA implementation (PR #1668) so the two surfaces read and write the exact
 * same sessionStorage keys.
 *
 *   - `culinary_class_preferred_store` : numeric store-id string (server consumes it).
 *   - `slt_user_city`                  : JSON { label, coordinates:{latitude,longitude},
 *                                          stateCode } — CLIENT ONLY (no server consumer).
 *
 * All access is feature-detected: when sessionStorage is unavailable (disabled,
 * private mode, quota, or a non-browser context) every getter returns null and
 * every setter is a no-op. Nothing here ever throws.
 *
 * CommonJS, no jQuery.
 */

var STORE_KEY = 'culinary_class_preferred_store';
var CITY_KEY = 'slt_user_city';

/**
 * The PWA persists the store id with `JSON.stringify`, so the raw sessionStorage
 * value is a JSON-quoted string (e.g. the five characters `"14"`), NOT bare
 * digits. Normalize by attempting a JSON.parse and falling back to the raw
 * string, so both the quoted form the PWA writes and a bare `14` are accepted.
 * @param {*} raw the raw sessionStorage value (null when the key is absent)
 * @returns {*} the unquoted string, or `raw` unchanged when it is not a JSON string
 */
function unwrapStored(raw) {
    if (typeof raw !== 'string') {
        return raw;
    }
    try {
        var parsed = JSON.parse(raw);
        if (typeof parsed === 'string') {
            return parsed;
        }
    } catch (e) {
        // not JSON — fall through and use the raw string as-is.
    }
    return raw;
}

/**
 * Resolve the sessionStorage object, or null if we are not in a browser.
 * @returns {Storage|null}
 */
function getStorage() {
    try {
        if (typeof window !== 'undefined' && window.sessionStorage) {
            return window.sessionStorage;
        }
    } catch (e) {
        // Accessing window.sessionStorage can throw in sandboxed iframes.
    }
    return null;
}

/**
 * Feature-detect a writable sessionStorage by probing a throwaway key.
 * @returns {boolean}
 */
function isAvailable() {
    var storage = getStorage();
    if (!storage) {
        return false;
    }
    var probe = '__slt_probe__';
    try {
        storage.setItem(probe, '1');
        storage.removeItem(probe);
        return true;
    } catch (e) {
        return false;
    }
}

/**
 * @param {*} id
 * @returns {boolean} true when id is a non-empty string of digits.
 */
function isValidStoreId(id) {
    return typeof id === 'string' && (/^\d+$/).test(id);
}

/**
 * The coordinates are what this entry is FOR — they are what the CLP anchors its
 * store resolution on. The label is presentational, and since SLTBE-8979 the PWA
 * writes it as null when a "Use My Location" geocode produced coordinates it could
 * not name; requiring a string here would throw away a perfectly usable anchor and
 * send the shopper to the browser geolocation prompt instead.
 * @param {*} city
 * @returns {boolean} true when city has the expected label/coordinates shape.
 */
function isValidCity(city) {
    return !!city
        && typeof city === 'object'
        && (typeof city.label === 'string' || city.label === null)
        && !!city.coordinates
        && typeof city.coordinates === 'object'
        && typeof city.coordinates.latitude === 'number'
        && typeof city.coordinates.longitude === 'number';
}

var ClassStorePreference = {

    /**
     * @returns {string|null} the remembered numeric store-id, or null.
     */
    getPreferredStore: function() {
        if (!isAvailable()) {
            return null;
        }
        try {
            var value = unwrapStored(getStorage().getItem(STORE_KEY));
            return isValidStoreId(value) ? value : null;
        } catch (e) {
            return null;
        }
    },

    /**
     * Persist the preferred store. Validates numeric shape, skips the write when
     * the value is unchanged, and never throws.
     * @param {string|number} id
     * @returns {boolean} true when a write happened.
     */
    setPreferredStore: function(id) {
        if (!isAvailable()) {
            return false;
        }
        var value = (id === null || id === undefined) ? id : String(id);
        if (!isValidStoreId(value)) {
            return false;
        }
        try {
            var storage = getStorage();
            if (unwrapStored(storage.getItem(STORE_KEY)) === value) {
                return false; // equality guard — nothing changed.
            }
            storage.setItem(STORE_KEY, value);
            return true;
        } catch (e) {
            return false;
        }
    },

    /**
     * @returns {object|null} the remembered city object, or null if absent/invalid.
     */
    getUserCity: function() {
        if (!isAvailable()) {
            return null;
        }
        try {
            var raw = getStorage().getItem(CITY_KEY);
            if (!raw) {
                return null;
            }
            var parsed = JSON.parse(raw);
            return isValidCity(parsed) ? parsed : null;
        } catch (e) {
            return null;
        }
    },

    /**
     * Persist the nearby city. Validates shape, skips the write when unchanged,
     * and never throws.
     * @param {object} city { label, coordinates:{latitude,longitude}, stateCode }
     * @returns {boolean} true when a write happened.
     */
    setUserCity: function(city) {
        if (!isAvailable()) {
            return false;
        }
        if (!isValidCity(city)) {
            return false;
        }
        try {
            var serialized = JSON.stringify(city);
            var storage = getStorage();
            if (storage.getItem(CITY_KEY) === serialized) {
                return false; // equality guard — nothing changed.
            }
            storage.setItem(CITY_KEY, serialized);
            return true;
        } catch (e) {
            return false;
        }
    },

    /**
     * Remove both keys. No-op when storage is unavailable; never throws.
     */
    clear: function() {
        if (!isAvailable()) {
            return;
        }
        try {
            var storage = getStorage();
            storage.removeItem(STORE_KEY);
            storage.removeItem(CITY_KEY);
        } catch (e) {
            // swallow — clearing is best-effort.
        }
    }
};

module.exports = ClassStorePreference;

},{}],72:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    ajax = require('../ajax'),
    progress = require('../progress'),
    util = require('../util'),
    dialog = require('../dialog'),
    radar = require('../radar'),
    gtm = require('../gtm'),
    classStorePreference = require('./classStorePreference');

var newLine = '\n';
var searchStoreText;
var ClassStoreFinder = {

    selectStorePrompt: function() {
        // SLTBE-8873: jQuery UI is not bundled on this surface, so dialog.open() -> .dialog() would throw. Bail out instead of crashing.
        if (typeof $ === 'undefined' || typeof $.fn.dialog !== 'function') {
            window.console.warn('classdetailstore: jQuery UI dialog unavailable, store picker skipped');
            return;
        }
        var self = this;
        dialog.open({
            html: ClassStoreFinder.selectStorePromptTemplate(),
            options: {
                title: '',
                dialogClass: 'Pdp-pick-store-panel',
                width: 760,
                height: 'auto',
                open: function() {
                    $('body').addClass('modal-open');
                    $('.ui-dialog').addClass('culinary-dialog');
                    $('#user-input-text-store-class').on('keypress', function(e) {
                        if (e.which === 13) {
                            searchStoreText = $('#user-input-text-store-class').val();
                            self.getStoreByText(searchStoreText);
                        }
                    });
                    $('.find-in-store-search-class').on('click', function() {
                        searchStoreText = $('#user-input-text-store-class').val();
                        self.getStoreByText(searchStoreText);

                    });

                    $('.cdp-use-current-location').on('click', function() {
                        self.getNearestStore();
                    });

                    if (radar.isEnabled) {
                        var resetClassLocationAddressList = function() {
                            $('#classLocationAddressList').empty();
                            $('#classLocationAddressList').addClass('hidden');
                        };

                        var userInputLocationValue = '';
                        $('body').on('keyup','#user-input-text-store-class', _.debounce(function(e) {
                            if (userInputLocationValue === e.target.value) {
                                return;
                            }

                            userInputLocationValue = e.target.value;
                            var classLocationAddressList = $('#classLocationAddressList');
                            if (e.target.value.length > 0) {
                                radar.autocomplete({
                                    query: e.target.value,
                                    limit: 5,
                                    layers: 'coarse',
                                    countryCode: 'US'
                                }).then((result) => {
                                    resetClassLocationAddressList();

                                    if (!result.addresses.length) {
                                        return;
                                    }

                                    result.addresses.forEach(function(address){
                                        $('<li/>')
                                            .addClass('location-search-address-list-item')
                                            .html(address.formattedAddress)
                                            .on('click', function() {
                                                userInputLocationValue = address.formattedAddress;
                                                $('#user-input-text-store-class').val(address.formattedAddress);
                                                resetClassLocationAddressList();
                                            })
                                            .appendTo(classLocationAddressList);
                                    });

                                    classLocationAddressList.removeClass('hidden');
                                });
                            } else {
                                resetClassLocationAddressList();
                            }
                        }, 1000));
                    }
                },
                close: function() {
                    $('body').removeClass('modal-open');
                }
            }
        });
    },

    selectStorePromptTemplate: function() {
        return [
            '<div class="location-near-you store-near-you">' + Resources.LOCATION_NEAR_YOU + '</div>',
            '<div id="preferred-store-panel">',
            '<div id="preferred-current-location">',
            '<a href="#" class="cdp-use-current-location c1"><span class="location-icon"></span>'  + 'use my location' + '</a>',
            '</div>',
            '<label class="label" for="user-input-text-store-class">' + Resources.ENTER_LOCATION + '</label>',
            '<div class="location-search-container">',
            '<div>',
            '<input type="text" id="user-input-text-store-class" placeholder="' + Resources.ENTER_CITY_ZIP + '" name="zipCode" autocomplete="off"/>',
            '<button class="find-in-store-search-class Preferred-Store button-primary">' + Resources.FIND + '</button>',
            '</div>',
            '<ul id="classLocationAddressList" class="location-search-address-list hidden"></ul>',
            '</div>',
            '<div class="no-results hide">' + Resources.INVALID_CITY_ZIP + '</div>',
            '</div>'
        ].join(newLine);
    },

    getStoreByText: function(searchStoreText) {
        progress.show($('.Pdp-pick-store-panel'));
        var href = $('.class-detail-location-select .class-store-url').attr('href');
        var pimId = ClassStoreFinder.getParameterByName('pimid', href);
        $.ajax({
            type: 'POST',
            url: Urls.getStoreClassDetail,
            data: {
                searchStoreText: searchStoreText,
                pimId: pimId
            }
        })
        .done(function (data) {
            if (data.length > 0) {
                ClassStoreFinder.selectStoreDialog(data);
                progress.hide();
            } else {
                ClassStoreFinder.selectStorePrompt();
                progress.hide();
                $('.no-results').show();
            }
        });
    },

    getNearestStore: function() {
        progress.show($('.Pdp-pick-store-panel'));
        var href = $('.class-detail-location-select .class-store-url').attr('href');
        var pimId = ClassStoreFinder.getParameterByName('pid', href);
        if (pimId == null) {
            pimId = $('input[id=class-product-id]').val();
        }

        var data = {
            pimId: pimId
        };

        var getNearestStoreCall = function() {
            $.ajax({
                type: 'POST',
                url: Urls.getNearestStore,
                data: data
            })
            .done(function (data) {
                if (data.length > 0) {
                    ClassStoreFinder.selectStoreDialog(data);
                    progress.hide();
                } else {
                    ClassStoreFinder.selectStorePrompt();
                    progress.hide();
                    $('.no-results').show();
                }
            });
        };

        getNearestStoreCall();
    },

    selectStoreDialog: function(stores) {
        var self = this;
        dialog.open({
            html: ClassStoreFinder.storeListTemplate(stores),
            options: {
                title: '',
                dialogClass: 'Pdp-pick-store-panel class-store-panel',
                width: 760,
                open: function() {
                    $('body').addClass('modal-open');
                    $('.ui-dialog').addClass('culinary-dialog');
                    $('.ui-dialog').addClass('dialog-updated');
                    $('#user-input-text-store-class').on('keypress', function(e) {
                        if (e.which === 13) {
                            searchStoreText = $('#user-input-text-store-class').val();
                            self.getStoreByText(searchStoreText);
                        }
                    });

                    $('.find-in-store-search-class').on('click', function() {
                        searchStoreText = $('#user-input-text-store-class').val();
                        self.getStoreByText(searchStoreText);

                    });

                    $('.cdp-use-current-location').on('click', function() {
                        self.getNearestStore();
                    });

                    $('.select-store-button').on('click', function(e) {
                        e.preventDefault();

                        var $button = $(this);
                        var masterId = $button.data('masterId');
                        var selectedStoreID = $button.data('store-id');

                        // SLTBE-8826: persist the picked store to per-tab sessionStorage
                        // (replaces the culinary_class_preferred_store cookie). Keys match
                        // the PWA exactly and are the cross-surface source of truth.
                        classStorePreference.setPreferredStore(String(selectedStoreID));
                        var latitude = parseFloat($button.attr('data-store-latitude'));
                        var longitude = parseFloat($button.attr('data-store-longitude'));
                        var city = $button.attr('data-store-city');
                        var stateCode = $button.attr('data-store-state');
                        if (city && !isNaN(latitude) && !isNaN(longitude)) {
                            classStorePreference.setUserCity({
                                label: stateCode ? city + ', ' + stateCode : city,
                                coordinates: {
                                    latitude: latitude,
                                    longitude: longitude
                                },
                                stateCode: stateCode || ''
                            });
                        }

                        try {
                            if (typeof digitalData != 'undefined' && digitalData.product[0] && digitalData.product[0].productInfo) {
                                var selectedStoreName = $button.parents('.store-tile').find('.store-name').text().trim();
                                digitalData.product[0].productInfo.storeId = String(selectedStoreID);
                                digitalData.product[0].productInfo.storeName = selectedStoreName;
                                digitalData.product[0].productInfo.sku = String(masterId);
                            }
                        } catch (e) {
                            window.console.warn(e);
                        }

                        dialog.close();
                        if ($('.class-variation-model').length > 0){
                            $('.class-variation-model').remove();
                        }
                        var href = $('.class-detail-location-select .class-store-url').attr('data-url');
                        var newhref = self.setParameterByName(href, 'pid', masterId);
                        var windowURL = window.location.href;
                        if (windowURL.indexOf('Product-Show')>=0) {
                            // SEO Url is disabled
                            window.history.replaceState({} , null, '?pid='+masterId);
                            console.warn('SEO URL is disabled, Please Enable it to observe real time classes scenarios.'); // eslint-disable-line
                        } else {
                            // SEO Url is enabled
                            self.updateCDPurlWithCid(windowURL, masterId);
                        }
                        self.updateContent(newhref);

                    });
                },
                close: function() {
                    $('body').removeClass('modal-open');
                }
            }
        });
    },

    /**
     * SLTBE-8826: on CDP load, reconcile the store the page rendered against the
     * store this tab remembers in sessionStorage (the cross-surface source of truth
     * shared with the PWA). When they differ, swap the CDP to the remembered store
     * — but ONLY if that store actually carries this class. An equality guard
     * prevents re-entry / loops.
     *
     * The store id is NOT string-rewritten into the product id anymore: a remembered
     * store may not offer this class (or it may be sold out), and blindly swapping
     * would load a 410/empty buy box with no revert. Instead we resolve the remembered
     * store's coordinates through the same server endpoint the manual store-pick path
     * trusts (getNearestStore) — which returns ONLY stores that have an orderable
     * variant for this class, each with a validated store-specific masterId. Then:
     *   - remembered store present in that list  -> swap to its validated masterId.
     *   - remembered store absent                -> fall through to the nearest
     *       carrying store (response is distance-sorted), mirroring the PWA.
     *   - list empty (no store carries it)       -> leave the deep-linked page as-is.
     */
    reconcileStoreOnLoad: function() {
        var self = this;
        var rememberedStore = classStorePreference.getPreferredStore();
        if (!rememberedStore) {
            return;
        }

        // The class product id embeds the store id as its trailing '-' segment
        // (mirrors the server nearByID rebuild in Product.js).
        var classProductId = $('#class-product-id').val();
        if (!classProductId || classProductId.indexOf('-') < 0) {
            return;
        }
        var idParts = classProductId.split('-');
        var renderedStore = idParts[idParts.length - 1];

        // Equality guard: nothing to do when the page already shows the remembered store.
        if (String(renderedStore) === String(rememberedStore)) {
            return;
        }

        // Resolve the remembered store's coordinates so the server can return the
        // stores that carry THIS class near that location. Without coordinates we
        // cannot validate that the remembered store is orderable, so we must not swap.
        var rememberedCity = classStorePreference.getUserCity();
        if (!rememberedCity || !rememberedCity.coordinates) {
            return;
        }

        var pimId = classProductId;

        // Same endpoint the manual/geolocation store-pick path trusts: it filters to
        // stores with an orderable variant for this class and returns each entry with
        // a validated store-specific masterId, distance-sorted (nearest first).
        $.ajax({
            type: 'POST',
            url: Urls.getNearestStore,
            data: {
                pimId: pimId,
                latitude: rememberedCity.coordinates.latitude,
                longitude: rememberedCity.coordinates.longitude
            }
        })
        .done(function(stores) {
            if (!stores || !stores.length) {
                // No store carries this class near the remembered location — leave
                // the deep-linked page exactly as rendered rather than break the buy box.
                return;
            }

            // Prefer the remembered store when it carries the class; otherwise fall
            // through to the nearest carrying store (mirrors the PWA re-anchor).
            var target = null;
            for (var i = 0; i < stores.length; i++) {
                if (String(stores[i].storeId) === String(rememberedStore)) {
                    target = stores[i];
                    break;
                }
            }
            if (!target) {
                target = stores[0];
            }
            if (!target || !target.masterId) {
                return;
            }

            // Equality guard again: the resolved carrying store may already be the
            // rendered one (e.g. remembered store didn't carry it and nearest === rendered).
            if (String(target.storeId) === String(renderedStore)) {
                return;
            }

            self.swapToStore(target.masterId);
        });
    },

    /**
     * SLTBE-8826: swap the CDP to a validated store-specific variant id via the same
     * URL-rewrite + ajax reload path the manual store-pick uses. `masterId` must come
     * from a getNearestStore/getStoreClassDetail response so it is guaranteed to be an
     * orderable variant for this class.
     * @param {string} masterId validated store-specific product (variant) id
     */
    swapToStore: function(masterId) {
        var self = this;
        var href = $('.class-detail-location-select .class-store-url').attr('data-url');
        if (!href) {
            return;
        }
        var newhref = self.setParameterByName(href, 'pid', masterId);

        // Keep the browser URL in step, mirroring the manual-select path.
        var windowURL = window.location.href;
        if (windowURL.indexOf('Product-Show') >= 0) {
            window.history.replaceState({}, null, '?pid=' + masterId);
        } else {
            self.updateCDPurlWithCid(windowURL, masterId);
        }
        self.updateContent(newhref);
    },

    // Update class detail page URL:
    updateCDPurlWithCid: function (windowURL, newCid) {
        var splitedURL = windowURL.split('?')[0].split('/');
        var splitedURLLength = splitedURL.length;
        var oldCid = splitedURL[splitedURLLength - 1];
        var updatedURL = windowURL.replace(oldCid, newCid+'.html');
        history.pushState(undefined, '', updatedURL);
    },

    storeListTemplate: function (stores) {
        if (stores && stores.length) {
            return [
                '<div class="location-near-you store-near-you">' + Resources.LOCATION_NEAR_YOU + '</div>',
                '<div id="preferred-store-panel">',
                '<div id="preferred-current-location">',
                '<a href="#" class="cdp-use-current-location c1"><span class="location-icon"></span>'  + 'use my location' + '</a>',
                '</div>',
                '<label class="label" for="user-input-text-store-class">' + Resources.ENTER_LOCATION + '</label>',
                '<div class="location-search-container">',
                '<div>',
                '<input type="text" id="user-input-text-store-class" placeholder="' + Resources.ENTER_CITY_ZIP + '" name="zipCode" autocomplete="off"/>',
                '<button class="find-in-store-search-class Preferred-Store button-primary">' + Resources.FIND + '</button>',
                '</div>',
                '<ul id="classLocationAddressList" class="location-search-address-list hidden"></ul>',
                '</div>',
                '</div>',
                '<div class="store-list-container">',
                '<ul class="store-list">',
                _.map(stores, function (store) {
                    return ClassStoreFinder.storeTemplate(store);
                }).join(newLine),
                '</ul>',
                '</div>',
                '<div class="store-list-pagination">',
                '</div>'
            ].join(newLine);
        } else {
            return '<div class="no-results">' + Resources.INVALID_CITY_ZIP + '</div>';
        }
    },

    storeTemplate: function (store) {
        return [
            '<li class="store-tile ' + store.storeId + '">',
            '<div class="store-details-classes">',
            '<span class="store-name">',
            '        ' + store.storeName,
            '</span>',
            '<span class="store-distance">',
            '        (' + (store.storeDistance).toFixed(2) + ' mi)',
            '</span>',
            '    <p class="store-address">',
            '        ' + store.address1 + '<br/>',
            '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode,
            '    </p>',
            '</div>',
            '<div class="store-button-classes">',
            '    <button class="select-store-button button-primary" data-master-id="' + store.masterId + '"'
                + ' data-store-id="' + store.storeId + '"'
                + ' data-store-city="' + (store.city || '') + '"'
                + ' data-store-state="' + (store.stateCode || '') + '"'
                + ' data-store-latitude="' + (store.latitude != null ? store.latitude : '') + '"'
                + ' data-store-longitude="' + (store.longitude != null ? store.longitude : '') + '">',
            '        ' + Resources.SELECT_LOCATION,
            '    </button>',
            '</div>',
            '</li>'
        ].join(newLine);
    },

    getParameterByName: function(name, url) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    setParameterByName: function(url, param, paramVal) {
        var newAdditionalURL = '';
        var tempArray = url.split('?');
        var baseURL = tempArray[0];
        var additionalURL = tempArray[1];
        var temp = '';
        if (additionalURL) {
            tempArray = additionalURL.split('&');
            for (var i=0; i<tempArray.length; i++){
                if (tempArray[i].split('=')[0] != param){
                    newAdditionalURL += temp + tempArray[i];
                    temp = '&';
                }
            }
        }

        var rowstxt = temp + '' + param + '=' + paramVal;
        return baseURL + '?' + newAdditionalURL + rowstxt;
    },

    updateContent: function (url) {
        progress.show($('#pdpMain'));
        ajax.load({
            url: url,
            target: $('#product-content'),
            callback: function (response, error) {
                if (error) {
                    console.error('Error loading product content: ', error); // eslint-disable-line
                    return;
                }

                var $response = $(response);

                var locationCity = $response.find('[data-location-city]');
                var locationState = $response.find('[data-location-state]');
                var dataSessions = $response.find('[data-session-display-date-time]');
                var courseDates = $response.find('[data-course-dates]');

                if (locationCity.length === 1 && locationState.length === 1) {
                    var location = [
                        locationCity[0].dataset.locationCity,
                        locationState[0].dataset.locationState
                    ].join(', ');
                    $('#sticky-location').html(location);
                }
                if (dataSessions.length === 1) {
                    $('#sticky-data-time-and-timezone').html(dataSessions[0].dataset.sessionDisplayDateTime);
                } else if (courseDates.length === 1) {
                    $('#sticky-data-time-and-timezone').html(courseDates[0].innerText.trim());
                }

                // FIXME: pdp dialog is duplicated because it's returned again in this ajax call. For now, this will work
                $('div.added-to-cart-container-hidden').not(':first').remove();

                $(document).on('click', '.class-detail-location-select .set-class-store', function(e) {
                    e.preventDefault();
                    ClassStoreFinder.selectStorePrompt();
                });
                $('.classAttendees').on('click', '.add-attendees', function(e) {
                    e.preventDefault();
                    const isDisabled = !!$('#add-attendees').data('disabled')
                    if (!isDisabled) {
                        util.displayAddattendeeform();
                        return
                    }
                });
                if (isGTMEnabled) {
                    // Read from #product-content (just replaced by ajax.load with the new variant)
                    // rather than parsing the response string, which is unreliable due to how
                    // jQuery's .find() handles top-level siblings in a fragment.
                    var newVariantSku = $('#product-content .product-number .prodSku').first().text().trim();
                    gtm.selectVariant(newVariantSku);
                }
            }
        });
    }
};

module.exports = ClassStoreFinder;

},{"../ajax":2,"../dialog":13,"../gtm":18,"../progress":59,"../radar":62,"../util":78,"./classStorePreference":71,"lodash":94}],73:[function(require,module,exports){
'use strict';

/**
 * SLTBE-8873 — pure decision logic for what the cooking-class CLP does with the
 * store on window `load` (and on a bfcache `pageshow`).
 *
 * The `slt_user_city` / `culinary_class_preferred_store` per-tab sessionStorage
 * entries are shared with the PWA and are the ABSOLUTE source of truth for where
 * the shopper is shopping for classes. This module turns the current page state
 * into one of four actions WITHOUT touching the DOM, sessionStorage, the SG
 * session, or the network — search.js wires the result to the actual AJAX.
 * Keeping it pure lets the branching be unit tested.
 *
 * Ranking (SLTBE-8979): remembered store, then remembered city, then whatever the
 * server rendered, then browser geo. The two sessionStorage entries outrank the
 * render because the render is a server guess (session store / geo-IP default)
 * while those entries are the shopper's own last action on either surface.
 *
 * Actions:
 *   { type: 'reconcile', storeId }  seed the SG session + render the CLP grid
 *                                   scoped to the remembered store. Runs whenever
 *                                   the remembered store differs from the rendered
 *                                   one — even when the server rendered a (stale)
 *                                   store, which is the case a URL storeId hid.
 *   { type: 'geo', coords }         no remembered store: resolve the nearest store
 *                                   from coordinates — the remembered city's when
 *                                   there is one, the browser's otherwise. NEVER
 *                                   auto-prompts the store-picker modal.
 *   { type: 'modal' }               nothing to resolve from: let the caller fall
 *                                   back to the manual picker.
 *   { type: 'none' }                the render already shows the remembered store.
 *
 * SLTBE-8979 removed the `alreadyReconciled` one-shot guard. It compared a
 * tab-scoped `slt_clp_store_reconciled` sentinel against the remembered store, and
 * since SLTBE-8873 made reconcile an in-place DOM swap (no reload), the sentinel
 * outlived the page it was recorded on. Returning to the CLP later in the same tab
 * — the normal PWA round-trip — hit `alreadyReconciled` on a freshly rendered
 * EMPTY shell and resolved to 'none', leaving the spinner up over a grid that was
 * never fetched. The guard existed to stop a reconcile *loop* back when reconcile
 * reloaded the page; with the in-place swap there is nothing to loop on, because
 * this decision is made once per page load.
 *
 * CommonJS, no jQuery.
 */

/**
 * @param {?object} coords candidate { latitude, longitude }
 * @returns {boolean} true when both coordinates are numbers.
 */
function hasCoords(coords) {
    return !!coords
        && typeof coords.latitude === 'number'
        && typeof coords.longitude === 'number';
}

/**
 * @param {object} state
 * @param {?string} state.rememberedStore remembered store-id from sessionStorage, or null
 * @param {?string} state.renderedStore   store-id the server rendered on the page, or null
 * @param {?object} state.cityCoords      { latitude, longitude } from `slt_user_city`, or null
 * @param {?object} state.geoCoords       { latitude, longitude } from browser geo, or null
 * @returns {{type:string, storeId?:string, coords?:object}}
 */
function resolveLoadAction(state) {
    var remembered = state.rememberedStore || null;
    var rendered = (state.renderedStore === undefined || state.renderedStore === null)
        ? null
        : String(state.renderedStore);

    // 1. Remembered store wins. Reconcile whenever it differs from whatever the
    //    server rendered — regardless of whether that render was empty. A stale URL
    //    storeId makes the render non-empty; without this the reconcile was skipped
    //    and the remembered store was silently discarded.
    if (remembered) {
        if (rendered !== null && String(remembered) === rendered) {
            return {type: 'none'};
        }
        return {type: 'reconcile', storeId: String(remembered)};
    }

    // 2. No remembered store but a remembered city (`slt_user_city`, written by a
    //    city pick on either surface): resolve the nearest store to it. This
    //    outranks the render on purpose — a session/geo-IP store the shopper never
    //    chose must not survive a city they did choose — and it means the browser
    //    geolocation prompt is never needed for a shopper who has already told us
    //    where they are.
    if (hasCoords(state.cityCoords)) {
        return {type: 'geo', coords: state.cityCoords};
    }

    // 3. Nothing remembered. If the server already rendered a store (e.g. an
    //    explicit nearestStore request), leave it alone.
    if (rendered !== null) {
        return {type: 'none'};
    }

    // 4. Empty sessionStorage + browser-geo coords available -> resolve, no modal.
    if (hasCoords(state.geoCoords)) {
        return {type: 'geo', coords: state.geoCoords};
    }

    // 5. Nothing remembered, no coordinates -> caller may open the manual picker.
    return {type: 'modal'};
}

module.exports = {
    resolveLoadAction: resolveLoadAction
};

},{}],74:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    progress = require('../progress'),
    util = require('../util'),
    goLocal = require('../goLocal');
var bopisBottomSection;
var newLine = '\n';
var searchStoreText = '';
var searchStoreRadius = '';
var searchStoreQty = '';
var selectedVariant = '';
var productName = '';
var productSKU = '';
var productImage = '';

// product Qty counter 
var qtyOptions = '';
for (var i = 1; i < 100; i++) {
    qtyOptions += '<option value=' + i + '>' + i + '</option>';
}
var extractMobileNumber = function (phoneText) {
    return phoneText.replace('Call to reserve ', '');
}

var formatAddressDetails = function (store) {
    var city = store.city ? store.city + ', ' : '';
    var stateCode = store.stateCode ? store.stateCode + ', ': '';
    var postalCode = store.postalCode ? store.postalCode : '';

    return city + stateCode + postalCode;
}
$('.no-stores').removeClass('show-error-msg');
$('body').on('click', '.details-span .arrow-down', function () {
    $('.store-selected-section .expand-section').toggleClass('show-hidden-part');
    $(this).toggleClass('rotate-arrow');
});

$('#Quantity').on('keypress', function () {
    $('.product-store-qty .quantity').removeClass('qty-dev-border-error');
    $('.product-store-qty .qty-error-msg').removeClass('show-error-msg');
});
var customStoreSelectionDropdowns = function () {
    $('.select-radius').selectmenu({
        icons: {button: 'custom-icon'}
    }).selectmenu('menuWidget').addClass('store-custom-select');
    $('.select-radius-wrapper .ui-selectmenu-text').html('<b>'+$('.select-radius-wrapper .ui-selectmenu-text').html()+'</b>')
    $('.select-radius-wrapper .ui-selectmenu-text').prepend('Radius: ');
    $('.select-radius').on('selectmenuchange', function() {
        $('.select-radius-wrapper .ui-selectmenu-text').html('<b>'+$('.select-radius-wrapper .ui-selectmenu-text').html()+'</b>')
        $('.select-radius-wrapper .ui-selectmenu-text').prepend('Radius: ');
    });
}
var pickUpStoreParts = [
    '<div class="pick-up-in-store">' + Resources.PICK_UP_IN_STORE + '</div>',
    '<div class="product-details-section">',
    '<div class="product-store-wrapper">',
    '<div class="product-store-img"></div>',
    '<div class="product-store-info">',
    '<p id="pick-Up-Store-product-name"></p>',
    '<p id="pick-Up-Store-product-sku"></p>',
    '<p id="selected-variant"></p>',
    '</div>',
    '</div>',
    '<div class="product-store-qty">',
    '<span class="qty-error-msg">' + Resources.VALIDATE_REQUIRED + '</span>',
    '</div>',
    '</div>'
].join(newLine);

var pickUpStoreModalTemplate = [
    pickUpStoreParts,
    '<div id="preferred-store-panel">',
    '<div id="preferred-current-location">',
    '<label class="select-store-label">' + Resources.SELECT_A_STORE + '</label>',
    '<a href="#" class="pdp-use-current-location c1"><span class="location-icon"></span>' + Resources.USE_MY_LOCATION + '</a>',
    '</div>',
    '<div class="form-area">',
    '<div class="pick-up-store-search">',
    '<input type="text" id="user-input-text-store" class="required"  placeholder="' + (SitePreferences.pdpStoreSearchByPostalCode ? Resources.ENTER_ZIP : Resources.ENTER_CITY_ZIP) + '" name="zipCode" autocomplete="off"/>',
    '<ul id="pickUpStoreAddressList" class="pick-up-store-address-list hidden"></ul>',
    '</div>',
    '<div class="select-radius-wrapper">',
    '<select class="form-control select-radius">',
    '<option value="10" selected>10 mi</option>',
    '<option value="15">15 mi</option>',
    '<option value="25">25 mi</option>',
    '<option value="50">50 mi</option>',
    '<option value="75">75 mi</option>',
    '<option value="100">100 mi</option>',
    '</select>',
    '</div>',
    '<button class="find-in-store-search Preferred-Store button-primary">' + Resources.SEARCH_ONE + '</button>',
    '<div class="no-stores">' + Resources.NO_STORES + '</div>',
    '</div>',
    '</div>',
    '<div class="pick-up-in-store-note">' + Resources.PICK_UP_IN_STORE_NOTE + '</div>',
    '<div class="change-store-location-msg hide-note-msg"><p>' + Resources.CHANGE_STORE_LOCATION_MSG + '</p></div>',
    '<div class="pick-up-in-store-bottom-section"></div>'
].join(newLine);

var storeTemplate = function(store) {
    if (store.status === 'Not Available In Store') {
        return [
            '<div class="not-avaliable-in-store '+ store.storeId +'">',
            '<span class="not-avaliable-store-name">' +store.storeName+ '</span>',
            '<span class="not-avaliable-store-distance">',
            '        (' + (store.storeDistance).toFixed(2) + ' miles)',
            '</span>',
            '</div>'
        ].join(newLine);
    } else {
        if (store.status === 'Available In Store') {
            return [
                '<div class="store-tile available-store ' + store.storeId + '">',
                '<div class="store-details-left">',
                '<span class="store-name">',
                '        ' + store.storeName,
                '</span>',
                '<span class="store-distance">',
                '        (' + (store.storeDistance).toFixed(2) + ' mi)',
                '</span>',
                '<div class="store-details-left-bottom-section">',
                '    <span class="store-heading">' + store.address1 + '</span>',
                '    <span class="store-deatils">' + formatAddressDetails(store) + '</span><br>',
                '<span class="store-hours">',
                '        ' + store.storeHours,
                '</span>',
                '<div class="call-for-holidays-section">',
                '<span class="call-for-holidays">' + Resources.CALL_FOR_HOLIDAYS + '</span>',
                '<span class="holidays-number"><a href="tel:' + extractMobileNumber(store.phone) + '">' + extractMobileNumber(store.phone) + '</a></span>',
                '</div>',
                '</div>',
                '</div>',
                '<div class="store-details-right">',
                '<button type="button" class="button-primary select-store-button available" data-storeId='+store.storeId+'>' + Resources.SELECT_STORE + '</button>',
                '    <span class="store-status ' + store.statusclass + '" data-status="' + store.statusclass + '">' + store.status + '</span>',
                '<span class="check-out-soon">' + Resources.CHECKOUT_SOON_TO_GET_IR_TODAY + '</span>',
                '<span class="store-phone">' + store.phone + '</span>',
                '</div>',
                '</div>'
            ].join(newLine);
        } else if (store.status === 'Limited') {
            return [
                '<div class="store-tile limited-store ' + store.storeId + '">',
                '<div class="store-details-left">',
                '<span class="store-name">',
                '        ' + store.storeName,
                '</span>',
                '<span class="store-distance">',
                '        (' + (store.storeDistance).toFixed(2) + ' mi)',
                '</span>',
                '<div class="store-details-left-bottom-section">',
                '    <span class="store-heading">' + store.address1 + '</span>',
                '    <span class="store-deatils">' + formatAddressDetails(store) + '</span><br>',
                '<span class="store-hours">',
                '        ' + store.storeHours,
                '</span>',
                '<div class="call-for-holidays-section">',
                '<span class="call-for-holidays">' + Resources.CALL_FOR_HOLIDAYS + '</span>',
                '<span class="holidays-number"><a href="tel:' + extractMobileNumber(store.phone) + '">' + extractMobileNumber(store.phone) + '</a></span>',
                '</div>',
                '</div>',
                '</div>',
                '<div class="store-details-right">',
                '<button type="button" class="button-primary select-store-button limited" disabled>' + Resources.SELECT_STORE + '</button>',
                '    <span class="store-status ' + store.statusclass + '" data-status="' + store.statusclass + '">' + store.status + '</span>',
                '<span class="call-store-to-checkout">' + Resources.PLEASE_CALL_STORE + '</span>',
                '<span class="store-phone">' + store.phone + '</span>',
                '</div>',
                '</div>'
            ].join(newLine);
        }
    }
};

var storeListPickUpModal = function (stores, selectedStore) {
    var storeListPart;
    var selectedStorePart;
    if (selectedStore) {
        selectedStorePart = [
            '<div class="store-selected-section">',
            '<span class="selected-store-span">' +Resources.SELECTED_STORE+ '</span>',
            '<span class="details-span">' + Resources.DETAILS + '<span class="arrow-down"></span></span>',
            '<div class="selected-store-container">',
            '<div class="store-name-distance">',
            '<span class="store-name">' + selectedStore.storeName + '</span>',
            '<span class="store-distance">',
            '        (' + (selectedStore.storeDistance).toFixed(2) + ' miles)',
            '</span>',
            '</div>',
            '</div>',
            '<div class="expand-section">',
            '<div class="right-box"><span class="selected-store-address">',
            '    <span class="store-heading">' + selectedStore.address1 + '</span>',
            '    <span class="store-deatils">' + formatAddressDetails(selectedStore) + '</span><br>',
            '</span></div>',
            '<div class="left-box"> ',
            '       ' + selectedStore.storeHours,
            '<div class="call-for-holidays-section">',
            '<span class="call-for-holidays">' + Resources.CALL_FOR_HOLIDAYS + '</span>',
            '<span class="holidays-number"><a href="tel:' + extractMobileNumber(selectedStore.phone) + '">' + extractMobileNumber(selectedStore.phone) + '</a></span>',
            '</div>',
            '</div>',
            '</div>',
            '</div>'
        ].join(newLine);
    } else {
        selectedStorePart = '';
    }
    if (stores && stores.length) {
        storeListPart = [
            '<div class="pick-up-in-store-note">' + Resources.PICK_UP_IN_STORE_NOTE + '</div>',
            '<div class="change-store-location-msg hide-note-msg"><p>' + Resources.CHANGE_STORE_LOCATION_MSG + '</p></div>',
            '<div class="store-list-container">',
            '<div class="store-list">',
            '<div class="unavailable-in-store-text">' + Resources.UNAVAILABLE_IN_STORE_TEXT + '</div>',
            '<div class="store-locations-title">',
            '<label class="store-locations-label">' + Resources.STORE_LOCATIONS + '</label>',
            '</div>',
            _.map(stores, function(store) {
                return storeTemplate(store);
            }).join(newLine),
            '</div>',
            '</div>',
            '<div class="store-list-pagination"></div>'
        ].join(newLine);
    } else {
        storeListPart = [
            '<div class="no-results">' + Resources.INVALID_ZIP + '</div>',
            '<div class="pick-up-in-store-note">' + Resources.PICK_UP_IN_STORE_NOTE + '</div>',
            '<div class="change-store-location-msg hide-note-msg"><p>' + Resources.CHANGE_STORE_LOCATION_MSG + '</p></div>'
        ].join(newLine);
    }
    return [
        pickUpStoreParts,
        '<div id="preferred-store-panel">',
        selectedStorePart,
        '<div id="preferred-current-location">',
        '<label class="select-store-label">' + Resources.SELECT_A_STORE + '</label>',
        '<a href="#" class="pdp-use-current-location c1"><span class="location-icon"></span>' + Resources.USE_MY_LOCATION + '</a>',
        '</div>',
        '<div class="pick-up-store-search">',
        '<input type="text" id="user-input-text-store" class="input-text" placeholder="' + (SitePreferences.pdpStoreSearchByPostalCode ? Resources.ENTER_ZIP : Resources.ENTER_CITY_ZIP) + '" name="zipCode" autocomplete="off"/>',
        '<ul id="pickUpStoreAddressList" class="pick-up-store-address-list hidden"></ul>',
        '</div>',
        '<div class="select-radius-wrapper">',
        '<select class="form-control select-radius">',
        '<option value="10" selected>10 mi</option>',
        '<option value="15">15 mi</option>',
        '<option value="25">25 mi</option>',
        '<option value="50">50 mi</option>',
        '<option value="75">75 mi</option>',
        '<option value="100">100 mi</option>',
        '</select>',
        '</div>',
        '<button class="find-in-store-search Preferred-Store button-primary">' + Resources.SEARCH_ONE + '</button>',
        '</div>',
        storeListPart,
        '<div class="pick-up-in-store-bottom-section"></div>'
    ].join(newLine);
}

var storeListInAvailableModal = function (stores) {
    var storeListPart;
    if (stores && stores.length) {
        storeListPart = [
            '<div class="pick-up-in-store-note">' + Resources.PICK_UP_IN_STORE_NOTE + '</div>',
            '<div class="change-store-location-msg hide-note-msg"><p>' + Resources.CHANGE_STORE_LOCATION_MSG + '</p></div>',
            '<div class="store-list-container">',
            '<div class="store-list">',
            '<label class="store-locations-label">' + Resources.STORE_LOCATIONS + '</label>',
            _.map(stores, function(store) {
                return storeTemplate(store);
            }).join(newLine),
            '</div>',
            '</div>',
            '<div class="store-list-pagination"></div>'
        ].join(newLine);
    } else {
        storeListPart = [
            '<div class="no-results">' + Resources.INVALID_ZIP + '</div>',
            '<div class="pick-up-in-store-note">' + Resources.PICK_UP_IN_STORE_NOTE + '</div>',
            '<div class="change-store-location-msg hide-note-msg"><p>' + Resources.CHANGE_STORE_LOCATION_MSG + '</p></div>'
        ].join(newLine);
    }
    return [
        '<div class="pick-up-store-default-modal">',
        '<div class="location-near-you store-near-you">' + Resources.STORE_NEAR_YOU + '</div>',
        '<div class="note">' + Resources.STORE_NOTE +'</div>',
        '<div id="preferred-store-panel">',
        '<div id="preferred-current-location">',
        '<label class="select-store-label">' + Resources.SELECT_A_STORE + '</label>',
        '<a href="#" class="pdp-use-current-location c1"><span class="location-icon"></span>'  + 'use my location' + '</a>',
        '</div>',
        '<label class="label" for="user-input-text-store">' + Resources.ENTER_LOCATION + '</label>',
        '<input type="text" id="user-input-text-store"  class="text-store-search-box input-text" placeholder="' + (SitePreferences.pdpStoreSearchByPostalCode ? Resources.ENTER_ZIP : Resources.ENTER_CITY_ZIP) + '" name="zipCode"/>',
        '<button class="find-in-store-search Preferred-Store button-primary">' + Resources.SEARCH_ONE + '</button>',
        '</div>',
        storeListPart,
        '</div>'
    ].join(newLine);
}

var storeListTemplate = function(stores, selectedStore) {
    if (SitePreferences.STORE_PICKUP) {
        return storeListPickUpModal(stores, selectedStore);
    } else {
        return storeListInAvailableModal(stores);
    }
};

var zipPromptTemplate = function() { 
    if (SitePreferences.STORE_PICKUP) {
        return pickUpStoreModalTemplate;
    } else {
        return [
            '<div class="pick-up-store-default-modal">',
            '<div class="location-near-you store-near-you">' + Resources.STORE_NEAR_YOU + '</div>',
            '<div class="note">' + Resources.STORE_NOTE +'</div>',
            '<div id="preferred-store-panel">',
            '<div id="preferred-current-location">',
            '<a href="#" class="pdp-use-current-location c1"><span class="location-icon"></span>'  + 'use my location' + '</a>',
            '</div>',
            '<label class="label" for="user-input-text-store">' + Resources.ENTER_LOCATION + '</label>',
            '<input type="text" id="user-input-text-store" class="text-store-search-box input-text" placeholder="' + (SitePreferences.pdpStoreSearchByPostalCode ? Resources.ENTER_ZIP : Resources.ENTER_CITY_ZIP) + '" name="zipCode"/>',
            '<button class="find-in-store-search Preferred-Store button-primary">' + Resources.SEARCH_ONE + '</button>',
            '<div class="no-stores">' + Resources.NO_STORES + '</div>',
            '</div>',
            '</div>'
        ].join(newLine);
    }
};

var storeinventory = {
    updateAfterPayDisplay: function() {
        var storeSelectedId =$('#storeSelectedId').val();
        var availableForInStorePickup = $('#availableForInStorePickup').val();
        var bopisAPEligability = $('#bopisApEligability').val();
        var shipOption = $('[name=shipOption]:checked').val();
        if (shipOption == 'shipToStore' && bopisAPEligability == 'false' && availableForInStorePickup == 'true' && storeSelectedId != 'null') {
            $('.after-pay').addClass('hide-afterpay');
            $('.bopis-afterpay').addClass('show-afterpay');
            $('.extend-offer-accordion').addClass('hide_extends_offers');
        } else {
            $('.after-pay').removeClass('hide-afterpay');
            $('.bopis-afterpay').removeClass('show-afterpay');
        }
    },
    checkInStoreAvailability: function() {
        progress.show($('.product-add-to-cart'));
        var selectedProductID = $('#pid').val();
        var selectedQuantity = $('#Quantity').val();
        var storeSelectedId =$('#storeSelectedId').val();
        var availableForInStorePickup = $('#availableForInStorePickup').val();

        $.ajax({
            type: 'POST',
            url: Urls.checkAvailabilityInStore,
            data : {
                productID: selectedProductID,
                storeId: storeSelectedId,
                quantity: selectedQuantity
            }
        }).done(function (response) {
            if (response.flag == 'disableStore' || response.flag == 'disableVarient') {
                $('.select-store-msg').hide();
                $('.ship-for-store-label .ShippingPrice__text').html(response.message);
                $('.ship-for-store-label .ShippingPrice__price').addClass('hidden');
                $('.change-store-link-wrapper').removeClass('hide');
                $('.ship-for-store-label').parents('.shipping-options').addClass('disabled');
                $('.ship-for-store-label').addClass('not-eligible');
                $('.ship-for-store-label').prev().attr('disabled','true').addClass('disabled');
                setTimeout(function(){
                    if ($('#extend-offer > div:not([style*="display: none"])').length > 0) {
                        $('.extend-offer-accordion').removeClass('hide_extends_offers');
                    }
                }, 700);
            } else if (response.flag == 'noStore') {
                $('.select-store-msg').show();
                $('.ship-for-store-label .ShippingPrice__text').html(response.message);
                $('.ship-for-store-label .ShippingPrice__price').addClass('hidden');
                $('.ship-for-store-label').parents('.shipping-options').removeClass('disabled');
                $('.ship-for-store-label').prev().removeAttr('disabled').removeClass('disabled');
            } else if (response.flag == 'notAvailableInStore') {
                $('.select-store-msg').hide();
                $('.ship-for-store-label .ShippingPrice__text').html(response.message);
                $('.ship-for-store-label .ShippingPrice__price').addClass('hidden');
                $('.ship-for-store-label').addClass('not-eligible');
                $('.ship-for-store-label').parents('.shipping-options').addClass('disabled');
                $('.ship-for-store-label').prev().attr('disabled','true').addClass('disabled');
            }  else if (response.flag == 'enable') {
                $('.select-store-msg').hide();
                $('.change-store-link-wrapper').removeClass('hide');
                $('.ship-for-store-label .ShippingPrice__text').html(response.message);
                $('.ship-for-store-label .ShippingPrice__price').removeClass('hidden');
                if ($('input[name="shiptype"]').val() == 'shipToStore' && $('#storeSelectedId').val() != null) {
                    $('body').find('.estimated-delivery').css('display','none');
                }
                $('.ship-for-store-label').parents('.shipping-options').removeClass('disabled');
                $('.ship-for-store-label').prev().removeAttr('disabled').removeClass('disabled');
                $('.ship-for-store-label').removeClass('not-eligible');
                $('.pdpForm').find('.add-to-cart').attr('disabled', false);
                if (availableForInStorePickup === 'true') {
                    $('.extend-offer-accordion').addClass('hide_extends_offers');
                }
            }
        });
        progress.hide();
        
    },
    checkInStoreAvailabilityForGoLocal: function() {
        var selectedProductID = $('#pid').val();
        var selectedQuantity = $('#Quantity').val();

        goLocal.checkUserAddressEligibility(selectedProductID, selectedQuantity);
    },
    zipPrompt: function() {
        searchStoreRadius = $('.select-radius option:selected').val();
        dialog.open({
            html: zipPromptTemplate(),
            options: {
                title: '',
                dialogClass: 'Pdp-pick-store-panel',
                width: 760,
                height: 'auto',
                open: function() {
                    if (searchStoreRadius !== undefined) {
                        $('.select-radius').val(searchStoreRadius);
                    }
                    $('#Quantity').parent().appendTo($('.product-store-qty').addClass('inventory'));
                    customStoreSelectionDropdowns();
                    selectedVariant = $('.attribute.first-attr .label').html();
                    productName = $('.product-col-2 .product-name').html();
                    productSKU = $('.product-number .prodSku').html();
                    var imageSrc = $('img.photo-grid__asset').attr('src');
                    productImage = '<img src='+imageSrc+' >';
                    $('.product-store-img').prepend(productImage);
                    $('#pick-Up-Store-product-name').html(Resources.PRODUCT_NAME + ' : '+ productName);
                    $('#pick-Up-Store-product-sku').html(Resources.PRODUCT_SKU + ' : '+ productSKU);
                    $('#selected-variant').html(selectedVariant);
                    bopisBottomSection = $('#bopisModalBottomSection').clone().removeClass('hide');
                    $('.pick-up-in-store-bottom-section').append(bopisBottomSection);
                    $('body').addClass('modal-open');
                    if ($('#bopisEligability').val()=='false'){
                        $('.ui-dialog').addClass('styling-dialog');
                    }     
                },
                beforeClose: function () {
                    $('#Quantity').parent().appendTo($('.product-add-to-cart .inventory'));
                    if ($('#storeSelectedId').val() == 'null' || $('#storeSelectedId').val() == ''){
                        $('#shipToAdress').prop('checked',true);
                        if ($('input[name="eddEnabled"]').length > 0) {
                            $('body').find('.estimated-delivery').css('display','block');
                        }
                        if ($('#extend-offer > div:not([style*="display: none"])').length > 0) {
                            $('.extend-offer-accordion').removeClass('hide_extends_offers');
                        }
                        $('#shipToAdress').prop('checked',true);
                    }
                },
                close : function (event) {
                    if (event.originalEvent){
                        $('#add-to-cart').attr('disabled', false);
                    }
                    $('body').removeClass('modal-open');   
                }
            }
        });
    },

    getStoresInventory: function(pid) {
        return TPromise.resolve($.ajax({
            url: util.appendParamsToUrl(Urls.storesInventory, {
                pid: pid,
                zipCode: User.zip
            }),
            dataType: 'json'
        }));
    },
    /**
     * @description open the dialog to select store
     * @param {Array} options.stores
     * @param {Function} options.continueCallback
     * @param {Function} options.selectStoreCallback
     **/
    selectStoreDialog: function(options) {
        searchStoreText = $('#user-input-text-store').val();
        searchStoreRadius = $('.select-radius option:selected').val();
        var self = this,
            stores = options.stores,
            selectedStore = options.selectedStore,
            storeList = storeListTemplate(stores, selectedStore);
        dialog.open({
            html: storeList,
            options: {
                title: '',
                buttons: [{
                    text: Resources.SEARCH_ONE,
                    click: function() {
                        searchStoreText = $('#user-input-text-store').val();
                        searchStoreRadius = $('.select-radius option:selected').val();
                        searchStoreQty = $('.pick-up-store-qty').val();
                        self.getStoreByText(searchStoreText, searchStoreRadius, searchStoreQty);
                    }
                }],
                dialogClass: 'Pdp-pick-store-panel',
                width: 760,
                open: function() {
                    if ($('.Pdp-pick-store-panel .available-store , .Pdp-pick-store-panel .limited-store').length > 0) {
                        $('.store-locations-title .store-locations-label').addClass('show-store-location-label');
                    }
                    if ($('.Pdp-pick-store-panel .not-avaliable-in-store').length > 0) {
                        $('.unavailable-in-store-text').addClass('unavailable-in-store-text-show');
                    }
                    $('#user-input-text-store').val(searchStoreText);
                    
                    if (searchStoreRadius !== undefined) {
                        $('.select-radius').val(searchStoreRadius);
                    }
                    $('#Quantity').parent().appendTo($('.product-store-qty').addClass('inventory'));
                    customStoreSelectionDropdowns();
                    bopisBottomSection = $('#bopisModalBottomSection').clone().removeClass('hide');
                    $('.pick-up-in-store-bottom-section').append(bopisBottomSection);
                    selectedVariant = $('.attribute.first-attr .label').html();
                    productName = $('.product-col-2 .product-name').html();
                    productSKU = $('.product-number .prodSku').html();
                    var imageSrc = $('img.photo-grid__asset').attr('src');
                    productImage = '<img src='+imageSrc+' >';
                    $('.product-store-img').prepend(productImage);
                    $('#pick-Up-Store-product-name').html(Resources.PRODUCT_NAME + ' : '+ productName);
                    $('#pick-Up-Store-product-sku').html(Resources.PRODUCT_SKU + ' : '+ productSKU);
                    $('#selected-variant').html(selectedVariant);

                    $('div.ui-dialog-buttonset').hide();
                    $('.ui-dialog').addClass('dialog-updated');
                    $('.store-list-container').css('max-height', '100%');
                    $('body').addClass('modal-open');
                    if ($('#bopisEligability').val()=='false'){
                        $('.ui-dialog').addClass('styling-dialog');
                    }
                },
                beforeClose: function () {
                    $('#Quantity').parent().appendTo($('.product-add-to-cart .inventory'));
                    if ($('#storeSelectedId').val() == 'null' || $('#storeSelectedId').val() == ''){
                        $('#shipToAdress').prop('checked',true);
                        if ($('input[name="eddEnabled"]').length > 0) {
                            $('body').find('.estimated-delivery').css('display','block');
                        }
                    }
                },
                close : function (event) {
                    if (event.originalEvent){
                        $('#add-to-cart').attr('disabled', false);
                    }
                    $('body').removeClass('modal-open');
                }
            }
        });
    },
    setUserZip: function(zip) {
        User.zip = zip;
        $.ajax({
            type: 'POST',
            url: Urls.setZipCode,
            data: {
                zipCode: zip
            }
        });
    },
    getNearestStore: function() {
        $('.no-stores').removeClass('show-error-msg');
        var self = this;
        var pid = $('input[name="pid"]').val();
        progress.show($('.Pdp-pick-store-panel'));
        searchStoreText = $('#searchStoreText').val();
        searchStoreRadius = $('#searchStoreRadius').val();

        var data ={
            pid: pid
        };

        var getNearestStoresPDP = function() {
            $.ajax({
                type:'POST',
                url:Urls.getNearestStoresPDP,
                data: data
            }).done(function(stores) {
                if (stores.length > 0) {
                    var options = {};
                    options.stores = stores;
                    self.selectStoreDialog(options);
                    progress.hide();
                } else {
                    self.zipPrompt();
                    progress.hide();
                    $('#user-input-text-store').val(searchStoreText);
                    $('.select-radius').val(searchStoreRadius);
                    $('.no-stores').addClass('show-error-msg');
                }
            });
        };

        getNearestStoresPDP();
    },
    selectAvailableStore: function(selectedStoreName,selectedStoreID) {
        var self = this;
        progress.show($('.Pdp-pick-store-panel'));
        $.ajax({  
            type: 'POST',
            url: Urls.setMyStore,
            data : {
                storeId: selectedStoreID
            }
        }).done(function (response) {
            if (response) {
                $('.store_select').text(selectedStoreName);
                progress.hide();
                $('.select-store-msg .cap').hide();
                $('.Pdp-pick-store-panel #dialog-container').dialog('close');
                $('#storeSelectedId').val(selectedStoreID);
                self.checkInStoreAvailability();
                if ($('#isShipToAddress').val() == 'true') {
                    $('[name="shipOption"]').prop('checked','false');
                    $('[name="shipOption"][value="shipToStore"]').prop('checked','true');
                }
                self.updateAfterPayDisplay();
            } else {
                progress.hide();
            }
        });
    },
    getStoreByText: function(searchStoreText, searchStoreRadius, searchStoreQty) {
        $('.no-stores').removeClass('show-error-msg');
        var self = this;
        var pid = $('input[name="pid"]').val();
        progress.show($('.Pdp-pick-store-panel'));
        $.ajax({
            type: 'POST',
            url: SitePreferences.pdpStoreSearchByPostalCode ? Urls.getStoreByPostalCode : Urls.getStoreByTextPDP,
            data: {
                searchStoreText: searchStoreText,
                pid: pid,
                searchStoreRadius: searchStoreRadius,
                searchStoreQty: searchStoreQty
            }
        }).done(function(data) {
            if (!_.isEmpty(data)) {
                if (data.stores.length > 0) {
                    var options = {};
                    options.stores = data.stores;
                    options.selectedStore = data.selectedStore;
                    self.selectStoreDialog(options);
                    progress.hide();
                } else {
                    self.zipPrompt();
                    progress.hide();
                    $('#user-input-text-store').val(searchStoreText);
                    $('.select-radius').val(searchStoreRadius);
                    $('.no-stores').addClass('show-error-msg');
                }
            } else {
                self.zipPrompt();
                progress.hide();
                $('#user-input-text-store').val(searchStoreText);
                $('.select-radius').val(searchStoreRadius);
                $('.no-stores').addClass('show-error-msg');
            }
        });
    },
    shippingLoad: function() {
        var $checkoutForm = $('.address');
        $checkoutForm.off('click');
        $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function() {
            $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
        });
    }
};

module.exports = storeinventory;

},{"../dialog":13,"../goLocal":17,"../progress":59,"../util":78,"lodash":94,"promise":96}],75:[function(require,module,exports){
'use strict';

var inventory = require('./'),
    classStoreFinder = require('./classdetailstore'),
    _ = require('lodash'),
    edd = require('../edd'),
    util = require('../util'),
    radar = require('../radar'),
    validator = require('../validator');

var newLine = '\n';
var pdpStoreTemplate = function(store) {
    return [
        '<li class="store-list-item ' + (store.storeId.toString() === User.storeId.toString() ? ' selected' : '') + '">',
        '    <input type="hidden" class="selected-pdp-storeID" name="selectedpdtstoreID" value="'+ store.storeId +'"></input>',
        '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode +
        ' ' + store.postalCode + '</div>',
        '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>',
        '</li>'
    ].join(newLine);
};
var pdpStoresListingTemplate = function(stores) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-pdp-container">',
            (stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + '</a>' : ''),
            '    <ul class="store-list-pdp">',
            _.map(stores, pdpStoreTemplate).join(newLine),
            '    </ul>',
            '</div>'
        ].join(newLine);
    }
};

var storesListing = function(stores) {
    // list all stores on PDP page
    if ($('.store-list-pdp-container').length) {
        $('.store-list-pdp-container').remove();
    }
    if ($('.set-preferred-store a').text().trim() == Resources.CHECKSTOREAVAILABILITY) {
        $('.set-preferred-store a').text(Resources.CHANGE_STORE_BOPIS);
    }
    $('.product-stores').empty();
    $('.product-stores').append(pdpStoresListingTemplate(stores));
    //$('.selected-store').replaceWith(pdpStoresListingTemplate(stores));
};

var productInventory = {
    setPreferredStore: function(storeId) {
        User.storeId = storeId;
        $.ajax({
            url: Urls.setPreferredStore,
            type: 'POST',
            data: {
                storeId: storeId
            }
        });
    },
    productSelectStore: function() {
        var self = this;
        inventory.getStoresInventory(this.pid).then(function(stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: User.storeId,
                selectedStoreText: Resources.PREFERRED_STORE,
                continueCallback: storesListing,
                selectStoreCallback: self.setPreferredStore
            });
            if (isGTMEnabled) {
                require('../gtm').findInStoreSearchPDP(User.zip, stores);
            }
        }).done();
    },

    init: function() {
        var quantity = $('#Quantity').val();
        var price = $('.pro-price').val();      
        if ($.isNumeric(quantity) && $.isNumeric(price)){
            var totalprice = quantity * price;
            if (totalprice > 75) {
                $('body').find('.free').css('display','inline-block');
                $('body').find('.not-free').css('display','none');
            } else {
                $('body').find('.free').css('display','none');
                $('body').find('.not-free').css('display','');
            }
        }
        var $availabilityContainer = $('.availability-results'),
            self = this;
        this.pid = $('input[name="pid"]').val();
        var isProductVariant = $('input[name="isProductVariant"]').val() === 'true';

        $('.class-detail-location-select .set-class-store').on('click', function(e) {
            e.preventDefault();
            classStoreFinder.selectStorePrompt();
        });

        // SLTBE-8826: on CDP load, reconcile the rendered store against the store
        // remembered in per-tab sessionStorage (shared with the PWA). No-op unless
        // this is a store-specific class CDP with a remembered store that differs.
        if ($('#class-product-id').length && typeof classStoreFinder.reconcileStoreOnLoad === 'function') {
            classStoreFinder.reconcileStoreOnLoad();
        }
 
        if (isProductVariant) {
            if (SitePreferences.STORE_PICKUP) {
                inventory.checkInStoreAvailability();
            }

            if (SitePreferences.GO_LOCAL_ENABLED) {
                inventory.checkInStoreAvailabilityForGoLocal();
            }
        }

        $('.store-modal-open').on('click', function(e) {
            e.preventDefault();
            var storeSelectedId = $('#storeSelectedId').val();
            if ($('#shipToStore').is(':checked') && storeSelectedId == undefined) {
                $('.pdpForm').find('.add-to-cart').attr('disabled', true);
            }
            if (!User.zip) {
                inventory.zipPrompt(function() {
                    self.productSelectStore();
                });
            } else {
                self.productSelectStore();
            }
            if (storeSelectedId != 'null' && $('#changeLocation').is(':visible')) {
                $('.pick-up-in-store-note').addClass('hide-note-msg');
                $('.change-store-location-msg').removeClass('hide-note-msg');
            }
            $('.Preferred-Store').addClass('add-padding');
        });

        $('[name=shipOption]').on('change', function() {
            if (this.value == 'shipGoLocal') {
                $('.extend-offer-accordion').addClass('hide_extends_offers');
                $('.estimated-delivery').css('display','none');

                if ($('#bopisApEligability').val() == 'false') {
                    $('.after-pay').addClass('hide-afterpay');
                    $('.bopis-afterpay').addClass('show-afterpay');
                }

                if (!$('input[name="goLocalPostalCode"]').val()) {
                    $('.GoLocalOption__ModalLink').trigger('click');
                }
            } else if (this.value == 'shipToStore') {
                var storeSelectedId = $('#storeSelectedId').val();
                $('.extend-offer-accordion').addClass('hide_extends_offers');
                if (storeSelectedId == '' || storeSelectedId == 'null'){
                    $('.store-modal-open').trigger('click');
                    $('.pdpForm').find('.add-to-cart').attr('disabled', true);
                } else {
                    if ($('#bopisApEligability').val() == 'false') {
                        $('.after-pay').addClass('hide-afterpay');
                        $('.bopis-afterpay').addClass('show-afterpay');
                    }
                    $('.pdpForm').find('.add-to-cart').attr('disabled', false);
                }
                $('body').find('.estimated-delivery').css('display','none');
            } else {
                $('.after-pay').removeClass('hide-afterpay');
                $('.bopis-afterpay').removeClass('show-afterpay');
                
                setTimeout(function () {
                    if ($('#extend-offer > div:not([style*="display: none"])').length > 0) {
                        const iFrameHeight = $('#extend-offer iframe').contents().find('body').height();
                        $('#extend-offer iframe').height(iFrameHeight);
                        $('.extend-offer-accordion').removeClass('hide_extends_offers');
                    }
                }, 100);
                if ($('input[name="eddEnabled"]').length > 0) {
                    $('body').find('.estimated-delivery').css('display', 'block');
                }
            }

            if (this.value == 'shipGoLocal') {
                $('.go-local-selected-container').show();
            } else {
                $('.go-local-selected-container').hide();
            }
        });

        $('#product-content .product-actions a.wish-list').on('click', function() {
            if (isGTMEnabled) {
                require('../gtm').addToWishlist();
            }
        });
        
        $('#product-content .product-actions a.gift-registry').on('click', function() {
            if (isGTMEnabled) {
                require('../gtm').addToGiftRegistry();
            }
        });

        $('#product-content').off('click','.giftcard-amounts a.amountanchor').on('click', '.giftcard-amounts a.amountanchor', function(e) {
            e.preventDefault();
            if ($(this).closest('li').hasClass('selected')) {
                $(this).closest('li').removeClass('selected');
            } else {
                $(this).closest('.giftcard-amounts').find('li.selected').removeClass('selected');
                $(this).closest('li').addClass('selected');
                $('.giftcard-custom-amount input').val($(this).text().trim());
                $('.giftcard-custom-amount input').trigger('focusout');
            }
        });

        $('#product-content').on('keyup', '.giftcard-custom-amount input', function() {
            if ($('.giftcard-custom-amount input').val() != $('ul.amount li.selected').text().trim()){
                $('ul.amount li.selected').removeClass('selected');
            }
        });
        $('#product-content').off('focusout', '.giftcard-custom-amount input').on('focusout', '.giftcard-custom-amount input', function(e) {
            e.preventDefault();
            $(this).closest('.field-wrapper').find('span').remove();
            $(this).removeClass('error');
            var enteredAmount = $(this).val();
            if (enteredAmount.indexOf('$') == -1) {
                enteredAmount = '$' + enteredAmount;
                $(this).val(enteredAmount);
            }
            var punctuation = /^\$\d+$/;
            if (!punctuation.test(enteredAmount)) {
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_customAmount" class="error">$10 minimum, $500 maximum; whole-dollar amounts only, no special characters.</span>');
                $(this).addClass('error');
                return;
            }
            var amount = parseInt(enteredAmount.split('$')[1], 10);
            var minAmount = parseInt($('input[name="minAmount"]').val(), 10);
            var maxAmount = parseInt($('input[name="maxAmount"]').val(), 10);
            if (amount < minAmount || amount > maxAmount) {
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_customAmount" class="error">Please enter an amount from $10 - $500</span>');
                $(this).addClass('error');
                return;
            } else {
                $(this).removeClass('error');
            }
            if ($('input[name="physical"]').length > 0 && $('input[name="physical"]').val() == 'true') {
                if ($('input[name="masterProduct"]').val() != 'true') {
                    $(this).closest('form').find('button#add-to-cart').removeAttr('disabled');
                    $(this).closest('form').find('button#add-to-cart').removeClass('add-to-cart-disabled');
                    $(this).closest('form').find('button#add-to-cart').addClass('add-to-cart');
                }
            } 
            if ($('input[name="electronic"]').length > 0 && $('input[name="electronic"]').val() == 'true') {
                if ($('input[name="masterProduct"]').val() != 'true') {
                    $(this).closest('form').find('button#add-to-cart').removeAttr('disabled');
                    $(this).closest('form').find('button#add-to-cart').removeClass('add-to-cart-disabled');
                    $(this).closest('form').find('button#add-to-cart').addClass('add-to-cart');
                }
            }
        });

        $('#product-content').off('focusout', '.giftcard-recipient-emailconfirm input').on('focusout', '.giftcard-recipient-emailconfirm input', function(e) {
            e.preventDefault();
            var email = $(this).closest('form').find('.giftcard-recipient-email input').val();
            var emailConfirm = $(this).val();
            if (emailConfirm == '') {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_recipientEmailconfirm" class="error">This field is required.</span>');
                $(this).addClass('error');
                return;
            // SLTBE-8954: trim before validating, matching validateEmail in
            // js/validator.js and the attendee handler in app.js. The
            // email-vs-confirm comparison below is left comparing raw values -
            // two differently padded entries really are two different strings.
            } else if (!validator.isEmail($.trim(emailConfirm))) {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_recipientEmailconfirm" class="error">Please enter a valid email address.</span>');
                $(this).addClass('error');
                return;
            } else {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).removeClass('error');
            }
            
            if ($('input[name="masterProduct"]').val() != 'true') {
                $(this).closest('form').find('button#add-to-cart').removeAttr('disabled');
                $(this).closest('form').find('button#add-to-cart').removeClass('add-to-cart-disabled');
                $(this).closest('form').find('button#add-to-cart').addClass('add-to-cart');
            }
            if (email.toLocaleLowerCase() != emailConfirm.toLocaleLowerCase()) {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_recipientEmailconfirm" class="error">Please enter the same value again.</span>');
                $(this).addClass('error');
            } else {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).removeClass('error');
                if ($('input[name="masterProduct"]').val() != 'true') {
                    $(this).closest('form').find('button#add-to-cart').removeAttr('disabled');
                    $(this).closest('form').find('button#add-to-cart').removeClass('add-to-cart-disabled');
                    $(this).closest('form').find('button#add-to-cart').addClass('add-to-cart');
                }
            }
        });

        $('#product-content').off('focusout', ' .giftcard-recipient-email input').on('focusout', ' .giftcard-recipient-email input', function(e) {
            e.preventDefault();
            var email = $(this).val();
            if (email == '') {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_recipientEmail" class="error">This field is required.</span>');
                $(this).addClass('error');
                return;
            // SLTBE-8954: trim before validating - see the confirm handler above.
            } else if (!validator.isEmail($.trim(email))) {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_recipientEmail" class="error">Please enter a valid email address.</span>');
                $(this).addClass('error');
                return;
            } else {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).removeClass('error');	
            }
            var emailConfirm = $(this).closest('form').find('.giftcard-recipient-emailconfirm input').val();
            if ($('input[name="masterProduct"]').val() != 'true') {
                $(this).closest('form').find('button#add-to-cart').removeAttr('disabled');
                $(this).closest('form').find('button#add-to-cart').removeClass('add-to-cart-disabled');
                $(this).closest('form').find('button#add-to-cart').addClass('add-to-cart');
            }
            if (emailConfirm != '') {
                $(this).closest('form').find('.giftcard-recipient-emailconfirm input').trigger('focusout');
            }
        });

        if ($availabilityContainer.length) {
            if (User.storeId) {
                inventory.getStoresInventory(this.pid).then(storesListing);
            }

            // See more or less stores in the listing
            $availabilityContainer.on('click', '.stores-toggle', function(e) {
                e.preventDefault();
                $('.store-list-pdp .store-list-item').toggleClass('visible');
                if ($(this).hasClass('collapsed')) {
                    $(this).text(Resources.SEE_LESS);
                } else {
                    $(this).text(Resources.SEE_MORE);
                }
                $(this).toggleClass('collapsed');
            });
        }
        if ($('#storeAvailability').val() == Resources.NOTAVAILABLE_INSTORE){
            $('#storepickin').prop('checked',false);
            $('#instorestock').prop('checked',true)
        }
        //show calendar in EGC page
        $('input[type="radio"]').click(function() {
            if ($(this).hasClass('later-date') && !($('#ui-datepicker-div').is(':visible'))) {
                util.datePicker();
                $('#sessionstartdate.giftvardcalinp').focus();
                
            }
        });
        
        $('.giftcard-giftmessage .field-wrapper').click(function() {
            $(this).find('.input-text').focus();
        });
        if ($('input[name="eddEnabled"]').length > 0 && $('#shipToAdress').is(':checked')) {
            $('body').find('.estimated-delivery').css('display','block');
        }
      
        $('#product-content').off('blur','.giftcard-giftmessage input').on('blur','.giftcard-giftmessage input', function() {
            var format = /^[\w\d!#$%.&'\-?_`:; ]*$/;
            var emojis = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gm;
            var giftmessage = $(this).val();
            if (!format.test(giftmessage) || emojis.test(giftmessage)) {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).closest('.field-wrapper').append('<span id="dwfrm_giftcard_recipientEmail" class="error">Please enter a valid message.</span>');
                $(this).addClass('error');
                $(this).addClass('valid');
                return;
            } else {
                $(this).closest('.field-wrapper').find('span').remove();
                $(this).removeClass('error');
            }

            if ($('input[name="physical"]').length > 0 && $('input[name="physical"]').val() == 'true') {
                if ($('input[name="masterProduct"]').val() != 'true') {
                    $(this).closest('form').find('button#add-to-cart').removeAttr('disabled');
                    $(this).closest('form').find('button#add-to-cart').removeClass('add-to-cart-disabled');
                    $(this).closest('form').find('button#add-to-cart').addClass('add-to-cart');
                }
                return;
            }
            if ($('input[name="masterProduct"]').val() != 'true' && !$('.giftcard-giftmessage input').hasClass('error')) {
                $(this).closest('form').find('button#add-to-cart').removeAttr('disabled');
                $(this).closest('form').find('button#add-to-cart').removeClass('add-to-cart-disabled');
                $(this).closest('form').find('button#add-to-cart').addClass('add-to-cart');
            }
        });
        var searchStoreText = '';
        $('body').on('keydown', '.select-radius-wrapper', function (e) {
            e.preventDefault();
            $('#user-input-text-store').removeClass('input-text-error');
            $('.user-input-search-error').removeClass('show-err-msg');
            var searchStoreQty = '';
            $('.product-store-qty .quantity').removeClass('qty-dev-border-error');
            $('.product-store-qty .qty-error-msg').removeClass('show-error-msg');
            if (e.which === 13) {
                searchStoreQty = $('#Quantity').val();
                if (searchStoreQty === '' || searchStoreQty == 0) {
                    $('.product-store-qty .quantity').addClass('qty-dev-border-error');
                    $('.product-store-qty .qty-error-msg').addClass('show-error-msg');
                    return;
                } 
                searchStoreText = $('#user-input-text-store').val();
                if (searchStoreText == '') {
                    $('#user-input-text-store').addClass('input-text-error');
                    $('.user-input-search-error').addClass('show-err-msg');
                    return;
                }
                inventory.getStoreByText(searchStoreText, $('.select-radius option:selected').val(), $('#Quantity').val()); 
            }
        });
        $('body').on('keypress','#user-input-text-store , .product-store-qty #Quantity', function(e) {
            $('#user-input-text-store').removeClass('input-text-error');
            $('.user-input-search-error').removeClass('show-err-msg');
            var searchStoreQty = '';
            $('.product-store-qty .quantity').removeClass('qty-dev-border-error');
            $('.product-store-qty .qty-error-msg').removeClass('show-error-msg');          
            if (e.which === 13) {
                                // trigger the search button
                searchStoreQty = $('#Quantity').val();
                if (searchStoreQty === '' || searchStoreQty == 0) {
                    $('.product-store-qty .quantity').addClass('qty-dev-border-error');
                    $('.product-store-qty .qty-error-msg').addClass('show-error-msg');
                    return;
                } 
                searchStoreText = $('#user-input-text-store').val();
                if (searchStoreText == '') {
                    $('#user-input-text-store').addClass('input-text-error');
                    $('.user-input-search-error').addClass('show-err-msg');
                    return;
                }
                inventory.getStoreByText(searchStoreText, $('.select-radius option:selected').val(), $('#Quantity').val());  
            }
        });
        $('body').on('keydown','.inventory #Quantity', function(e) {
            if ((90 >= e.which && e.which >= 65) || (111 >= e.which && e.which >= 107) || (192 >= e.which && e.which >= 186) || e.which==16 || (222 >= e.which && e.which >= 219) || (41 >= e.which && e.which >= 33)) {
                e.preventDefault();
            }
        });
        var previousValueQtyInput;
        $('body').on('click','.inventory #Quantity', function () {
            var current = $(this);
            var value = current.val();
            if (value) {
                previousValueQtyInput = parseInt(value, 10);
            }
    
            current.val('');
            current.on('blur', function () {
                var currentValue = current.val();
                if (!currentValue) {
                    current.val(previousValueQtyInput);
                }
                current.off('blur');
            });
        });
        $('body').on('change keyup','.inventory #Quantity', function() {
            var current = $(this);
            var qty = parseInt(current.val(), 10);
            if (qty < 1){
                current.val(1);
            }
        });

        if (radar.isEnabled && !SitePreferences.pdpStoreSearchByPostalCode) {
            var resetPickUpStoreAddressList = function() {
                $('#pickUpStoreAddressList').empty();
                $('#pickUpStoreAddressList').addClass('hidden');
            };

            var userInputTextStoreValue = '';
            $('body').on('keyup','#user-input-text-store', _.debounce(function(e) {
                if (userInputTextStoreValue === e.target.value) {
                    return;
                }

                userInputTextStoreValue = e.target.value;
                var pickUpStoreAddressList = $('#pickUpStoreAddressList');
                if (e.target.value.length > 0) {
                    radar.autocomplete({
                        query: e.target.value,
                        limit: 5,
                        layers: 'coarse',
                        countryCode: 'US'
                    }).then((result) => {
                        resetPickUpStoreAddressList();

                        if (!result.addresses.length) {
                            return;
                        }

                        result.addresses.forEach(function(address){
                            $('<li/>')
                                .addClass('address-list-item')
                                .html(address.formattedAddress)
                                .on('click', function() {
                                    userInputTextStoreValue = address.formattedAddress;
                                    $('#user-input-text-store').val(address.formattedAddress);
                                    resetPickUpStoreAddressList();
                                })
                                .appendTo(pickUpStoreAddressList);
                        });

                        pickUpStoreAddressList.removeClass('hidden');
                    });
                } else {
                    resetPickUpStoreAddressList();
                }
            }, 1000));
        }

        $('body').on('click','.find-in-store-search', function() { 
            var searchStoreQty = '';
            $('#user-input-text-store').removeClass('input-text-error');
            $('.user-input-search-error').removeClass('show-err-msg');
            $('.product-store-qty .quantity').removeClass('qty-dev-border-error');
            $('.product-store-qty .qty-error-msg').removeClass('show-error-msg');
            $('.no-stores').removeClass('show-error-msg');
            searchStoreText = $('#user-input-text-store').val();
            searchStoreQty = $('#Quantity').val();
            if (searchStoreQty === '' || searchStoreQty == 0) {
                $('.product-store-qty .quantity').addClass('qty-dev-border-error');
                $('.product-store-qty .qty-error-msg').addClass('show-error-msg');
                return;
            } 
            if (searchStoreText === '') {
                $('#user-input-text-store').addClass('input-text-error');
                $('.user-input-search-error').addClass('show-err-msg');
            } else {
                searchStoreQty = $('#Quantity').val();
                inventory.getStoreByText(searchStoreText, $('.select-radius option:selected').val(), searchStoreQty);
            }
        });

        $('body').on('click','.select-store-button', function () {
            var selectedStoreName = $(this).parents('.store-tile').find('.store-name').text().trim();
            var selectedStoreID=$(this).data('store-id');
            $('#isShipToAddress').val(true);
            $('#changeLocation').text(Resources.STORE_CHANGE_LOCATION);
            inventory.selectAvailableStore(selectedStoreName,selectedStoreID);
        });
        $('body').on('click','.ui-dialog-titlebar-close , .select-store-button', function(){
            $('.pdpForm').find('.add-to-cart').attr('disabled', false);
        
        });
    }
};

$('body').on('submit', 'form[id^="dwfrm_product_addtocart_"]', function(e) {
    e.preventDefault();
    $('#add-to-cart').trigger('click');
});

$('body').on('click','.pdp-use-current-location', function() {
    inventory.getNearestStore();
});
$('body').on('click','#product-content .set-preferred-store', function(e) {
    e.preventDefault();
    if (!User.zip) {
        inventory.zipPrompt(function() {
            self.productSelectStore();
        });
    } else {
        self.productSelectStore();
    }
});
$('#product-content').off('focusout', '.zip-code-input-text').on('focusout', '.zip-code-input-text', function() {
    edd();
});
$('body').on('keypress','.zip-code-input-text', function(e) {
    if (e.which === 13) {
        edd();
        $('#user-input-text-zipcode').blur();
    }
});
module.exports = productInventory;

},{"../edd":14,"../gtm":18,"../radar":62,"../util":78,"../validator":79,"./":74,"./classdetailstore":72,"lodash":94}],76:[function(require,module,exports){
'use strict';

/**
 * Checks the TLS and displays a warning if appropriate
 * @function getUserAgent Checks the TLS and displays a warning if appropriate
 **/
function getUserAgent() {
    // Use an external service to check the TLS of the browser
    // NOTE: this implementation uses https://www.howsmyssl.com
    //     you may also wish to consider the API available at https://www.ssllabs.com/projects/ssllabs-apis/index.html
    var url = 'https://www.howsmyssl.com/a/check';
    var cookieName = 'dw_TLSWarning';
    var cookieValue = getCookie(cookieName);

    // Test to see if this browser has already been flagged by looking at its cookies
    if (!cookieValue) {
        getTLS(url, function (message) {
            if (message.length > 0) {
                showWarning(message[0]);

                // the browser is bad - set the cookie to true (for 15 minutes)
                setCookie(cookieName, 'true', 15);
            } else {
                // else the browser is good, set the cookie to false (for 30 days) so we don't check again
                setCookie(cookieName, 'false', 60 * 24 * 30);
            }
        });
    } else if (cookieValue === 'true') {
        // if we already know that this is an invalid browser, show the warning
        showWarning(Resources.TLS_WARNING);
    }
}

/**
 * Calls out to the TLS service and calls the callback with a message (if necessary)
 * @function getTLS
 *
 * @param {string} url - URL of external TLS-checking API
 * @param {function} callback - function to call with response
 **/
function getTLS(url, callback) {
    var message = [];

    // First, see if the browser is among the suspect browsers to see if a TLS check is necessary
    var userAgent = navigator.userAgent;

    /** This list derived from https://www.ssllabs.com/ssltest/clients.html **/
    var badBrowsers = ['MSIE 6.0','MSIE 7.0','MSIE 8.0','MSIE 9.0','MSIE 10.0',
                       'Android 2.3.7', 'Android 4.0.4', 'Android 4.1.1', 'Android 4.2.2', 'Android 4.3',
                       'Safari 5.1.9 / OS X 10.6.8', 'Safari 6.0.4 / OS X 10.8.4 '];
    function checkTLSLevel(data) {
        // If we can determine the TLS level, check to see if it's less than 1.2
        if (parseFloat(data.tls_version.split(' ')[1]) < 1.1) {
            message.push(Resources.TLS_WARNING);
            callback(message);

            //If you want to track statistics on bad TLS hits, include this call
            $.ajax({url: Urls.TLSBadTLS});
        }
    }

    function reportBadBrowser () {
        // If the TLS level cannot be determined just report that this browser is suspect
        message.push(Resources.TLS_WARNING);
        callback(message);

        //If you want to track statistics on deprecated browsers, include this call
        $.ajax({url: Urls.TLSBadBrowser});
    }

    for (var i = 0; i < badBrowsers.length; i++) {
        if (userAgent.match(badBrowsers[i])) {
            // It's a suspect browser, let's see what it's TLS level is
            $.ajax({
                url: url
            }).done(checkTLSLevel).fail(reportBadBrowser);
            break;
        }
    }

    /** For testing purposes, uncomment this block
        message.push(Resources.TLS_WARNING);
    **/
    callback(message);
}

/**
 * @function showWarning turns on the browser-compatibility-alert and sets the message
 *
 * @param {string} message - the message that will be shown upon detection of a bad browser
 **/
function showWarning(message) {
    $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(message)).appendTo('#browser-check');
}

/**
 * @function getCookie
 *
 * @param {string} key - The cookie name
 * @returns {string} value - the value of the cookie if found, null otherwise
 **/
function getCookie(key) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var tokens = cookies[i].split('=');
        var cookieKey = tokens[0].trim();
        if (cookieKey === key) {
            return tokens[1];
        }
    }
    return '';
}

/**
 * @function setCookie
 *
 * @param {string} key - The cookie name
 * @param {string} value - The cookie value
 * @param {integer} minutes - The number of minutes to expire the cookie
 **/
function setCookie (key, value, minutes) {
    var date = new Date();
    date.setTime(date + (minutes * 60 * 1000));

    document.cookie = key + '=' + value + '; expires=' + date.toGMTString() + '; path=/; Secure';
}

/**
 * Export the getUserAgent function
 */

exports.getUserAgent = getUserAgent;

},{}],77:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {
    $(document).tooltip({
        items: '.tooltip',
        content: function () {
            return $(this).find('.tooltip-content').html();
        },
        close: function(event, ui) {
            ui.tooltip.hover(function() {
                $(this).stop(true).fadeTo(400, 1);
            },
                function() {
                    $(this).fadeOut('400', function() {
                        $(this).remove();
                    });
                });
        },
        position: {
            my: 'center bottom-5',
            at: 'center top',
            using: function(position, feedback) {
                $(this).css(position);
                $(this).addClass(feedback.vertical);
                if ($(window).width() < 500) {
                    var t = position.top;
                    $(this).css('top', t - 5);
                    var f = position.left;
                    if (f <= 0 || f <= 15 || $(this).width() < 100) {
                        $(this).css('left', '5px');
                    } else {
                        $(this).css('left', f - 52);
                    }
                } else {
                    $(this).css('top', position.top - 5);
                    $(this).css('left', position.left - 10);
                }
            }
        }
    });
    
    $('.share-link').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        if (!target) {
            return;
        }
        $(target).toggleClass('active');
    });
};

},{}],78:[function(require,module,exports){
'use strict';

var _ = require('lodash');
var dateCapture = require('./dateformat');

var REFINEMENT_NAME = /^prefn(\d+)=(.*)$/;
var REFINEMENT_VALUE = /^prefv(\d+)=(.*)$/;

var util = {
    initialStateOrder: (window.history.state && window.history.state.order) || 0,

    singleExecutionPromise(fn) {
        var currentPromise = null;
        return function() {
            var theArgs = arguments;
            if (!currentPromise) {
                currentPromise = fn.apply(this, theArgs)
                    .then(function(result){
                        currentPromise = null;
                        return result;
                    })
                    .catch(function(error){
                        currentPromise = null;
                        throw error;
                    });
            }
            return currentPromise;
        }
    },
    

    isInitialState: function() {
        return ((window.history.state && window.history.state.order) || 0) === this.initialStateOrder;
    },

    isExtendProductId: function(productId) {
        var extendSkuPrefix = window.SitePreferences.extendSkuPrefix;
        var extendPPSkuPrefix = window.SitePreferences.extendPPSkuPrefix;
        return typeof productId === 'string' && (productId.indexOf(extendSkuPrefix) === 0 || productId.indexOf(extendPPSkuPrefix) === 0);
    },

    getExtendProductId: function(extendTerm, isPP) {
        var extendSkuPrefix = window.SitePreferences.extendSkuPrefix;
        var extendPPSkuPrefix = window.SitePreferences.extendPPSkuPrefix;
        return isPP ? extendPPSkuPrefix + extendTerm : extendSkuPrefix + extendTerm;
    },

    /**
     * Convert the provided string URL to data
     * @param url
     * @returns {{baseUrl: string, params: {}, refinements: {}}}
     */
    urlStringToData: function(url) {
        var params = {};
        var refinements = {};
        var urlList = (url || location.href).split('?');
        var baseUrl = urlList[0];
        var queryString = urlList[1] || '';
        var paramsList = queryString.split('&');
        var i;
        var p;
        var matchMap;
        var paramList;

        var refinementNames = {};
        var refinementValues = {};
        for (i = 0; i < paramsList.length; ++i) {
            matchMap = REFINEMENT_NAME.exec(paramsList[i]);
            if (matchMap) {
                refinementNames[matchMap[1]] = decodeURIComponent(matchMap[2]);
            } else {
                matchMap = REFINEMENT_VALUE.exec(paramsList[i]);
                if (matchMap) {
                    refinementValues[matchMap[1]] = decodeURIComponent(matchMap[2]);
                } else {
                    paramList = paramsList[i].split('=');
                    params[decodeURIComponent(paramList[0])] = decodeURIComponent(paramList[1]);
                }
            }
        }

        for (p in refinementNames) {
            if (refinementNames.hasOwnProperty(p) && refinementValues.hasOwnProperty(p) && refinementNames[p] && refinementValues[p]) {
                refinements[refinementNames[p]] = (refinementValues[p] || '').split('|');
            }
        }

        return {
            baseUrl: baseUrl,
            params: params,
            refinements: refinements
        }
    },

    /**
     * Convert the provided url json to string
     * @param urlData
     * @returns {string}
     */
    urlDataToString: function(urlData) {
        var baseUrl = urlData.baseUrl;
        var params = urlData.params;
        var refinements = urlData.refinements;
        var queryItems = [];
        var p;
        var i;
        for (p in params) {
            if (params.hasOwnProperty(p)) {
                queryItems.push(encodeURIComponent(p) + '=' + encodeURIComponent(params[p]));
            }
        }
        i = 1;
        for (p in refinements) {
            if (refinements.hasOwnProperty(p)) {
                queryItems.push('prefn' + i + '=' + encodeURIComponent(p));
                queryItems.push('prefv' + i + '=' + encodeURIComponent(refinements[p]));
            }
        }
        return baseUrl + (baseUrl.indexOf('?') > 0 ? '&' : '?') + queryItems.join('&');
    },

    getURLRefinementValue: function(url, refinementName) {
        var urlData = this.urlStringToData(url);
        return (urlData.refinements[refinementName] || []).join('|');
    },

    getURLRefinementValues: function(url, refinementName) {
        var urlData = this.urlStringToData(url);
        return urlData.refinements[refinementName] || [];
    },

    /**
     * @function
     * @description appends the parameter with the given name and value to the given url and returns the changed url
     * @param {String} url the url to which the parameter will be added
     * @param {String} name the name of the parameter
     * @param {String} value the value of the parameter
     * @param {Boolean} notEncodeValue the value of the parameter
     */
    appendParamToURL: function(url, name, value, notEncodeValue) {
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        return url + separator + name + '=' + (notEncodeValue ? value : encodeURIComponent(value));
    },

    /**
     * @function
     * @description remove the parameter and its value from the given url and returns the changed url
     * @param {String} url the url from which the parameter will be removed
     * @param {String} name the name of parameter that will be removed from url
     */
    removeParamFromURL: function(url, name) {
        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
            return url;
        }
        var hash;
        var params;
        var domain = url.split('?')[0];
        var paramUrl = url.split('?')[1];
        var newParams = [];
        // if there is a hash at the end, store the hash
        if (paramUrl.indexOf('#') > -1) {
            hash = paramUrl.split('#')[1] || '';
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (var i = 0; i < params.length; i++) {
            // put back param to newParams array if it is not the one to be removed
            if (params[i].split('=')[0] !== name) {
                newParams.push(params[i]);
            }
        }
        return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
    },
    /**
     * @function
     * @description get all URL parameters
     * @param {String} url
     */
    getURLParam: function(url) {
        var urlParams = [];
        if (url.indexOf('?') === -1) {
            return urlParams;
        }
        var params;
        var paramUrl = url.split('?')[1];
        if (paramUrl.indexOf('#') > -1) {
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (var i = 0; i < params.length; i++) {
            if (params[i].split('=').length == 2) {
                var param = {};
                param.paramKey = decodeURIComponent(params[i].split('=')[0]);
                param.paramValue = decodeURIComponent(params[i].split('=')[1]);
                urlParams.push(param);

            }
        }
        return urlParams;
    },
    /**
     * @function
     * @description get parameter value for given Key
     * @param {String} url the url from which the parameter will be taken
     * @param {String} name the name of parameter
     */
    getParamValue: function(url, name) {
        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
            return null;
        }
        var params;
        var paramUrl = url.split('?')[1];
        var paramValue;
        // if there is a hash at the end, store the hash
        if (paramUrl.indexOf('#') > -1) {
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (var i = 0; i < params.length; i++) {
            if (params[i].split('=').length == 2 && params[i].split('=')[0] === name) {
                paramValue = decodeURIComponent(params[i].split('=')[1]);
            }
        }
        return paramValue;
    },


    /**
     * @function
     * @description appends the parameters to the given url and returns the changed url
     * @param {String} url the url to which the parameters will be added
     * @param {Object} params
     */
    appendParamsToUrl: function(url, params) {
        var _url = url;
        _.each(params, function(value, name) {
            _url = this.appendParamToURL(_url, name, value);
        }.bind(this));
        return _url;
    },
    /**
     * @function
     * @description extract the query string from URL
     * @param {String} url the url to extra query string from
     **/
    getQueryString: function(url) {
        var qs;
        if (!_.isString(url)) {
            return;
        }
        var a = document.createElement('a');
        a.href = url;
        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }
        return qs;
    },
    /**
     * @function
     * @description
     * @param {String}
     * @param {String}
     */
    elementInViewport: function(el, offsetToTop) {
        var top = el.offsetTop,
            left = el.offsetLeft,
            width = el.offsetWidth,
            height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        if (typeof(offsetToTop) !== 'undefined') {
            top -= offsetToTop;
        }

        if (window.pageXOffset !== null) {
            return (
                top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );
        }

        if (document.compatMode === 'CSS1Compat') {
            return (
                top < (window.document.documentElement.scrollTop + window.document.documentElement.clientHeight) &&
                left < (window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth) &&
                (top + height) > window.document.documentElement.scrollTop &&
                (left + width) > window.document.documentElement.scrollLeft
            );
        }
    },

    /**
     * @function
     * @description Appends the parameter 'format=ajax' to a given path
     * @param {String} path the relative path
     */
    ajaxUrl: function(path) {
        return this.appendParamToURL(path, 'format', 'ajax');
    },

    /**
     * @function
     * @description
     * @param {String} url
     */
    toAbsoluteUrl: function(url) {
        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
            url = '/' + url;
        }
        return url;
    },
    /**
     * @function
     * @description Loads css dynamically from given urls
     * @param {Array} urls Array of urls from which css will be dynamically loaded.
     */
    loadDynamicCss: function(urls) {
        var i, len = urls.length;
        for (i = 0; i < len; i++) {
            this.loadedCssFiles.push(this.loadCssFile(urls[i]));
        }
    },

    /**
     * @function
     * @description Loads css file dynamically from given url
     * @param {String} url The url from which css file will be dynamically loaded.
     */
    loadCssFile: function(url) {
        return $('<link/>').appendTo($('head')).attr({
            type: 'text/css',
            rel: 'stylesheet'
        }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
    },
    // array to keep track of the dynamically loaded CSS files
    loadedCssFiles: [],

    /**
     * @function
     * @description Removes all css files which were dynamically loaded
     */
    clearDynamicCss: function() {
        var i = this.loadedCssFiles.length;
        while (0 > i--) {
            $(this.loadedCssFiles[i]).remove();
        }
        this.loadedCssFiles = [];
    },
    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {String} qs The query string from which the parameters will be extracted
     */
    getQueryStringParams: function(qs) {
        if (!qs || qs.length === 0) {
            return {};
        }
        var params = {};
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        // Decoding per param to avoid param names or values containing '=' or '&' to make it fail
        qs.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
            function($0, $1, $2, $3) {
                params[decodeURIComponent($1)] = decodeURIComponent($3);
            }
        );
        return params;
    },

    fillAddressFields: function(address, $form) {
        for (var field in address) {
            if (field === 'ID' || field === 'UUID' || field === 'key') {
                continue;
            }
            // if the key in address object ends with 'Code', remove that suffix
            // keys that ends with 'Code' are postalCode, stateCode and countryCode
            if (field === 'countryCode') {
                $form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field].toUpperCase());
            } else {
                $form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
            }
            // update the state fields
            if (field === 'countryCode') {
                $form.find('[name$="country"]').trigger('change');
                // retrigger state selection after country has changed
                // this results in duplication of the state code, but is a necessary evil
                // for now because sometimes countryCode comes after stateCode
                $form.find('[name$="state"]').val(address.stateCode);
            }
        }
    },
    /**
     * @function
     * @description Updates the number of the remaining character
     * based on the character limit in a text area
     */
    limitCharacters: function() {
        $('form').find('textarea[data-character-limit]').each(function() {
            var characterLimit = $(this).data('character-limit');
            var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG,
                '<span class="char-remain-count">' + characterLimit + '</span>',
                '<span class="char-allowed-count">' + characterLimit + '</span>');
            var charCountContainer = $(this).next('div.char-count');
            if (charCountContainer.length === 0) {
                charCountContainer = $('<div class="char-count"/>').insertAfter($(this));
            }
            charCountContainer.html(charCountHtml);
            // trigger the keydown event so that any existing character data is calculated
            $(this).change();
        });
    },
    /**
     * @function
     * @description Updates the number of the remaining character
     * based on the character limit in a text area for Gift Message
     */
    limitCharactersGiftMessage: function() {
        $('form').find('textarea[data-gift-message-char-limit]').each(function() {
            var parent = $(this).parent();
            if (!parent.find('.gift-message-char-count').length) {
                var characterLimit = $(this).data('gift-message-char-limit');
                var maxLines = $(this).prop('rows');
                var charactersPerLine = characterLimit / maxLines;
                var message = String.format(Resources.CHAR_LIMIT_GIFT_MSG, charactersPerLine, 1, maxLines);
                var charCountHtml =`<div class="gift-message-char-count">${message}</div>`;
                parent.addClass('gift-message-container');
                parent.append(charCountHtml);
            }
            // trigger the keyup event so that any existing character data is calculated
            $(this).trigger('keyup');
        });
    },
    /**
     * @function
     * @description Binds the onclick-event to a delete button on a given container,
     * which opens a confirmation box with a given message
     * @param {String} container The name of element to which the function will be bind
     * @param {String} message The message the will be shown upon a click
     */
    setDeleteConfirmation: function(container, message) {
        $(container).on('click', '.delete', function() {
            return window.confirm(message);
        });
    },
    /**
     * @function
     * @description Scrolls a browser window to a given x point
     * @param {String} The x coordinate
     */
    scrollBrowser: function(xLocation) {
        $('html, body').animate({
            scrollTop: xLocation
        }, 500);
    },

    isMobile: function() {
        var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
        var idx = 0;
        var isMobile = false;
        var userAgent = (navigator.userAgent).toLowerCase();

        while (mobileAgentHash[idx] && !isMobile) {
            isMobile = (userAgent.indexOf(mobileAgentHash[idx]) >= 0);
            idx++;
        }
        return isMobile;
    },

    datePicker: function() {
        $('.startdate,.enddate').attr('readonly', 'true');
        $('.ui-datepicker').addClass('date-pickerclass');
        if ($('.send-later').length > 0) {
            $('.ui-datepicker').addClass('giftvardcalendar');
        }
        if ($('.class-prdct.hasDatepicker').length > 0) {
            $('.ui-datepicker').addClass('class-prdct');
        }

        var dateToday = new Date();
        var dates = $('.startdate,.enddate').datepicker({
            dateFormat: 'mm-dd-yy',
            autoSize: true,
            beforeShow: function(input, inst) {
                var calendar = inst.dpDiv;
                var $sendLaterField = inst.input.closest('.pdpForm').find('input.send-later');
                var $classDateWidth = inst.input.closest('#secondary');
                var $classDateCalender = inst.input.closest('.plp-class').find('.calender-main');
                if ($sendLaterField.length > 0) {
                    $(this).datepicker('option', 'minDate', '+1');
                }
                if ($('.send-later').length > 0) {
                    $('.send-later').addClass('giftvardcalinp');
                }
                if ($('.pt_gift-registry .startdate.hasDatepicker').length > 0) {
                    $('.ui-datepicker').addClass('giftregistry-cal');
                }
                setTimeout(function() {
                    calendar.position({
                        my: 'right top',
                        at: 'right bottom',
                        collision: 'none',
                        of: input
                    });
                    inst.input.addClass('active');
                    if ($(window).width() <= 1023) {
                        if ($sendLaterField.length > 0) {
                            calendar.css('width', $sendLaterField.outerWidth());
                            calendar.css('right', 22);
                        }
                        if ($classDateWidth.length > 0) {
                            if (inst.input.hasClass('class-prdct')) {
                                $classDateWidth.addClass('classproductZindex');
                                $classDateCalender.addClass('calender-mainZindex');
                                if ($(window).width() <= 767) {
                                    $('.pt_classes-search-result .pagination').hide();
                                }
                            }
                            //calendar.css('width', $classDateWidth.outerWidth());
                        }
                    }

                }, 1);
            },
            onClose: function(date, datepicker) {
                $('.pt_classes-search-result .pagination').show();
                $('.calender-main').removeClass('calender-mainZindex');
                datepicker.input.removeClass('active');
                if (datepicker.input.hasClass('send-later')) {
                    if (date != '') {
                        datepicker.input.closest('.pdpForm').find('input.later-date').prop('checked', true);
                    }
                }
            },
            //showOn: false,
            dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            showButtonPanel: false,
            minDate: dateToday,
            onSelect: function(selectedDate) {
                var option = this.id == 'sessionstartdate' ? 'minDate' : 'maxDate',
                    instance = $(this).data('datepicker'),
                    date = $.datepicker.parseDate(instance.settings.dateFormat || $.datepicker._defaults.dateFormat, selectedDate, instance.settings);
                dates.not(this).datepicker('option', option, date);
                //enableapplybutton();
                if (dates[0] != undefined && dates[1] != undefined) {
                    dateCapture.endDateCap(dates[0].value, dates[1].value);
                }
                if ($('.startdate').val() != '') {
                    $('.startdate').removeClass('error');
                    $('.startdate').closest('.focus-date').find('span.error').remove();
                }
            }
        });
    },

    generateAttendeeFormPDP: function(index) {
        var dataToAppend = '<div class="mainAttendee">';
        dataToAppend += '<div class="attendeenumber">Attendee #' + index + '</div>';
        dataToAppend += '<div class="first-section">';
        dataToAppend += '<div class="form-row firstName">';
        dataToAppend += '<label for="attendee-firstname-' + index + '"><span class="required-indicator">* </span><span>First Name</span></label>';
        dataToAppend += '<div class="field-wrapper">';
        dataToAppend += '<input type="text" value="" maxlength="35" class="input-text attendee-input firstname" name="attendee_firstname_[]" id="attendee-firstname-' + index + '">';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '<div class="form-row lastName">';
        dataToAppend += '<label for="attendee-lastname-' + index + '"><span class="required-indicator">* </span><span>Last Name</span></label>';
        dataToAppend += '<div class="field-wrapper">';
        dataToAppend += '<input type="text" value="" maxlength="35" class="input-text attendee-input lastname" name="attendee_lastname_[]" id="attendee-lastname-' + index + '">';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '<div class="second-section">';
        dataToAppend += '<div class="form-row form-email">';
        dataToAppend += '<label for="attendee-email-' + index + '"><span class="required-indicator">* </span><span>Email</span></label>';
        dataToAppend += '<div class="field-wrapper">';
        dataToAppend += '<input type="text" value="" maxlength="44" class="input-text attendee-input attendee-email" name="attendee_email_[]" id="attendee-email-' + index + '">';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '<div class="form-row form-phone">';
        dataToAppend += '<label for="attendee-phone-' + index + '"><span class="required-indicator">* </span><span>Phone</span></label>';
        dataToAppend += '<div class="field-wrapper">';
        dataToAppend += '<input type="text" value="" maxlength="15" class="input-text attendee-input attendee-phone" name="attendee_phone_[]" id="attendee-phone-' + index + '">';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        return dataToAppend;
    },

    generateAttendeeFormCart: function(index, uuid) {
        var dataToAppend = '<div class="addmainAttendee">';
        dataToAppend += '<div class="mainAttendee">';
        dataToAppend += '<div class="attendeenumber">Attendee #' + index + '</div>';
        dataToAppend += '<div class="sections">';
        dataToAppend += '<div class="first-section">';
        dataToAppend += '<div class="form-row firstName">';
        dataToAppend += '<label for="attendee-firstname-' + index + '"><span class="required-indicator">* </span><span>First Name</span></label>';
        dataToAppend += '<div class="field-wrapper">';
        dataToAppend += '<input type="text" value="" maxlength="35" class="input-text attendee-input firstname" name="attendee_firstname_[]" id="attendee-firstname-' + index + '">';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '<div class="form-row lastName">';
        dataToAppend += '<label for="attendee-lastname-' + index + '"><span class="required-indicator">* </span><span>Last Name</span></label>';
        dataToAppend += '<div class="field-wrapper">';
        dataToAppend += '<input type="text" value="" maxlength="35" class="input-text attendee-input lastname" name="attendee_lastname_[]" id="attendee-lastname-' + index + '">';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '<div class="second-section">';
        dataToAppend += '<div class="form-row form-email">';
        dataToAppend += '<label for="attendee-email-' + index + '"><span class="required-indicator">* </span><span>Email</span></label>';
        dataToAppend += '<div class="field-wrapper">';
        dataToAppend += '<input type="text" value="" maxlength="44" class="input-text attendee-input attendee-email" name="attendee_email_[]" id="attendee-email-' + index + '">';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '<div class="form-row form-phone">';
        dataToAppend += '<label for="attendee-phone-' + index + '"><span class="required-indicator">* </span><span>Phone</span></label>';
        dataToAppend += '<div class="field-wrapper">';
        dataToAppend += '<input type="text" value="" maxlength="15" class="input-text attendee-input attendee-phone" name="attendee_phone_[]" id="attendee-phone-' + index + '">';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '<div class="third-section">';
        dataToAppend += '<button class="textbutton removeAttendee" value="removeAttendee" name="removeAttendee">x Remove</button>';
        dataToAppend += '</div>';
        dataToAppend += '</div>';
        dataToAppend += '<input type="hidden" value="' + uuid + '" class="uuid" name="attendee_uuid_[]">';
        dataToAppend += '</div>';
        dataToAppend += '</div>'
        return dataToAppend;
    },

    displayAddattendeeform: function() {
        if (isNaN($('.classQuantity').val())) {
            $('.classQuantity').val('1');
        }
        var textVal = $('.classQuantity').val();
        $('.attendeeInstructions').removeClass('hide')
        $('.cancellationPolicy').removeClass('hide')
        var existedAttendeeLength = $('.mainAttendee').length;
        if (existedAttendeeLength > textVal || existedAttendeeLength === 0) {
            $('.attendeeDetails').text(' ');
            for (var i = 1; i <= textVal; i++) {
                var index = i;
                $('.attendeeDetails').append(this.generateAttendeeFormPDP(index));
            }
        } else if (existedAttendeeLength < textVal && existedAttendeeLength !== 0) {
            var newAttendeeLength = textVal-existedAttendeeLength;
            for (var j = 1; j <= newAttendeeLength; j++) {
                var Attendeeindex = j+existedAttendeeLength;
                $('.attendeeDetails').append(this.generateAttendeeFormPDP(Attendeeindex));
            }
        }
        $('#add-to-cart.class-add-to-cart').removeClass('hide').attr('enabled','enabled');
    },

    hideAddAttendeeForm: function() {
        $('.attendeeInstructions').addClass('hide');
        $('.cancellationPolicy').addClass('hide');
        $('#add-to-cart.class-add-to-cart').addClass('hide');
        $('.attendeeDetails').children().remove();
    }
};

module.exports = util;

},{"./dateformat":12,"lodash":94}],79:[function(require,module,exports){
'use strict';

var naPhone = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
    phone: {
        us: naPhone,
        ca: naPhone,
        fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
        it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
        jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
        cn: /.*/,
        gb: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/
    },
    postal: {
        us: /^\d{5}(-\d{4})?$/,
        ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
        fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
        it: /^([0-9]){5}$/,
        jp: /^([0-9]){3}[-]([0-9]){4}$/,
        cn: /^([0-9]){6}$/,
        gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/
    },
    cvn: /^[0-9]+$/,
    notCC: /^(?!(([0-9 -]){13,19})).*$/,
    giftMsg: /^[\w\d\n!#$%,.&'\-?_`:; ]*$/,
    invalidCharacters:/[:^&'"<>]+/,
    customerName:/^[\w\d&'\-<. ]*$/,
    alphanumeric: /^[\S ]*$/,
    eventName: /^[\w\d!#$%.&'\-?_`:; ]*$/,
    cityName: /^[\w\d ,-]*$/,
    emojis: /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gm,
    xss: /<\s*script\b[^>]*>[^<]+<\s*\/\s*script\s*>/
};
var poBoxList = [
    /PO Box/i,
    /P.O Box/i,
    /PO. Box/i,
    /P.O. Box/i,
    /POBox/i,
    /P.OBox/i,
    /PO.Box/i,
    /P.O.Box/i
];

// global form validator settings
var settings = {
    errorClass: 'error',
    errorElement: 'span',
    onkeyup: false,
    onfocusout: function(element) {
        if (!this.checkable(element)) {
            this.element(element);
        }
    },
    errorPlacement: function(error, element) {
        if (element.attr('id').endsWith('giftMessage')) {
            element.parent().append(error);
        } else {
            error.insertAfter(element);
        }
    }
};

/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function(value, el) {
    var country = $(el).closest('form').find('.country');
    if (country.length === 0 || !country.val() || country.val().length === 0 || !regex.phone[country.val().toLowerCase()]) {
        return true;
    }

    var rgx = regex.phone[country.val().toLowerCase()];
    var isOptional = this.optional(el);
    var isValid = rgx.test($.trim(value));

    return isOptional || isValid;
};

/**
 * @function
 * @description Validates zipcode
 * @param {String} value The zipcode number which will be validated
 * @param {String} el The input field
 */
function validateZip(value, el) {
    var country = $(el).closest('form').find('.country');
    var newZip=$('input[id*="postal"]').val();
    $('.zipcode-checkout').val(newZip);
    var isShipping = $('.isShipping-checkout').val();
    var queryString = '?zipCode='+newZip+'&fromCheckout=true';
    if (country != undefined && (country.length === 0 || !country.val() ||country.val().length === 0 || !regex.postal[country.val().toLowerCase()])) {
        return true;
    }
    var isOptional = this.optional(el);
    var isValid = regex.postal[country.val().toLowerCase()].test($.trim(value));
    if  (isValid && isShipping == 'true') {
        $.ajax({
            url: Urls.getedd + queryString,
            type: 'GET',
            success: function (data) {
                var finalEDD = data.finalEDD;
                if (!isNaN(finalEDD)) {
                    var existingEDD = $('.checkout-estimated-delivery .estimation').text();
                    $('.checkout-estimated-delivery .estimation').text(finalEDD);
                    require('./gtm').onEDDChange(finalEDD, existingEDD);

                }
            },
            error: function () {
            }
        });
    }
    return isOptional || isValid;
}
/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function(value) {
    var isValid = regex.notCC.test($.trim(value));
    return isValid;
};


/**
 * SLTBE-8954 - a faithful port of the `validator` npm package's `isEmail()`
 * with default options, which is exactly what class-validator's `@IsEmail()`
 * enforces on the attendee DTO in slt-sfcc-bff. One definition of "valid
 * email" across PWA, SFCC and BFF is the point of the ticket: an address
 * accepted here is accepted end-to-end, where the previous loose regex let
 * addresses through that only failed the async Braze job an hour later.
 *
 * The character classes and length bounds are copied verbatim from
 * validator/lib/isEmail.js and validator/lib/isFQDN.js (v13). Agreement with
 * the real library was fuzz-verified over 10,500 inputs before this landed.
 *
 * Duplicated in app_surlatable_core/cartridge/scripts/validator.js - SFCC has
 * no module reachable from both browserify'd client code and Rhino cartridge
 * scripts, so the two copies are deliberately identical. Change both together.
 */
var EMAIL_MAX_LENGTH = 254;
var EMAIL_LOCAL_MAX_LENGTH = 64;
var EMAIL_LABEL_MAX_LENGTH = 63;
var EMAIL_LOCAL_PART = /^[a-z\d!#$%&'*+\-/=?^_`{|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var EMAIL_LOCAL_PART_QUOTED = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var EMAIL_DOMAIN_TLD = /^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i;
var EMAIL_DOMAIN_LABEL = /^[a-z_\u00A1-\uFFFF0-9-]+$/i;
var EMAIL_DOMAIN_FULL_WIDTH = /[\uFF01-\uFF5E]/;
var EMAIL_DOMAIN_WHITESPACE = /\s/;
var EMAIL_DOMAIN_ALL_NUMERIC = /^\d+$/;
var EMAIL_DOMAIN_EDGE_HYPHEN = /^-|-$/;

/**
 * @function
 * @description UTF-8 byte length, matching validator/lib/isByteLength.js. The
 *              RFC caps are byte counts and not character counts, so a local
 *              part of 33 two-byte characters is over the 64-byte limit.
 * @param {String} value The string to measure
 * @returns {Number} The byte length, or -1 when value cannot be encoded
 */
function emailByteLength(value) {
    try {
        return encodeURI(value).split(/%..|./).length - 1;
    } catch (e) {
        // Lone surrogate: encodeURI throws a URIError. The upstream library
        // lets it propagate; we reject instead, so a malformed UTF-16 string
        // can never take down a blur handler or a cart update.
        return -1;
    }
}

/**
 * @function
 * @description Port of isFQDN(domain, { require_tld: true, allow_underscores: false }).
 * @param {String} domain The part of the address after the last @
 * @returns {Boolean} true when the domain is a fully qualified domain name
 */
function isEmailDomain(domain) {
    var labels = domain.split('.');
    var tld = labels[labels.length - 1];
    var label;
    var i;

    if (labels.length < 2) {
        return false;
    }

    // require_tld: the final label has to look like a TLD, and an all-numeric
    // one is rejected outright, so a@example.123 fails.
    if (!EMAIL_DOMAIN_TLD.test(tld) || EMAIL_DOMAIN_WHITESPACE.test(tld) || EMAIL_DOMAIN_ALL_NUMERIC.test(tld)) {
        return false;
    }

    for (i = 0; i < labels.length; i++) {
        label = labels[i];

        if (label.length > EMAIL_LABEL_MAX_LENGTH) {
            return false;
        }
        if (!EMAIL_DOMAIN_LABEL.test(label)) {
            return false;
        }
        // Full-width characters are never valid in a hostname.
        if (EMAIL_DOMAIN_FULL_WIDTH.test(label)) {
            return false;
        }
        if (EMAIL_DOMAIN_EDGE_HYPHEN.test(label)) {
            return false;
        }
        if (label.indexOf('_') !== -1) {
            return false;
        }
    }

    return true;
}

/**
 * @function
 * @description Validates an email address. Deliberately does NOT trim, because
 *              the BFF does not trim before @IsEmail() either - a caller that
 *              wants surrounding whitespace tolerated must trim it first.
 * @param {String} value The address to validate
 * @returns {Boolean} true when the address is valid
 */
function isEmail(value) {
    var parts;
    var domain;
    var localPart;
    var localParts;
    var localBytes;
    var domainBytes;
    var i;

    if (typeof value !== 'string' || value.length > EMAIL_MAX_LENGTH) {
        return false;
    }

    // The domain is everything after the LAST @; the rest is the local part,
    // which may itself contain an @ when it is quoted.
    parts = value.split('@');
    domain = parts.pop();
    localPart = parts.join('@');

    localBytes = emailByteLength(localPart);
    domainBytes = emailByteLength(domain);

    if (localBytes < 0 || localBytes > EMAIL_LOCAL_MAX_LENGTH) {
        return false;
    }
    if (domainBytes < 0 || domainBytes > EMAIL_MAX_LENGTH) {
        return false;
    }
    if (!isEmailDomain(domain)) {
        return false;
    }

    // A quoted local part is validated as a whole; an unquoted one is a
    // dot-atom, so every dot-separated atom must be non-empty and legal. That
    // is what rejects foo@bar..com, foo.@bar.com and .foo@bar.com.
    if (localPart.charAt(0) === '"' && localPart.charAt(localPart.length - 1) === '"') {
        return EMAIL_LOCAL_PART_QUOTED.test(localPart.slice(1, localPart.length - 1));
    }

    localParts = localPart.split('.');
    for (i = 0; i < localParts.length; i++) {
        if (!EMAIL_LOCAL_PART.test(localParts[i])) {
            return false;
        }
    }

    return true;
}

/**
 * @function
 * @description Validates email
 * @param {String} email address
 * @param {String} el The input field
 */
var validateEmail = function(value, el) {
    var isValid = isEmail($.trim(value));
    var isOptional = this.optional(el);
    return isOptional || isValid;
};

/**
 * @function
 * @description Validates Gift Message
 * @param {String} Gift Message
 */
var validateGiftMessage = function(value) {
    var isValid = regex.giftMsg.test($.trim(value));
    var containsEmojis = regex.emojis.test($.trim(value));
    return isValid && !containsEmojis;
};

/**
 * @function
 * @description Validate Event Name
 * @param {String} Event Name
 */
var validateEventName = function(value) {
    var isValid = regex.eventName.test($.trim(value));
    var containsEmojis = regex.emojis.test($.trim(value));
    return isValid && !containsEmojis;
};

/**
 * @function
 * @description General Validation
 * @param {String} input text
 */
var validateAlphanumeric = function(value) {
    var isValid = regex.alphanumeric.test($.trim(value));
    var containsEmojis = regex.emojis.test($.trim(value));
    return isValid && !containsEmojis;
};

/**
 * @function
 * @description Validates Customer Name
 * @param {String} Customer Name
 */
var validateCustomerName = function(value) {
    var isValid = regex.customerName.test($.trim(value));
    var containsEmojis = regex.emojis.test($.trim(value));
    return isValid && !containsEmojis;
};

/**
 * @function
 * @description Validates city Name
 * @param {String} city name
 */
var validateCityName = function(value) {
    var isValid = regex.cityName.test($.trim(value));
    return isValid;
};

/**
 * @function
 * @description Validates XSS Attack
 * @param {String} field value
 */
var validateXSSAttack = function(value) {
    var isValid = regex.xss.test($.trim(value));
    return !isValid;
};

/**
 * @function
 * @description Validates that a cvv is a numeric value
 * @param {String} value The cvv field which will be validated
 */
var validateCVNNumber = function (value, el) {
    var cvnMaxLength = 3;
    var cvnErrFlag = false;
    var isValid = regex.cvn.test($.trim(value));
    
    if (!isValid) {
        return false;
    }
    
    var ctype = $(el).closest('form').find('select[name$="creditCard_type"]').val();
    if (ctype == 'Amex') {
        cvnMaxLength = 4;
    }
    var cvnLength = $.trim(value).length;
    if (cvnLength > cvnMaxLength) {
        cvnErrFlag = true;
    }
    if (cvnErrFlag == false && cvnLength > 0 && cvnLength < cvnMaxLength) {
        cvnErrFlag = true;
    }
    if (cvnErrFlag) {
        return false;
    } else {
        return true;
    }
};

/**
 * @function
 * @description Validates credit card number
 * @param {String} value The credit card number field which will be validated
 */
var validateCreditCardNumber = function(value, el) {
    var numberRegex = /^[\d]*$/;
    var maskedRegex = /^\*{1,12}/;
    var ctype = $(el).closest('form').find('select[name$="creditCard_type"]').val();
    var number = $.trim(value);
    var ismasked = false;
    if (maskedRegex.test(number)) {
        var savedCreditCard = $(el).closest('form').find('select[name$="creditCardList"]').val();
        if (savedCreditCard && savedCreditCard != '') {
            ismasked = true;
        }
    }
    if (!numberRegex.test(number) && !ismasked) {
        return false;
    }
    if (ctype == 'Visa') {
        return number.length >= 13 && number.length <= 16;
    } else if (ctype == 'MasterCard') {
        return number.length == 16;
    } else if (ctype == 'Amex') {
        return number.length == 15;
    } else if (ctype == 'Maestro') {
        return number.length == 16;
    } else if (ctype == 'Discover') {
        return number.length == 16;
    } else {
        return false;
    }
};

var validatePOBox = function(value) {
    if (!value) {
        return true;
    }

    return !poBoxList.some(function(poBox) {
        return poBox.test(value);
    });
};

/**
 * Add XSS Attack validation method to jQuery validation plugin.
 * Text fields must have 'input-text' css class to be validated
 */
$.validator.addMethod('input-text', validateXSSAttack, Resources.INVALID_VALUE);

/**
 * Add customer name validation method to jQuery validation plugin.
 * Text fields must have 'customer-name' css class to be validated
 */
$.validator.addMethod('customer-name', validateCustomerName, Resources.INVALID_NAME);

/**
 * Add city name validation method to jQuery validation plugin.
 * Text fields must have 'city-name' css class to be validated
 */
$.validator.addMethod('city-name', validateCityName, Resources.INVALID_CITY_NAME);

/**
 * Add General Validation method to jQuery validation plugin.
 * Text fields must have 'alphanumeric' css class to be validated
 */
$.validator.addMethod('alphanumeric', validateAlphanumeric, Resources.INVALID_VALUE);

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);

/**
 * Add Gift Message validation method to jQuery validation plugin.
 * Text fields must have 'GiftMessage' css class to be validated as Gift Message
 */
$.validator.addMethod('GiftMessage', validateGiftMessage, Resources.INVALID_GIFT_MESSAGE);


/**
 * Add Event Name validation method to jQuery validation plugin.
 * Text fields must have 'event-name' css class to be validated as Event Name
 */
$.validator.addMethod('event-name', validateEventName, Resources.INVALID_VALUE);

/**
 * Add email validation method to jQuery validation plugin.
 * Text fields must have 'email' css class to be validated as phone
 */
$.validator.addMethod('email', validateEmail, Resources.INVALID_EMAIL);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);


/**
 * Add zipcode validation method to jQuery validation plugin.
 * Text fields must have 'zipcode' css class to be validated as phone
 */
$.validator.addMethod('postal', validateZip, Resources.INVALID_ZIP);

/**
 * Add CC cvv Number validation method to jQuery validation plugin.
 * Text fields must have 'cvn' css class to be validated as a invalid cvv
 */
$.validator.addMethod('cvn', validateCVNNumber, Resources.INVALID_CVN_NUMBER);

/**
 * Add Credit Card Number validation method to jQuery validation plugin.
 * Text fields must have 'credit-card-number' css class to be validated as a invalid Credit Card Number
 */
$.validator.addMethod('credit-card-number', validateCreditCardNumber, Resources.INVALID_CREDIT_CARD_NUMBER);

/**
 * Validates if the field value contains PO Box (or something similar).
 * Used for address1 and address2 field to block PO Box address.
 */
$.validator.addMethod('not-po-box', validatePOBox, Resources.UNABLE_TO_SHIP_TO_PO_BOX);


/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod('gift-cert-amount', function(value, el) {
    var isOptional = this.optional(el);
    var isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
    return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod('positivenumber', function(value) {
    if ($.trim(value).length === 0) {
        return true;
    }
    return (!isNaN(value) && Number(value) >= 0);
}, ''); // '' should be replaced with error message if needed

$.extend($.validator.messages, {
    required: Resources.VALIDATE_REQUIRED,
    remote: Resources.VALIDATE_REMOTE,
    email: Resources.VALIDATE_EMAIL,
    url: Resources.VALIDATE_URL,
    date: Resources.VALIDATE_DATE,
    dateISO: Resources.VALIDATE_DATEISO,
    number: Resources.VALIDATE_NUMBER,
    digits: Resources.VALIDATE_DIGITS,
    creditcard: Resources.VALIDATE_CREDITCARD,
    equalTo: Resources.VALIDATE_EQUALTO,
    maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
    minlength: $.validator.format(Resources.VALIDATE_MINLENGTH),
    rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
    range: $.validator.format(Resources.VALIDATE_RANGE),
    max: $.validator.format(Resources.VALIDATE_MAX),
    min: $.validator.format(Resources.VALIDATE_MIN)
});

var validator = {
    regex: regex,
    isEmail: isEmail,
    settings: settings,
    init: function() {
        var self = this;
        $('form:not(.suppress)').each(function() {
            $(this).validate(self.settings);
        });
    },
    initForm: function(f) {
        $(f).validate(this.settings);
    }
};

module.exports = validator;

},{"./gtm":18}],80:[function(require,module,exports){
'use strict';

const updateProductIds = function() {
    window.wunderkind.product.sku = $('input[type="hidden"][id="pid"]').val();

    if (!window.wunderkind.product.id) {
        window.wunderkind.product.id = window.wunderkind.product.sku;
    }
}

exports.updateCart = function() {
    try {
        window.wunderkind.cart.quantity = parseInt($('.minicart-quantity').text().replace(/[^0-9]/gi, ''), 10) || 0;
        window.wunderkind.cart.value = parseFloat($('input[type="hidden"][name="cartTotal"]').val().replace(/[^0-9.]/gi, '')) || 0;
    } catch (e) {
        // Ignore.
    }
}

exports.updateProduct = function() {
    if (!pageContext || pageContext.type !== 'product') {
        return;
    }

    window.wunderkind.product.id = $('input[type="hidden"][id="pid"]').attr('data-masterid');
    window.wunderkind.product.name = $('.product-detail .product-name').first().text().trim();
    window.wunderkind.product.url = window.location.href;
    window.wunderkind.product.imgUrl = $('.product-detail .photo-grid__asset').attr('src') || $('.product-image img').first().attr('src');
    window.wunderkind.product.itemCategory = $('.breadcrumb .breadcrumb-element').last().text();

    try {
        var productATS = parseInt($('input.productATS').val(), 10);
        window.wunderkind.product.inStock = productATS > 0;

        window.wunderkind.product.price = parseFloat($('input[type="hidden"][name="price"]').val().replace(/[^0-9.]/gi, '')) || 0;
    } catch (e) {
        window.wunderkind.product.inStock = false;
    }

    if (window.wunderkind.product.sku) {
        updateProductIds();
    } else {
        setTimeout(() => {
            updateProductIds();
        }, 2000);
    }
}

exports.init = function() {
    window.wunderkind = {
        cart: {
            quantity: 0, // Number of items in cart
            value: 0 // Dollar value in cart
        },
        user: {
            email: null, // User email in Base64 representation using btoa function
            loggedIn: false // Whenever the user is logged in or not 
        },
        product: {
            id: null, // Master ID
            sku: null, // Variant ID
            name: null,
            url: null,
            imgUrl: null,
            price: null,
            inStock: false,
            itemCategory: null
        },
        category: {
            title: null,
            categoryIds: null
        }
    };

    var email = $('input[type="hidden"][name="customerEmail"]').val();
    if (email) {
        window.wunderkind.user.email = btoa(email);
        window.wunderkind.user.loggedIn = true;
    }

    if (pageContext && pageContext.type === 'search') {
        window.wunderkind.category.title = $('.header-category').text();
        window.wunderkind.category.categoryIds = [];
        $('.product-tile').each(function() {
            window.wunderkind.category.categoryIds.push($(this).data('itemid'));
        });
    }

    this.updateCart();

    this.updateProduct();
}

},{}],81:[function(require,module,exports){
"use strict";

// rawAsap provides everything we need except exception management.
var rawAsap = require("./raw");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"./raw":82}],82:[function(require,module,exports){
(function (global){(function (){
"use strict";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],83:[function(require,module,exports){

},{}],84:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBind = require('./');

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

},{"./":85,"get-intrinsic":89}],85:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var GetIntrinsic = require('get-intrinsic');

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

},{"function-bind":88,"get-intrinsic":89}],86:[function(require,module,exports){
/*!
 * eventie v1.0.6
 * event binding helper
 *   eventie.bind( elem, 'click', myFn )
 *   eventie.unbind( elem, 'click', myFn )
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true */
/*global define: false, module: false */

( function( window ) {

'use strict';

var docElem = document.documentElement;

var bind = function() {};

function getIEEvent( obj ) {
  var event = window.event;
  // add event.target
  event.target = event.target || event.srcElement || obj;
  return event;
}

if ( docElem.addEventListener ) {
  bind = function( obj, type, fn ) {
    obj.addEventListener( type, fn, false );
  };
} else if ( docElem.attachEvent ) {
  bind = function( obj, type, fn ) {
    obj[ type + fn ] = fn.handleEvent ?
      function() {
        var event = getIEEvent( obj );
        fn.handleEvent.call( fn, event );
      } :
      function() {
        var event = getIEEvent( obj );
        fn.call( obj, event );
      };
    obj.attachEvent( "on" + type, obj[ type + fn ] );
  };
}

var unbind = function() {};

if ( docElem.removeEventListener ) {
  unbind = function( obj, type, fn ) {
    obj.removeEventListener( type, fn, false );
  };
} else if ( docElem.detachEvent ) {
  unbind = function( obj, type, fn ) {
    obj.detachEvent( "on" + type, obj[ type + fn ] );
    try {
      delete obj[ type + fn ];
    } catch ( err ) {
      // can't delete window object properties
      obj[ type + fn ] = undefined;
    }
  };
}

var eventie = {
  bind: bind,
  unbind: unbind
};

// ----- module definition ----- //

if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( eventie );
} else if ( typeof exports === 'object' ) {
  // CommonJS
  module.exports = eventie;
} else {
  // browser global
  window.eventie = eventie;
}

})( window );

},{}],87:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],88:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":87}],89:[function(require,module,exports){
'use strict';

var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('has');
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"function-bind":88,"has":92,"has-symbols":90}],90:[function(require,module,exports){
'use strict';

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require('./shams');

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

},{"./shams":91}],91:[function(require,module,exports){
'use strict';

/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],92:[function(require,module,exports){
'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

},{"function-bind":88}],93:[function(require,module,exports){
/*!
 * imagesLoaded v3.2.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'eventEmitter/EventEmitter',
      'eventie/eventie'
    ], function( EventEmitter, eventie ) {
      return factory( window, EventEmitter, eventie );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('wolfy87-eventemitter'),
      require('eventie')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EventEmitter,
      window.eventie
    );
  }

})( window,

// --------------------------  factory -------------------------- //

function factory( window, EventEmitter, eventie ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var objToString = Object.prototype.toString;
function isArray( obj ) {
  return objToString.call( obj ) == '[object Array]';
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

  // -------------------------- imagesLoaded -------------------------- //

  /**
   * @param {Array, Element, NodeList, String} elem
   * @param {Object or Function} options - if function, use as callback
   * @param {Function} onAlways - callback function
   */
  function ImagesLoaded( elem, options, onAlways ) {
    // coerce ImagesLoaded() without new, to be new ImagesLoaded()
    if ( !( this instanceof ImagesLoaded ) ) {
      return new ImagesLoaded( elem, options, onAlways );
    }
    // use elem as selector string
    if ( typeof elem == 'string' ) {
      elem = document.querySelectorAll( elem );
    }

    this.elements = makeArray( elem );
    this.options = extend( {}, this.options );

    if ( typeof options == 'function' ) {
      onAlways = options;
    } else {
      extend( this.options, options );
    }

    if ( onAlways ) {
      this.on( 'always', onAlways );
    }

    this.getImages();

    if ( $ ) {
      // add jQuery Deferred object
      this.jqDeferred = new $.Deferred();
    }

    // HACK check async to allow time to bind listeners
    var _this = this;
    setTimeout( function() {
      _this.check();
    });
  }

  ImagesLoaded.prototype = new EventEmitter();

  ImagesLoaded.prototype.options = {};

  ImagesLoaded.prototype.getImages = function() {
    this.images = [];

    // filter & find items if we have an item selector
    for ( var i=0; i < this.elements.length; i++ ) {
      var elem = this.elements[i];
      this.addElementImages( elem );
    }
  };

  /**
   * @param {Node} element
   */
  ImagesLoaded.prototype.addElementImages = function( elem ) {
    // filter siblings
    if ( elem.nodeName == 'IMG' ) {
      this.addImage( elem );
    }
    // get background image on element
    if ( this.options.background === true ) {
      this.addElementBackgroundImages( elem );
    }

    // find children
    // no non-element nodes, #143
    var nodeType = elem.nodeType;
    if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
      return;
    }
    var childImgs = elem.querySelectorAll('img');
    // concat childElems to filterFound array
    for ( var i=0; i < childImgs.length; i++ ) {
      var img = childImgs[i];
      this.addImage( img );
    }

    // get child background images
    if ( typeof this.options.background == 'string' ) {
      var children = elem.querySelectorAll( this.options.background );
      for ( i=0; i < children.length; i++ ) {
        var child = children[i];
        this.addElementBackgroundImages( child );
      }
    }
  };

  var elementNodeTypes = {
    1: true,
    9: true,
    11: true
  };

  ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
    var style = getStyle( elem );
    // get url inside url("...")
    var reURL = /url\(['"]*([^'"\)]+)['"]*\)/gi;
    var matches = reURL.exec( style.backgroundImage );
    while ( matches !== null ) {
      var url = matches && matches[1];
      if ( url ) {
        this.addBackground( url, elem );
      }
      matches = reURL.exec( style.backgroundImage );
    }
  };

  // IE8
  var getStyle = window.getComputedStyle || function( elem ) {
    return elem.currentStyle;
  };

  /**
   * @param {Image} img
   */
  ImagesLoaded.prototype.addImage = function( img ) {
    var loadingImage = new LoadingImage( img );
    this.images.push( loadingImage );
  };

  ImagesLoaded.prototype.addBackground = function( url, elem ) {
    var background = new Background( url, elem );
    this.images.push( background );
  };

  ImagesLoaded.prototype.check = function() {
    var _this = this;
    this.progressedCount = 0;
    this.hasAnyBroken = false;
    // complete if no images
    if ( !this.images.length ) {
      this.complete();
      return;
    }

    function onProgress( image, elem, message ) {
      // HACK - Chrome triggers event before object properties have changed. #83
      setTimeout( function() {
        _this.progress( image, elem, message );
      });
    }

    for ( var i=0; i < this.images.length; i++ ) {
      var loadingImage = this.images[i];
      loadingImage.once( 'progress', onProgress );
      loadingImage.check();
    }
  };

  ImagesLoaded.prototype.progress = function( image, elem, message ) {
    this.progressedCount++;
    this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
    // progress event
    this.emit( 'progress', this, image, elem );
    if ( this.jqDeferred && this.jqDeferred.notify ) {
      this.jqDeferred.notify( this, image );
    }
    // check if completed
    if ( this.progressedCount == this.images.length ) {
      this.complete();
    }

    if ( this.options.debug && console ) {
      console.log( 'progress: ' + message, image, elem );
    }
  };

  ImagesLoaded.prototype.complete = function() {
    var eventName = this.hasAnyBroken ? 'fail' : 'done';
    this.isComplete = true;
    this.emit( eventName, this );
    this.emit( 'always', this );
    if ( this.jqDeferred ) {
      var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
      this.jqDeferred[ jqMethod ]( this );
    }
  };

  // --------------------------  -------------------------- //

  function LoadingImage( img ) {
    this.img = img;
  }

  LoadingImage.prototype = new EventEmitter();

  LoadingImage.prototype.check = function() {
    // If complete is true and browser supports natural sizes,
    // try to check for image status manually.
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      // report based on naturalWidth
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      return;
    }

    // If none of the checks above matched, simulate loading on detached element.
    this.proxyImage = new Image();
    eventie.bind( this.proxyImage, 'load', this );
    eventie.bind( this.proxyImage, 'error', this );
    // bind to image as well for Firefox. #191
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.proxyImage.src = this.img.src;
  };

  LoadingImage.prototype.getIsImageComplete = function() {
    return this.img.complete && this.img.naturalWidth !== undefined;
  };

  LoadingImage.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.img, message );
  };

  // ----- events ----- //

  // trigger specified handler for event type
  LoadingImage.prototype.handleEvent = function( event ) {
    var method = 'on' + event.type;
    if ( this[ method ] ) {
      this[ method ]( event );
    }
  };

  LoadingImage.prototype.onload = function() {
    this.confirm( true, 'onload' );
    this.unbindEvents();
  };

  LoadingImage.prototype.onerror = function() {
    this.confirm( false, 'onerror' );
    this.unbindEvents();
  };

  LoadingImage.prototype.unbindEvents = function() {
    eventie.unbind( this.proxyImage, 'load', this );
    eventie.unbind( this.proxyImage, 'error', this );
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  // -------------------------- Background -------------------------- //

  function Background( url, element ) {
    this.url = url;
    this.element = element;
    this.img = new Image();
  }

  // inherit LoadingImage prototype
  Background.prototype = new LoadingImage();

  Background.prototype.check = function() {
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.img.src = this.url;
    // check if image is already complete
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      this.unbindEvents();
    }
  };

  Background.prototype.unbindEvents = function() {
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  Background.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.element, message );
  };

  // -------------------------- jQuery -------------------------- //

  ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
    jQuery = jQuery || window.jQuery;
    if ( !jQuery ) {
      return;
    }
    // set local variable
    $ = jQuery;
    // $().imagesLoaded()
    $.fn.imagesLoaded = function( options, callback ) {
      var instance = new ImagesLoaded( this, options, callback );
      return instance.jqDeferred.promise( $(this) );
    };
  };
  // try making plugin
  ImagesLoaded.makeJQueryPlugin();

  // --------------------------  -------------------------- //

  return ImagesLoaded;

});

},{"eventie":86,"wolfy87-eventemitter":116}],94:[function(require,module,exports){
(function (global){(function (){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],95:[function(require,module,exports){
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require('./util.inspect');
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

},{"./util.inspect":83}],96:[function(require,module,exports){
'use strict';

module.exports = require('./lib')

},{"./lib":101}],97:[function(require,module,exports){
'use strict';

var asap = require('asap/raw');

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._40 = 0;
  this._65 = 0;
  this._55 = null;
  this._72 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._37 = null;
Promise._87 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._65 === 3) {
    self = self._55;
  }
  if (Promise._37) {
    Promise._37(self);
  }
  if (self._65 === 0) {
    if (self._40 === 0) {
      self._40 = 1;
      self._72 = deferred;
      return;
    }
    if (self._40 === 1) {
      self._40 = 2;
      self._72 = [self._72, deferred];
      return;
    }
    self._72.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._65 === 1) {
        resolve(deferred.promise, self._55);
      } else {
        reject(deferred.promise, self._55);
      }
      return;
    }
    var ret = tryCallOne(cb, self._55);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._65 = 3;
      self._55 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._65 = 1;
  self._55 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._65 = 2;
  self._55 = newValue;
  if (Promise._87) {
    Promise._87(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._40 === 1) {
    handle(self, self._72);
    self._72 = null;
  }
  if (self._40 === 2) {
    for (var i = 0; i < self._72.length; i++) {
      handle(self, self._72[i]);
    }
    self._72 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

},{"asap/raw":82}],98:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

},{"./core.js":97}],99:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js');

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._65 = 1;
  p._55 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._65 === 3) {
            val = val._55;
          }
          if (val._65 === 1) return res(i, val._55);
          if (val._65 === 2) reject(val._55);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

},{"./core.js":97}],100:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype['finally'] = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

},{"./core.js":97}],101:[function(require,module,exports){
'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');

},{"./core.js":97,"./done.js":98,"./es6-extensions.js":99,"./finally.js":100,"./node-extensions.js":102,"./synchronous.js":103}],102:[function(require,module,exports){
'use strict';

// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = require('./core.js');
var asap = require('asap');

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};

},{"./core.js":97,"asap":81}],103:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._65 === 3) {
      return this._55.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._55;
  };

  Promise.prototype.getReason = function () {
    if (this._65 === 3) {
      return this._55.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._55;
  };

  Promise.prototype.getState = function () {
    if (this._65 === 3) {
      return this._55.getState();
    }
    if (this._65 === -1 || this._65 === -2) {
      return 0;
    }

    return this._65;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

},{"./core.js":97}],104:[function(require,module,exports){
(function (global){(function (){
/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],105:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],106:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":105,"./parse":107,"./stringify":108}],107:[function(require,module,exports){
'use strict';

var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

},{"./utils":109}],108:[function(require,module,exports){
'use strict';

var getSideChannel = require('side-channel');
var utils = require('./utils');
var formats = require('./formats');
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + (commaRoundTrip && isArray(obj) && valuesArray.length === 1 ? '[]' : '') + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":105,"./utils":109,"side-channel":113}],109:[function(require,module,exports){
'use strict';

var formats = require('./formats');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

},{"./formats":105}],110:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],111:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],112:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":110,"./encode":111}],113:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bind/callBound');
var inspect = require('object-inspect');

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

},{"call-bind/callBound":84,"get-intrinsic":89,"object-inspect":95}],114:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var punycode = require('punycode');
var util = require('./util');

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = require('querystring');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

},{"./util":115,"punycode":104,"querystring":112}],115:[function(require,module,exports){
'use strict';

module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};

},{}],116:[function(require,module,exports){
/*!
 * EventEmitter v4.2.11 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function () {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var exports = this;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);
                i = listeners.length;

                while (i--) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return EventEmitter;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}.call(this));

},{}]},{},[3]);
